import { es } from 'date-fns/locale';

// Part 1, lines 1 to 200
export default {
  // 酒店知识库独立语言块，保留原有语言内容。
  hotelKnowledge: {
    "title": "Base de conocimiento del hotel",
    "tip": "Gestiona las preguntas y respuestas del hotel actual.",
    "created": "Fecha de creación",
    "updated": "Fecha de actualización",
    "to": "hasta",
    "startDate": "Fecha de inicio",
    "endDate": "Fecha de fin",
    "question": "Pregunta",
    "answer": "Respuesta",
    "tags": "Etiquetas",
    "questionSearch": "Buscar preguntas por palabra clave",
    "tagSearch": "Buscar etiquetas por palabra clave",
    "search": "Buscar",
    "reset": "Restablecer",
    "create": "Añadir",
    "batchDelete": "Eliminar selección",
    "loadFailed": "Error al cargar. Inténtalo de nuevo.",
    "notFilled": "Sin completar",
    "actions": "Acciones",
    "view": "Ver texto completo",
    "edit": "Editar",
    "delete": "Eliminar",
    "details": "Detalles del conocimiento",
    "missingTitle": "Falta contenido histórico",
    "missingView": "Falta la pregunta o la respuesta de este registro. Complétala antes de guardar.",
    "missingForm": "Falta la pregunta o la respuesta. Complétala antes de guardar.",
    "noDetails": "Sin detalles",
    "close": "Cerrar",
    "enterQuestion": "Introduce una pregunta",
    "enterAnswer": "Introduce una respuesta",
    "answerPlaceholder": "Introduce una respuesta. Se admiten varias líneas.",
    "tagPlaceholder": "Introduce una etiqueta y pulsa Intro",
    "tagTip": "Pulsa Intro para añadir una etiqueta. Las comas y los espacios no separan etiquetas. La longitud total no puede superar 512 caracteres.",
    "cancel": "Cancelar",
    "save": "Guardar",
    "chooseHotel": "Selecciona primero un hotel",
    "empty": "Sin datos",
    "editTitle": "Editar conocimiento",
    "createTitle": "Añadir conocimiento",
    "tagRequired": "Añade al menos una etiqueta",
    "tagText": "Las etiquetas deben ser texto. Elimínalas y vuelve a añadirlas.",
    "tagBlank": "Las etiquetas no pueden estar vacías. Elimínalas y vuelve a añadirlas.",
    "tagsTooLong": "Las etiquetas son demasiado largas. Acórtalas e inténtalo de nuevo.",
    "questionTooLong": "La pregunta no puede superar 512 caracteres",
    "answerTooLong": "La respuesta no puede superar 5000 caracteres",
    "invalidRecord": "El registro no es válido. Vuelve a abrirlo para editarlo.",
    "editSuccess": "Edición guardada correctamente",
    "createSuccess": "Añadido correctamente",
    "deleteLimit": "Se pueden eliminar hasta 100 registros cada vez",
    "confirmBatch": "¿Eliminar los {count} registros seleccionados en esta página? Esta acción no se puede deshacer.",
    "confirmOne": "¿Eliminar este registro? Esta acción no se puede deshacer.",
    "deleteConfirm": "Confirmar eliminación",
    "confirmDelete": "Confirmar eliminación",
    "deleteSuccess": "Eliminado correctamente",
    "dataChanged": "Los datos han cambiado. Actualiza la lista y vuelve a intentarlo."
  },
  // 本次 AI 用量同步独立追加，保留原有语言块。
  aiUsageSync: {
    "beta": "Beta",
    "title": "Estadísticas de uso de IA",
    "priceConfig": "Configuración de precios por tipo de habitación",
    "dateRange": "Rango de fechas",
    "startDate": "Fecha de inicio",
    "endDate": "Fecha de fin",
    "scene": "Tipo de notificación",
    "all": "Todos",
    "callStatus": "Estado de llamada",
    "callStatusLabel": "Información del estado de llamada",
    "running": "En curso",
    "success": "Correcta",
    "failed": "Fallida",
    "tokenStatus": "Datos de uso",
    "tokenStatusLabel": "Información de datos de uso",
    "known": "Disponibles",
    "unknownUsage": "No disponibles",
    "query": "Consultar",
    "reset": "Restablecer",
    "categoryError": "Error al cargar los tipos de notificación",
    "retry": "Volver a cargar",
    "chooseHotel": "Seleccione primero un hotel",
    "dailyUsage": "Uso diario de IA",
    "noCallsFiltered": "No hay llamadas con los filtros seleccionados.",
    "statisticsError": "Error al cargar las estadísticas de uso",
    "loadingTrend": "Cargando tendencia…",
    "details": "Detalles de llamadas",
    "detailsError": "Error al cargar los detalles de llamadas",
    "loading": "Cargando…",
    "noCalls": "No hay registros de llamadas",
    "waiting": "Esperando consulta",
    "callTime": "Hora de llamada",
    "usage": "Uso de IA",
    "requestInfo": "Información de solicitud",
    "requestId": "ID de solicitud: ",
    "requestDetails": "Detalles de solicitud",
    "totalUsage": "Uso total de IA",
    "callCount": "Número de llamadas",
    "successCount": "Llamadas correctas",
    "unknownCount": "Llamadas con uso desconocido",
    "today": "Hoy",
    "last7": "Últimos 7 días",
    "last30": "Últimos 30 días",
    "thisMonth": "Este mes",
    "pending": "Pendiente",
    "unknown": "Desconocido",
    "usageLabel": "Uso: ",
    "callCountLabel": "Llamadas: ",
    "unknownCountLabel": "Llamadas con uso desconocido: ",
    "missingUsage": "Algunas llamadas no tienen datos de uso",
    "usageAxis": "Uso",
    "description": "El uso incluye las llamadas de IA registradas para el hotel actual y excluye los chats sin hotel asociado. Las fechas usan la hora de Pekín.",
    "callStatusHelp": "En curso, correcta y fallida indican el estado de la llamada a la plataforma. El éxito no implica que se haya generado una notificación.",
    "usageHelp": "Disponibles: el uso se conoce, incluido cero. No disponibles: existe la llamada pero se desconoce el uso y se excluye del total, independientemente del resultado.",
    "invalidDates": "Seleccione un rango válido. El inicio no puede ser posterior al fin y ninguna fecha puede ser posterior a hoy en hora de Pekín."
  },
  navbar: {
    searchHotel: 'Buscar nombre del hotel',
    nightAudit: 'Auditoría nocturna',
    nightAuditWarning: 'El hotel está realizando la auditoría nocturna, inténtelo más tarde',
    groupBooking: 'Reserva de grupo',
    orderBox: 'Caja de pedidos',
  },
  common: {
    logo: 'Logo',
    bundleSale: 'Venta en Paquete',
    title: 'Sistema de Gestión Hotelera EaseHUB',
    billingCycleType: 'Tipo de ciclo de facturación',
    weeklySettlement: 'Liquidación semanal',
    monthlySettlement: 'Liquidación mensual',
    accountReceivablePayment: 'Pago de cuenta por cobrar (AR)',
    noResults: 'No se encontró información del hotel',
    shiftHandover: 'Entrega de turno',
    salesClerk: 'Vendedor',
    currentShift: 'Turno actual',
    requestFailed: 'Solicitud fallida',
    confirmModify: 'Confirmar modificación',
    operationSuccess: '¡Operación exitosa!',
    individualBooking: 'Reserva individual',
    longBooking: 'Reserva de larga estancia',
    cashPay: 'Pago inmediato',
    cashPayment: 'Cuenta de pago inmediato',
    doorCard: 'Tarjeta de habitación',
    more: 'Más',
    success: 'Éxito',
    close: 'Cerrar',
    loadingEllipsis: 'Cargando...',
    cancel: 'Cancelar',
    printReport: 'Imprimir informe',
    printTime: 'Hora de impresión',
    businessDay: 'Día hábil',
    operationDate: 'Fecha de operación',
    subject: 'Concepto',
    amount: 'Importe',
    save: 'Guardar',
    yuan: '',
    confirm: 'Confirmar',
    nextStep: 'Siguiente paso',
    all: 'Todos',
    immediateQuery: 'Consultar de inmediato',
    action: 'Acción',
    pleaseSelect: 'Seleccione',
    pleaseInput: 'Introduzca',
    inputYuan: 'Introduzca',
    yes: 'Sí',
    no: 'No',
    remark: 'Observación',
    delete: 'Eliminar',
    oneHour: 'Una hora',
    twoHours: 'Dos horas',
    threeHours: 'Tres horas',
    fourHours: 'Cuatro horas',
    fiveHours: 'Cinco horas',
    sixHours: 'Seis horas',
    sevenHours: 'Siete horas',
    eightHours: 'Ocho horas',
    saveSuccess: 'Guardado con éxito',
    notice: 'Aviso',
    status: 'Estado',
    cancelled: 'Cancelado',
    booked: 'Reservado',
    hardLoading: 'Cargando intensamente',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    Deadline: 'Fecha límite',
    name2: 'Nombre',
    roomNumber: 'Número de habitación',
    checkInDate3: 'Fecha de entrada',
    checkOutDate3: 'Fecha de salida',
    unitPrice3: 'Precio unitario',
    quantity: 'Cantidad',
    addBook: 'Agregar cuenta',
    bookName: 'Nombre de la cuenta',
    accountOfConsumption: 'Concepto de consumo',
    details3: 'Detalles',
    id: 'ID',
    commodityDetail: 'Detalle del producto',
    externalDocumentNumber: 'Número de documento externo',
    accountOfPayment2: 'Concepto de pago',
    strikeABalance: 'Ajustar cuenta',
    pleaseFillInRemarks2: 'Por favor, complete la observación',
    search: 'Buscar',
    nationality: 'Nacionalidad',
    sex: 'Sexo',
    male: 'Masculino',
    female: 'Femenino',
    nation: 'Etnia',
    contactInformation2: 'Información de contacto',
    dateOfBirth: 'Fecha de nacimiento',
    documentType: 'Tipo de documento',
    address2: 'Dirección',
    documentNumber: 'Número de documento',
    validityOfVisa: 'Validez de la visa',
    visaType: 'Tipo de visa',
    visaNumber: 'Número de visa',
    pleaseEnterYourIdNumber: 'Introduzca el número de documento',
    pleaseEnterTheCorrectIdNumber4: 'Introduzca el número de documento correcto',
    pleaseFillInYourName2: 'Por favor, complete el nombre',
    pleaseSelectDocumentType: 'Seleccione el tipo de documento',
    dontWorryAboutGoldMembers2: 'Miembro Oro Qingzhu',
    goEasyOnThePlatinumMembers2: 'Miembro Platino Qingzhu',
    lightOnDiamondMembers2: 'Miembro Diamante Qingzhu',
    unregisteredMember: 'Miembro no registrado',
    ok2: 'Aceptar',
    issuingAuthority: 'Autoridad emisora',
    idPhoto: 'Foto del documento',
    qingzhuGroup: 'Grupo Qingzhu',
    mobilePhoneNumber: 'Número de móvil',
    view: 'Ver',
    activated: 'Activado',
    nonmember: 'No miembro',
    coupon: 'Cupón',
    ranking5: 'Clasificación',
    hotelName4: 'Nombre del hotel',
    isNotSet: 'No configurado',
    yu: 'Saldo',
    noVacancy: 'Sin disponibilidad',
    consumption: 'Consumo',
    refund: 'Reembolso',
    iGotIt2: 'Entendido',
    startANightTrial: 'Iniciar auditoría nocturna',
    operator: 'Operador',
    handledBy: 'Gestionado por',
    to: 'Hasta',
    currentBusinessDay: 'Día hábil actual',
    ok: 'Aceptar',
    morningShift2: 'Turno de mañana',
    middleShift2: 'Turno intermedio',
    nightShift2: 'Turno nocturno',
    pleaseEnterYourName: 'Introduzca el nombre',
    selectAll: 'Seleccionar todo',
    pleaseEnterContent: 'Introduzca el contenido',
    serialNumber: 'Número de serie',
    address: 'Dirección',
    signatureOfAuthorizer: 'Firma del autorizador',
    signature3: 'Firma',
    roomType: 'Tipo de habitación',
    dayRate: 'Tarifa del día',
    checkInTime: 'Hora de entrada',
    checkOutTime: 'Hora de salida',
    settlementAmount: 'Importe de liquidación',
    hotelAddress: 'Dirección del hotel',
    selectDate: 'Seleccionar fecha',
    selectionTime: 'Seleccionar hora',
    cancelCard: 'Cancelar tarjeta',
    thisCardIsEmptyPleaseMakeABusinessCardFirst:
      'Esta tarjeta está vacía, cree una tarjeta primero',
    logoutSuccessful: 'Cancelación exitosa',
    cardCancellationFailure: 'Error al cancelar la tarjeta',
    contactSupport: 'Contacte con soporte técnico para verificar el hardware',
    submit: 'Enviar',
    contactPerson6: 'Persona de contacto',
    contactNumber2: 'Número de contacto',
    merchant3: 'Comerciante',
    Submitsuccessfully: 'Enviado con éxito',
    smallProgram: 'Mini programa',
    technicalSupport: 'Soporte técnico',
    roomBillCheck: 'Verificación de factura de habitación',
    financialAssistant: 'Asistente financiero',
    settlementCycle: 'Ciclo de liquidación',
    refundSuccessful: 'Reembolso exitoso',
    beingRefunded: 'Reembolsando',
    refundFailure: 'Error en el reembolso',
    channel: 'Canal',
    cloakroom: 'Bloquear habitación',
    infiniteQuantity: 'Cantidad ilimitada',
    compute: 'Calcular',
    dateOfSale: 'Fecha de venta',
    originalPrice: 'Precio original',
    pleaseEnterTheOriginalPrice: 'Introduzca el precio original',
    member: 'Miembro',
    salesAmount: 'Importe de ventas',
    amountOfConsumption: 'Importe de consumo',
    protocolUnit: 'Unidad de convenio',
    subjectDesc: 'Descripción del concepto',
    qzOrderNo: 'Número de pedido Qingzhu',
    checkInType: 'Tipo de entrada',
    checkInOutDate: 'Fechas de entrada y salida',
    channelOrderNo: 'Número de pedido del canal',
    pleaseEnterTheCorrectPhoneNumber3: 'Introduzca el número de móvil correcto',
    logs: 'Registros',
    walkIn: 'Cliente sin reserva',
    businessCardPrintingSuccess: 'Tarjeta creada con éxito',
    exportSuccessfully2: 'Exportado con éxito',
    exportFailure: 'Error al exportar',
    other: 'Otro',
    toBeProcessed: 'Pendiente',
    completed: 'Completado',
    commonProduct: 'Producto común',
    freeRoomProducts: 'Productos de habitación gratuita',
    makeACard: 'Crear tarjeta',
    day: 'Día',
    points2: 'Minutos',
    sunday: 'Domingo',
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',
    lose: 'Fallido',
    // Part 2, lines 201 to 400
    since: 'Desde',
    amountTotal: 'Subtotal',
    total: 'Total',
    tradeName: 'Nombre del producto',
    itemType: 'Tipo de artículo',
    orderStatus: 'Estado del pedido',
    orderNumber: 'Número de pedido',
    anonymousUser: 'Usuario anónimo',
    commentTime: 'Hora del comentario',
    merchantReply: 'Respuesta del comerciante',
    recoveryTime: 'Hora de respuesta',
    recover: 'Responder',
    pleaseWriteAResponseOfAtLeast10Words:
      'Por favor, escriba una respuesta de al menos 10 caracteres',
    replyTextMinimum10Words: 'El texto de respuesta debe tener al menos 10 caracteres',
    negativeComment: 'Reseña negativa',
    cancel2: 'Cancelar',
    commentTemplateManagement: 'Gestión de plantillas de comentarios',
    modifiedSuccessfully: 'Modificado con éxito',
    hygiene: 'Higiene',
    service: 'Servicio',
    facility: 'Instalaciones',
    position: 'Ubicación',
    appeal: 'Apelación',
    successfullyDeleted: 'Eliminado con éxito',
    replySuccessfully2: 'Respuesta exitosa',
    theMobilePhoneNumberFormatIsIncorrect5: 'El formato del número de teléfono es incorrecto',
    none4: 'Ninguno',
    thisFunctionHasNotBeenOpenedIfYouNeedToOpenPleaseClickOpen:
      'Esta función aún no está habilitada, si necesita habilitarla haga clic en abrir',
    noCommentsYet: 'Aún no hay comentarios',
    picture: 'Imagen',
    guestName: 'Nombre del huésped',
    handle: 'Procesar',
    edit: 'Editar',
    type: 'Tipo',
    salesman: 'Vendedor',
    successfulOperation: 'Operación exitosa',
    pleaseEnterTheCompanyName2: 'Introduzca el nombre de la empresa',
    customerType: 'Tipo de cliente',
    effective: 'Válido',
    inVain: 'Inválido',
    valid: 'Válido',
    forbidden: 'Deshabilitado',
    enable: 'Habilitar',
    companyName2: 'Nombre de la empresa',
    favorable2: 'Descuento',
    day2: 'Día',
    telephone: 'Teléfono',
    pleaseEnterThePhoneNumber: 'Introduzca el número de teléfono',
    mailbox: 'Correo electrónico',
    accountName: 'Nombre de la cuenta',
    startTime: 'Hora de inicio',
    endTime: 'Hora de fin',
    beingSubmitted: 'Enviando',
    pleaseSelectGender: 'Seleccione el sexo',
    confirmDeletion: 'Confirmar eliminación',
    letMeThinkItOver: 'Déjame pensarlo',
    theSizeOfTheUploadedPictureCannotExceed: 'El tamaño de la imagen cargada no puede exceder',
    identificationCard2: 'Documento de identidad',
    editor: 'Editor',
    topLine: 'En línea',
    downline: 'Fuera de línea',
    validity: 'Validez',
    fullDayRoom: 'Habitación de día completo',
    hourlyRoom: 'Habitación por horas',
    append3: 'Agregar',
    immediatelyReduce3: 'Descuento inmediato',
    activityName2: 'Nombre de la actividad',
    sort: 'Clasificación',
    on: 'Activar',
    amountOfGift2: 'Importe de regalo',
    pleaseFillIn2: 'Por favor, complete',
    pleaseSelectADate: 'Seleccione una fecha',
    roomFeeConsumption: 'Consumo de tarifa de habitación',
    selectFile: 'Seleccionar archivo',
    uploadFailure: 'Error al cargar',
    uploadSuccessfully: 'Carga exitosa',
    print: 'Imprimir',
    dateRange: 'Rango de fechas',
    reupload: 'Volver a cargar',
    printBill: 'Imprimir factura',
    cardNumber: 'Número de tarjeta',
    paymentMethod: 'Método de pago',
    payMethod: 'Forma de pago',
    balance: 'Saldo',
    membershipCardNumber: 'Número de tarjeta de miembro',
    birthday: 'Cumpleaños',
    tradingHours: 'Hora de la transacción',
    enterAMaximumOf50Characters: 'Ingrese un máximo de 50 caracteres',
    membersMobileNumber: 'Número de móvil del miembro',
    time: 'Hora',
    modifyInformation: 'Modificar información',
    lengthOfStay: 'Días de estancia',
    roomListNumber: 'Número de lista de habitación',
    roomTypeName: 'Nombre del tipo de habitación',
    settleAccounts: 'Cerrar cuenta',
    accountNumber: 'Cuenta contable',
    paymentRecord: 'Registro de pagos',
    paymentAmount: 'Importe del pago',
    paymentVerificationCode: 'Código de verificación de pago',
    enterInAnAccount: 'Registrar en cuenta',
    pleaseSelectACollectionSet: 'Seleccione el conjunto de cuentas por cobrar',
    pleaseSelectTheAccountNumber: 'Seleccione la cuenta contable',
    pleaseSelectAPaymentMethod: 'Seleccione el método de pago',
    vipSignature: 'Firma VIP',
    amountNotWrittenOff3: 'Importe no conciliado',
    availableCredit3: 'Crédito disponible',
    maximumAmount4: 'Límite máximo',
    whetherItIsValidOrNot: '¿Es válido?',
    enabledSuccessfully: 'Habilitado con éxito',
    disableSuccessfully: 'Deshabilitado con éxito',
    roomNumberName: 'Habitación - Nombre',
    payment2: 'Pago',
    operatingTime: 'Hora de operación',
    classes: 'Turnos',
    transfer: 'Transferencia',
    accountOutstanding2: 'Cuenta pendiente',
    accountClosed: 'Cuenta cerrada',
    rolledOut: 'Transferido',
    haveStruckOff: 'Conciliado',
    noRoomChargeIsGenerated: 'No se genera cargo de habitación',
    date3: 'Fecha',
    itemName4: 'Nombre del artículo',
    pleaseEnterRemarks2: 'Introduzca observaciones',
    entryAndDepartureTime: 'Hora de entrada y salida',
    roomRate: 'Tarifa de habitación',
    preAuthorizationAmount: 'Importe de preautorización',
    room: 'Habitación',
    settlement: 'Liquidación',
    pleaseSelectMemberInformation: 'Seleccione la información del miembro',
    pleaseFillInThePaymentVerificationCode: 'Introduzca el código de verificación de pago',
    accountNumber3: 'Número de cuenta',
    successfulEntry: 'Registro exitoso',
    externalOrderNumber: 'Número de pedido externo',
    transferTo: 'Transferir a',
    beAuthorized: 'Autorizado',
    haveAlreadySettled: 'Ya liquidado',
    authorizationMode: 'Modo de autorización',
    authorizedAmount: 'Importe autorizado',
    authorizationTime: 'Hora de autorización',
    productType: 'Tipo de producto',
    pleaseEnterTheChannelNumber: 'Introduzca el número del canal',
    derive: 'Exportar',
    unwritten: 'No conciliado',
    cancelled3: 'Conciliado',
    lehuiScanTheCode: 'Lehui - Escanear código',
    amountOnAccount3: 'Importe en cuenta',
    billingTime5: 'Hora de cargo',
    nameOfGuest3: 'Nombre del huésped',
    roomNumber3: 'Número de habitación',
    people: 'Personas',
    nameOfExpenseItem: 'Nombre del ítem de gasto',
    viewDetails: 'Ver detalles',
    bankOfDeposit: 'Banco',
    bankCardNumber4: 'Número de tarjeta bancaria',
    toBeConfirmed2: 'Pendiente de confirmar',
    rejected: 'Rechazado',
    adjustmentAmount: 'Importe de ajuste',
    meituan: 'Meituan',
    totalOrderAmount: 'Importe total del pedido',
    lightSettlementWithMerchants: 'Liquidación Qingzhu con comerciantes',
    membershipDistribution: 'Distribución de membresía',
    crossStoreRebate: 'Reembolso entre tiendas',
    avoidCommissionSubsidies: 'Subsidio de comisión Qingzhu',
    membershipIncentiveSettlement: 'Liquidación de incentivos de membresía',
    theUnitedStatesGroupDirectlyConnected: 'Conexión directa Meituan',
    flyingPigsConnectDirectly: 'Conexión directa Fliggy',
    fullNameOfTheBank4: 'Nombre completo del banco',
    accountBankAbbreviation4: 'Abreviatura del banco',
    theLocationOfTheBank4: 'Ubicación del banco',
    pleaseEnterYourFullBankName2: 'Introduzca el nombre completo del banco',
    pleaseSelectBankAbbreviation2: 'Seleccione la abreviatura del banco',
    pleaseSelectYourBankLocation2: 'Seleccione la ubicación del banco',
    pleaseEnterYourBankCardNumber2: 'Introduzca el número de tarjeta bancaria',
    modificationTime2: 'Hora de modificación',
    bankExample: 'Ejemplo: Banco Industrial y Comercial de China, sucursal XX',
    companyNameNote: 'Nota: si es cuenta corporativa, complete el nombre de la empresa',
    causeOfFailure: 'Motivo del fallo',
    pleaseEnterYourPhoneNumber: 'Introduzca el número de móvil',
    downloadStatement: 'Descargar estado de cuenta',
    operationLog: 'Registro de operaciones',
    ctripDirectConnection: 'Conexión directa Ctrip',
    directConnectionInTheSameDirection: 'Conexión directa Tongcheng',
    flyingPig: 'Fliggy',
    ctrip: 'Ctrip',
    roomNight: 'Noches de habitación',
    pictureUpload: 'Carga de imágenes',
    aSinglePictureMustNotBeLargerThan: 'Una sola imagen no debe ser mayor que',
    checkInRoomType2: 'Tipo de habitación de entrada',
    checkInPerson: 'Huésped',
    hotelSellingPrice: 'Precio de venta del hotel',
    effectiveDate3: 'Fecha de vigencia',
    viewExamples: 'Ver ejemplos',
    underReview: 'En revisión',
    billingType: 'Tipo de facturación',
    invoiceTitle2: 'Título de la factura',
    pleaseEnterTheInvoiceTitle2: 'Introduzca el título de la factura',
    invoiceHasBeenIssued: 'Factura emitida',
    haveBeenCancelled: 'Anulada',
    paymentStatus: 'Estado de pago',
    preferentialPrice: 'Precio preferencial',
    gateRate: 'Precio de mostrador',
    // Part 3, lines 401 to 600
    availableRoom: 'Habitaciones disponibles',
    orderableNumber: 'Cantidad disponible para reservar',
    numberOfRoomsReserved: 'Número de habitaciones reservadas',
    breakfast: 'Desayuno',
    copyOf: 'Copias',
    dailyRate: 'Tarifa diaria',
    typeOfTouristSource3: 'Tipo de origen del cliente',
    namephoneNumbermembershipNumber: 'Nombre / Teléfono / Número de miembro',
    selectTimePoint5: 'Seleccionar punto de tiempo',
    externalChannel3: 'Canal externo',
    retentionTime3: 'Tiempo de retención',
    contactName2: 'Nombre del contacto',
    numberOfDays: 'Número de días',
    pleaseSelectAProtocolUnit3: 'Seleccione la unidad de convenio',
    pleaseEnterTheNameOfTheExternalChannel2: 'Introduzca el nombre del canal externo',
    pleaseFillInTheMembershipInformation3: 'Complete la información del miembro',
    pleaseFillInTheReservationName2: 'Introduzca el nombre del reservante',
    pleaseFillInTheReservationNumber2: 'Introduzca el teléfono del reservante',
    theAmountCanOnlyBeEnteredInNumbers2: 'El importe solo puede ingresarse en números',
    noMemberInformationFound: 'No se encontró información del miembro',
    noProtocolUnitIsQueried2: 'No se encontró información de la unidad de convenio',
    bulkRepricing: 'Cambio de precio masivo',
    totalRoomRate6: 'Tarifa total de habitaciones',
    trialCalculationOfHousePrice3: 'Cálculo de prueba de la tarifa',
    free: 'Gratis',
    between: 'Habitaciones',
    upgradeRoomType: 'Actualizar tipo de habitación',
    printOrNot: '¿Imprimir o no?',
    predepartureTime2: 'Hora prevista de salida',
    rooms: 'Número de habitaciones',
    averageHousePrice: 'Precio promedio de habitación',
    arrivalTime: 'Hora prevista de llegada',
    creationTime: 'Hora de creación',
    advancedSearch: 'Búsqueda avanzada',
    simpleSearch: 'Búsqueda simple',
    price: 'Precio',
    orderTaking: 'Recepción de pedidos',
    sellingPrice: 'Precio de venta',
    floorPrice: 'Precio base',
    channelName2: 'Nombre del canal',
    bookingSuccessful2: 'Reserva exitosa',
    checkedIn2: 'Registrado',
    cancelSuccessfully2: 'Cancelado con éxito',
    sorting: 'Ordenar',
    invoiceNumber2: 'Número de factura',
    taxIdentificationNumber: 'Número de identificación fiscal',
    emailAddress: 'Correo electrónico',
    eTicket: 'Factura electrónica especial',
    eTicket2: 'Factura electrónica normal',
    paperTicket: 'Factura en papel especial',
    paperTicket2: 'Factura en papel normal',
    void: 'Anular',
    teamType: 'Tipo de grupo',
    teamName: 'Nombre del grupo',
    markUpAmount: 'Importe adicional',
    productName: 'Nombre del producto',
    lengthOfStay2: 'Duración de la estancia',
    hours: 'Horas',
    checkIn: 'Registrar entrada',
    changeRooms: 'Cambiar habitación',
    rowHouse: 'Asignación de habitaciones',
    printCheckInSlip: 'Imprimir comprobante de check-in',
    proceedWith: 'Continuar',
    rowHouseSuccess2: 'Asignación exitosa',
    toCheckIn: 'Pendiente de check-in',
    checkedOut: 'Check-out realizado',
    onAccount: 'En cuenta',
    basicInformation: 'Información básica',
    prepayment: 'Prepago',
    originalHouseType: 'Tipo de habitación original',
    seeMore: 'Ver más',
    thisRoomSupportsSmartDoorLocks: 'Esta habitación admite cerraduras inteligentes',
    listingStatus: 'Estado del registro',
    checkin: 'Check-in',
    preionization2: 'Salida prevista',
    weekTitle: 'Semana',
    thePriceActuallyPaidByTheGuest: 'Precio pagado realmente por el huésped',
    late3: 'Tarde',
    late4: 'Día',
    nonCancellable2: 'No cancelable',
    one: 'Uno',
    two: 'Dos',
    three: 'Tres',
    four: 'Cuatro',
    five: 'Cinco',
    six: 'Seis',
    lightweightDistribution: 'Distribución Qingzhu',
    liveAndTravelLightly: 'Qingzhu viajes de negocios',
    jingdongDirectLink: 'Conexión directa JD',
    baiduMapDirectConnection: 'Conexión directa Baidu Maps',
    tiktokDirectConnection: 'Conexión directa TikTok',
    ctripSingleStore: 'Ctrip tienda individual',
    agoda: 'Agoda',
    meituanHomestay: 'Meituan Homestay',
    tujiaHomestay: 'Tujia Homestay',
    booking: 'Booking',
    expedia: 'Expedia',
    preCancelable: 'Cancelable previamente',
    partialWriteOff: 'Cancelación parcial',
    tookEffect: 'En vigor',
    loseEffectiveness: 'Sin efecto',
    joinAHouse3: 'Unirse a habitación vinculada',
    bookingInformation: 'Información de la reserva',
    pleaseSelectARoom3: 'Seleccione una habitación',
    houseInformation: 'Información de habitaciones vinculadas',
    thereIsNoRowHouse: 'Habitaciones no asignadas',
    reasonsForChangingRooms3: 'Motivo del cambio de habitación',
    numberOfRooms7: 'Total de habitaciones',
    typeOfOperation3: 'Tipo de operación',
    exchangeAndUpgradeReport2: 'Informe de cambio y actualización',
    noDataAvailable2: 'No hay datos disponibles',
    pleaseSelectABusinessDayRange2: 'Seleccione el rango de días hábiles',
    exportReport: 'Exportar informe',
    accountName3: 'Nombre del concepto',
    aMaximumOf31DaysCanBeQueried: 'El rango de tiempo admite consultas de hasta 31 días',
    naturalDay2: 'Día natural',
    otherConsumption3: 'Otros consumos',
    aggregateConsumption3: 'Consumo total',
    aggregateConsumptionTaxIncluded: 'Consumo Total (Impuestos Incluidos)',
    materialType: 'Tipo de material',
    materialName: 'Nombre del material',
    storageTypeSell: 'Venta',
    materialCode: 'Código de material',
    materialUnit: 'Unidad de especificación',
    inStorageNum: 'Cantidad de entrada',
    outStorageNum: 'Cantidad de salida',
    selectTime: 'Seleccione la hora',
    floor: 'Piso',
    lumpSumPayment3: 'Pago total',
    ifTheRateIsGreaterThanHalfDayTheRateIsLessThanFullDay:
      'Si supera la tarifa de medio día y es inferior a la de día completo, se contabiliza como día completo',
    businessDate: 'Fecha hábil',
    calculationFormula: 'Fórmula de cálculo',
    manualRoomFeeCalculationHalfDayRoomFee05BedNightFullDayRoomFee1BedNight:
      'Cálculo manual de noches: medio día = 0.5 noche, día completo = 1 noche',
    halfDayRoomFeeTheAmountChargedIsLessThanOrEqualToHalfTheRoomRate:
      'Tarifa de medio día: el importe adicional es menor o igual a la mitad de la tarifa',
    fullDayRoomFeeTheAmountChargedIsGreaterThanOrEqualToTheRoomRateAndTheAmountExceedsTheRoomRateBy2TimesRecord2BedNightsAndSoOn:
      'Tarifa de día completo: el importe adicional es mayor o igual a la tarifa; si supera el doble, se contabilizan 2 noches, y así sucesivamente',
    rentedBedNightsExcludeFreeRoomsAndSelfUsedRoomNights:
      'Noches vendidas: excluye habitaciones gratuitas y de uso propio',
    subtotal: 'Subtotal',
    totalOccupancy3: 'Total de habitaciones',
    lettingRate: 'Tasa de ocupación',
    inResidenceDate: 'Fecha de estancia',
    bookingDate: 'Fecha de reserva',
    exposureNumber2: 'Personas expuestas',
    numberOfVisitors3: 'Número de visitantes',
    onlineChannel3: 'Canal en línea',
    reasonForDeactivation: 'Motivo de desactivación',
    downTime: 'Hora de desactivación',
    enterAMaximumOf20Characters: 'Ingrese un máximo de 20 caracteres',
    checkInInformation: 'Información de check-in',
    numberOfRooms6: 'Número de habitaciones',
    totalPrice: 'Precio total',
    paymentInformation2: 'Información de pago',
    pleaseSelectAProduct: 'Seleccione un producto',
    viewOrderDetails: 'Ver detalles del pedido',
    automaticallyJumpToOrderDetails: 'Saltar automáticamente a los detalles del pedido',
    addHoming3: 'Agregar acompañante',
    getVerificationCode: 'Obtener código de verificación',
    pleaseSelectTheNumberOfRoomsFirst: 'Seleccione primero el número de habitaciones',
    theNumberOfReservedRoomsCannotBeGreaterThanTheNumberOfAvailableRooms:
      'El número reservado no puede ser mayor que el disponible',
    pleaseEnterAmount: 'Introduzca el importe',
    makeAReservation: 'Realizar reserva',
    increaseRoomType: 'Agregar tipo de habitación',
    deleteRoomType: 'Eliminar tipo de habitación',
    store: 'Tienda',
    meituanDirectNew: 'Meituan conexión directa (nuevo)',
    outOfService: 'Fuera de servicio',
    smokeFreeOrNot: '¿Libre de humo?',
    roomOrientation: 'Orientación de la habitación',
    windowCondition: 'Condición de la ventana',
    windowed: 'Con ventana',
    windowless: 'Sin ventana',
    innerFenestra: 'Ventana interior',
    roomCharacteristics: 'Características de la habitación',
    airAndClean: 'Aire limpio',
    airViscus: 'Aire sucio',
    dendrojing: 'Estancia limpia',
    astriction: 'Estancia sucia',
    continuousStaySpecial: 'Oferta por estancia continua',
    orderEarlyAndReduceMore: 'Reserva anticipada con mayor descuento',
    discountValue: 'Descuento',
    select: 'Seleccionar',
    becameInvalid: 'Invalidado',
    dateOfOperation: 'Fecha de operación',
    promotionalAllocation: 'Configuración de promociones',
    promotionManagement: 'Gestión de promociones',
    operationContent2: 'Contenido de la operación',
    turnOnAutomaticDeferral: 'Activar ajuste automático de precio',
    productSetup: 'Configuración del producto',
    thePriceShallNotBeLessThan20YuanAndShallNotBeHigherThan99998Yuan:
      'El precio no debe ser inferior a 20 ni superior a 99998000',
    iKnow: 'Lo sé',
    dataSpecification: 'Descripción de datos',
    settings: 'Configuración',
    restrictSales: 'Ventas restringidas',
    pleaseEnterPrice: 'Introduzca el precio',
    modificationFailure: 'Error en la modificación',
    deletionFailure: 'Error en la eliminación',
    product: 'Producto',
    pleaseSelectChannel: 'Seleccione el canal',
    standardProduct: 'Producto estándar',
    bindingSuccessful: 'Vinculación exitosa',
    lobby: 'Vestíbulo',
    inventoryQuantity: 'Cantidad en inventario',
    uploadPictures: 'Subir imágenes',
    currentlyLimitedTo10Images: 'Actualmente limitado a 10 imágenes',
    pictureSizeMustBeLargerThan: 'El tamaño de la imagen debe ser mayor que',
    warn3: 'Advertencia',
    // Part 4, lines 601 to 800
    theInputContentOfTheCurrentPageDoesNotMeetTheSpecificationsPleaseCheck:
      'El contenido ingresado en la página actual no cumple con las especificaciones, por favor verifique',
    layer: 'Capa',
    untie: 'Desvincular',
    cipher5: 'Contraseña',
    pleaseEnterYourAccountNumber: 'Introduzca la cuenta',
    pleaseEnterPassword4: 'Introduzca la contraseña',
    obtainTheSmsVerificationCode: 'Obtener código de verificación SMS',
    disposition: 'Configuración',
    passwordType: 'Tipo de contraseña',
    setANewPassword: 'Establecer nueva contraseña',
    pleaseEnterYourNewPassword: 'Introduzca la nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    pleaseEnterYourPasswordAgain: 'Introduzca la contraseña nuevamente',
    electronicPriceBoard: 'Tablero electrónico de precios de habitaciones',
    operationInstruction: 'Instrucciones de operación',
    cardholder: 'Titular de la tarjeta',
    contact: 'Contacto',
    pleaseEnterTheCardholderName: 'Introduzca el nombre del titular de la tarjeta',
    cardholderNameIsRequired: 'El nombre del titular es obligatorio',
    theCardholderNameMustBe2To5CharactersLong:
      'El nombre del titular debe tener entre 2 y 5 caracteres',
    remarksRequired: 'La observación es obligatoria',
    selectCardType: 'Seleccionar tipo de tarjeta',
    windowType2: 'Tipo de ventana',
    suspensionOfSale: 'Suspensión de venta',
    enterMaterialName: 'Introducir nombre del material',
    modifyTarget: 'Modificar objetivo',
    theRecommendedTargetValueIsEstimatedBasedOnTheChangeTrendOfTheDataInTheSamePeriodLastYearAndTheActualDataOfLastMonth:
      'El valor objetivo recomendado se estima según la tendencia de cambio de los datos del mismo período del año pasado y los datos reales del mes pasado',
    dayUnit: '{day} días',
    checkInOperator: 'Operador de check-in',
    months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    week: {
      mon: 'Lunes',
      tue: 'Martes',
      wed: 'Miércoles',
      thu: 'Jueves',
      fri: 'Viernes',
      sat: 'Sábado',
      sun: 'Domingo',
    },
  },
  language: {
    zh: '中文',
    en: 'EN',
    zhHk: '繁体',
    th: 'ไทย',
    id: 'Indonesian',
    es: 'Español',
    vi: 'Tiếng Việt',
  },
  activitySign: {
    eventDate: 'Fecha del evento',
    alreadyRegistered: 'Ya inscrito',
    signUpActivity: 'Actividades disponibles para inscripción',
    noRegistrationIsAvailable: 'No hay actividades disponibles para inscripción',
    registeredActivity: 'Actividades inscritas',
    thereAreNoRegisteredActivities: 'No hay actividades inscritas',
    thereAreNoCanceledEvents: 'No hay eventos cancelados',
    signUp: 'Inscribirse',
  },
  componentsCostprint8cmprint: {
    dateOfConsumption: 'Fecha de consumo',
  },
  componentsCostprinta4template: {
    totalConsumption: 'Total de consumo',
    dateOfConsumption: 'Fecha de consumo',
    feeName: 'Nombre del gasto',
  },
  componentsCounter: {
    theGoodsAreOnlyInStock: 'Este producto solo tiene en stock',
    thereIsNotEnoughStockOfThisCommodity: 'Stock insuficiente de este producto',
  },
  componentsNowpayaccounthandle: {
    modifyTheBookSuccessfully: 'Cuenta modificada con éxito',
    bookModification: 'Modificar cuenta',
    pleaseEnterABookName: 'Introduzca el nombre de la cuenta',
    pleaseSelectTheConsumerCategory: 'Seleccione la categoría de consumo',
    newAccountSuccessfully: 'Nueva cuenta creada con éxito',
  },
  componentsRecorddetail: {
    memberInfo: 'Nombre del miembro / Número de tarjeta',
  },
  componentsRushbalance: {
    successfulWriteOff: 'Compensación exitosa',
  },
  componentsShoppinggoods: {
    onlyAvailable: 'Mostrar solo disponibles',
    commodityCategory: 'Categoría de producto',
    pleaseEnterTheProductName: 'Introduzca el nombre del producto',
    noDataIsQueried: 'No se encontraron datos',
    name3: 'Nombre',
    purchaseQuantity: 'Cantidad de compra',
    vendibility: 'Disponible para la venta',
    allGoods: 'Todos los productos',
  },
  componentsAddroomer: {
    addLabel: 'Añadir etiqueta',
    noCustomerProfile: 'Este huésped no tiene perfil de cliente',
    guestSaveFailedRetry: 'No se pudo guardar el huésped. Inténtelo de nuevo',
    changeOccupancy: 'Modificar huésped',
    increaseOccupancy: 'Agregar huésped',
    validityPeriod: 'Validez del documento',
    startDate: 'Fecha de inicio',
    addGuest: 'Agregar huésped',
    atLeastOneGuest: 'Debe mantenerse al menos un huésped',
    guest: 'Huésped',
    enterGuestName: 'Introduzca el nombre de {name}',
    enterValidPhone: 'Introduzca el número de móvil correcto de {name}',
    selectDocumentType: 'Seleccione el tipo de documento de {name}',
    enterDocumentNumber: 'Introduzca el número de documento de {name}',
  },
  componentsAnnouncement: {
    noticeBoard: 'Tablón de anuncios',
  },
  componentsIdentifyMembers: {
    memberInformation: 'Información del miembro',
    pleaseFillInTheGuestMobilePhoneNumberQuickIdentificationInformation:
      'Introduzca el número de móvil del huésped para identificar rápidamente la información',
    guestsCanUpgradeToAHigherLevelMembership:
      'Los huéspedes pueden actualizar a un nivel superior de membresía',
    l: 'L',
    unnamed: 'No verificado',
    inRealName: 'Verificado',
    points: 'Puntos',
    memberRightsAndInterests: 'Beneficios del miembro',
    patron: 'Huésped',
    unfold: 'Desplegar',
    unactivated: 'No activado',
    membershipSalesCopy: 'Texto de venta de membresía',
    bookingDiscount: 'Descuento en reservas',
    costPerformance: 'Relación costo-beneficio de la tarjeta',
    memberPoints: 'Puntos del miembro',
    lateCheckOut: 'Salida tardía',
    copywritingType: 'Tipo de texto',
    afterTheGuestAuthenticatesThemselvesInThelightStayHotelReservationMiniProgramTheyCanReceiveA18YuanFreeBirthdayGiftCouponOrParticipateInExclusiveOffers:
      'Después de que el huésped complete la verificación en el mini programa “Reserva de hoteles Qingzhu”, podrá recibir un cupón de regalo de cumpleaños o participar en ofertas exclusivas',
    afterTheGuestLogsInForTheFirstTimeInThelightStayHotelReservationMiniProgramTheyCanActivateTheirMembershipAndEnjoyExclusiveMemberBenefits:
      'Cuando el huésped inicie sesión por primera vez en el mini programa “Reserva de hoteles Qingzhu”, podrá activar la membresía y disfrutar de beneficios exclusivos',
    lightStayMemberLevelNonMember: 'Nivel de miembro Qingzhu: No miembro',
    lightStayMembershipLevel: 'Nivel de membresía Qingzhu',
  },
  componentsSellcard: {
    employeeLastWeeksCardSalesList: 'Empleados · Ranking de ventas de tarjetas de la semana pasada',
    dragLeftAndRightToViewTheTable: 'Deslice a izquierda y derecha para ver la tabla',
    hotelLastWeeksCardSalesList: 'Hotel · Ranking de ventas de tarjetas de la semana pasada',
    cardSalesRanking: 'Ranking de ventas de tarjetas',
    employee2: 'Empleado',
    numberOfCardsSold: 'Cantidad de tarjetas vendidas',
    amountOfCommission: 'Importe de comisión',
  },
  detailcomponentsOnecarddialog: {
    waitingGuestToSwipeCard: 'Esperando que el huésped pase la tarjeta',
    paymentInProcess: 'Pago en proceso',
    guestPaymentSuccess: 'Pago del huésped exitoso',
    guestPaymentFailedPleaseInitiatePaymentAgain:
      'El pago del huésped falló, inicie el cobro nuevamente',
  },
  customerPSearch: {
    singleStoreMembershipLevel: 'Nivel de membresía por tienda',
    enterYourNamePhoneNumberAndCardNumber:
      'Ingrese nombre, número de móvil y número de tarjeta para buscar',
  },
  customerPTable: {
    topUp: 'Recargar',
    gift: 'Regalar',
    viewMembers2: 'Ver miembros',
    modifyMembership2: 'Modificar membresía',
    storedValueDeduction: 'Deducción de saldo',
    integralChange2: 'Cambio de puntos',
    integralQuery2: 'Consulta de puntos',
    storedValueQuery2: 'Consulta de saldo',
    rechargeAllAccumulatedRechargeAmounts: 'Recarga: importe total acumulado',
    giftAllAccumulatedGiftAmounts: 'Regalo: importe total acumulado',
    consumptionAllAccumulatedConsumptionAmounts: 'Consumo: importe total acumulado',
    refundAllAccumulatedRefundAmounts: 'Reembolso: importe total acumulado',
    distributionSettings: 'Configuración de distribución',
  },
  componentsNightaudit: {
    theCurrentBusinessDayIs: 'El día hábil actual es',
    startTheNightTrial: 'Iniciar auditoría nocturna',
    theNightTrialIsInProgressAndCannotBeClosed:
      'La auditoría nocturna está en curso y no se puede cerrar',
    immediateFeedback: 'Retroalimentación inmediata',
    nightAuditCompleted: 'Auditoría nocturna completada',
    nightTrialInProgress: 'Auditoría nocturna en curso',
    nightTrialNewsNotice2: 'Notificación de auditoría nocturna',
    nightAuditFailedPleaseHandleAccordingToThePromptAndPerformTheNightAuditAgainIfYouEncounterAnyProblemsPleaseContactTechnicalSupport:
      'La auditoría nocturna falló, siga las indicaciones y ejecútela nuevamente. Si hay problemas, contacte con soporte técnico',
  },
  componentsNightauditGrayEnv: {
    nightTrialNewsNotice2: 'Notificación de auditoría nocturna',
    procedure: 'Proceso',
    mistake: 'Error',
    carryOut: 'Ejecutar',
    nightAuditFailureToEncounterProblemsCanBeInTheMorningAfter8OclockAsSoonAsPossibleToContactTechnicalSupportToHelpSolve:
      'Si la auditoría nocturna falla, puede contactar con soporte técnico después de las 8 a. m. lo antes posible para ayudar a resolverlo',
    whenAnErrorOccursTheNightAuditStopsPleaseConfirmItCarefully:
      'Cuando ocurre un error, la auditoría nocturna se detiene, por favor confirme cuidadosamente',
  },
  componentsOpenPageLayout: {
    backToHomePage: 'Volver a la página principal',
  },
  componentsShiftchoose: {
    pleaseSelectFlightSchedule: 'Seleccione el turno',
    hello: 'Hola',
  },
  baseBasemultipleselect: {
    thisOptionWasNotFound: 'No se encontró esta opción',
  },
  printsettingHalfprint: {
    test: 'Prueba',
    print: 'Imprimir',
    trisection: 'Tres secciones',
    printInThirds: 'Imprimir en tres secciones',
    printInHalf: 'Imprimir en dos secciones',
  },
  printsettingPrint: {
    print: 'Imprimir',
  },
  printsettingSmallprint: {
    feeName: 'Nombre del gasto',
    totalConsumption: 'Total de consumo',
    // Part 5, lines 801 to 1000
  },
  hardwareIdcardbtn: {
    readIdentityCard: 'Leer documento de identidad',
  },
  hardwareReaddoorcard: {
    pleasePlaceYourKeyCardOnTheCardReader: 'Coloque la tarjeta de la habitación sobre el lector',
    effectiveTime: 'Hora de inicio de vigencia',
    failureTime: 'Hora de expiración',
    readCard: 'Leer tarjeta',
    failedToObtainTheLockInformationProcedure: 'Error al obtener la información de la cerradura',
    thisCardIsNotAGuestCardPleaseReBusinessCardPrinting:
      'Esta tarjeta no es una tarjeta de huésped, vuelva a crear la tarjeta',
    wheatDoorLockPlugInReadCard: 'Lectura de tarjeta del plugin de cerradura Wheat',
    the: 'de',
    wheatDoorLockPlugInCancellationCard: 'Cancelación de tarjeta del plugin de cerradura Wheat',
    cardReadingFailure: 'Fallo en la lectura de la tarjeta',
  },
  componentsFeedback: {
    selectAttachment: 'Seleccionar adjunto',
    viewFeedbackLog: 'Ver registros de feedback',
    commitFailure: 'Error al enviar',
    problemFeedback3: 'Feedback de problemas',
    pleaseEnterTheContactName4: 'Introduzca el nombre del contacto',
    pleaseEnterAContactNumber3: 'Introduzca el número de contacto',
    uploadAttachment2: 'Subir adjunto',
    pleaseEnterADetailedDescriptionOfTheProblem2:
      'Introduzca una descripción detallada del problema',
    theUploadedFilesCannotExceed: 'Los archivos cargados no pueden exceder',
    aMaximumOfFiveFilesCanBeUploaded2: 'Se pueden subir como máximo 5 archivos',
    aMaximumOfFiveFilesCanBeUploadedTheSizeOfEachFileCannotExceed20Mb:
      'Se pueden subir como máximo 5 archivos, el tamaño de cada archivo no debe exceder 20 MB, formatos compatibles',
    pleaseExplainTheProblemAndEnterTheQqNumberToFacilitateContact:
      'Explique el problema e introduzca el número de QQ para facilitar el contacto',
  },
  componentsFeedjump: {
    lightWinTreasureSmallProgram: 'Mini programa Qingyingbao',
    scanCodeUsingASmallProgram: 'Escanear código para usar el mini programa',
    realTimeControlOfRoomStatus: 'Control en tiempo real del estado de las habitaciones',
    onlineOneClickPriceAdjustment: 'Ajuste de precios en línea con un clic',
    memberDevelopmentTools: 'Herramientas de desarrollo de miembros',
    moreFeaturesComingOnline: 'Más funciones en línea próximamente',
    hotelOperationCarefulAssistant: 'Operación hotelera · Asistente cuidadoso',
  },
  componentsGethelp: {
    getHelp: 'Obtener ayuda',
  },
  componentsGoappshop: {
    applicationMarket: 'Mercado de aplicaciones',
  },
  componentsJointrain: {
    attendTraining: 'Participar en capacitación',
  },
  componentsLeftcontent: {
    hotelOperationsManager: 'Gerente de operaciones del hotel',
    cityOperationsManager: 'Gerente de operaciones de la ciudad',
    customerServiceHotline: 'Línea de atención al cliente',
  },
  componentsTrain: {
    trainingCoursesAreInFullSwing: 'Los cursos de formación están en pleno desarrollo',
    getDetailedTrainingNoticesAndMaterials: 'Obtener avisos y materiales detallados de formación',
    followThelightStaySystemServicePublicAccount:
      'Siga la cuenta oficial “Servicio del sistema Qingzhu”',
    basicCourseIntroductorySeries: 'Curso básico: serie introductoria',
    mondayAndWednesday1430Start: 'Todos los lunes y miércoles a las 14:30',
    advancedCourseComplexScenesCommonQuestionsRecentNewFeatures:
      'Curso avanzado: escenarios complejos + preguntas frecuentes + nuevas funciones recientes',
    friday1430Start: 'Todos los viernes a las 14:30',
  },
  merchantPCtxTab: {
    oldFinancialReconciliationSystem: 'Sistema antiguo de conciliación financiera',
    lightCommissionSubsidyHasBeenMovedToMemberIncentivePleaseGoToMemberIncentiveToConfirmTheBill:
      'El subsidio de comisión Qingzhu se ha trasladado a Incentivos de membresía, vaya allí para confirmar la factura',
  },
  merchantPCtxTab1: {
    oldFinancialReconciliationSystem: 'Sistema antiguo de conciliación financiera',
    lightCommissionSubsidyHasBeenMovedToMemberIncentivePleaseGoToMemberIncentiveToConfirmTheBill:
      'El subsidio de comisión Qingzhu se ha trasladado a Incentivos de membresía, vaya allí para confirmar la factura',
  },
  merchantPSearchqu: {
    enterHotelName: 'Introduzca el nombre del hotel',
  },
  payIndex: {
    toBePaid: 'Pendiente de pago',
    pleaseScanQrCodeToCompletePayment: 'Escanee el código QR para completar el pago',
    canBeClosedAfter: 'Se puede cerrar después de',
    paymentSuccess: 'Pago exitoso',
    automaticShutdownInSeconds: 'Cierre automático en segundos',
    automaticPageRefresh: 'Actualización automática de la página',
    duringThePayment: 'Pago en proceso',
    paymentAnomaly: 'Anomalía en el pago',
    ifThePaymentIsAbnormalContactTechnicalSupport: 'Pago anómalo, contacte con soporte técnico',
    paymentFailure: 'Fallo en el pago',
    payOff: 'Pago cerrado',
    waitForTheUserToScanTheCode: 'Esperando que el usuario escanee el código',
    currentStatusOfLehuiPayment: 'Estado actual del pago Lehui',
    theGunScannedTheCodeSuccessfully: 'El lector escaneó el código con éxito',
    theUserHasPaidSuccessfully: 'El usuario ha pagado con éxito',
    ifTheUserDoesNotPayItCanBeReRecordedInTheFinancePage:
      'Si el usuario no paga, se puede volver a registrar en la página financiera',
  },
  sellCalctable: {
    maximumPromotion: 'Promoción máxima',
    nonMemberSellingPricebrestimatedSettlementPrice:
      'Precio de venta no miembro<br>/Precio estimado de liquidación',
    ordinaryMemberSellingPricebrestimatedSettlementPrice:
      'Precio de venta miembro común<br>/Precio estimado de liquidación',
    goldMemberSellingPricebrestimatedSettlementPrice:
      'Precio de venta miembro oro<br>/Precio estimado de liquidación',
    platinumMemberSellingPricebrestimatedSettlementPrice:
      'Precio de venta miembro platino<br>/Precio estimado de liquidación',
    diamondMemberSellingPricebrestimatedSettlementPrice:
      'Precio de venta miembro diamante<br>/Precio estimado de liquidación',
  },
  sellPTableTdNew: {
    noData: 'Sin datos',
  },
  sellPricecalc: {
    channelSellingPriceCalculator: 'Calculadora de precio de venta por canal',
    selectRoomType: 'Seleccionar tipo de habitación',
    pleaseSelectRoomType: 'Seleccione el tipo de habitación',
    selectProduct: 'Seleccionar producto',
    pleaseSelectAProductName: 'Seleccione el nombre del producto',
    selectSaleDate: 'Seleccionar fecha de venta',
    distributionChannel: 'Canal de distribución',
    pleaseSelectTheDistributionChannelNamenotRequired:
      'Seleccione el nombre del canal de distribución (opcional)',
    canNotExceed: 'No puede exceder',
    pleaseSelectASaleDate: 'Seleccione la fecha de venta',
    figure: 'Número',
  },
  filtersIndex: {
    all: 'Todo',
    sinceThe: 'Desde',
    free: 'Gratis',
    group: 'Grupo',
    association: 'Asociación',
    theClock: 'Por horas',
    long: 'Largo',
    inapplicability: 'No aplicable',
    haveProcessed: 'Procesado',
    notProcessed: 'No procesado',
    averageSalesRate: 'Tarifa media de venta',
    consumptionNight: 'Noches consumidas',
    averageHousePriceOfConsumption: 'Precio medio de habitación consumida',
    onlinePermeability: 'Tasa de penetración en línea',
    cancelNight: 'Noches canceladas',
    rejectionNight: 'Noches rechazadas',
    channelProvision: 'Proporcionado por el canal',
    theHotelProvides: 'Proporcionado por el hotel',
  },
  jsonBookertypeoptions: {
    singleStoreMember: 'Miembro de tienda individual',
    lightLivingMember: 'Miembro Qingzhu',
  },
  layoutIndex: {
    collapseMenuBar: 'Contraer barra de menú',
  },
  componentsNavbar: {
    shiftManagement: 'Gestión de turnos',
    helpCenter: 'Centro de ayuda',
    logout: 'Cerrar sesión',
    reportTitle: 'Informe estadístico de resumen de turnos',
    headers: {
      income: 'Ingresos',
      expend: 'Gastos',
      total: 'Importe total',
    },
  },
  componentsSidemessage: {
    orderNotice: 'Notificación de pedidos',
    orderMessageReceivedNotification: 'Se ha recibido una notificación de pedido',
    youDoNotHaveOrderManagementPermission: 'Aún no tiene permisos de gestión de pedidos',
    ignore: 'Ignorar',
    order: 'Mensaje de pedido',
    noData: 'No hay mensajes nuevos',
    system: 'Mensaje del sistema',
    settlement: 'Mensaje de liquidación',
    dynamic: 'Mensaje dinámico',
    serviceManagement: 'Gestión de órdenes de servicio',
    roomService: 'Servicio de habitaciones',
    itemBorrow: 'Préstamo de artículos',
    extendStay: 'Servicio de extensión de estancia',
    manualEntry: 'Registro manual',
    confirmOrder: 'Confirmar pedido',
    viewOrder: 'Ver pedido',
    youDoNotHaveAccessToEbkOrderManagement: 'Aún no tiene permisos de gestión de pedidos EBK',
    youReceive: 'Usted ha recibido',
    aNewMessage: 'mensajes nuevos',
    have: 'Hay',
    orderMessage: 'mensajes de pedido',
    aNewSystemMessage: 'mensajes nuevos del sistema',
    aNewSettlementMessage: 'mensajes nuevos de liquidación',
  },
  componentsSoundnotice: {
    playOut: 'Reproducción finalizada',
    theVoicePromptsThatAMessageIsReceived: 'Aviso de voz de mensaje recibido',
  },
  nightcheckNightStart: {
    nightTrialSequence: 'Secuencia de auditoría nocturna',
    nightAuditInstructions2: 'Instrucciones de auditoría nocturna',
  },
  nightcheckNightTip: {
    theHotelHasNotBeenAuditedAtNightInOrderToAvoidAffectingTheHotelsRevenueDataPleaseStartTheNightAuditAsSoonAsPossible:
      'El hotel aún no ha realizado la auditoría nocturna, para evitar afectar los datos de ingresos, iníciela lo antes posible',
    nightAuditInstructions2: 'Instrucciones de auditoría nocturna',
    beforeTheNightAuditPleaseBeSureToCheckWhetherTheHotelsAccountingDataIsCorrectInAdvanceToAvoidAffectingTheHotelsRevenue:
      'Antes de la auditoría nocturna, asegúrese de verificar previamente que los datos contables del hotel sean correctos',
    pleaseConfirmThatAllCheckInAndCheckOutOrdersForTheCurrentBusinessDayHaveBeenProcessed:
      'Confirme que todos los pedidos de check-in y check-out del día hábil actual hayan sido procesados',
    youHaveSetUpANightAuditToAutomaticallyCancelTheStoreOrdersThatHaveNotArrived:
      'Ha configurado la auditoría nocturna para cancelar automáticamente los pedidos no llegados',
    preArrivalAutoCheckIn: 'Ha configurado el check-in automático para pedidos de llegada prevista durante la auditoría nocturna',
    preArrivalAutoNoshow: 'Ha configurado el marcado automático de no-show para pedidos de llegada prevista durante la auditoría nocturna',
    preDepartureAutoCheckOut: 'Ha configurado el check-out automático para pedidos de salida prevista durante la auditoría nocturna',
    preDepartureAutoExtendStay: 'Ha configurado la extensión automática de estancia para pedidos de salida prevista durante la auditoría nocturna',
    // Part 6, lines 1001 to 1200
    theEarliestTimeForManualNightAuditIs:
      'La hora más temprana para la auditoría nocturna manual es',
    nightAuditProcess: 'Proceso de auditoría nocturna',
    hotelBusinessDaysAreNowGreaterThanNaturalDays:
      'El día hábil del hotel ya es mayor que el día natural',
    nightAuditReminder: 'Recordatorio de auditoría nocturna',
    hotelBusinessDay: 'Día hábil del hotel',
    currentNaturalDay: 'Día natural actual',
    viewLogs: 'Ver registros',
    theNightTrialWasCompleted: 'Auditoría nocturna completada',
    nightAuditStartTimeCanNotBeEarlierThan21OclockCanNotPerformNightAuditOperationOh:
      'La hora de inicio de la auditoría nocturna no puede ser anterior a las 21:00, no se puede ejecutar la operación',
    thereIsAnOngoingNightTrialPleaseDoNotRepeatTheProcedure:
      'Hay una auditoría nocturna en curso, no repita la operación',
  },
  nightcheckNightTipGrayEnv: {
    theCurrentBusinessDayOfTheHotelIsLongerThanTheNaturalDayOrTheNightAuditCanNotStartEarlierThan21OclockCanNotPerformTheNightAuditOperation:
      'El día hábil del hotel es mayor que el día natural, o la auditoría nocturna no puede comenzar antes de las 21:00, no se puede ejecutar la operación',
    theNightTrialHasNotBeenCompletedPleaseExecuteTheNightTrialAsSoonAsPossible:
      'La auditoría nocturna aún no se ha completado, ejecútela lo antes posible',
  },
  globalMethodsmixin: {
    hotelChangeAlert: 'Alerta de cambio de hotel',
    theHotelIsCurrentlyFrom: 'El hotel actual ha cambiado de',
    switchTo: 'Cambiar a',
  },
  regularIndex: {
    pleaseEnterTheCorrectEmailAddress: 'Introduzca una dirección de correo electrónico correcta',
    pleaseEnterTheCorrectIdNumber: 'Introduzca el número de identificación correcto',
    pleaseEnterTheCorrectIdNumber2: 'Introduzca el número de documento correcto',
  },
  sidebarLogo: {
    helpCenter2: 'Centro de ayuda',
  },
  modulesMember: {
    drench: 'Qingzhu',
  },
  modulesUser: {
    client: 'Cliente',
    membershipManagement: 'Gestión de membresías',
    singleStoreMemberManagement: 'Gestión de miembros de tienda individual',
    storeValueManagement: 'Gestión de saldo de tienda individual',
    singleStorePointsSetting: 'Configuración de puntos de tienda individual',
    storeValueReport: 'Informe de saldo de tienda individual',
    failedToObtainOperationInformationProcedure: 'Error al obtener la información operativa',
    billReconciliation: 'Conciliación de facturas',
    paymentRecord: 'Registro de pagos',
    expenseStatement: 'Detalle de gastos',
  },
  utilsAddroute: {
    initializesTheReceivableFinancialMenu: 'Inicializar el menú financiero de cuentas por cobrar',
  },
  utilsDoorcard: {
    initializationFailure: 'Error de inicialización',
    noKeyCardReaderPlugInFound: 'No se encontró el plugin del lector de tarjetas',
    cardReadingError: 'Error de lectura de tarjeta',
    plugIn: 'Plugin',
    cardReadingResult: 'Resultado de lectura de tarjeta',
    cardReadingFailure: 'Fallo en la lectura de la tarjeta',
    businessCardWriteData: 'Escritura de datos de la tarjeta',
    businessCardPrintingResult: 'Resultado de creación de tarjeta',
    businessCardFailure: 'Fallo en la creación de tarjeta',
    logoutStatusCode: 'Código de estado de cancelación',
    logoutFailure: 'Error de cancelación',
  },
  utilsDoorcardmaitian: {
    noKeyCardReaderPlugInFound: 'No se encontró el plugin del lector de tarjetas',
    cancelTheCardSuccessfully: 'Tarjeta cancelada con éxito',
    readTheCardSuccessfully: 'Tarjeta leída con éxito',
  },
  utilsEnum: {
    roomInNeedOfRepair: 'La habitación necesita reparación',
    guestRequest: 'Solicitud del huésped',
    hotelRowRoomDemand: 'Demanda de asignación de habitaciones del hotel',
    inProcess: 'En proceso',
    alreadyEnded: 'Finalizado',
    storeOrderPreArrivalHasNotBeenChecked: 'Comprobación de no llegada previa del pedido de tienda',
    leaveTheRoomForInspectionToday: 'Inspección de habitaciones con salida prevista hoy',
    generateRoomChargesInTheRoom: 'Generar cargos de habitación para habitaciones ocupadas',
    cleanRoomToDirtyRoom: 'De habitación limpia a sucia',
    switchingDay: 'Cambio de día hábil',
    preArrivalNoShowRoomListPending: 'No llegada previa, habitación pendiente de check-in',
    preSeparationIsNotSeparated: 'Salida prevista no realizada',
    allRoomChargesAreGeneratedAndRecordedInTheAccount:
      'Todos los cargos de habitaciones ocupadas generados y registrados',
    roomChange: 'Cambio de estado de habitación',
    generateCureReport: 'Generar informe consolidado',
    shopHourRoom: 'Habitación por horas en tienda',
    onlineHourRoom: 'Habitación por horas en línea',
    presaleFullDayRoomProduct: 'Producto de preventa de habitación de día completo',
    presaleClockRoomProduct: 'Producto de preventa de habitación por horas',
  },
  utilsFreego: {
    theCardReaderIsNotConnectedToTheComputer:
      'El lector de tarjetas no está conectado al ordenador',
    checkValueError: 'Error de valor de verificación',
    passwordError: 'Contraseña incorrecta',
    readCard: 'Leer tarjeta',
    cardReaderCommunicationIsNormal: 'La comunicación del lector de tarjetas es normal',
    businessCardPrintingSoftwareIsNotOpened: 'El software de creación de tarjetas no está abierto',
    theReaderIsNotConnectedOrTheSoftwareIsNotOpen:
      'El lector no está conectado o el software no está abierto',
    sorryYourBrowserDoesNotSupportCardReaderPleaseUseChrome:
      'Lo sentimos, su navegador no admite el lector de tarjetas, utilice el navegador Chrome',
  },
  utilsIdcard: {
    idCardReaderIsConnectedToScanYourIdCardConnectTheIdCardScannerToYourComputerAndRefreshThePage:
      'El lector de documentos está conectado. Para escanear documentos, conecte el escáner al ordenador y actualice la página',
    toScanDocumentsInstallTheIdCardReaderControl:
      'Para escanear documentos, instale el controlador del lector de documentos',
    abnormalReadingIdCardPleaseRefreshAndTryAgain:
      'Lectura anómala del documento, actualice e inténtelo de nuevo',
    noIdInformationIsReadPleaseCheckWhetherTheIdCardIsPlacedOrPlacedInTheCorrectPosition:
      'No se leyó información del documento, verifique si está colocado correctamente',
  },
  utilsIndex: {
    justNow: 'Justo ahora',
    aMinuteAgo: 'Hace un minuto',
    hoursAgo: 'Hace horas',
    month: 'Mes',
    when: 'Hora',
    connectionSuccessful: 'Conexión exitosa',
    theGlobalConnectionIsClosed: 'La conexión global está cerrada',
    yourBrowserDoesNotSupportIt: 'Su navegador no lo admite',
  },
  utilsLinktopage: {
    contactTheAdministratorToEnableIt: 'Contacte al administrador para habilitarlo',
    noCorrespondingLedgerFound: 'No se encontró el libro contable correspondiente',
    accountReceivable: 'Cuentas por cobrar',
    administrativeAuthority: 'Permisos administrativos',
  },
  utilsRequest: {
    doNotRepeatRequests: 'No repita solicitudes',
    noFlightFoundPleaseSelectAgain: 'No se encontraron turnos, seleccione nuevamente',
    systemErrorPleaseContactTechnicalSupport: 'Error del sistema, contacte con soporte técnico',
    networkException: 'Excepción de red',
    requestTimedOutPleaseRefreshThePage: 'La solicitud expiró, actualice la página',
    requestTimeout: 'Tiempo de espera de la solicitud agotado',
    requestFailed: 'Solicitud fallida',
  },
  utilsSharestorage: {
    putInTheInitialMarker: 'Colocar marca inicial',
  },
  appdetailIndex: {
    specification: 'Especificación',
    contactBusinessManager: 'Contactar al gerente comercial',
    buyNow: 'Comprar ahora',
    applicationIntroduction: 'Introducción de la aplicación',
    workingHours: 'Horario laboral',
    pleaseSelectProductSpecifications: 'Seleccione las especificaciones del producto',
  },
  applistIndex: {
    fullApplication: 'Todas las aplicaciones',
    haveOpened: 'Habilitadas',
    haveNotOpened: 'No habilitadas',
    inService: 'En servicio',
    contactBusinessManager: 'Contactar al gerente comercial',
    workingHours: 'Horario laboral',
    openImmediately: 'Abrir inmediatamente',
    immediateRenewal: 'Renovar ahora',
    expiredDays: 'Ha expirado hace {days} días',
    daysLeftToExpire: 'Quedan {days} días para expirar',
  },
  createorderIndex: {
    goToPay: 'Ir a pagar',
    remaining: 'Restante',
    orderProduct2: 'Producto pedido',
    purchaser2: 'Comprador',
    specification: 'Especificación',
    successfulCustomsOrder2: 'Cierre de pedido exitoso',
  },
  createorderPay: {
    amountPaid: 'Importe pagado',
    paymentCountdown: 'Cuenta regresiva de pago',
    qrCodeHasExpired: 'El código QR ha expirado',
    updateNow: 'Actualizar ahora',
    payment3: 'Pagar',
    scanQRCode: 'Use WeChat / Alipay para escanear el código QR y pagar',
  },
  orderlistIndex: {
    orderDate: 'Fecha de pedido',
    product: 'Producto',
    toBePaid: 'Pendiente de pago',
    paymentSuccess: 'Pago exitoso',
    paymentFailure: 'Pago fallido',
    refunded: 'Reembolsado',
    partialRefund: 'Reembolso parcial',
    goToPay: 'Ir a pagar',
    orderTime: 'Hora del pedido',
    orderProduct2: 'Producto pedido',
    orderSpecification: 'Especificación del pedido',
    refundAmount: 'Importe de reembolso',
    orderEffectiveTime: 'Hora de vigencia del pedido',
    purchaser2: 'Comprador',
    orderOperation: 'Operación del pedido',
    successfulCustomsOrder2: 'Cierre de pedido exitoso',
  },
  commentChannelComment: {
    modifyReply: 'Modificar respuesta',
    setAsTemplate: 'Establecer como plantilla',
    selectRecommendedTemplate: 'Seleccionar plantilla recomendada',
    inputReplyContentNoMoreThan10WordsAndNoMoreThan500Words:
      'Ingrese el contenido de la respuesta, entre 10 y 500 caracteres',
    theMaximumResponseTextIs500Characters:
      'El texto de respuesta permite un máximo de 500 caracteres',
    areYouSureYouWantToDeleteReplies: '¿Está seguro de que desea eliminar la respuesta?',
  },
  commentCommentTempManage: {
    newTemplate: 'Nueva plantilla',
    goodReputation: 'Buena reseña',
    // Part 7, lines 1201 to 1400
    delete2: 'Eliminar',
    templateName: 'Nombre de la plantilla',
    replyClassification: 'Clasificación de respuesta',
    replyContent2: 'Contenido de la respuesta',
    pleaseEnterAtLeast10Characters: 'Introduzca al menos 10 caracteres',
    keyword: 'Palabra clave',
    pleaseEnterTheKeywordsThatYouWantToMatchTheCommentsSeparatedByCommas:
      'Introduzca las palabras clave que desea hacer coincidir con los comentarios, separadas por comas',
    pleaseEnterATemplateName: 'Introduzca el nombre de la plantilla',
    theValueCanContainNoMoreThan15Characters: 'La longitud no puede exceder 15 caracteres',
    pleaseSelectAReplyCategory: 'Seleccione la categoría de respuesta',
    pleaseEnterTheReplyContent: 'Introduzca el contenido de la respuesta',
    '10To500CharactersInLength': 'Longitud entre 10 y 500 caracteres',
    theValueContainsAMaximumOf50Characters: 'La longitud no puede exceder 50 caracteres',
    definitiveDeletion: 'Confirmar eliminación',
    deletingATemplateSucceeded: 'Plantilla eliminada con éxito',
    creatingATemplateSucceeded: 'Plantilla creada con éxito',
  },
  commentComment: {
    reasonForNotPassing: 'Motivo de no aprobación',
    setAsTemplate: 'Establecer como plantilla',
    replyAgain: 'Responder nuevamente',
    reappeal: 'Apelar nuevamente',
    inComplaint: 'En apelación',
    typeOfAppeal: 'Tipo de apelación',
    statementOfAppeal: 'Descripción de la apelación',
    selectRecommendedTemplate: 'Seleccionar plantilla recomendada',
    inputTheReplyContentTheNumberOfWordsMoreThan10And300Words:
      'Introduzca el contenido de la respuesta, entre 10 y 300 caracteres',
    theMaximumResponseTextIs500Characters:
      'El texto de respuesta permite un máximo de 500 caracteres',
    areYouSureYouWantToDeleteReplies: '¿Está seguro de que desea eliminar la respuesta?',
  },
  commentComplain: {
    onceYourComplaintHasBeenReviewedTheCommentWillBeAutomaticallyDeleted:
      'Una vez que su apelación sea revisada, el sistema eliminará automáticamente el comentario',
    youCanUploadUpToFivePictures: 'Se pueden subir hasta cinco imágenes',
    launchAComplaint: 'Iniciar apelación',
    typeOfAppeal: 'Tipo de apelación',
    statementOfAppeal: 'Descripción de la apelación',
    uploadCredentials: 'Subir comprobantes',
    pleaseFillInTheContact: 'Por favor, complete el contacto',
    pleaseEnterTheCorrectName: 'Introduzca el nombre correcto',
    pleaseSelectTheAppealType: 'Seleccione el tipo de apelación',
    theCauseOfTheComplaintMustBeAtLeast10Words:
      'El motivo de la apelación debe tener al menos 10 caracteres',
    theMaximumCauseOfAppealIs300Words:
      'El motivo de la apelación permite un máximo de 300 caracteres',
    underAppeal: 'Apelación en proceso',
    addAppealSuccess: 'Apelación añadida con éxito',
  },
  commentIndex: {
    totalEvaluation: 'Todas las evaluaciones',
    waitForReply: 'Pendiente de respuesta',
    appealed: 'Apelado',
    allRoomTypes: 'Todos los tipos de habitación',
    noReplyYet: 'Sin respuesta',
    toBeReviewed: 'Pendiente de revisión',
    notPass: 'No aprobado',
    alreadyPassed: 'Aprobado',
  },
  commentMain: {
    deleteReplySucceeded: 'Respuesta eliminada con éxito',
    modifiedReplySucceeded: 'Respuesta modificada con éxito',
  },
  commentPreview: {
    viewPicture: 'Ver imagen',
  },
  commentReplyList: {
    replyDate: 'Fecha de respuesta',
    commentChannel: 'Canal de comentarios',
    review2: 'Comentario',
    replyContent2: 'Contenido de la respuesta',
    commentReply: 'Respuesta al comentario',
    modifyReply: 'Modificar respuesta',
    deleteReply: 'Eliminar respuesta',
    meituanReview: 'Comentario Meituan',
    ctripReview: 'Comentario Ctrip',
    whereToComment: 'Comentario Qunar',
    sameTripReview: 'Comentario Tongcheng Travel',
    dianpingReviews: 'Comentario Dianping',
    flyingPigReview: 'Comentario Fliggy',
    parallelComment: 'Comentario Tongcheng',
  },
  commentScore: {
    renewal: 'Actualizar',
    guestImpression: 'Impresión del huésped',
    overallGuestRating: 'Calificación general del huésped',
  },
  complainDetail: {
    issueDetails: 'Detalles del problema',
    processingDetails: 'Detalles del procesamiento',
    serviceProblem: 'Problema de servicio',
    healthProblem: 'Problema de higiene',
    processor: 'Procesador',
    processingTime: 'Hora de procesamiento',
    communicationSituation: 'Situación de comunicación',
  },
  complainHandle: {
    successfulProcessing: 'Procesamiento exitoso',
    problemHandling: 'Gestión del problema',
    roomInformation: 'Información de la habitación',
    guestInformation: 'Información del huésped',
    communicationSituation: 'Situación de comunicación',
    enterAMaximumOf300Characters: 'Ingrese un máximo de 300 caracteres',
    pleaseEnterTheProcessingResult: 'Introduzca el resultado del procesamiento',
  },
  complainIndex: {
    submissionDate: 'Fecha de envío',
    processed: 'Procesado',
    submissionTime: 'Hora de envío',
    feedbackProblem: 'Problema reportado',
    untreated: 'No procesado',
    viewTheResults: 'Ver resultados',
  },
  ebkComment: {
    inputTheReplyContentTheNumberOfWordsMoreThan10And300Words:
      'Introduzca el contenido de la respuesta, entre 10 y 300 caracteres',
    theMaximumResponseTextIs300Characters:
      'El texto de respuesta permite un máximo de 300 caracteres',
    modifiedReplySucceeded: 'Respuesta modificada con éxito',
  },
  ebkGrade: {
    guestImpression: 'Impresión del huésped',
  },
  ebkIndex: {
    totalEvaluation: 'Todas las evaluaciones',
    waitForReply: 'Pendiente de respuesta',
  },
  customerCompany: {
    new: 'Nuevo',
    whetherToAllowHangingAccounts2: '¿Permitir cuentas a crédito?',
    loginListHidesRates: 'Ocultar tarifa en la lista de inicio de sesión',
    confirmAction: '¿Confirmar {action} el cliente corporativo “{name}”?',
  },
  customerDialog: {
    whetherToAllowHangingAccounts2: '¿Permitir cuentas a crédito?',
    theRegistrationFormHidesTheRoomRate: 'Ocultar tarifa en el formulario de registro',
    addACorporateClient: 'Agregar cliente corporativo',
    changeCorporateAccount: 'Modificar cliente corporativo',
    companyInformation: 'Información de la empresa',
    forShort: 'Abreviatura',
    pleaseEnterCompanyAbbreviation: 'Introduzca la abreviatura de la empresa',
    code: 'Código',
    pleaseEnterTheCode: 'Introduzca el código',
    legalPerson: 'Representante legal',
    pleaseEnterTheLegalPersonName: 'Introduzca el nombre del representante legal',
    fax: 'Fax',
    pleaseEnterTheFaxNumber: 'Introduzca el número de fax',
    city: 'Ciudad',
    postcode: 'Código postal',
    pleaseEnterPostalCode: 'Introduzca el código postal',
    pleaseEnterDiscountRatio: 'Introduzca el porcentaje de descuento',
    enterAMaximumOf100Characters: 'Ingrese un máximo de 100 caracteres',
    contactInformation: 'Información de contacto',
    pleaseEnterTheContactNumber: 'Introduzca el número de contacto',
    pleaseEnterEmail: 'Introduzca el correo electrónico',
    setUp: 'Configuración de crédito',
    pleaseEnterYourAccountName: 'Introduzca el nombre de la cuenta',
    accountType: 'Tipo de cuenta',
    maximumAmount: 'Límite máximo',
    pleaseEnterDiscount: 'Introduzca el descuento',
    pleaseEnterAnIntegerBetween0And100: 'Introduzca un número entero entre 0 y 100',
    pleaseEnterTheCorrect11DigitMobileNumber:
      'Introduzca el número de móvil correcto de 11 dígitos',
    pleaseEnterName: 'Introduzca el nombre',
    pleaseEnterTheContactName3: 'Introduzca el nombre del contacto',
    creditAccount: 'Cuenta de crédito',
    theCreditLimitCannotBeExceeded: 'El límite de crédito no puede exceder',
    enterRange: 'Introduzca un número entre 1 y 365',
  },
  customerIndex: {
    protocolUnitToBeDeveloped: 'Unidad de convenio, en desarrollo',
  },
  heavenlyEyeCallThePolice: {
    alarmEvent: 'Evento de alarma',
    shootingTime: 'Hora de captura',
    theFollowingGuestsHaveNotBeenAddedToTheWhiteListSelectTheGuestsThatMatchThePhoto:
      'Los siguientes huéspedes aún no se han añadido a la lista blanca, seleccione el huésped que coincida con la foto',
    stranger: 'Desconocido',
    whiteAdded: 'Añadido a la lista blanca',
    ignored: 'Ignorado',
    whitelist: 'Añadir a la lista blanca',
    environmentalPhotograph: 'Foto del entorno',
    facePhoto: 'Foto facial',
    pleaseSelectUser: 'Seleccione un usuario',
  },
  heavenlyEyeWhiteList: {
    personnelType: 'Tipo de personal',
    addStaff: 'Agregar empleado',
    pleaseEnterTheRoomNumber: 'Introduzca el número de habitación',
    employee2: 'Empleado',
    dweller: 'Huésped',
    avatar: 'Avatar',
    photograph: 'Fotografía',
    pleaseSelectEnterName: 'Seleccione o introduzca el nombre',
    pleaseCompleteTheFormBeforeSubmitting: 'Complete el formulario antes de enviarlo',
    inputLabelDuplication: 'Etiqueta duplicada',
    pleaseEnterTheLabelContent: 'Introduzca el contenido de la etiqueta',
    doNotEnterLabelsInMoreThan10Words: 'No introduzca etiquetas de más de 10 palabras',
    whetherToDeleteTheWhitelist: '¿Confirmar la eliminación de este empleado de la lista blanca?',
    uploadImageFormat: 'Las imágenes cargadas solo pueden ser en formato JPG o PNG',
  },
  hicList: {
    dateOfPresentation: 'Fecha de presentación',
    // Part 8, lines 1401 to 1600
    dataExport: 'Exportación de datos',
    bookingChannel: 'Canal de reserva',
    bodyTemperature: 'Temperatura corporal',
    healthStatus: 'Estado de salud',
    theHealthInformationCollectionReportIsSuccessfullyExportedProcedure:
      'El informe de recopilación de información de salud se exportó correctamente',
    failedToExportTheHealthInformationCollectionReportProcedure:
      'Error al exportar el informe de recopilación de información de salud',
  },
  hicQrCode: {
    downloadPicture: 'Descargar imagen',
  },
  marketActivity: {
    couponType: 'Tipo de cupón',
    couponName: 'Nombre del cupón',
    beOffline: 'Fuera de línea',
    terminated: 'Terminado',
    full: 'Completo',
    reduction: 'Descuento',
    fromTheDateOfReceipt: 'Desde la fecha de recepción del cupón',
    withinDays: 'Días de validez',
    thisParameterIsValidWithinAFixedPeriod: 'Válido dentro de un período fijo',
    restrictedRoomNight: 'Noches de habitación restringidas',
    unlimited: 'Ilimitado',
    oneNight: 'Una noche',
    discountType: 'Tipo de descuento',
    validForTimePeriod: 'Válido durante el período',
    instructionsForUse: 'Instrucciones de uso',
    selectionOfParticipatingGoods: 'Seleccionar productos participantes',
    allGoods: 'Todos los productos',
    platform: 'Plataforma',
    theNameOfTheCouponWillBeDisplayedToTheUserPleaseFillItInCarefully:
      'El nombre del cupón se mostrará al usuario, complételo cuidadosamente',
    denomination: 'Valor nominal',
    fillInTheCouponAmountdiscountAmount: 'Complete el importe del cupón (importe del descuento)',
    pleaseSelectTheYearMonthAndDay2: 'Seleccione año, mes y día',
    instructionsWillBeDisplayedToTheUserPleaseFillInCarefully:
      'Las instrucciones se mostrarán al usuario, complételas cuidadosamente',
    viewActivity: 'Ver actividad',
    maxOut: 'Descuento por umbral',
    availableForBooking1Room1NightOnly: 'Solo válido para reservar 1 habitación por 1 noche',
    events: 'Actividades',
    orderNeedsToBeFull: 'El pedido debe alcanzar el umbral',
    issued: 'Emitido',
    haveBeenUsed: 'Utilizado',
    expired2: 'Vencido',
    editCoupon: 'Editar cupón',
    addCoupon: 'Agregar cupón',
    pleaseSelectTheOfferType: 'Seleccione el tipo de oferta',
    pleaseEnterExpiryDate2: 'Introduzca la vigencia',
    pleaseSelectExpirationDate: 'Seleccione la vigencia',
    pleaseEnterTheCouponName2: 'Introduzca el nombre del cupón',
    amountCanOnlyBeEnteredInPositiveIntegersPleaseReEnter:
      'El importe solo puede ser un entero positivo, vuelva a introducirlo',
    successfulActivation: 'Activación exitosa',
    deactivated: 'Activación cancelada',
    pleaseConfirmWhetherYouWantToTerminate: 'Confirme si desea terminar',
    terminationSuccess: 'Terminación exitosa',
    cancelledTermination: 'Terminación cancelada',
    pleaseEnterTheValidityPeriod: 'Introduzca el contenido correspondiente a la vigencia',
    createACoupon: 'Crear cupón',
    unedited: 'Edición cancelada',
    discountTemplate: 'Descuento inmediato { money }',
    fullReductionTemplate: 'Descuento por umbral { minAmount }',
    validityDaysTemplate: 'Válido por { day } días desde la recepción del cupón',
    activationConfirmation:
      'Una vez activado el cupón no podrá modificarse, ¿confirma la activación?',
    importValidationWarning:
      'Algunos hoteles importados presentan validaciones anómalas, ¿desea continuar?',
  },
  marketActivitydata: {
    classificationSpecification: 'Descripción de la clasificación',
    data: 'Datos',
    marketingRevenue: 'Ingresos de marketing',
    marketingExpenses: 'Gastos de marketing',
    numberOfContacts: 'Personas alcanzadas',
    numberOfVisitors: 'Número de visitantes',
    numberOfTransactions: 'Número de transacciones',
    revenueDescription: 'Ingresos generados por usuarios alcanzados en los últimos 30 días',
    costDescription: 'Coste generado por marketing en los últimos 30 días',
    reachCountDescription:
      'Número de usuarios alcanzados por actividades de marketing en los últimos 30 días',
    visitCountDescription:
      'Número de usuarios alcanzados que visitaron esta tienda en los últimos 30 días',
    orderCountDescription:
      'Número de usuarios que realizaron pedidos tras ser alcanzados en los últimos 30 días',
  },
  marketCrowddata: {
    subdivide: 'Segmentación',
    classificationSpecification: 'Descripción de la clasificación',
    numberOfPeople: 'Número de personas',
    membersWhoHaveStayedAtThisStore: 'Miembros que se han alojado en esta tienda',
    allMembers: 'Todos los miembros',
    usersWhoHaveStayedInThisStoreInThePast1Year:
      'Usuarios que se alojaron en esta tienda en el último año',
    lowFrequencyMember: 'Miembros de baja frecuencia',
    usersWhoHaveStayedInTheLast1YearButHaveNotStayedInTheLast3Months:
      'Usuarios que se alojaron en el último año pero no en los últimos 3 meses',
    loyalUser: 'Usuarios leales',
    usersWhoHaveStayedAtLeast3TimesInTheLast1Year:
      'Usuarios que se alojaron más de 3 veces en el último año',
    lostUsers: 'Usuarios perdidos',
    usersWhoHaveStayedInThePast2YearsAndHaveNotStayedInThePast1Year:
      'Usuarios que se alojaron en los últimos 2 años pero no en el último año',
    interestedMember: 'Miembros interesados',
    interestedUserGroupsOfThisStore: 'Grupos de usuarios interesados de esta tienda',
    inThePast7DaysTheUserHasEnteredTheHomepageOfTheMiniProgramOfTheHotelAndHasNotPlacedAnOrder:
      'En los últimos 7 días, el usuario entró en la página principal del mini programa del hotel y no realizó pedido',
    localInterestUserGroups: 'Grupos de usuarios interesados locales',
    inThePast7DaysIHaveSearchedTheCityAndHotelWhereTheHotelIsLocated:
      'En los últimos 7 días, buscó la ciudad y el hotel donde se ubica este hotel',
    orEnteredOtherHotelsInTheCityButDidNotPlaceAnOrder:
      'O entró en otros hoteles de la ciudad pero no realizó pedido',
    intraCityUserGroup: 'Grupo de usuarios de la misma ciudad',
    usersWhoHaveStayedInTheCityInTheLast30DaysAreNotUsersOfThisStore:
      'Usuarios que se alojaron en la ciudad en los últimos 30 días pero no en esta tienda',
    createActivity: 'Crear actividad',
    lowFrequencyUser: 'Usuarios de baja frecuencia',
    marketingSuggestion:
      'Sugerencia: cree actividades de marketing a tiempo para retener usuarios y aumentar pedidos',
  },
  marketDatakb: {
    crowdDataBulletinBoard: 'Panel de datos de audiencia',
    activityDataKanban: 'Panel de datos de actividades',
  },
  marketDistribution: {
    releaseTime: 'Hora de emisión',
    events: 'Actividades',
    releaseMode: 'Modo de emisión',
    smsSending: 'Envío de SMS',
    publicAccount: 'Cuenta pública',
    stopSmsPlatformPush: 'Desactivar envío desde la plataforma SMS de Qingzhu',
    stopThePublicAccountPush: 'Desactivar envío desde la cuenta pública de Qingzhu',
    iHaveReadAndAgree: 'He leído y acepto',
    precisionMarketingRules: 'Reglas de marketing de precisión',
    pleaseReadAndAgree: 'Por favor lea y acepte',
    warmReminder: 'Recordatorio',
    issue: 'Emitir',
    couponName: 'Nombre del cupón',
    pleaseEnterTheCouponName2: 'Introduzca el nombre del cupón',
    sendingCrowd: 'Audiencia destinataria',
    pleaseSelectTheSender: 'Seleccione la audiencia',
    quantityIssued: 'Cantidad emitida',
    pleaseFillInTheNumberOfIssuedCards: 'Introduzca la cantidad a emitir',
    sendingMode: 'Modo de envío',
    notificationTemplate: 'Plantilla de notificación',
    pleaseSelectANotificationTemplate: 'Seleccione la plantilla de notificación',
    projectedCost: 'Coste estimado',
    allUsers: 'Todos los usuarios',
    interestedUsersOfThisStore: 'Usuarios interesados de esta tienda',
    lostUsers: 'Usuarios perdidos',
    loyalUser: 'Usuarios leales',
    lowFrequencyUser: 'Usuarios de baja frecuencia',
    interestedUsersInTheSameCity: 'Usuarios interesados de la misma ciudad',
    localUser: 'Usuarios locales',
    unactivated: 'No activado',
    terminated: 'Terminado',
    voucherInformation: 'Información del cupón emitido',
    issuer: 'Emisor',
    pleaseEnterTheReleaseQuantity: 'Introduzca la cantidad a emitir',
    couponIssuedSuccessfully: 'Cupón emitido con éxito',
    pleaseEnterCoupon: 'Introduzca el cupón',
    sendBatch: 'Lote de envío',
    pleaseEnterTheCorrectCoupon: 'Introduzca el cupón correcto',
    perPersonUnit: 'Cupones/persona',
    rule1:
      '1. No se recomienda crear actividades de marketing con demasiada frecuencia. Qingzhu cuenta con un mecanismo antifatiga: en un período determinado, los usuarios solo pueden recibir una cantidad limitada de notificaciones/SMS de marketing.',
    rule2:
      '2. Para evitar el uso excesivo de notificaciones/SMS y posibles molestias a los usuarios que afecten la imagen de la marca del hotel, se limita a 1 envío por usuario cada 7 días por canal.',
    rule3:
      '3. No se garantiza el envío exitoso de todas las notificaciones/SMS; prevalecerá el efecto real de alcance.',
    rule4:
      '4. Las notificaciones/SMS de marketing no enviadas con éxito reembolsarán el coste; los registros de envío deben indicar éxito o fallo.',
  },
  marketRules: {
    rulesRulesRules: 'Reglas',
  },
  memberActivityManage: {
    longTerm: 'Largo plazo',
    customInterval: 'Intervalo personalizado',
    activeTime: 'Periodo de actividad',
    addActivity: 'Agregar actividad',
    editingActivity: 'Editar actividad',
    editGear: 'Editar nivel',
    addGear: 'Agregar nivel',
    unlimited: 'Ilimitado',
    rechargeAmount2: 'Importe de recarga',
    enabledState: 'Estado habilitado',
    activeState: 'Estado de actividad',
    pleaseEditTheAddedGears: 'Edite los niveles añadidos',
  },
  memberIntegralSetting: {
    integralRatioSetting: 'Configuración de la proporción de puntos',
    points: 'Puntos',
    automaticCumulativePointSetting: 'Configuración de acumulación automática de puntos',
    storedValueConsumption: 'Consumo de saldo',
    nonCumulativeIntegral: 'No acumula puntos',
    pleaseFillInThePointsRatioSetting: 'Complete la configuración de la proporción de puntos',
    pleaseSelectTheAutomaticAccumulationPointSetting:
      'Seleccione la configuración de acumulación automática de puntos',
    roomAndStoredConsumption: 'Consumo de habitación + consumo de saldo',
    integralRatioLimit: 'La proporción de puntos solo puede estar entre 0.01 y 1000',
  },
  memberMemberManage: {
    pleaseArrangeMemberInformationAccordingToTheRequirementsInTheTemplate:
      'Organice la información de los miembros según los requisitos de la plantilla',
    downloadTemplate: 'Descargar plantilla',
    freeCommissionPolicyTips: 'Aviso de política sin comisión',
    downloadFailureData: 'Descargar datos fallidos',
    normal: 'Normal',
    registrationTime: 'Hora de registro',
    entryTime: 'Hora de entrada',
    augment: 'Aumentar',
    decrease: 'Disminuir',
    singleStoreStoredValueBillPrinting: 'Impresión de facturas de saldo de tienda individual',
    theAmountOfMemberStoredValueIsOnlyAvailableInThisStoreAndIsNotAvailableInOtherStores:
      // Part 9, lines 1601 to 1800
      'El saldo de valor almacenado del miembro solo es válido en esta tienda y no puede usarse en otras tiendas',
    currentMembersHaveUnusedBalancesOrPointsPleaseConfirmWhetherToDisable:
      'El miembro actual tiene saldos o puntos no utilizados, confirme si desea deshabilitarlo',
    lightLivingMember: 'Miembro Qingzhu',
    startOfEntryDate: 'Fecha de inicio de registro',
    dateOfEntry: 'Fecha de fin de registro',
    membershipIntroduction: 'Importación de miembros',
    memberExport: 'Exportación de miembros',
    newMember: 'Nuevo miembro',
    viewGrade: 'Ver nivel',
    viewMembers2: 'Ver miembros',
    storedValueQuery2: 'Consulta de saldo',
    transactionType: 'Tipo de transacción',
    registered: 'Registrado',
    unregistered: 'No registrado',
    theAmountOfThisStoredValue: 'Importe de esta recarga',
    storedValueActivity: 'Actividad de recarga',
    eventGiftAmount: 'Importe de regalo de la actividad',
    currentStoredValueBalance: 'Saldo actual',
    storageTime: 'Hora de recarga',
    currentBalance: 'Saldo actual',
    topUpTheTotalAmount: 'Importe total recargado',
    totalGiftAmount: 'Importe total regalado',
    totalPayment: 'Importe total pagado',
    totalRefundAmount: 'Importe total reembolsado',
    singleStoreMembershipLevel: 'Nivel de membresía de tienda individual',
    storePoints: 'Puntos de tienda individual',
    storedValueAccumulation: 'Acumulación de saldo',
    incorrectEmailFormat: 'Formato de correo electrónico incorrecto',
    membershipLevel: 'Nivel de membresía',
    occupation: 'Ocupación',
    pleaseEnterOccupation: 'Introduzca la ocupación',
    salespersonName: 'Nombre del vendedor',
    salespersonId: 'ID del vendedor',
    pleaseEnterSalespersonId: 'Introduzca el ID del vendedor',
    pleaseEnterTheSalespersonsName: 'Introduzca el nombre del vendedor',
    pleaseSelectTheYearMonthAndDay2: 'Seleccione año, mes y día',
    detailedAddress: 'Dirección detallada',
    lv: 'Nivel',
    gradeName: 'Nombre del nivel',
    variableIntegral: 'Puntos variables',
    pointBalance: 'Saldo de puntos',
    transactionAmount: 'Importe de la transacción',
    changeType: 'Tipo de cambio',
    changeOfAmount: 'Importe del cambio',
    pleaseEnterAnInteger: 'Introduzca un número entero',
    topUpActivity: 'Actividad de recarga',
    pleaseSelectAnActivity: 'Seleccione una actividad',
    activeGear: 'Nivel de actividad',
    rechargeAmount2: 'Importe de recarga',
    pleaseEnterTheRechargeAmount: 'Introduzca el importe de recarga',
    amountReceivable: 'Importe a cobrar',
    printDocuments: 'Imprimir documentos',
    deductionAmount: 'Importe de deducción',
    pleaseEnterTheAmountOfDeduction: 'Introduzca el importe de la deducción',
    increaseTheIntegral: 'Aumentar puntos',
    reduceIntegral: 'Reducir puntos',
    filling: 'Recargar',
    send: 'Regalar',
    pleaseEnterTheCorrectIdNumber: 'Introduzca el número de identificación correcto',
    pleaseEnterTheCorrectIdNumber2: 'Introduzca el número de documento correcto',
    pleaseFillInTheIdNumber: 'Complete el número de documento',
    operationFailure: 'Error de operación',
    youDoNotHaveAccessRightsPleaseContactLightLiveOperationsToAddPermissions:
      'No tiene permisos de acceso, contacte con operaciones de Qingzhu para añadir permisos',
    currentLimitSelect1FilePleaseRemoveAndAdd:
      'Actualmente solo se permite seleccionar 1 archivo, elimínelo y vuelva a añadir',
    memberDataIsExportedSuccessfullyProcedure: 'Los datos de miembros se exportaron correctamente',
    memberDataFailedToBeExportedProcedure: 'Error al exportar los datos de miembros',
    noDataAvailableAtThisTime: 'No hay datos disponibles en este momento',
    memberImportTemplateDownloadedSuccessfully:
      'La plantilla de importación de miembros se descargó correctamente',
    failedToDownloadTheMemberImportTemplate:
      'Error al descargar la plantilla de importación de miembros',
    modifyMembership2: 'Modificar miembro',
    addAMemberSuccessfully: 'Miembro añadido con éxito',
    renewMemberSuccessfully: 'Miembro actualizado con éxito',
    integralChange2: 'Cambio de puntos',
    memberRecharge: 'Recarga de miembro',
    deductionOfStoredValue: 'Deducción de saldo',
    scoreChangeSuccess: 'Cambio de puntos exitoso',
    memberRechargeSuccessfully: 'Recarga de miembro exitosa',
    theDeductionOfStoredValueIsSuccessful: 'La deducción de saldo fue exitosa',
    integralQuery2: 'Consulta de puntos',
    pleaseEnterSalesman: 'Introduzca el vendedor',
    definitiveRemoval: 'Confirmar eliminación',
    derivedInformation: 'Información exportada',
    memberDataExportInformation: 'Información de exportación de datos de miembros.xlsx',
    memberImportTemplate: 'Plantilla de importación de miembros.xlsx',
    totalMembers: 'Hay un total de {memberTotal} miembros',
    xlsFormatOnly: 'Solo se admiten archivos en formato XLS',
    commissionRefundNotice:
      'Desde el 1 de febrero de 2021, los miembros importados por primera vez mediante la función “Importación de miembros” que reserven y se alojen en este hotel a través del mini programa Qingzhu recibirán el reembolso completo de la comisión generada',
    enabled: 'Habilitado',
    disabled: 'Deshabilitado',
    idTypeAndNumber: 'Tipo de documento / Número de documento',
    distributionSettings: 'Configuración de distribución',
    setAsAPromotionalUser: 'Establecer como usuario promocional',
  },
  memberMemberReport: {
    ordinaryMember: 'Miembro ordinario',
    goldMember: 'Miembro oro',
    platinumMember: 'Miembro platino',
    diamondMember: 'Miembro diamante',
    enterYourNamePhoneNumberAndIdNumber: 'Introduzca nombre, teléfono y número de documento',
    membership: 'Identidad de miembro',
    activateStore: 'Activar tienda',
    ourStore: 'Nuestra tienda',
    otherStores: 'Otras tiendas',
    sourceOfDevelopment: 'Fuente de desarrollo',
    activationDate: 'Fecha de activación',
    dateOfPurchase: 'Fecha de compra',
    purchaseTime: 'Hora de compra',
    memberNickname: 'Apodo del miembro',
    memberName: 'Nombre del miembro',
    membershipIdNumber: 'Número de documento del miembro',
    activationTime: 'Hora de activación',
    currentLevelDevelopmentSource: 'Fuente de desarrollo del nivel actual',
    currentLevelPurchaseTime: 'Hora de compra del nivel actual',
  },
  memberSaveReport: {
    downloadReport: 'Descargar informe',
    totalAmountOfStoredValue: 'Total de saldo',
    totalGiftAmount: 'Total de regalos',
    totalConsumptionAmount: 'Total de consumo',
    totalAmountOfRefund: 'Total de reembolsos de consumo',
    user: 'Usuario',
    transactionType: 'Tipo de transacción',
    storedValue: 'Saldo',
    consumptionRefund: 'Reembolso de consumo',
    membershipLevel: 'Nivel de membresía',
    storedValueAmount: 'Importe de saldo',
    amountOfRefund: 'Importe de reembolso',
    memberStoredValueReport: 'Informe de saldo de miembros.xlsx',
    theMemberStoredValueReportIsSuccessfullyExported:
      'El informe de saldo de miembros se exportó correctamente',
    failedToExportTheMemberStoredValueReport: 'Error al exportar el informe de saldo de miembros',
    searchPlaceholder: 'Teléfono / documento / nombre / número de tarjeta',
  },
  clientClient: {
    guestTag: 'Etiqueta del huésped',
    pleaseEnterYourContactInformation: 'Introduzca la información de contacto',
    pleaseEnterYourNationality: 'Introduzca la nacionalidad',
    pleaseEnterNationality: 'Introduzca la etnia',
    pleaseEnterAddress: 'Introduzca la dirección',
    age: 'Edad',
    customerLabel: 'Etiqueta del cliente',
    modifyGuestInformation: 'Modificar información del huésped',
    inputLabelDuplication: 'Etiqueta duplicada',
    pleaseEnterTheLabelContent: 'Introduzca el contenido de la etiqueta',
    doNotEnterLabelsInMoreThan10Words: 'No introduzca etiquetas de más de 10 palabras',
  },
  financeIndex: {
    pleaseCancelRenewFirst:
      'Cancele primero la extensión de estancia antes de realizar el check-out',
    addAnotherItem: 'Agregar otro ítem',
    checkInOrderNumber: 'Número de orden de check-in',
    adjustFinance: 'Ajustar finanzas',
    batchTransfer: 'Transferencia por lotes',
    checkOut: 'Check-out con cuenta a crédito',
    pleaseEnterTheRoomNumber: 'Introduzca el número de habitación',
    pleaseEnterRoomTypeName: 'Introduzca el nombre del tipo de habitación',
    pleaseEnterChannel: 'Introduzca el canal',
    pleaseEnterCheckInTime: 'Introduzca la hora de check-in',
    pleaseEnterYourDepartureTime: 'Introduzca la hora de salida',
    pleaseEnterAccount: 'Introduzca el concepto',
    entryTime2: 'Hora de registro',
    pleaseEnterTheCreditDate: 'Introduzca la hora de registro',
    consumptionAmountyuan: 'Importe de consumo',
    pleaseEnterTheAmountSpent: 'Introduzca el importe de consumo',
    paymentAmountyuan: 'Importe de pago',
    pleaseEnterThePaymentAmount: 'Introduzca el importe de pago',
    editBill: 'Editar factura',
    checkOut2: 'Check-out',
    cancelAccount: 'Cancelar liquidación',
    partialClosing: 'Liquidación parcial',
    accountAdjustment: 'Ajuste de cuenta',
    smallGoodsAreAccountedFor: 'Registro de artículos pequeños',
    pleaseSelectAPaymentHistory: 'Seleccione un registro de pago',
    pleaseFillInTheAmountOfPayment: 'Introduzca el importe del pago',
    yourAccountInformationIsEmptyPleaseEnterTheAccountBeforePrinting:
      'La información contable está vacía, registre primero antes de imprimir',
    theRoomNumberCannotBeEmptyPleaseCheckWhetherThePagePathIsCorrect:
      'El número de la orden de habitación no puede estar vacío, verifique si la ruta de la página es correcta',
    smallwares: 'Artículos pequeños',
    creditOrdersDoNotSupportPartialCheckout: 'Los pedidos a crédito no admiten liquidación parcial',
    pleaseSelectTheOrderYouWantToCheckOut: 'Seleccione el pedido que desea liquidar',
    creditBookingIsNotSupportedPleaseCheckOutDirectly:
      'Las reservas a crédito no admiten cuenta a crédito, realice el check-out directamente',
    pleaseSelectACover: 'Seleccione el conjunto de cuentas',
    unionpayScanCode: 'UnionPay - Escanear código',
    checkOutSuccessfully: 'Check-out exitoso',
    securityDeposit: 'Depósito',
    warmReminder: 'Recordatorio',
    signOut: 'Cerrar sesión',
    cancelled: 'Cancelado',
    the: 'de',
    wheatDoorLockPlugInCancellationCard: 'Cancelación de tarjeta del plugin de cerradura Wheat',
    whetherTheKeyCardHasBeenCancelled: '¿La tarjeta de la habitación ha sido cancelada?',
    selectUnsettledAccountsWarning: 'Seleccione cuentas “no liquidadas”',
    feizhuRoomFeeValidation:
      'El importe de la tarifa de habitación de Fliggy debe ser ≥ 0, tarifa actual: {roomRateFees}',
    feizhuNonRoomFeeValidation:
      'El importe de “no habitación” de Fliggy debe ser ≥ 0, importe actual: {fees}',
    pleaseSelectUnsettledAccounts: 'Seleccione cuentas no liquidadas',
    additionalChargeAmountEmpty: 'El importe adicional está vacío, vuelva a intentarlo',
  },
  financeMangementOld: {
    accountType: 'Tipo de cuenta',
    creditAccount: 'Cuenta de crédito',
    prepaidAccount: 'Cuenta prepago',
    // Part 10, lines 1801 to 2000
    settlementPeriod: 'Período de liquidación',
    maximumAmount: 'Límite máximo',
    theMaximumMustBeGreaterThanZero: 'El límite máximo debe ser mayor que cero',
    theMaximumAmountCannotBeGreaterThan100Million:
      'El límite máximo no puede superar cien millones',
    theStartTimeCannotBeEqualToTheEndTime: 'La hora de inicio no puede ser igual a la hora de fin',
    theStartTimeCannotBeLaterThanTheEndTime:
      'La hora de inicio no puede ser posterior a la hora de fin',
    pleaseSelectAnEndTime: 'Seleccione la hora de fin',
    theEndTimeCannotBeEqualToTheStartTime: 'La hora de fin no puede ser igual a la hora de inicio',
    theEndTimeCannotBeLaterThanTheStartTime:
      'La hora de fin no puede ser anterior a la hora de inicio',
    pleaseEnterTheBillingPeriod: 'Introduzca el período de liquidación',
    settlementPeriodCanOnlyBeEnteredInNumbers: 'El período de liquidación solo admite números',
    newAccount: 'Nueva cuenta',
    pleaseFillInTheAccountName: 'Complete el nombre de la cuenta',
    pleaseFillInTheCompanyName: 'Complete el nombre de la empresa',
    pleaseSelectAnAccountType: 'Seleccione el tipo de cuenta',
    pleaseSelectAChannelName: 'Seleccione el nombre del canal',
  },
  financeMangement: {
    creditAccount: 'Cuenta de crédito',
    prepaidAccount: 'Cuenta prepago',
    enableConfirmation:
      'Tras habilitar, esta unidad de convenio admitirá cuentas a crédito. ¿Desea habilitar?',
    disableConfirmation:
      'Tras deshabilitar, esta unidad de convenio dejará de admitir cuentas a crédito. ¿Desea deshabilitar?',
  },
  foodRoomAccountFinance: {
    foodSource: 'Fuente de alimentos',
    foodRoomAccountLabel: 'Cuenta de habitación de alimentos',
    foodOrderNo: 'N.º de pedido de Food',
    fmisAccountSerialNo: 'N.º de serie de cuenta FMIS',
    chargedAmount: 'Importe cargado',
    notAllowedSplit: 'Las cuentas de habitación de alimentos no se pueden dividir',
    notAllowedRush: 'Las cuentas de habitación de alimentos no se pueden revertir',
    notAllowedTransfer: 'Las cuentas de habitación de alimentos no se pueden transferir',
    notAllowedPartialSettlement: 'Las cuentas de habitación de alimentos no admiten liquidación parcial',
  },
  financeMixin: {
    onlinePaymentAccountsAreNotAllowedToOpen: 'Las cuentas de pago en línea no permiten desglosar',
    smallCommodityAccountsCanNotBeDismantled:
      'Las cuentas de artículos pequeños no permiten desglosar',
    negativeDebtCannotBeBroken: 'Las deudas negativas no permiten desglosar',
    accountsReceivableAreNotAllowedToBeDebunked: 'Las cuentas por cobrar no permiten desglosar',
    debitsAreNotAllowedInThisAccount: 'Este concepto no permite desglosar',
    onlinePaymentRefundAccountDoesNotAllowForChargebacks:
      'Las devoluciones de pagos en línea no permiten compensación',
    theAccountHasBeenRefundedAndCannotBeCharged:
      'La cuenta ya fue reembolsada y no permite compensación',
    refundedAccountsCannotBeCharged: 'Las cuentas reembolsadas no pueden compensarse',
    thisAccountIsNotAllowedToBeCharged: 'Este concepto no permite compensación',
    businessDayHasBeenSwitchedNoChargeIsAllowed:
      'El día hábil ya cambió, no se permite compensación',
    splitBill: 'Desglosar',
    transfer: 'Transferir',
    offset: 'Compensar',
    refund: 'Reembolsar depósito',
  },
  detailcomponentsAccountlisttable: {
    onAccount: 'En cuenta',
  },
  detailcomponentsAddjudge: {
    theRoomChargeIsExcessive: 'El cargo adicional de habitación es excesivo',
    chargeJudgment: 'Evaluación de cargo adicional',
    addOnOption: 'Opción de cargo adicional',
    generatedRoomCharge: 'Cargo de habitación generado',
    pleaseFillInTheAdditionalRoomCharge: 'Complete el cargo adicional de habitación',
    theAdditionalAmountCannotBe0: 'El importe adicional no puede ser 0',
  },
  detailcomponentsAdjustaccounts: {
    reconciliationSuccess: 'Ajuste de cuenta exitoso',
    accountAdjustment: 'Ajuste de cuenta',
    accountOfReconciliation: 'Concepto de ajuste',
    incorrectTransferAmountFormatupToTwoDecimalPlaces:
      'Formato de importe incorrecto (hasta dos decimales)',
    theTransferAmountCannotBe: 'El importe del ajuste no puede ser',
    theTransferAmountCannotBeGreaterThan100Million:
      'El importe del ajuste no puede superar cien millones',
  },
  detailcomponentsArsuitselect: {
    receivableSet: 'Conjunto de cuentas por cobrar',
    creditOrderCheckoutTip: 'Los pedidos de estancia con crédito deben registrarse como cuentas por cobrar al hacer el check-out',
    nonProtocolOrderArTip: 'Los pedidos de empresas sin contrato no pueden registrarse como cuentas por cobrar',
  },
  detailcomponentsBackout: {
    closedSuccessfully: 'Cancelación de liquidación exitosa',
    cancelAccount: 'Cancelar liquidación',
    confirmationRevocation: 'Confirmar cancelación',
    pleaseSelectTheBillYouWantToCancel: 'Seleccione la factura que desea cancelar',
  },
  detailcomponentsBorrow: {
    return: 'Devolver',
    itemBorrowingReminder: 'Recordatorio de préstamo de artículos',
    borrowARoom: 'Préstamo de habitación',
    quantityBorrowed: 'Cantidad prestada',
    returnQuantity: 'Cantidad devuelta',
    loanDate2: 'Fecha de préstamo',
    returnOrNot: '¿Devolver o no?',
    whetherToReturnAll: '¿Devolver todo?',
    amountOfCompensation: 'Importe de compensación',
    onlyNumbersGreaterThan0CanBeEntered: 'Solo se permiten números mayores que 0',
    partOfTheReturnCanOnlyBeLessThanTheAmountBorrowed:
      'La devolución parcial debe ser menor que la cantidad prestada',
    returned: 'Devuelto',
    noReturn: 'No devuelto',
    returnSuccessfully: 'Devolución exitosa',
  },
  detailcomponentsColorblock: {
    financialType: 'Tipo financiero',
    accountingType: 'Tipo contable',
    orderForGoods: 'Pedido',
  },
  detailcomponentsCommon: {
    unionpayScanCode: 'UnionPay - Escanear código',
    insufficientMemberBalance: 'El saldo del miembro es {balance}, seleccione otro cobrador',
  },
  detailcomponentsCreditsettletip: {
    creditSettleAlert:
      'Aviso: pedido Fliggy con crédito. Liquidación real de habitación {roomRate}, liquidación de no habitación {nonRoomRate}. Verifique los importes antes de enviar el check-out',
  },
  detailcomponentsDivideaccounts: {
    additionalDebits: 'Agregar desglose',
    totalAmount: 'Importe total',
    totalDebitsTaken: 'Total desglosado',
    totalUndismantledLoans: 'Total no desglosado',
    successfulDismantling: 'Desglose exitoso',
    borrowMoney: 'Desglosar',
    loanAmount: 'Importe a desglosar',
    upTo150Words: 'Hasta 150 caracteres',
    closedAccount: 'Desglosado',
    tenAtMost: 'Máximo diez desgloses',
    theAmountOfDebitsIsNotEqualToTheTotalAmount: 'El importe desglosado no coincide con el total',
    theDebitAmountMustBeFilledInAndGreaterThan: 'El importe a desglosar es obligatorio y mayor que',
  },
  detailcomponentsEnteraccount: {
    breakfastType: 'Tipo de desayuno',
    includedBreakfast: 'Desayuno incluido',
    purchasedBreakfast: 'Desayuno comprado',
    unitPrice: 'Precio unitario',
    servings: 'Porciones',
    mealDate: 'Fecha de consumo',
    selectMultipleDates: 'Seleccione varias fechas',
    selectedDays: 'Total de días: {count}',
    cashCnyReceipt: 'Cobro en efectivo',
    accountEntry: 'Concepto de registro',
    amountRecorded: 'Importe registrado',
    pleaseFillInTheAmountOfPayment: 'Complete el importe del registro',
    pleaseSelectAPaymentMethod: 'Seleccione el método de pago',
    entriesCannotBeEmpty: 'El concepto de registro no puede estar vacío',
    theAmountRecordedCannotBe: 'El importe registrado no puede ser 0',
    pleaseFillInUnitPrice: 'Complete el precio unitario',
    unitPriceCannotBeZero: 'El precio unitario no puede ser 0',
    pleaseFillInServings: 'Complete la cantidad',
    servingsCannotBeZero: 'La cantidad no puede ser 0',
    pleaseSelectMealDate: 'Seleccione la fecha de consumo',
    ArRefundCannotExceedBalance: 'El reembolso AR no puede superar el saldo AR',
  },
  detailcomponentsExpandcolumn: {
    memberName: 'Nombre del miembro',
    receivableSet: 'Conjunto de cuentas por cobrar',
    from: 'Desde',
    orderForGoods: 'Pedido',
    rollOutTo: 'Transferir a',
    refundedAmount: 'Reembolsado: {amount}',
  },
  detailcomponentsHangaccounts: {
    checkOut: 'Check-out con cuenta a crédito',
    reasonForPayment: 'Motivo de la cuenta a crédito',
  },
  detailcomponentsHourroomfeeconfirm: {
    roomRateConfirmation: 'Confirmación de tarifa de habitación',
    roomRate2: 'Importe de tarifa de habitación',
  },
  detailcomponentsPartsettle: {
    partialClosing: 'Liquidación parcial',
    pleaseFillInTheAmountOfPayment: 'Complete el importe del pago',
    pleaseSelectAPaymentHistory: 'Seleccione un registro de pago',
  },
  detailcomponentsPreauthcheck: {
    authorizedSettlement: 'Liquidación autorizada',
  },
  detailcomponentsPreauthtemplate: {
    cancelAuthorizationPleaseWait: 'Cancelando autorización, espere',
    succeededInCancelingAuthorization: 'Autorización cancelada con éxito',
    thereIsAnOutstandingPreAuthorizationRecordInTheRoom:
      'Existe un registro de preautorización pendiente en la habitación',
    confirmThatYouWantToCancelAuthorization: 'Confirme que desea cancelar la autorización',
    roomPaymentRequired: 'La habitación requiere {action} importe:',
    orderCanceledWarning: 'El pedido ha sido cancelado, no se puede {action}',
    roomCheckedInWarning: 'La habitación está ocupada, no se puede {action}',
    roomCheckedOutWarning: 'La habitación está en estado "check-out", no se puede {action}',
  },
  detailcomponentsRefundtip: {
    refundReminder: 'Aviso de reembolso',
    whenUsingAnOnlineRefundTheAmountWillBeRefundedToTheAccountFromWhichTheGuestPaid:
      'Al usar reembolso en línea, el importe se devolverá a la cuenta desde la que pagó el huésped',
    whenUsingAOneCardRefundSystem:
      'Al usar reembolso con tarjeta única, el importe se devolverá a la cuenta del huésped',
  },
  detailcomponentsSmallwarecost: {
    smallwares: 'Artículos pequeños',
    smallGoodsEnteredTheAccountSuccessfully: 'Artículos pequeños registrados con éxito',
    smallGoodsAreAccountedFor: 'Registro de artículos pequeños',
    payOrNot: '¿Pagar o no?',
    pleaseEnterTheExternalOrderNumber: 'Introduzca el número de pedido externo',
    pleaseSelectASmallItem: 'Seleccione un artículo pequeño',
    insufficientMemberBalance: 'El saldo del miembro es {balance}, seleccione otro cobrador',
  },
  detailcomponentsTransferaccounts: {
    transferMoney: 'Transferir',
    transferToAccount: 'Transferir a cuenta',
    pleaseSelectValidTransferAccount: 'Seleccione una cuenta de destino válida',
    transferSuccess: 'Transferencia exitosa',
    batchTransferSuccess: 'Transferencia por lotes exitosa',
  },
  mangementMember: {
    orderType: 'Tipo de pedido',
    receivableOrders: 'Cuentas por cobrar del pedido',
    totalAmountNotApproved: 'Total no verificado',
    approvedTotalAmount: 'Total verificado',
    amountAvailable: 'Importe disponible',
    amountSpent: 'Importe utilizado',
    whetherToWriteOffAllTheReceivables: '¿Desea compensar todas las cuentas por cobrar?',
    whetherToReverseWriteOffAllTheReceivables: '¿Desea compensar inversamente todas las cuentas por cobrar?',
    cancelAfterVerification: 'Compensar',
    reverseWriteOff: 'Compensación inversa',
    depositInAdvance: 'Depósito anticipado',
    dateOfPosting: 'Fecha de registro en cuenta',
    pleaseEnterTheOrderNumber: 'Introduzca el número de pedido',
    completeWriteOff: 'Compensación total',
    completeReverseWriteOff: 'Compensación total inversa',
    batchWriteOff: 'Compensación por lotes',
    batchReverseWriteOff: 'Compensación por lotes inversa',
    records: 'Registros',
    advanceCredit: 'Registro prepago',
    thePrepaidAmountMustBeGreaterThanZero: 'El importe prepago debe ser mayor que cero',
    theAmountInAdvanceCannotBeGreaterThan100Million:
      'El importe prepago no puede superar cien millones',
    checkTheDepartureDateUpToOneMonth: 'La fecha de salida admite consulta de hasta un mes',
    noAccountPleaseCreateANewOne: 'No hay conjunto de cuentas, cree uno nuevo',
    allWereSuccessfullyWrittenOff: 'Compensación total exitosa',
    // Part 11, lines 2001 to 2200
    allWriteOffsFailed: 'Falló la compensación total',
    noWriteOffIsAllowedOnTheDayReceivableIsGenerated:
      'No se permite la compensación el mismo día en que se generan las cuentas por cobrar',
    pleaseSelectTheItemsYouWantToWriteOff: 'Seleccione los ítems que desea compensar',
    listOfAccountsReceivable3XLS: 'Lista de cuentas por cobrar.xls',
    prepaymentAmountRequired: 'Complete el importe del prepago',
    prepaymentAmountFormatError: 'Formato del importe de prepago incorrecto (máximo dos decimales)',
  },
  mangementTablerow: {
    paidInAmount: 'Importe cobrado',
  },
  mangementVerificatemodal: {
    successfulWriteOff: 'Compensación exitosa',
    cancelAfterVerification: 'Compensar',
    reverseWriteOff: 'Compensación inversa',
    generationTime: 'Hora de generación',
    amountWrittenOff2: 'Importe compensado',
    pleaseFillInTheWriteOffAmount: 'Complete el importe a compensar',
    theAmountToBeWrittenOffCannotBeGreaterThanTheAmountThatCanBeWrittenOff:
      'El importe a compensar no puede ser mayor que el importe compensable',
  },
  mangementVerifyrecordsmodal: {
    records: 'Registros',
    lot: 'Lote',
  },
  merchantChargeList: {
    accumulatedUncreditedNightsInArrearsDuringTheContractPeriod:
      'Noches adeudadas no compensadas acumuladas durante el período contractual',
    hideZeroAmounts: 'Ocultar importes cero',
  },
  merchantCheckBill: {
    confirmationCheck: 'Confirmar verificación',
    afterConfirmationSettlementWillBeMadeInAccordanceWithThisBill:
      'Tras la confirmación, la liquidación se realizará conforme a este estado de cuenta',
    appealChannel: 'Canal de apelación',
    causeOfAppeal: 'Motivo de apelación',
    youCanEnterUpTo150Words: 'Puede introducir hasta 150 caracteres',
    accountName: 'Nombre de la cuenta',
    roomBillCheck: 'Verificación de factura de habitación',
    memberIncentiveCheck: 'Verificación de incentivos de miembros',
    confirmed: 'Confirmado',
    reasonForAdjustment: 'Motivo del ajuste',
    deductibleTarget: 'Objetivo de deducción',
    currentDeduction: 'Deducción del período actual',
    deductible: 'Deducido',
    confirmationTime: 'Hora de confirmación',
    rejectionTime: 'Hora de rechazo',
    liveLightlyInTheDirectCamp: 'Qingzhu directo',
    new: 'Nuevo',
    appealSuccessfully: 'Apelación exitosa',
    checkSuccessfully: 'Verificación exitosa',
    currDeductionDesc:
      '1. Deducción positiva: Qingzhu deduce al comerciante. 2. Deducción negativa: reembolso al comerciante',
    qzMerchantSettleDesc:
      'Liquidación Qingzhu–comerciante = importe total del pedido − deducción del período',
  },
  merchantInfoManage: {
    changeLetter: 'Carta de modificación',
    note: 'Nota',
    paymentCanOnlyBeMadeAfterTheModificationOfTheReceivingAccountIsApprovedIfTheCurrentSettlementPaymentIsToBePaidThePaymentWillStillBeMadeAccordingToTheOriginalAccount:
      'La modificación de la cuenta de cobro debe aprobarse antes del pago. Si hay pagos pendientes, se realizarán a la cuenta original',
    groundsForRejection: 'Motivo de rechazo',
    downloadTheAttachmentTemplate2: 'Descargar plantilla de adjunto',
    viewingModificationLogs2: 'Ver registros de modificación',
    thisSettlementInformationIsUsedForRoomFeeSettlementAndCanOnlyBeModifiedByTheHotelOwnerPleaseAddItWithCaution:
      'Esta información de liquidación se usa para liquidar tarifas de habitación y solo el propietario del hotel puede modificarla; añádala con precaución',
    thisAccountIsUsedForTheSettlementOfRoomChargesAndCanOnlyBeModifiedByTheHotelOwnerPleaseModifyItCarefullyUploadTheChangeLetterAndAffixTheOfficialSealAsRequired:
      'Esta cuenta de cobro se usa para liquidar tarifas de habitación y solo el propietario del hotel puede modificarla; modifique con cuidado y cargue la carta de cambio con sello oficial',
    modifyLog2: 'Registro de modificaciones',
    beforeModification3: 'Antes de la modificación',
    receivablesAccountManagement2: 'Gestión de cuentas de cobro',
    bankAccountName4: 'Nombre del titular bancario',
    letterOfRequestForChange2: 'Carta de solicitud de cambio',
    pleaseEnterYourBankName2: 'Introduzca el nombre del titular bancario',
    pleaseUploadTheRequestForChange2: 'Cargue la carta de solicitud de cambio',
    afterModification2: 'Después de la modificación',
    afterDownloadingTheApplicationChangeLetterYouNeedToPrintItOutSignAndSealItAndThenUploadThePictureOrPdfFile:
      'Tras descargar la carta de solicitud de cambio, imprímala, fírmela y séllela, luego cargue la imagen o el PDF',
    onlyJpgPngAndPdfFilesCanBeUploaded: 'Solo se admiten archivos jpg, png y pdf',
  },
  merchantMerchantHelper: {
    smallProgramSettlementRules: 'Reglas de liquidación del mini programa',
    settlementOfPaymentProblems: 'Problemas de pago en la liquidación',
    smallProgramSettlementRulesCommonProblems:
      'Problemas comunes de las reglas de liquidación del mini programa',
    frequentlyAskedQuestionsAboutSettlementPayments:
      'Preguntas frecuentes sobre pagos de liquidación',
    q1SettlementCriteria: 'P1: ¿Qué facturas pueden liquidarse?',
    a1SettlementCriteria: 'Liquidamos pedidos con estado completado y check-out realizado.',
    q2PmsCancellation: 'P2: ¿Qué hacer si se cancela la factura en PMS?',
    a2PmsCancellation:
      'Si el PMS está cancelado, nuestro estándar es: si el huésped solicita la cancelación y se reembolsa, contacte al servicio al cliente para el proceso de reembolso.',
    q1AuditTime: 'P1: ¿Cuándo es la auditoría de liquidación?',
    a1AuditTime:
      'Antes del viernes se cargan las facturas de liquidación directa de la próxima semana; el comerciante solo debe confirmarlas el jueves siguiente para recibir el pago.',
    q2PaymentTime: 'P2: Tras confirmar la factura, ¿cuándo se paga?',
    a2PaymentTime:
      'Los comerciantes que confirmen recibirán el pago el jueves. Pagos fallidos anteriores se reintentarán entre jueves y viernes.',
    q3CheckPayment: 'P3: ¿Cómo verificar si ya se pagó?',
    a3CheckPayment: 'En la pantalla de registros de pagos puede verificar el estado.',
    q4RejectedStatement: 'P4: ¿Qué pasa si se rechaza el estado de cuenta?',
    a4RejectedStatement:
      'Las facturas rechazadas se revisan nuevamente; si se confirman antes del jueves, se pagan ese jueves; de lo contrario, se pagan el jueves siguiente.',
  },
  merchantRemitRecord: {
    roomChargePaymentRecords: 'Registros de pago de tarifas de habitación',
    memberIncentiveRecord: 'Registros de incentivos de miembros',
    fundsToBeRemitted: 'Pendiente de pago',
    remitting: 'Pagando',
    remittedMoney: 'Pagado',
    paymentFailure2: 'Fallo de pago',
    collectionAccount: 'Cuenta de cobro',
    payee: 'Beneficiario',
    statusUpdateTime: 'Hora de actualización de estado',
    paymentTime: 'Hora de pago',
    timeToInitiateAPayment: 'Hora de inicio del pago',
  },
  merchantSettleInfo: {
    pleaseScanTheQrCodeOfYourCloudAccountToBindYourBankCard:
      'Escanee el código QR de su cuenta en la nube para vincular su tarjeta bancaria',
    bindBankCard: 'Vincular tarjeta bancaria',
    completeInformation: 'Información personal',
    bankAccountName4: 'Nombre del titular bancario',
    idNumber: 'Número de identificación',
    pleaseEnterYourBankName2: 'Introduzca el nombre del titular bancario',
    pleaseEnterYourIdNumber2: 'Introduzca el número de identificación',
    idNumberFormatIsIncorrectPleaseReEnter:
      'Formato del número de identificación incorrecto, vuelva a introducirlo',
    phoneNumberFormatIsIncorrectPleaseReEnter:
      'Formato del número de teléfono incorrecto, vuelva a introducirlo',
    pleaseUpload: 'Cargar',
    internalUserHidden: 'Usuarios internos no visibles',
    amountPendingPayment: 'Importe {amount}, se pagará más tarde',
  },
  billCheckBillDetails: {
    channelDetails: 'Detalles del canal',
    whereToConnectDirectly: 'Qunar directo',
    drench: 'Qingzhu',
    cityWide: 'Ciudad',
    whereToGo: 'Qunar',
    distribution: 'Distribución',
    tradeCaravan: 'Viajes de negocios',
    statementOfAccount: 'Estado de cuenta',
    qzSettleFormula:
      'Liquidación Qingzhu–comerciante = importe liquidado del pedido + reembolsos asumidos por el comerciante + descuentos asumidos por el comerciante + importes benéficos',
    merchantDiscountNote:
      'Si hay reembolsos en este período, el descuento asumido por el comerciante es 0',
  },
  billCheckBill: {
    turnDown: 'Rechazar',
    ticketReceived: 'Factura recibida',
    forThePublic: 'Cuenta corporativa',
    forPrivacy: 'Cuenta personal',
    expenseDetail: 'Detalle de gastos',
    confirmationCheck: 'Confirmar verificación',
    afterConfirmationSettlementWillBeMadeInAccordanceWithThisBill:
      'Tras confirmar, la liquidación se hará conforme a este estado',
    perfectInformation: 'Completar información',
    causeOfAppeal: 'Motivo de apelación',
    youCanEnterUpTo150Words: 'Puede introducir hasta 150 caracteres',
    creditDetails: 'Detalles de deducción',
    roomNightCreditDetails: 'Detalles de deducción por noches',
    invoiceManagement: 'Gestión de facturas',
    sellersName: 'Nombre del vendedor',
    invoiceNumber: 'Número de factura',
    invoiceDate: 'Fecha de factura',
    invoiceAmount2: 'Importe de la factura',
    electronicInvoiceOrNot: '¿Factura electrónica?',
    invoiceFile: 'Archivo de factura',
    reasonForRejectingInvoice: 'Motivo de rechazo de la factura',
    theTotalAmountOfTheOrderIncludesTheAmountOfThePreviousBillAndTheMerchantSettlementAmountLessThan0:
      'El importe total del pedido incluye importes de períodos anteriores con liquidación negativa',
    quantityDueForTheCurrentPeriod: 'Cantidad a deducir del período',
    actualAmountOfDeductionForTheCurrentPeriod: 'Cantidad deducida real del período',
    amountDeductedForTheNightOfThePeriod: 'Importe deducido por noches del período',
    uncreditedQuantityForTheCurrentPeriod: 'Cantidad no deducida del período',
    pleaseEnter150WordsOrLess: 'Introduzca hasta 150 caracteres',
    pleaseEnterTheInvoiceHoldersInformation: 'Introduzca la información del titular de la factura',
    pleaseEnterTheInvoiceNumber: 'Introduzca el número de factura',
    pleaseEnterExpiryDate2: 'Introduzca la vigencia',
    pleaseSelectTheInvoiceType: 'Seleccione el tipo de factura',
    pleaseSelectWhetherToEInvoice: 'Seleccione si es factura electrónica',
    pleaseUploadTheInvoicePhoto: 'Cargue la foto de la factura',
    pleaseFillInTheAmount: 'Complete el importe',
    specialTicket: 'Factura especial',
    ordinaryTicket: 'Factura ordinaria',
    expenseItem: 'Concepto de gasto',
    amountIncurred: 'Importe incurrido',
    source: 'Origen',
    instructions: 'Descripción',
    confirmationTime: 'Hora de confirmación',
    groupReceiptStatus: 'Estado de recepción del grupo',
    rejectionTime: 'Hora de rechazo',
    whetherTheInvoiceHasBeenEntered: '¿La factura está registrada?',
    feeDetails: 'Detalles de gastos',
    fileUpload: 'Carga de archivos',
    uploadAMaximumOf5Images: 'Máximo 5 imágenes',
    appealSuccessfully: 'Apelación exitosa',
    checkSuccessfully: 'Verificación exitosa',
    theSizeOfTheUploadedCompressedPackageCannotExceed:
      'El tamaño del archivo comprimido no puede exceder',
    onlyTheUploadFormatIsSupported: 'El formato de carga admitido es',
    theCompressedPackageFileCannotBeLargerThan: 'El archivo comprimido no puede ser mayor que',
    amountOfDeductionForTheCurrentPeriod: 'Importe de deducción del período',
    theMerchantNeedsToInvoiceTheAmount: 'Importe que el comerciante debe facturar',
    billingDetails: 'Detalles del estado',
    currentAdrAmount: 'Importe ADR del período',
    settlementSystemUpgrade:
      'Para cumplir los requisitos bancarios y mejorar la eficiencia, el sistema de liquidación se ha actualizado y requiere completar información bancaria adicional',
    confirmPreviousBills:
      'Confirme primero los estados anteriores; de lo contrario, no se mostrará el nuevo período',
    paperInvoiceInstructions:
      'Facturas en papel: el envío debe ser prepagado; envíos a cobrar serán rechazados. Destinatario: Qingzhu Distribución Factura Electrónica; Tel: 15901580289',
    uploadFormatRestrictions:
      'Nota: se admite un solo formato entre pdf, imágenes, word, comprimidos u ofd. Límites: pdf/ofd hasta 5 (3MB c/u); imágenes hasta 5 (3MB c/u, jpg/jpeg/png); word 1 (20MB); comprimido 1 (20MB, rar/zip/7z)',
    cumulativeUndeductedNights:
      'Noches adeudadas acumuladas no deducidas durante el contrato (antes de la deducción del período)',
    // Part 12, lines 2201 to 2400
    invoiceDuplicate:
      'El número de factura está duplicado. Verifique si el número es correcto; si es correcto, indique en las observaciones el motivo del uso repetido de la misma factura.',
    pdfSizeExceeded: 'El tamaño del PDF cargado no puede superar los 3MB',
    ofdSizeExceeded: 'El tamaño del OFD cargado no puede superar los 3MB',
    wordSizeExceeded: 'El tamaño del Word cargado no puede superar los 20MB',
    singleFormatOnly: 'Solo se admite un formato',
  },
  billCheckMemberDetails: {
    memberIncentiveDetails: 'Detalles de incentivos de miembros',
    memberIncentiveStatement: 'Estado de incentivos de miembros',
  },
  billDeductionDetails: {
    feeDetails: 'Detalles de gastos',
    statementDetailsSheet: 'Hoja de detalles del estado de cuenta',
  },
  billRemitRecord: {
    collectionAccount: 'Cuenta de cobro',
    payee: 'Beneficiario',
    statusUpdateTime: 'Hora de actualización del estado',
    timeToInitiateAPayment: 'Hora de inicio del pago',
    paymentTime: 'Hora de pago',
  },
  billCheckDetails: {
    channelOrderDetails: 'Detalles del pedido del canal',
    merchantRefunds: 'Reembolsos asumidos por el comerciante',
    merchantConcession: 'Descuentos asumidos por el comerciante',
    channelOrderNumber: 'Número de pedido del canal',
    reasonForAdjustment3: 'Motivo del ajuste',
    adjustmentType: 'Tipo de ajuste',
    originalOrderPrice: 'Precio original del pedido',
    memberDiscount: 'Descuento de miembro',
    skimpingOnCommission: 'Comisión Qingzhu',
    payChannelCommission: 'Comisión del canal de pago',
    amountOfMerchantWelfare: 'Importe de beneficio social del comerciante',
    refundNight: 'Noches reembolsadas',
    totalRefundAmount: 'Importe total del reembolso',
    stayEasyAndRefundCommission: 'Comisión de reembolso Qingzhu',
    subsidy: 'Subsidio',
    saleCardOrderNumber: 'Número de pedido de venta de tarjeta',
    membershipLevel: 'Nivel de membresía',
    dateOfRegistration: 'Fecha de registro',
    referrer: 'Referente',
    amountPaid: 'Importe pagado',
    merchantsShareTheAmount: 'Importe de participación del comerciante',
    employeeShareAmount: 'Importe de participación del empleado',
    shareAmount: 'Importe de participación',
    rebateRatio: 'Porcentaje de comisión',
    commissionRebate: 'Importe de comisión',
    distributionSubchannel: 'Subcanal de distribución',
    channelCost: 'Costo original del canal',
    lightSettlementWithMerchantsOrder: 'Liquidación Qingzhu con comerciantes (pedido)',
    lightUndertakeDiscounts: 'Descuentos asumidos por Qingzhu',
  },
  billDedetails: {
    currentAmountReceivable: 'Importe por cobrar del período',
    amountOfDeductionForTheCurrentPeriod: 'Importe de deducción del período',
    remainingAmountOfDeduction: 'Importe restante por deducir',
    pleasureManagementFee: 'Tarifa de gestión Yuexiang',
    brandManagementFee: 'Tarifa de gestión de marca',
    mastersCommission: 'Costo del gerente',
    otherExpenses: 'Otros gastos',
    openingDate: 'Fecha de apertura',
    preferentialPolicy: 'Política preferencial',
    managementFeeStartDate: 'Fecha de inicio del cobro de la tarifa de gestión',
    thisPeriodOfBusinessSelfPromotion: 'Autopromoción del comerciante del período',
    enjoyCommissionRate: 'Tasa de comisión Yuexiang',
    enjoyManagementFeeForThisPeriod: 'Tarifa de gestión Yuexiang del período',
    currentAdjustmentExpense: 'Gastos de ajuste del período',
    reasonsForAdjustingExpensesInTheCurrentPeriod: 'Motivos del ajuste de gastos del período',
    notPaidInThePreviousPeriod: 'No pagado del período anterior',
    currentReceivable: 'Por cobrar del período',
    currentPaid: 'Pagado del período',
    balanceDue: 'Saldo pendiente',
    brandCommissionRate: 'Tasa de comisión de marca',
    currentBrandManagementFee: 'Tarifa de gestión de marca del período',
    monthlyRate: 'Tarifa mensual',
    currentObjective: 'Objetivo del período',
    totalPmsRevenueForThePeriod: 'Ingresos totales del PMS del período',
    totalPmsReceivableForThePeriod: 'Total por cobrar del PMS del período',
  },
  chargeIndex: {
    expenseItem: 'Concepto de gasto',
    totalAmountPayable: 'Importe total a pagar',
    cashPayable: 'Efectivo a pagar',
    creditPayable: 'Pago por deducción',
    deductionAdjustment: 'Ajuste de deducción',
    deductible: 'Deducido',
    residualCredit: 'Deducción restante',
    managementFeeStartDate: 'Fecha de inicio del cobro de la tarifa de gestión',
    currentObjective: 'Objetivo del período',
    currentPeriodAdjustment: 'Ajuste del período',
    notPaidInThePreviousPeriod: 'No pagado del período anterior',
    currentReceivable: 'Por cobrar del período',
    currentPaid: 'Pagado del período',
    balanceDue: 'Saldo pendiente',
  },
  commonIndex: {
    accountName: 'Nombre de la cuenta',
    collectionAccountType: 'Tipo de cuenta de cobro',
    distributionRoomBillReconciliation: 'Conciliación de facturas de habitación por distribución',
    memberIncentiveCheck: 'Verificación de incentivos de miembros',
    directSellingRoomFeePaymentRecords:
      'Registros de pago de tarifas de habitación por venta directa',
    distributeRoomChargePaymentRecords:
      'Registros de pago de tarifas de habitación por distribución',
    memberIncentiveRecord: 'Registro de incentivos de miembros',
    confirmed: 'Confirmado',
    reasonForAdjustment: 'Motivo del ajuste',
    settlementGrounds: 'Fundamento de liquidación',
    operationDetails: 'Detalles de la operación',
    merchantRefunds: 'Reembolsos asumidos por el comerciante',
    merchantConcession: 'Descuentos asumidos por el comerciante',
    amountOfMerchantWelfare: 'Importe de beneficio social del comerciante',
    americanOrder: 'Pedido Meituan',
    flyingPigOrder: 'Pedido Fliggy',
    lightLiveMiniProgramOrder: 'Pedido del mini programa Qingzhu',
    memberShareAmount: 'Importe de participación del miembro',
    theAmountOfCrossStoreRefund: 'Importe de comisión intertiendas',
    lightlyAdjustTheAmount: 'Importe de ajuste Qingzhu',
    reasonForAdjustment3: 'Motivo del ajuste',
    fundsToBeRemitted: 'Pendiente de pago',
    remitting: 'Pagando',
    remittedMoney: 'Pagado',
    paymentFailure2: 'Fallo de pago',
    lightSettlementWithMerchantsOrder: 'Liquidación Qingzhu con comerciantes (pedido)',
  },
  infoInfoManage: {
    note: 'Nota',
    theApplicationChangeLetterNeedsToBePrintedOutAndSignedWithTheOfficialSealAfterDownloadingIfThePrintIs2PagesPleaseAffixTheSealAndUploadThePicture:
      'La carta de solicitud de cambio debe imprimirse, firmarse y sellarse; si son 2 páginas, use sello de unión y cargue la imagen',
    submitAndModifyTheAuditProcessOfTheReceivingAccountOnlyAfterTheAuditIsPassedCanThePaymentBeMadeTheRejectedAccountWillNotBeMade:
      'Envíe la modificación de la cuenta de cobro para auditoría; solo tras aprobarse se realizará el pago; las cuentas rechazadas no se pagarán',
    beforeModification3: 'Antes de la modificación',
    pleaseBePatientWhileTheInformationIsBeingReviewed:
      'La información está en revisión, por favor espere',
    groundsForRejection: 'Motivo de rechazo',
    downloadTheAttachmentTemplate2: 'Descargar plantilla de adjunto',
    forPrivacy: 'Cuenta personal',
    forThePublic: 'Cuenta corporativa',
    auditStatus: 'Estado de auditoría',
    viewingModificationLogs2: 'Ver registros de modificación',
    pleaseUploadYourBankCardInformationAsSoonAsPossibleToAvoidAffectingYourPaymentProgress:
      'Cargue la información de la tarjeta bancaria lo antes posible para no afectar el progreso del pago',
    modifyLog2: 'Registro de modificaciones',
    receivablesAccountManagement2: 'Gestión de cuentas de cobro',
    collectionAccountType: 'Tipo de cuenta de cobro',
    pleaseSelectACollectionAccountType: 'Seleccione el tipo de cuenta de cobro',
    bankAccountName5: 'Nombre del titular bancario',
    recipientsCellPhoneNumber: 'Número de móvil del beneficiario',
    pleaseEnterTheRecipientsMobilePhoneNumber: 'Introduzca el número de móvil del beneficiario',
    payeeIdNumber: 'Número de identificación del beneficiario',
    pleaseEnterThePayeeIdNumber: 'Introduzca el número de identificación del beneficiario',
    payeeIdCardFront: 'Anverso del documento del beneficiario',
    reverseOfPayeeIdCard: 'Reverso del documento del beneficiario',
    uploadContractAttachment: 'Cargar adjunto del contrato',
    letterOfRequestForChange2: 'Carta de solicitud de cambio',
    pleaseEnterTheBankAccountName: 'Introduzca el nombre del titular bancario',
    pleaseEnterTheLegalPersonName: 'Introduzca el nombre del representante legal',
    legalPersonNameCanOnlyBeEnteredInChineseCharactersPleaseReEnter:
      'El nombre del representante legal solo admite caracteres chinos, vuelva a introducirlo',
    phoneNumberFormatIsIncorrectPleaseReEnter:
      'Formato del número de teléfono incorrecto, vuelva a introducirlo',
    pleaseEnterYourIdNumber2: 'Introduzca el número de identificación',
    idNumberFormatIsWrongCanOnlyEnterNumbersAndUppercaseLettersPleaseReEnter:
      'Formato del número de identificación incorrecto; solo números y letras mayúsculas',
    pleaseEnterAUnifiedSocialCreditCode: 'Introduzca el código de crédito social unificado',
    onlyNumbersAndLettersAreSupportedPleaseReEnter: 'Solo se admiten números y letras',
    pleaseUploadTheRequestForChange2: 'Cargue la carta de solicitud de cambio',
    frontOfIdentityCard: 'Anverso del documento',
    reverseOfIdCard: 'Reverso del documento',
    businessLicense: 'Licencia comercial',
    pleaseUploadTheContractAttachment: 'Cargue el adjunto del contrato',
    afterModification2: 'Después de la modificación',
    corporateName: 'Nombre del representante legal',
    unifyTheSocialCreditCode: 'Código de crédito social unificado',
    legalPersonMobilePhoneNumber: 'Móvil del representante legal',
    pleaseEnterTheFrenchPhoneNumber: 'Introduzca el móvil del representante legal',
    legalPersonIdNumber: 'Número de identificación del representante legal',
    pleaseEnterTheCorporateIdNumber:
      'Introduzca el número de identificación del representante legal',
    corporateIdentityCardFront: 'Anverso del documento del representante legal',
    reverseOfCorporateIdentityCard: 'Reverso del documento del representante legal',
    pleaseUpload: 'Cargar',
    fileUpload: 'Carga de archivos',
    uploadAMaximumOf2Images: 'Máximo 2 imágenes',
    theSizeOfTheUploadedProfilePictureCannotExceed:
      'El tamaño de la imagen de perfil no puede superar',
    uploadPictureFormatOnlySupported: 'Formato de imagen admitido',
    onlyJpgJpegAndPngFilesCanBeUploaded: 'Solo se admiten archivos jpg, jpeg y png',
    onlyJpgJpegPngFilesCanBeUploadedPleaseUploadTheChangeLetterAsAPhoto:
      'Solo se admiten jpg, jpeg y png; cargue la carta de cambio como una foto',
    pleaseWaitFileUploadIsNotComplete: 'Espere, la carga del archivo no ha finalizado',
    contractStampPageRequired: 'Página del contrato con sello (obligatoria)',
    otherPagesOptional: 'Otras páginas (opcional, hasta 2 imágenes)',
    contractStampInstructions:
      '2. Página del contrato con sello: debe incluir la información de la cuenta de cobro del proveedor y el sello oficial',
    individualMobileNote: 'Nota: si es comerciante individual, complete el móvil del operador',
    individualNameNote: 'Nota: si es comerciante individual, complete el nombre del operador',
    individualIdNote: 'Nota: si es comerciante individual, complete el documento del operador',
    individualRegNumberNote: 'Nota: si es comerciante individual, complete el número de registro',
    maxTwoImages: 'Máximo 2 imágenes',
    recipientLegalMobile: 'Móvil del beneficiario/representante legal',
    recipientLegalIdNumber: 'Documento del beneficiario/representante legal',
  },
  invoicingAddInvoicingApplication: {
    billingApplication: 'Solicitud de facturación',
    // Part 13, lines 2401 to 2600
    expenseType: 'Tipo de gasto:',
    totalAmountApplied: 'Importe total solicitado',
    theApplicationAmountIsIncorrect: 'El importe solicitado es incorrecto',
    status: 'Estado:',
    causeOfRejection: 'Motivo de rechazo:',
    billingInformation: 'Información de facturación:',
    pleaseEnterPhoneNumber: 'Introduzca el teléfono',
    dutyNumber: 'Número fiscal',
    pleaseEnterYourTaxId: 'Introduzca el número fiscal',
    pleaseEnterYourAccountBank: 'Introduzca el banco de apertura',
    pleaseEnterTheAddress: 'Introduzca la dirección',
    openABankAccount: 'Cuenta bancaria',
    pleaseEnterYourBankAccountNumber: 'Introduzca el número de cuenta bancaria',
    pleaseEnterEmail: 'Introduzca el correo electrónico',
    pickUpTelephone: 'Teléfono de recepción',
    pleaseEnterTheReceivingPhoneNumber: 'Introduzca el teléfono de recepción',
    mailingAddress: 'Dirección postal',
    pleaseEnterYourMailingAddress: 'Introduzca la dirección postal',
    addressee: 'Destinatario',
    pleaseEnterTheRecipient: 'Introduzca el destinatario',
    repudiationPeriod: 'Período rechazado:',
    claimPeriod: 'Período solicitado:',
    pleaseEnterTheAmountRequested: 'Introduzca el importe solicitado',
    theNumberCannotExceed15Digits: 'El número no puede exceder 15 dígitos',
    pleaseEnterTheCorrectNumber: 'Introduzca el número correcto',
    paymentPeriod: 'Período de facturación',
    availableAmount: 'Importe disponible',
    amountApplied2: 'Importe solicitado',
    pleaseSelectTheBillingType5: 'Seleccione el tipo de facturación',
    receipt: 'Recibo',
    pleaseEnterTitle: 'Introduzca el título',
    theCurrentlySelectedFeeTypeDoesNotHaveBillingDataPleaseSelectAgain:
      'El tipo de gasto seleccionado no tiene datos de facturación, seleccione nuevamente',
    theTotalApplicationAmountNeedsToBeGreaterThan: 'El importe total solicitado debe ser mayor que',
    invoicingTypeAndFeeTypeDoNotCorrespondTheReceiptCanOnlyMatchTheDepositAndQualityDeposit:
      'El tipo de factura y el tipo de gasto no corresponden; el recibo solo puede corresponder a depósitos y depósitos de calidad',
    thePageIsAutomaticallyClosed5SecondsAfterSubmission:
      'Envío exitoso, la página se cerrará automáticamente en 5 s',
    generalInvoice: 'Factura ordinaria (factura electrónica)',
    specialInvoice: 'Factura especial (factura electrónica)',
  },
  invoicingInvoicingApplication: {
    applicationDate: 'Fecha de solicitud',
    billingApplication: 'Solicitud de facturación',
    expenseType: 'Tipo de gasto',
    amountApplied2: 'Importe solicitado',
    expressNumber: 'Número de envío',
    alreadyRequested: 'Ya solicitado',
  },
  preauthorizationIndex: {
    turn: 'Transferir',
    increaseAuthorization: 'Aumentar autorización',
    authorizationFailure: 'Fallo de autorización',
    settlementTime: 'Hora de liquidación',
    preAuthorizationDetailsLightWinTreasureHotelManagementSystem:
      'Detalles de preautorización - Sistema de gestión hotelera Light Win Treasure',
    declined: 'Rechazado',
    flyingPigCreditDoesNotSupportPreAuthorization:
      'El crédito Fliggy no admite preautorización por el momento',
    newAuthorization: 'Nueva autorización',
    cancelAuthorizationPleaseWait: 'Cancelando autorización, espere',
    succeededInCancelingAuthorization: 'Autorización cancelada con éxito',
    pleaseWaitForTheSettlementAuthorization: 'Liquidando autorización, espere',
    confirmThatYouWantToCancelAuthorization: 'Confirme que desea cancelar la autorización',
    orderStatusWarning: 'El pedido está {status}, no se puede {action}',
    roomStatusWarning: 'La habitación ya está ocupada, no se puede {action}',
    roomCheckoutWarning: "El estado de la habitación es 'check-out', no se puede {action}",
  },
  componentsAuthsettle: {
    payment3: 'Pago',
    paidInAmount: 'Importe cobrado',
    settlementSuccess: 'Liquidación exitosa',
    authorizedSettlement: 'Liquidación autorizada',
    accountEntry: 'Cuenta de registro',
    pleaseFillInTheAuthorizedAmount: 'Introduzca el importe autorizado',
    theActualAmountReceivedMustBeGreaterThan0: 'El importe cobrado debe ser mayor que 0',
    theActualAmountReceivedCannotBeGreaterThanTheAuthorizedAmount:
      'El importe cobrado no puede ser mayor que el importe autorizado',
  },
  componentsBanklist: {
    bankOfChina: 'Banco de China',
    industrialAndCommercialBankOfChina: 'Banco Industrial y Comercial de China',
    industrialAndCommercialBankOfChina3: 'ICBC',
    agriculturalBankOfChina: 'Banco Agrícola de China',
    agriculturalBankOfChina3: 'Banco Agrícola',
    chinaConstructionBank: 'Banco de Construcción de China',
    chinaConstructionBank3: 'Banco de Construcción',
    postalSavingsBankOfChina: 'Banco Postal de Ahorros de China',
    postalSavingsBank: 'Banco Postal',
    bankOfCommunications: 'Banco de Comunicaciones',
    chinaMerchantsBank: 'Banco Mercantil de China',
    shanghaiPudongDevelopmentBank: 'Banco de Desarrollo de Pudong de Shanghái',
    shanghaiPudongDevelopmentBank3: 'SPDB',
    chinaCiticBank: 'Banco CITIC de China',
    everbrightBank: 'Banco Everbright',
    chinaMinshengBank: 'Banco Minsheng de China',
    minshengBank: 'Banco Minsheng',
    guangdongDevelopmentBank: 'Banco de Desarrollo de Guangdong',
    guangfaBank: 'Banco Guangfa',
    pingAnBank: 'Banco Ping An',
    industrialBank: 'Banco Industrial',
    huaxiaBank: 'Banco Huaxia',
    bankOfShanghai: 'Banco de Shanghái',
    bankOfBeijing: 'Banco de Pekín',
    bohaiBank: 'Banco Bohai',
    zheshangBank: 'Banco Zheshang',
    huishangBank: 'Banco Huishang',
    hsbc: 'Banco HSBC',
    hangSengBank: 'Banco Hang Seng',
    hengfengBank: 'Banco Hengfeng',
  },
  componentsExpandcolumn: {
    bankName: 'Nombre del banco',
    authorizationCode: 'Código de autorización',
    from: 'Desde',
    rollOutTo: 'Transferir a',
  },
  componentsTransferaccounts: {
    transferMoney: 'Transferir',
    transferToAccount: 'Cuenta de destino',
    authorizationFailure: 'Fallo de autorización',
  },
  componentsUpdateauthorization: {
    automaticSettlementAfterExpiration: 'Liquidación automática tras el vencimiento',
    authorizationCode: 'Código de autorización',
    bankName: 'Nombre del banco',
    pleaseFillInTheAuthorizedAmount: 'Introduzca el importe autorizado',
    newAuthorization: 'Nueva autorización',
    modifyAuthorization: 'Modificar autorización',
    renewal: 'Actualizar',
  },
  componentsCancelorder: {
    reminderThisOrderIsAnEbOrderPleaseVerifyTheOtaOrderStatusBeforeCancellation:
      'Aviso: este pedido es EB; verifique el estado del pedido OTA antes de cancelarlo',
    orderCancelledSuccessfully: 'Pedido cancelado con éxito',
    cancelAnOrder2: 'Cancelar pedido',
    cancellationReason: 'Motivo de cancelación',
    remarks5100Words: 'Observaciones (5–100 caracteres)',
    replyTextMinimum5Words: 'El texto de respuesta debe tener al menos 5 caracteres',
    pleaseSelectACancellationReason: 'Seleccione el motivo de cancelación',
    originalStayWillBeCancelled: 'La extensión del pedido original se cancelará automáticamente',
    cancellationRules: 'Reglas de cancelación',
    channelDescription: 'Descripción del canal',
    refundScore: 'Reembolsar puntos',
    refundCoupon: 'Reembolsar cupón',
    orderMessage: 'Mensaje del pedido',
    pleaseEnterOrderMessage: 'Introduzca el mensaje del pedido',
    directCancelSuccessComment: 'Pedido cancelado con éxito',
  },
  componentsEditcontactinfo: {
    modifyAContact: 'Modificar contacto',
    pleaseEnterThe11DigitPhoneNumber: 'Introduzca el número de móvil de 11 dígitos',
  },
  componentsEditorder: {
    modifyTheOrder2: 'Modificar pedido',
    selectDate1: 'Seleccionar fecha 1',
    selectDate2: 'Seleccionar fecha 2',
    contactNumber4: 'Teléfono de contacto',
    theRetentionTimeMustNotBeLessThanTheCurrentTime:
      'La hora de retención no puede ser anterior a la hora actual',
    theRetentionTimeShallNotBeLessThanTheEstimatedArrivalTime:
      'La hora de retención no puede ser anterior a la hora estimada de llegada',
    theRetentionTimeMustNotBeLongerThanThePreDepartureTime:
      'La hora de retención no puede ser posterior a la hora prevista de salida',
    doNotRepeatThisOperationWhileSubmittingChanges:
      'No repita esta operación mientras se envían los cambios',
    orderModificationSuccessful: 'Pedido modificado con éxito',
  },
  componentsEditOrderV2: {
    addedRoomsOverAvailability: 'El número de habitaciones añadidas no puede superar la disponibilidad',
    arrivalBeforeToday: 'La fecha de llegada de una nueva habitación no puede ser anterior a hoy',
    assignedRoom: 'Habitación asignada {room}',
    availabilityLoading: 'Cargando la disponibilidad de este tipo de habitación. Inténtelo más tarde',
    availableCount: 'Disponibles: {count}',
    checkedInRoom: 'Alojada {room}',
    checkedOutRoom: 'Salida realizada {room}',
    chooseArrivalTime: 'Seleccione la hora de llegada',
    chooseDepartureTime: 'Seleccione la hora de salida',
    detailLoadFailed: 'No se pudieron cargar los datos de modificación del pedido',
    detailLoadRetry: 'No se pudieron cargar los datos de modificación del pedido. Inténtelo de nuevo',
    discountLabel: '{discount}% de descuento sobre la tarifa mostrador',
    invalidStay: 'Seleccione horas de llegada y salida válidas',
    keepOneRoom: 'Debe conservarse al menos una habitación válida después de la modificación',
    latestPriceFailed: 'No se pudieron cargar las últimas tarifas. Ajuste las fechas e inténtelo de nuevo',
    latestPriceLoading: 'Cargando las últimas tarifas. Envíe los cambios más tarde',
    longStayAtLeastTenDays: 'La estancia de una reserva de larga duración debe ser de al menos 10 días',
    longStayAtMostOneYear: 'La estancia de una reserva de larga duración no puede superar un año',
    longStayNoMorning: 'Las habitaciones de madrugada no están permitidas en reservas de larga duración',
    markedCancelled: 'Marcada para cancelar',
    newRoomOrder: 'Nueva habitación',
    newRoomPriceLoading: 'Cargando fechas y tarifas de las nuevas habitaciones. Envíe los cambios más tarde',
    noReducibleRoom: 'No hay habitaciones temporales o pendientes que puedan reducirse para este tipo',
    otherStatus: 'Otro estado',
    phonePlaceholder: 'Introduzca el número de móvil',
    productPriceFailed: 'No se pudieron cargar los productos y tarifas del hotel. Inténtelo de nuevo',
    roomNumberValue: 'Habitación {room}',
    roomOrderDetails: 'Detalles',
    roomTypeInfo: 'Información del tipo de habitación',
    roomTypeNoProduct: 'No hay productos disponibles para este tipo de habitación',
    stayChangedClearRoom: 'Las fechas cambiaron. Se eliminó la asignación anterior; vuelva a asignar una habitación',
    stayPriceRefreshFailed: 'No se pudieron cargar las tarifas tras cambiar las fechas. Inténtelo de nuevo',
    stayProductPriceFailed: 'No se pudieron cargar los productos y tarifas para la estancia seleccionada',
    stayProductUnavailable: 'No hay productos disponibles para este tipo de habitación durante la estancia seleccionada',
    storeProductMissing: 'No se encontró ningún producto del hotel',
    temporaryRoomOrder: 'Habitación temporal',
    unassignedSummary: '{count} habitación(es) pendientes de asignación',
  },
  componentsEditroomorder: {
    modifyingTheAgreedUnitInformationWillRecalculateAllRoomRatesInTheOrder:
      'Modificar la información de la unidad acordada recalculará todas las tarifas de habitación del pedido',
    modifyRoomList: 'Modificar lista de habitaciones',
  },
  componentsEditroomprice: {
    modifyTheHousePrice: 'Modificar tarifa de habitación',
    theCurrentPriceCalendarCannotBeModified:
      'El calendario de precios actual no se puede modificar',
    updatePriceCalendarSuccessfully: 'Calendario de precios actualizado con éxito',
  },
  componentsLevelup: {
    payTheBill: 'Pagar',
    partUpgrade: 'Parte de mejora',
    confirmTheUpgrade: 'Confirmar mejora',
    currentRoomType: 'Tipo de habitación actual',
    reselection: 'Reelegir',
    chargeOrNot: '¿Cobrar?',
    currentTotalHousePrice: 'Precio total actual',
    totalRateAfterUpgrade: 'Precio total tras la mejora',
    priceDifference: 'Diferencia de precio',
    upgradeCause: 'Motivo de la mejora',
    enterAMaximumOf150Words: 'Máximo 150 caracteres',
    pleaseChooseWhetherToCharge: 'Seleccione si se cobrará',
    pleaseEnterTheUpgradeReason: 'Introduzca el motivo de la mejora',
    inTheCaseOfPaymentTheSpreadCannotBeLessThanOrEqualTo0:
      'Si es de pago, la diferencia no puede ser menor o igual a 0',
    reminderIfYouUpgradeTheRoomTypeBetweenTheNightAuditAnd0600PleaseManuallyHandleTheRoomRateDifference:
      'Aviso: si se mejora el tipo de habitación entre el cierre nocturno y las 06:00, gestione manualmente la diferencia de tarifa',
  },
  componentsSeeroomprice: {
    viewRoomRates: 'Ver tarifas de habitación',
  },
  componentsStay: {
    theCurrentRoomTypeIsSoldOutPleaseSelectAnotherDate:
      'El tipo de habitación actual está agotado, seleccione otra fecha',
    existingRoomSingleChargeCheckOut: 'Check-out con cargo a cuenta de la habitación actual',
    theAccountOfTheExistingHouseBillIsTransferredToTheNewHouseBill:
      'La cuenta del pedido actual se transfiere al nuevo pedido y luego se hace check-out',
    promptTheCurrentRoomIsALinkedRoomBillAfterExtendingTheStayYouNeedToManuallyAddTheNewRoomBillToTheLinkedRooms:
      'Aviso: la habitación actual es una factura vinculada; tras extender la estancia, debe añadir manualmente la nueva factura a las habitaciones vinculadas',
    nonStoreSingleCanNotSustain: 'Los pedidos que no son de la tienda no admiten extensión',
    youCannotRenewYourStayUntilTheCheckOutDate:
      'No se puede extender la estancia antes de la fecha de salida',
    extendStayadvance: 'Extender/Adelantar',
    originalOrder2: 'Pedido original',
    continuationPrice: 'Precio de extensión',
    changeTheCheckOutTime: 'Cambiar la hora de salida',
    selectDateTime: 'Seleccionar fecha y hora',
    continuationPriceRule: 'Regla de precio de extensión',
    swapOrder: 'Cambiar pedido',
    nameAndMobilePhoneNumberOfThePersonWhoMadeTheReservation:
      'Nombre y móvil del titular de la reserva',
    // Part 14, lines 2601 to 2800
    subscriber: 'Titular de la reserva',
    roomAccountProcessing: 'Procesamiento de la cuenta de la habitación',
    pleaseSelectTheRenewalPriceRule: 'Seleccione la regla de precio para la extensión',
    checkOutTimeCannotBeLessThanTheCurrentTime:
      'La hora de salida no puede ser anterior a la hora actual',
    theRenewalOfStayIsSuccessful: 'La extensión de la estancia se realizó con éxito',
    pleaseSelectANewOrder: 'Seleccione un nuevo pedido',
    theRenewalOfTheOrderDoesNotSupportTheFlyingPigCreditOrder:
      'La extensión mediante cambio de pedido no admite pedidos de crédito Fliggy',
    extendStayadvanceSuccess: 'Prórroga de estancia / salida anticipada exitosa',
    roomNumber: 'Nº Habitación',
    checkInPerson: 'Huésped',
    checkOutTime: 'Hora de salida',
    makeCard: 'Crear tarjeta',
    booked: 'Contabilizar',
    close: 'Cerrar',
  },
  componentsTools: {
    pendingClosing: 'Pendiente de solicitar cierre',
    closingSuccessful: 'Solicitud de cierre exitosa',
    failedToApplyForClosing: 'Error al solicitar el cierre',
    firstNightRate: 'Tarifa de la primera noche',
    lateNightRate: 'Tarifa de la última noche',
    maximumHousePrice: 'Tarifa máxima',
    minimumRoomRate: 'Tarifa mínima',
  },
  ebkorderIndex: {
    priceDescription: 'Descripción de precios',
    merchantPromotionTotalAmountBorneByTheMerchant:
      'Promoción del comerciante = total asumido por el comerciante',
    totalSellingPriceTotalOrderAmountMerchantPromotion:
      'Total de venta = total del pedido − promoción del comerciante',
    totalCommissionTotalSellingPriceCommissionRate:
      'Comisión total = total de venta × tasa de comisión',
    totalBasePriceTotalSellingPriceTotalCommission:
      'Precio base total = total de venta − comisión total',
    userPaymentAmountActuallyPaidByTheUser: 'Pago del usuario = importe realmente pagado',
    totalOrder: 'Total del pedido',
    totalSellingPrice: 'Total de venta',
    userPayment: 'Pago del usuario',
    totalCommission: 'Comisión total',
    totalFloorPrice: 'Precio base total',
    merchantPromotion: 'Promoción del comerciante',
    viewOrder: 'Ver pedido',
    orderTransferMethod: 'Método de traslado del pedido',
    removalOfOrder: 'Trasladar pedido',
    contactAndMobilePhoneNumber: 'Contacto y teléfono móvil',
    channelOrderStatus: 'Estado del pedido del canal',
    orderStatus: 'Estado del traslado',
    channelOrderNumber: 'Número de pedido del canal',
    channelType: 'Tipo de habitación del canal',
    expectedArrivalexpectedDeparture: 'Llegada prevista / Salida prevista',
    bookingType: 'Tipo de reserva',
    estimatedTimeOfArrival: 'Hora estimada de llegada',
    orderCreationTime: 'Hora de creación del pedido',
    inBooking: 'En reserva',
    bookingFailed: 'Reserva fallida',
    bookingException: 'Excepción de reserva',
    initialRejection: 'Rechazo inicial',
    canceling: 'Cancelando',
    otherStates: 'Otros estados',
    movedOrder: 'Pedido trasladado',
    unmovedOrder: 'Pedido no trasladado',
    createTimeDesc: 'Hora de creación descendente',
    createTimeAsc: 'Hora de creación ascendente',
    arriveTimeDesc: 'Hora de llegada descendente',
    arriveTimeAsc: 'Hora de llegada ascendente',
    ebkOrderCheckMsg: 'No hay datos, haga clic para añadir',
  },
  ebkorderUnbindtip: {
    youDoNotHaveAMeituanAccount: 'Aún no ha vinculado una cuenta de Meituan',
    pleaseSetItInmoresystemSettingsebAccountAuthorization:
      'Configúrelo en [Más] - [Configuración del sistema] - [Autorización de cuenta EB]',
    clickToGo: 'Haga clic para ir',
  },
  orderBoxIndex: {
    title: 'Caja de pedidos',
    businessType: 'Tipo de negocio',
    processStatus: 'Estado de procesamiento',
    businessTypeCreateOrder: 'Crear pedido',
    businessTypeCancelOrder: 'Cancelar pedido',
    businessTypeCheckout: 'Check-out',
    businessTypeExtendStay: 'Extender estancia',
    statusPending: 'Pendiente',
    statusProcessing: 'En proceso',
    statusProcessed: 'Procesado',
    quickAccept: 'Aceptación rápida',
    confirmQuickAccept: '¿Confirmar aceptación rápida de este pedido?',
  },
  invoiceInvoiceDetail: {
    personage: 'Persona',
    firm: 'Empresa',
    headerType: 'Tipo de encabezado',
    invoiceAmount2: 'Importe de la factura',
    pleaseEnterTheInvoiceAmount: 'Introduzca el importe de la factura',
    pleaseEnterTheInvoiceNumber2: 'Introduzca el número de factura',
    invoiceGroup: 'Agrupar facturación',
    selectRoomList: 'Seleccionar lista de habitaciones',
    orderAmount: 'Importe del pedido',
    pleaseEnterTheInvoiceTitleToSearch: 'Introduzca el encabezado de la factura para buscar',
    pleaseEnterYourTaxIdentificationNumber: 'Introduzca el número de identificación fiscal',
    unitAddress: 'Dirección de la empresa',
    pleaseEnterTheAddressOfTheUnit: 'Introduzca la dirección de la empresa',
    telephoneNumber: 'Número de teléfono',
    bankOfDeposit2: 'Banco de depósito',
    pleaseEnterYourBank: 'Introduzca el banco',
    bankAccount: 'Cuenta bancaria',
    pleaseEnterYourBankAccount: 'Introduzca la cuenta bancaria',
    pleaseEnterYourEmailAddress: 'Introduzca el correo electrónico',
    invoiceMailingAddress: 'Dirección postal de la factura',
    pleaseEnterTheInvoiceMailingAddress: 'Introduzca la dirección postal de la factura',
    billingNote: 'Nota de facturación',
    pleaseEnterYourBillingRemarks: 'Introduzca las observaciones de facturación',
    pleaseSelectTheBillingType5: 'Seleccione el tipo de facturación',
    pleaseSelectAHeaderType: 'Seleccione el tipo de encabezado',
    fillInAtLeastOneEMailAndMailingAddress:
      'Complete al menos el correo electrónico o la dirección postal',
  },
  invoiceInvoiceList: {
    toBeInvoiced: 'Pendiente de facturar',
    pleaseEnterYourTaxIdentificationNumber: 'Introduzca el número de identificación fiscal',
    pleaseEnterTheInvoiceNumber2: 'Introduzca el número de factura',
    newInvoice: 'Nueva factura',
    invoiceType: 'Tipo de factura',
    invoiceAmount: 'Importe de facturación',
    billingTime: 'Hora de facturación',
  },
  invoiceRoomInvoiceAssociationSearch: {
    roomListInvoiceList2: 'Lista de facturas por habitación',
    namePhoneNumberRoomNumber: 'Nombre del huésped, teléfono, número de habitación',
  },
  invoiceRoomInvoiceList: {
    roomListInvoiceList2: 'Lista de facturas por habitación',
    accumulatedInvoiceAmount: 'Importe acumulado de facturas',
    toBeInvoiced: 'Pendiente de facturar',
    newInvoice: 'Nueva factura',
    invoiceType: 'Tipo de factura',
    invoiceAmount: 'Importe de facturación',
    billingTime: 'Hora de facturación',
  },
  orderListBaseinfo: {
    getThePhoneNumber: 'Obtener número de teléfono',
    preSaleVoucherNumber: 'Número del cupón de preventa',
    contractNumber: 'Número de contrato',
    invoice: 'Factura',
    promotionalActivity: 'Actividad promocional',
    estimatedSettlementAmount: 'Importe estimado de liquidación',
    pack: 'Paquete',
    selfServiceReservation: 'Reserva en autoservicio',
    theInvoiceForThisOrderIsProvidedByTheSalesChannelToTheGuest2:
      'La factura de este pedido la proporciona el canal de ventas al huésped',
    thisOrderIsInvoicedByYourHotelToTheGuest:
      'La factura de este pedido la emite su hotel al huésped',
    theAmountIsForReferenceOnlyTheSpecificSettlementAmountIsSubjectToTheBill:
      'Este importe es solo de referencia; el importe de liquidación específico está sujeto al estado de cuenta',
    systemRemark: 'Observación del sistema',
    sellerRemark: 'Observación del comerciante',
  },
  orderListCheckIn: {
    handleSuccessfully: 'Gestión exitosa',
    viewCheckInInformation: 'Ver información de check-in',
    handleAgain: 'Gestionar nuevamente',
    handlingFailure: 'Error en la gestión',
    theNameCannotBeBlank2: 'El nombre no puede estar vacío',
    theIdTypeCannotBeEmpty: 'El tipo de documento no puede estar vacío',
    theIdNumberCannotBeEmpty: 'El número de documento no puede estar vacío',
    pleaseArrangeTheRoomFirst: 'Por favor, asigne la habitación primero',
    checkInData: 'Datos del registro de check-in',
  },
  orderListDetail: {
    checkInStatus: 'Estado de check-in',
    total: 'Total',
    chargedToAccount: 'Cargado a cuenta',
    natureTraffic: 'Tráfico orgánico',
    natureOrderTip: 'Este pedido proviene del canal de reservas de venta directa de Qingzhu',
    preCheckInForm: 'Formulario de pre check-in',
    continuationOrder: 'Pedido de extensión',
    liveOnCredit: 'Estancia a crédito',
    preSaleVoucherReservationForm: 'Formulario de reserva de cupón de preventa',
    meituanEbOrder: 'Pedido EB de Meituan',
    ctripEbOrder: 'Pedido EB de Ctrip',
    flash: 'Flash',
    fullGuarantee: 'Garantía total',
    roomListInformation: 'Información de la lista de habitaciones',
    automaticRowHouse: 'Asignación automática',
    bulkCheckIn: 'Check-in masivo',
    unterracedHouse: 'Sin asignar',
    upgrades: 'Mejoras',
    prefabricatedKeyCard: 'Tarjeta llave preconfigurada',
    modifyTheOrder2: 'Modificar pedido',
    cancelAnOrder2: 'Cancelar pedido',
    rejectAnOrder: 'Rechazar pedido',
    pleaseArrangeTheRoomBeforePreformingTheKeyCard:
      'Asigne la habitación antes de preparar la tarjeta',
    theListingHasBeenCancelled: 'Esta habitación ha sido cancelada',
    noRoomingAllowedAfterThePreDepartureTime:
      'No se permite asignar habitaciones después de la hora prevista de salida',
    allListingsAreAlreadyFurnished: 'Todas las habitaciones ya han sido asignadas',
    theAutomaticPlatoonSucceeded: 'Asignación automática exitosa',
    someRowhousesAreSuccessful: 'Asignación parcial exitosa',
    smartCheckInBusinessHasNotOpenedTheFunction:
      'El comerciante no ha habilitado la función de check-in inteligente',
    thisOrderIsARenewalOrderCheckInMayAffectTheOriginalRoomRenewal:
      'Este pedido es de extensión; el check-in puede afectar la extensión de la habitación original',
    thisOrderIsARenewalOrderWhichMayAffectTheContinuationOfTheOriginalRoom:
      'Este pedido es de extensión; continuar puede afectar la extensión de la habitación original',
    exceedDepartureDate:
      'Se ha superado la fecha prevista de salida; no se permite mejorar el tipo de habitación',
    theCurrentTimeHasExceededTheCheckOutTimeCannotUpgradeTheRoom:
      'La hora actual ha superado la hora de salida; no se admite la mejora de habitación',
    cancelingTheCurrentRowSucceededProcedure: 'Cancelación de la asignación actual exitosa',
    orderAcceptedSuccessfully: 'Pedido aceptado con éxito',
    successfulRejection: 'Rechazo exitoso',
    thisActionWillCancelTheListingWhetherToContinue:
      'Esta acción cancelará la habitación, ¿desea continuar?',
  },
  orderListGiftinfodetail: {
    packageName: 'Nombre del paquete',
    packageValue: 'Valor del paquete',
    wayOfGiving: 'Forma de entrega',
    dateOfPresentation2: 'Fecha de entrega',
    packageDetails: 'Detalles del paquete',
    oneDeliveryPerRoom: 'Una entrega por habitación',
    complimentaryOnceADayPerRoom: 'Una cortesía diaria por habitación',
  },
  orderListOrderDetail: {
    orderDetails: 'Detalles del pedido',
    finance3: 'Finanzas',
    preAuthorizationDetail: 'Detalles de preautorización',
  },
  orderListOrderList: {
    durationOfResidence: 'Duración de la estancia',
    bookingTime: 'Hora de reserva',
    preCheckInForm: 'Formulario de pre check-in',
    housePig: 'House Pig',
    presaleTicket: 'Cupón de preventa',
    // Part 15, lines 2801 to 3000
    nameMobilePhoneNumberOrderNumberChannelNumberQuery:
      'Consulta por nombre, teléfono móvil, número de pedido o número de canal',
    multipleSearch: 'Búsqueda múltiple',
    selfServiceReservation: 'Reserva en autoservicio',
    rejectAnOrder: 'Rechazar pedido',
    individualTraveler: 'Huésped individual',
    team2: 'Grupo',
    estimate: 'Llegada prevista',
    firstDayPrice: 'Precio del primer día',
    areYouSureYouWantToTakeTheOrder: '¿Está seguro de que desea aceptar el pedido?',
    orderAcceptedSuccessfully: 'Pedido aceptado con éxito',
    booked: 'Reservado',
    refused: 'Rechazado',
    extendStayCheckInImpact:
      'Este pedido es de extensión; el check-in puede afectar la extensión de la habitación original',
    exceededDepartureCannotUpgrade:
      'Se ha superado la fecha prevista de salida a las 6:00; no se permite mejorar el tipo de habitación',
    exceededCheckoutCannotUpgrade:
      'La hora actual ha superado la hora de salida; no se admite la mejora de habitación',
    exceededDepartureCannotArrangeRoom:
      'Se ha superado la hora prevista de salida; no se permite asignar habitaciones',
    preArrivalNotArrived: 'Llegada prevista no presentada',
    noshow: 'No-show',
  },
  orderListNoShow: {
    title: 'No-show',
    noshowReason: 'Motivo de no-show',
    remarkPlaceholder: 'Observaciones (5-100 caracteres)',
    remarkMinLength: 'Las observaciones deben tener al menos 5 caracteres',
    pleaseSelectNoshowReason: 'Seleccione un motivo de no-show',
  },
  orderListPricedetail: {
    channelCost: 'Precio original del canal',
    eventDiscount: 'Descuento de actividad',
    guestActivityDiscount: 'Descuento de actividad del huésped',
    memberDiscount: 'Descuento de miembro',
    guestMembershipDiscount: 'Descuento de membresía del huésped',
    sameTripExclusiveOffer: 'Oferta exclusiva Tongcheng',
    guestTongchengExclusiveDiscount: 'Descuento exclusivo Tongcheng para el huésped',
    guestPurchasePrice: 'Precio de compra del huésped',
    activityDiscountAndHotelSellingPriceExplanationThereWillBeADifferenceBetweenTheGuestsOfThisChannelAndTheSettlementBillYouCanClickpricePromptToViewTheActualAmountPaidByTheGuests:
      'Explicación de descuentos y precio de venta del hotel: puede haber diferencias entre los huéspedes de este canal y la liquidación; haga clic en “Aviso de precio” para ver el importe real pagado',
    priceDetails: 'Detalles de precio',
    memberBenefits: 'Beneficios de membresía',
    jointMemberBenefits: 'Beneficios de membresía conjunta',
  },
  orderListPromotiondetail: {
    eventDetails2: 'Detalles de la actividad',
    preferentialRules: 'Reglas de descuento',
  },
  orderListPromotiondetailnew: {
    eventDetails2: 'Detalles de la actividad',
    dateCondition: 'Condición de fecha',
    bookingConditions: 'Condiciones de reserva',
    preferentialRules: 'Reglas de descuento',
    participationDate: 'Fecha de participación',
  },
  orderListRefuse: {
    areYouSureYouWantToDeclineThisOrder: '¿Confirma que desea rechazar este pedido?',
    confirmationRejection: 'Confirmar rechazo',
    successfulRejection: 'Rechazo exitoso',
    theOrderWillBeClosedAtTheSameTime: 'Tras rechazar, el pedido se cerrará al mismo tiempo',
    overbookingSetup: 'Configuración de sobreventa',
  },
  orderListTip: {
    useWechatToScanThecheckInQrCodeAtTheFrontDeskToOpenTheOrderInquiryPage:
      'Use WeChat para escanear el “código QR de check-in” en recepción y abrir la página de consulta de pedidos',
    fillInTheBookingPersonsNameMobilePhoneNumberAndCheckInDateToCheckTheBookingForm:
      'Complete el nombre del titular, teléfono móvil y fecha de check-in para consultar la reserva',
    selectTheBookingFormThatNeedsToBeCheckedInAndSelectTheRoomWhereYouWantToAddPeopleToFillInTheInformation:
      'Seleccione la reserva que necesita check-in y elija la habitación para añadir huéspedes y completar la información',
    atThisPointYouCanViewTheRoomAlertInThePreOrderDetailsAfterFillingInTheInformationOfAllTheGuestsClickThecheckInButtonToCheckInTheGuests:
      'En este punto, puede ver la alerta de la habitación en los detalles de la pre-reserva; tras completar los datos, haga clic en “Check-in” para registrar a los huéspedes',
    atThisPointYouCanSeeInTheListDetailsThatThePersonHasBeenAddedSuccessfully:
      'En este punto, puede ver en los detalles de la habitación que el huésped se ha añadido correctamente',
    off: 'Cerrar',
    theUserHasCompletedTheProcedure: 'El usuario ha completado el proceso',
    pleaseGuideTheGuestsTocheckInInTheFollowingWay:
      'Guíe a los huéspedes para realizar el “check-in” de la siguiente manera',
    afterTheGuestsFillInAndSubmitThePageWillDisplaypleaseBringYourIdToTheFrontDeskForVerification:
      'Tras completar y enviar, la página mostrará “Por favor, lleve su documento a recepción para verificación”',
    pleaseGuideTheGuestsToAddAdditionalGuestsAsFollows:
      'Guíe a los huéspedes para “añadir huéspedes” de la siguiente manera',
  },
  groupOrderAddroomer: {
    validityPeriod: 'Periodo de validez',
    addmodifyCheckInGuests: 'Añadir/Modificar huéspedes',
    pleaseEnterAddress: 'Introduzca la dirección',
    startDate: 'Fecha de inicio',
    currentSubscript: 'Índice actual',
  },
  groupOrderIndex: {
    bulkCheckIn: 'Check-in por lotes',
    automaticRowHouse: 'Asignación automática',
    checkInAddition: 'Añadir huéspedes',
    pleaseSelectTheRoomYouWantToCheckIn: 'Seleccione la habitación para realizar el check-in',
    theEmptyAndDirtyRoomYouSelectedIsConfirmedToCheckIn:
      'La habitación seleccionada está vacía y sucia; ¿confirma el check-in?',
    checkInSuccessful: 'Check-in realizado con éxito',
    roomNoLongerAvailablePleaseChangeToAnotherRoomNumber:
      'La habitación está fuera de servicio; cambie a otra',
    theRoomIsOccupiedPleaseChangeToAnotherRoomNumber: 'La habitación está ocupada; cambie a otra',
    pleaseArrangeTheRoomBeforeChoosing: 'Asigne la habitación antes de seleccionar',
    allListingsAreAlreadyFurnished: 'Todas las habitaciones ya han sido asignadas',
    theAutomaticPlatoonSucceeded: 'Asignación automática exitosa',
    pleaseListTheRoomFirstAndThenAddTheGuest:
      'Asigne primero la habitación y luego añada al huésped',
    succeededInCancelingTheRowHouse: 'Cancelación de asignación exitosa',
  },
  presalecouponsPredetail: {
    ticketName: 'Nombre del cupón de preventa',
    presaleTicket: 'Cupón de preventa',
    saleOrderNumber: 'Número de pedido de venta',
    purchaseTime: 'Hora de compra',
    advanceOrder: 'Pedido de reserva',
    availableProduct: 'Producto disponible',
    commodityContent: 'Contenido del producto',
    ruleInformation: 'Información de reglas',
    availableTime: 'Tiempo disponible para reservar',
    checkInTime2: 'Tiempo disponible para check-in',
    markUpRule: 'Regla de recargo',
    cancellationRules: 'Reglas de cancelación',
    paymentInformation: 'Información de pago',
    crossedPrice: 'Precio tachado',
    chineseFood: 'Comida china',
    dinner2: 'Cena',
    bookedBedtotalBedHours: 'Noches reservadas / Noches totales (horas)',
    raiseAPrice: 'Aplicar recargo',
    meituanDirectNew: 'Meituan directo (nuevo)',
    officialWebsiteDirect: 'Sitio web oficial directo',
    ctripSingleStore: 'Ctrip tienda individual',
    agoda: 'Agoda',
    meituanHomestay: 'Meituan Homestay',
    tujiaHomestay: 'Tujia Homestay',
    booking: 'Booking',
    expedia: 'Expedia',
  },
  presalecouponsPrelist: {
    dateOfPayment: 'Fecha de pago',
    productId: 'ID de producto',
    sellOrderNumber: 'Número de pedido de venta',
    noAppointment: 'Sin reserva',
    completeWriteOff: 'Compensación total',
    completeReverseWriteOff: 'Compensación total inversa',
    refunded: 'Reembolsado',
    orderNumber2: 'Número de pedido',
    timeOfPayment: 'Hora de pago',
    bookedBedtotalBedHours: 'Noches reservadas / Noches totales (horas)',
  },
  hardwareParking: {
    parkingLotManagement: 'Gestión del estacionamiento',
    parkingLotDescription: 'Permite reconocer matrículas automáticamente para entrada y salida',
    settings: 'Configuración',
    parkingLotConfig: 'Configuración del estacionamiento',
    currentDevice: 'Dispositivo actual',
    unboundDeviceTip: 'El hotel actual no tiene vinculado ningún dispositivo de estacionamiento',
    sidPlaceholder: 'Introduzca el SID',
    secretKeyPlaceholder: 'Introduzca el SecretKey',
    enableStatus: 'Estado de activación',
    hotelNotBoundWarning: 'El hotel actual no tiene vinculado ningún dispositivo de estacionamiento',
    enterSidAndSecretKey: 'Introduzca el SID y el SecretKey',
    saveSuccess: 'Guardado correctamente',
    saveFailed: 'Error al guardar',
    configFailed: 'Error de configuración',
    parkingDeviceEnabled: 'Dispositivo de estacionamiento activado',
    parkingDeviceDisabled: 'Dispositivo de estacionamiento desactivado',
    fetchHardwareRelationFailed: 'Error al obtener la relación de vinculación del hardware',
    fetchConfigFailed: 'Error al obtener la configuración del estacionamiento',
  },
  roomOrderListVehicleDialog: {
    title: 'Matrícula',
    platePlaceholder: 'Introduzca la matrícula',
    add: 'Añadir',
    plateNo: 'Matrícula',
    enterPlateWarning: 'Introduzca la matrícula',
    enterPlateFormatWarning: 'Formato de matrícula incorrecto',
    addSuccess: 'Añadido correctamente',
    deleteConfirm: '¿Seguro que desea eliminar esta matrícula?',
    deleteSuccess: 'Eliminado correctamente',
  },
  roomOrderListDetail: {
    vehiclePlateNo: 'Matrícula',
    saveFailed: 'Error al guardar',
    cancelStay: 'Cancelar extensión',
    enterRemarkContent: 'Introduzca el contenido de las observaciones',
    systemRemark: 'Observación del sistema',
    merchantRemark: 'Observación del comerciante',
    originalStayOrder: 'Pedido original de extensión',
    newStayOrder: 'Nuevo pedido de extensión',
    continued: 'Extensión',
    downloadIdPhoto: 'Descargar foto del documento',
    uploadedToPolice: 'Subido al sistema policial',
    reuploadToPolice: 'Volver a subir al sistema policial',
    cancelStaySuccess: 'Cancelación de extensión exitosa',
    enterNumber: 'Introduzca la cantidad',
    liveOnCredit: 'Estancia a crédito',
    duration: 'Duración',
    invoice: 'Factura',
    roomInformation2: 'Información de la habitación',
    numberOfGuests: 'Número de huéspedes',
    doorLockCode: 'Código de cerradura',
    generatePassword: 'Generar contraseña',
    resetPassword: 'Restablecer contraseña',
    passwordInvalidation: 'Invalidar contraseña',
    idNumber2: 'Número de documento',
    guestAddress: 'Dirección del huésped',
    theInvoiceForThisOrderIsProvidedByTheSalesChannelToTheGuest2:
      'La factura de este pedido la proporciona el canal de ventas al huésped',
    thisOrderIsInvoicedByYourHotelToTheGuest:
      'La factura de este pedido la emite su hotel al huésped',
    originalOrder2: 'Pedido original',
    swapOrder: 'Cambiar pedido',
    faceCollection: 'Captura facial',
    invoice2: 'Emitir factura',
    sendPassword: 'Enviar contraseña',
    upgradeTheRoom: 'Mejorar habitación',
    extendStayadvance: 'Extender/Adelantar',
    transferToFullDayRoom: 'Convertir a habitación de día completo',
    decamping: 'Reducir cohabitación',
    increaseCohabitation: 'Aumentar cohabitación',
    checkInSlip4: 'Formulario de registro de check-in',
    reinstatement: 'Restablecer check-in',
    renewalOrder2: 'Pedido de extensión',
    roomChangeConfirmationForm3: 'Formulario de confirmación de cambio de habitación',
    conferenceCorps: 'Grupo de conferencia',
    tourParty: 'Grupo turístico',
    confirmNeedToResumeCheckIn: 'Confirmar reanudación del check-in',
    operationReminder: 'Recordatorio de operación',
    reinstatedCheckInSuccessful: 'Reanudación del check-in exitosa',
    fullDayRoomTransfersAreNotSupportedForOnlineOrders:
      'Los pedidos en línea no admiten conversión a día completo',
    whetherToCancelTheRowRoomAndTransferToTheFullDay:
      '¿Cancelar la asignación y convertir a día completo?',
    areYouSureYouWantToChangeToAFullDayRoom:
      '¿Confirma la conversión a habitación de día completo?',
    checkOutTimeWillBeChangedTo2: 'Tras convertir a día completo, la hora de salida se ajustará a',
    theRoomIsIn: 'La habitación está en',
    existingRowHouse: 'Asignación existente',
    conversionToFullDayRoomSuccessful: 'Conversión a día completo exitosa',
    flyingPigCreditLiveOrdersDoNotSupportJointHousing2:
      'Los pedidos de crédito Fliggy no admiten habitaciones vinculadas',
    generatePassword2: 'Generando contraseña',
    passwordGeneratedSuccessfully: 'Contraseña generada con éxito',
    areYouSureYouWantToResetYourCurrentPassword:
      '¿Confirma que desea restablecer la contraseña actual?',
    resetPassword2: 'Restableciendo contraseña',
    resetPasswordSuccessfully: 'Contraseña restablecida con éxito',
    areYouSureYouWantToInvalidateYourCurrentPassword:
      '¿Confirma que desea invalidar la contraseña actual?',
    thePasswordIsInvalid: 'Invalidando contraseña',
    thePasswordIsInvalidProcedure: 'Contraseña invalidada con éxito',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomCannotBeChanged2:
      'La hora actual ha superado la hora de salida; no se admite cambiar de habitación',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomUpgradeIsNotSupported2:
      'La hora actual ha superado la hora de salida; no se admite la mejora de habitación',
    theCurrentTimeHasPassed600CheckInDateTheRoomUpgradeIsNotSupported2:
      'La hora actual ha superado las 6:00 de la fecha de salida; no se admite la mejora de habitación',
    theGuestHasAppliedForOnlineRenewalAndMayNotBeAbleToRenewTheOrder:
      'El huésped ha solicitado extensión en línea; continuar puede impedir el cambio de pedido para la extensión',
    flyingPigCreditOrdersCanNotBeSustained2: 'Los pedidos de crédito Fliggy no admiten extensión',
    itHasPassedTheCheckOutDateAndCannotBeExtended2:
      'Se ha superado la fecha de salida; no se puede extender',
    successfulRoomExchange2: 'Cambio de habitación exitoso',
    upgradedRoomTypeData: 'Datos del tipo de habitación mejorado',
    theOtherRoomsInTheOrderHaveCheckedOutAndThecustomerTypeCannotBeModified:
      'Las otras habitaciones del pedido ya han hecho check-out; no se puede modificar el “tipo de cliente”',
    theGuestHasAppliedForOnlineRenewalAndConfirmedTheNeedToContinueChangingRooms:
      'El huésped ha solicitado extensión en línea; ¿confirma continuar con el cambio de habitación?',
  },
  roomOrderListGroupRoomDetail: {
    // Part 16, lines 3001 to 3200
    contactNumber4: 'Teléfono de contacto',
    aTotalOf: 'Total',
    occupancyStatus: 'Estado de ocupación',
    onAccount2: 'En cuenta',
    rollOut: 'Transferir',
    setAsMaster: 'Establecer como pedido principal',
    rescission: 'Desvincular habitaciones',
    teamRegistrationSheet: 'Formulario de registro de equipo',
    numberOfRooms: 'Número de habitaciones',
    confirmToCancelTheHouseRelationship:
      'Confirmar la cancelación de la relación de habitaciones vinculadas',
    successfullyDisconnectingTheHouse: 'Desvinculación de habitaciones exitosa',
    rollOutSuccess: 'Transferencia exitosa',
    setTheMasterOrderToSucceed: 'Pedido principal establecido con éxito',
  },
  roomOrderListMinusroomer: {
    residentGuest: 'Huésped alojado',
    reduceRoommateSuccess: 'Reducción de convivientes exitosa',
    decamping: 'Reducir cohabitación',
    pleaseSelectTheNumberOfPeopleYouWantToReduce:
      'Seleccione el número de personas que desea reducir',
    keepAtLeastOneOccupantInTheRoom: 'Debe mantenerse al menos un ocupante en la habitación',
  },
  roomOrderListRelativeRoom: {
    roomOrder: 'Órdenes de habitación',
    reservationOrder: 'Reservas',
    pendingCheckIn: 'Pendiente de llegada',
    pleaseSelectARoomOrder: 'Seleccione una orden de habitación',
    linkRoomNumber: 'Número de habitación vinculada',
    inTheRoom: 'Habitación ocupada',
    residentialTeam: 'Equipo alojado',
    flyingPigCreditDoesNotSupportHousing: 'El crédito Fliggy no admite habitaciones vinculadas',
    directChannelsDoNotSupportTheEstablishmentOfJointHousesAndTeamsWithStoreChannels:
      'Los canales directos no admiten crear habitaciones vinculadas ni equipos con canales de tienda',
    guestsNameMobilePhoneNumberAndRoomNumber:
      'Nombre del huésped, teléfono móvil y número de habitación',
    teamNameBookingPersonNameMobilePhoneNumber:
      'Nombre del equipo, nombre del reservante y teléfono móvil',
    pleaseSelectATeam: 'Seleccione un equipo',
    joinTheTeamSuccessfully: 'Incorporación al equipo exitosa',
    joinTheRoomSuccessfully: 'Incorporación a la habitación exitosa',
  },
  roomOrderListRollin: {
    flyingPigCreditDoesNotSupportHousing: 'El crédito Fliggy no admite habitaciones vinculadas',
    directChannelsDoNotSupportTheEstablishmentOfJointHousesAndTeamsWithStoreChannels:
      'Los canales directos no admiten crear habitaciones vinculadas ni equipos con canales de tienda',
    transferIn: 'Transferir a habitación vinculada',
    namePhoneNumberRoomNumber2: 'Nombre del huésped, teléfono móvil y número de habitación',
    succeededInJoiningTheHouse: 'Ingreso a la habitación vinculada exitoso',
  },
  roomOrderListRoomOrderDetail: {
    twinRooms: 'Habitaciones vinculadas',
    roomList: 'Lista de habitaciones',
    noRoomListingInformationAvailable: 'No hay información de habitaciones',
    manage: 'Gestionar',
    fullState: 'Todos los estados',
    finance3: 'Finanzas',
    preAuthorizationDetail: 'Detalles de preautorización',
    houseDetails: 'Detalles de habitaciones vinculadas',
    listingDetails: 'Detalles de la habitación',
    thereAreNoOccupants: 'No hay ocupantes',
  },
  roomOrderListRoomOrderList: {
    durationOfResidence: 'Tiempo de estancia',
    bookingTime: 'Hora de reserva',
    room2: 'Habitación',
    doNotGift: 'No regalar',
    nameMobilePhoneNumberOrderNumberChannelNumberQuery:
      'Consulta por nombre, teléfono móvil, número de pedido o número de canal',
    multipleSearch: 'Búsqueda múltiple',
    bonusPoints: 'Otorgar puntos',
    subscriber: 'Reservante',
    subscriberNumber: 'Teléfono del reservante',
    areYouSureYouWantToGiveAwayPoints: '¿Confirma que desea otorgar puntos?',
    rewardPointsSuccessfully: 'Puntos otorgados con éxito',
    guestphone: 'Huésped/Teléfono',
    actualCheckoutTime: 'Hora real de salida',
  },
  faceFacedialog: {
    faceCollection: 'Captura facial',
    faceCollectionSuccess: 'Captura facial exitosa',
    faceCollectionFailure: 'Error en la captura facial',
    takeAPicture: 'Tomar foto',
    upload: 'Subir',
    upCross: 'Subiendo',
    uploadingPhotosPleaseCloseLater: 'Las fotos se están subiendo, cierre más tarde',
    pleaseTakeAPictureFirst: 'Primero tome una foto',
    collectionSuccess: 'Captura exitosa',
    collectionFailedPleaseTryAgain: 'La captura falló, inténtelo de nuevo',
  },
  printtemplateChangeroom: {
    theOriginal: 'Original',
    changeDate: 'Fecha de cambio de habitación',
    roomRateUpgrade: 'Mejora de tarifa:',
    roomRate: 'Tarifa:',
  },
  printtemplateChangeroomprintsmall: {
    changeDate: 'Fecha de cambio de habitación',
    checkOutTime: 'Hora de salida',
    theOriginal: 'Original',
  },
  printtemplateGroupordertableprint: {
    position: 'Posición',
  },
  printtemplateStayinprint: {
    confidentiality: 'Confidencial',
  },
  printtemplateStaymore: {
    departureDate: 'Fecha prevista de salida',
    newDepartureDate: 'Nueva fecha prevista de salida',
  },
  printtemplateStaymoreprint: {
    departureDate: 'Fecha prevista de salida',
    newDepartureDate: 'Nueva fecha prevista de salida',
  },
  noticeOrdernotice: {
    messageCenter: 'Centro de mensajes',
    orderInformation: 'Información del pedido',
    dynamic: 'Mensajes dinámicos',
    settlement: 'Mensajes de liquidación',
    system: 'Mensajes del sistema',
    noData: 'No hay mensajes nuevos',
    dynamicInformation: 'Información dinámica',
    systemInformation: 'Información del sistema',
    nightTrialFailTitle: 'Fallo en la auditoría nocturna',
    nightTrialFailContent: 'La auditoría nocturna ha fallado, por favor procésela a tiempo.',
  },
  noticeServicemanage: {
    serviceManagement: 'Gestión de servicios',
    roomService: 'Servicio de habitaciones',
    itemBorrow: 'Préstamo de artículos',
    extendStay: 'Servicio de extensión de estancia',
  },
  operatelogLog: {
    nightAuditLog: 'Registro de auditoría nocturna',
    downloadLog: 'Descargar registro',
    downloadSuccessfully: 'Descarga exitosa',
  },
  operatelogNightauditlog: {
    nightTrialMethod: 'Método de auditoría nocturna',
    nightTrialResult: 'Resultado de la auditoría nocturna',
    manualNightAudit: 'Auditoría nocturna manual',
    automaticNightAudit: 'Auditoría nocturna automática',
    nightAuditFailure: 'Fallo en la auditoría nocturna',
    successfulNightAudit: 'Auditoría nocturna exitosa',
    nightTrialDate: 'Fecha de auditoría nocturna',
    nightAuditRecord: 'Registro de auditoría nocturna',
  },
  operatelogWorkingday: {
    variableMode: 'Modo de variación',
  },
  financeAccountsreceivableaging: {
    bookName: 'Nombre del libro',
    totalAmountReceivable: 'Total de cuentas por cobrar',
    amountPayable030Days: 'Cuentas por cobrar (0–30 días)',
    amountPayable3160Days: 'Cuentas por cobrar (31–60 días)',
    amountPayable6190Days: 'Cuentas por cobrar (61–90 días)',
    amountToBeCollected91DaysOrMore: 'Cuentas por cobrar (91 días o más)',
    typeOfExchange: 'Tipo de cambio de habitación',
    originalRoomNumber: 'Número de habitación original',
    existingRoomNumber: 'Número de habitación actual',
    currentHouseType: 'Tipo de habitación actual',
    roomChangeTime: 'Hora de cambio de habitación',
    changeRoomsAfterCheckIn: 'Cambio de habitación tras el check-in',
    originalRoomRate: 'Tarifa original',
    spotRate: 'Tarifa actual',
  },
  financeAdjustmentCash: {
    financialStatement: 'Flujo financiero',
    occurrenceTime: 'Hora de ocurrencia',
    reconciliationStatement: 'Informe de ajuste',
  },
  financeAr: {
    channelReconciliationReport: 'Informe de conciliación por canal',
    writeOffStatus: 'Estado de conciliación',
    amountOnCredit: 'Importe en cuenta',
    estimatedSettlementPrice: 'Precio de liquidación estimado',
    unapprovedAmount: 'Importe no conciliado',
    guestInvoiceRequirement: 'Requisitos de factura del huésped',
    roomNumbername: 'Habitación/Nombre',
  },
  financeBreakfastStatistic: {
    flatBreakfast: 'Desayuno incluido',
    advancePurchase: 'Compra anticipada',
    availableBreakfasts: 'Desayunos disponibles',
    verifiedBreakfasts: 'Desayunos verificados',
    breakfastAmount: 'Importe de desayuno',
    breakfastStatisticsReport: 'Informe de estadísticas de desayuno',
    breakfastStatisticsReportxls: 'Informe de estadísticas de desayuno.xls',
  },
  financeChannelConsume: {
    typeOfCompany: 'Tipo de empresa',
    roomNights: 'Noches de habitación',
  },
  financeCheckout: {
    checkOutBusinessDay: 'Día hábil de salida',
    helpOneself: 'Uso propio',
    team2: 'Equipo',
    checkOutStatement: 'Informe de cierre y salida',
  },
  financeCreatedCompanyAccountOfAge: {
    scale: 'Proporción',
    aged180DaysOrMore: 'Antigüedad de 180 días o más',
    agingStatementOfCreditCompany: 'Informe de antigüedad de cuentas de empresas de crédito',
    accountAge030Days: 'Antigüedad 0–30 días',
    accountAge3160Days: 'Antigüedad 31–60 días',
    accountAge6190Days: 'Antigüedad 61–90 días',
    accountAge91180Days: 'Antigüedad 91–180 días',
  },
  financeDemandAccount: {
    collectTheRoomChargeInAdvance: 'Cobro anticipado de tarifa de habitación',
    estimatedArrears: 'Deuda estimada',
    collectionStatement: 'Informe de cobranza',
  },
  // Part 17, lines 3201 to 3400
  financeHangAccount: {
    accountStatus: 'Estado contable',
    businessDayOfHangingAccount: 'Día hábil de la cuenta a crédito',
    hangTheAccountOperator: 'Operador de la cuenta a crédito',
    currentBalance: 'Saldo actual',
    closingTime: 'Hora de cierre',
    noteOfHangingAccount: 'Observaciones de la cuenta a crédito',
    temporaryDebitStatement: 'Informe temporal de cuenta a crédito',
    membercompany: 'Miembro/Empresa',
  },
  financeInventoryInOut: {
    inOutDate: 'Fecha de entrada/salida de inventario',
    storageType: 'Tipo de entrada/salida',
    storageTypeOut: 'Salida',
    fileName: 'Informe de entrada/salida de inventario',
    columns: {
      inStoragePrice: 'Importe de entrada',
      outStoragePrice: 'Importe de salida',
    },
  },
  financeHousekeeping: {
    cleaningDate: 'Fecha de limpieza',
    cleanType: 'Tipo de limpieza',
    cleaner: 'Personal de limpieza',
    status: 'Estado de la orden',
    dailyCleaningAndLinen: 'Limpieza diaria + cambio de ropa de cama',
    dailyCleaning: 'Limpieza diaria',
    dispatchTime: 'Hora de asignación',
    cleanTime: 'Hora de limpieza',
    checkRoomTime: 'Hora de inspección',
    recleaningReason: 'Motivo de relimpieza',
    checkerName: 'Supervisor de inspección',
    statuses: {
      toBeCleared: 'Pendiente de limpieza',
      finishCleaning: 'Limpieza completada',
      noCleaning: 'No requiere limpieza',
      cancelOrder: 'Cancelar asignación',
      unauditedRoom: 'Pendiente de inspección',
      wardRoundRejection: 'Inspección rechazada',
    },
  },
  settingHousekeeping: {
    cleaners: 'Personal de limpieza',
    selectCleaners: 'Seleccione personal de limpieza',
    onDutyConfig: 'Configuración de horario del personal de limpieza',
    roomAssign: 'Asignación de habitaciones',
    assignMode: {
      free: 'Asignación libre',
      byFloor: 'Asignar por piso',
      byRoom: 'Asignar por habitación',
    },
    viewAssign: 'Ver asignación',
    cleanerPrefix: 'Limpieza:',
    autoDispatchConfig: 'Configuración de asignación automática de limpieza',
    autoDispatch: {
      off: 'Desactivar asignación automática',
      on: 'Activar asignación automática',
    },
    autoDispatchRoomType: 'Tipo de habitación para asignación automática',
    leaveRoom: 'Habitación de salida',
    stayRoom: 'Habitación en estancia',
    dispatchRule: 'Reglas de asignación de limpieza',
    rules: {
      byTotal: 'Distribuir equitativamente el total de órdenes por persona',
      byPending: 'Distribuir equitativamente las órdenes pendientes por persona',
    },
    leaveCleanType: 'Tipo de limpieza automática para habitaciones de salida',
    stayCleanType: 'Tipo de limpieza automática para habitaciones en estancia',
    dispatchTimeForStay: 'Hora de asignación para habitaciones en estancia',
    afterCleanCheck: '¿Requiere inspección después de la limpieza?',
    needCheck: {
      no: 'No requiere',
      yes: 'Requiere',
    },
    dialog: {
      assignRelation: 'Relación de asignación',
      selectFloor: 'Seleccione el piso',
    },
    messages: {
      selectCleaners: 'Seleccione personal de limpieza',
      dutyTimeInvalid:
        'La hora de fin del turno del personal de limpieza no puede ser anterior a la hora de inicio',
    },
  },
  financeBreakfastDetails: {
    mealDate: 'Fecha de consumo',
    includeWaitingForCheckIn: '¿Incluir habitaciones pendientes de check-in?',
    title: 'Informe detallado de desayunos',
    columns: {
      guestNum: 'Número de personas',
      roomContainsBreakfastNum: 'Desayuno incluido en la habitación',
      buyBreakfastNum: 'Desayunos comprados',
      useBreakfastNum: 'Cantidad canjeada',
    },
  },
  breakfastVerification: {
    checkedInRoomList: 'Habitaciones ocupadas',
    roomNo: 'Habitación',
    breakfastCount: 'Desayunos',
    verified: 'Verificado',
    buyBreakfast: 'Comprar desayuno',
    verificationRecord: 'Registros de verificación',
    verificationTime: 'Hora de verificación',
    cardReading: 'Leyendo tarjeta',
    swipeCardVerification: 'Verificar con tarjeta',
    breakfastVerification: 'Verificación de desayuno',
    pendingBreakfast: 'Desayunos pendientes',
    verificationCount: 'Cantidad a verificar',
    confirmVerification: 'Confirmar',
    noRoomRead: 'No se leyó información de la habitación',
    cardReadFailed: 'Error al leer la tarjeta. Compruebe la tarjeta o el lector.',
    noPendingBreakfast: 'Esta habitación no tiene desayunos pendientes de verificar',
    verificationCountPositive: 'La cantidad a verificar debe ser mayor que 0',
    verificationCountExceedsPending: 'La cantidad no puede superar los desayunos pendientes',
    verificationSuccess: 'Verificación realizada correctamente',
  },
  buyBreakfastDialog: {
    title: 'Comprar desayuno',
    entryAccount: 'Cuenta de cargo',
    count: 'Cantidad',
    totalAmount: 'Importe total',
    payVerificationCode: 'Código de verificación de pago',
    positiveMoney: 'Introduzca un importe mayor que 0 con hasta 2 decimales',
    positiveInteger: 'Introduzca un entero mayor que 0',
    priceRequired: 'Introduzca el precio unitario',
    countRequired: 'Introduzca la cantidad',
    roomOrderNoMissing: 'No se encontró el número de orden de habitación. No se puede comprar desayuno.',
    selectAccountSet: 'Seleccione el conjunto de cuentas',
    onlinePaymentFailed: 'Error en el cobro en línea',
    paymentIncomplete: 'El pago no se completó. No se generó el cargo de desayuno.',
    buySuccess: 'Desayuno comprado correctamente',
  },
  financeBreakfastVerificateDetail: {
    title: 'Informe detallado de verificación de desayuno',
  },
  readDoorCardRoom: {
    lockNotConfigured: 'La cerradura no está configurada o no está habilitada',
    getLockInfoFailed: 'Error al obtener información de la cerradura',
    readCardTimeout: 'Tiempo de lectura agotado. Compruebe el lector de tarjetas.',
    emptyCard: 'Esta tarjeta está en blanco. Emita una tarjeta primero.',
    notGuestCard: 'Esta tarjeta no es de huésped. Vuelva a emitirla.',
    readCardServiceFailed: 'Error al leer la tarjeta. Contacte con soporte para comprobar el servicio de hardware.',
    readCardFailed: 'Error al leer la tarjeta. Compruebe la tarjeta o el lector.',
    noRoomInfo: 'No se leyó información de la habitación',
    unsupportedLockReadMode: 'El modo actual de lectura de la cerradura no es compatible',
  },
  financePreauth: {
    authorizationStatus: 'Estado de autorización',
    authorizationDate: 'Fecha de autorización',
    settlementDate: 'Fecha de liquidación',
    expirationDate: 'Fecha de vencimiento',
    preAuthorizationStatement: 'Informe de preautorización',
    settlementTime: 'Hora de liquidación',
  },
  financeRedeemDetail: {
    dateType: 'Tipo de fecha',
    writeOffDate: 'Fecha de conciliación',
    dateOfPosting: 'Fecha de cuenta a crédito',
    dateOfEntry2: 'Fecha de registro',
    bookType: 'Tipo de libro',
    businessDayOfHangingAccount: 'Día hábil de la cuenta a crédito',
    hangTheAccountOperator: 'Operador de la cuenta a crédito',
    theRoomNumberIsCharged: 'Número de habitación cargado',
    writeOffTheAmountCredited: 'Importe conciliado registrado',
    writeOffTheEntryTime: 'Hora de registro de la conciliación',
    writeOffTheAccountOperator: 'Operador del registro de conciliación',
    amountWrittenOff2: 'Importe conciliado',
    writeOffTime: 'Hora de conciliación',
    writeOffTheOperator: 'Operador de conciliación',
    channelWriteOffDetailReport: 'Informe detallado de conciliación por canal',
  },
  financeRushCash: {
    financialStatement: 'Flujo financiero',
    occurrenceTime: 'Hora de ocurrencia',
    debitStatement: 'Informe de compensación',
  },
  financeSellRank: {
    agreementUnitConsumptionRankingTable: 'Tabla de ranking de consumo por unidad de convenio',
  },
  financeTodayGuestBalance: {
    roomFee3: 'Tarifa de habitación',
    balanceSheetForGuestsInResidence: 'Hoja de balance de huéspedes en estancia',
  },
  financeTransferCash: {
    turnOutOfRoom: 'Habitación de salida',
    bookkeepingTime: 'Hora de registro contable',
    turnIntoARoom: 'Habitación de entrada',
    transferTime: 'Hora de transferencia',
    transferStatement: 'Informe de transferencias',
  },
  financeZeroRoomFee: {
    zeroRoomRateReport: 'Informe de tarifa de habitación cero',
  },
  incomeBaseprice: {
    totalRevenue: 'Ingresos totales',
    roomNight: 'Noches totales',
    storeRevenue: 'Ingresos de la tienda',
    interstoreNight: 'Noches de la tienda',
    directRevenuebasePrice: 'Ingresos directos (precio base)',
    straightInternight: 'Noches directas',
    miniProgramRevenuebasePrice: 'Ingresos del mini programa (precio base)',
    smallProgramNight: 'Noches del mini programa',
    xinmeituanDirectRevenuebasePrice: 'Ingresos directos Nuevo Meituan (precio base)',
    newUnitedStatesGroupStraightInternight: 'Noches directas Nuevo Meituan',
    ctripDirectRevenuebasePrice: 'Ingresos directos Ctrip (precio base)',
    ctripDirectConnectionBetweenNight: 'Noches directas Ctrip',
    directRevenuebasePrice2: 'Ingresos directos Tongcheng (precio base)',
    theSameJourneyDirectlyConnectedToTheNight: 'Noches directas Tongcheng',
    qunarDirectRevenuebasePrice: 'Ingresos directos Qunar (precio base)',
    whereToGoStraightToTheNight: 'Noches directas Qunar',
    tiktokDirectRevenuebasePrice: 'Ingresos directos TikTok (precio base)',
    tiktokStraightBetweenNight: 'Noches directas TikTok',
    flyingPigDirectRevenuebasePrice: 'Ingresos directos Fliggy (precio base)',
    flyingPigsStraightInternight: 'Noches directas Fliggy',
    baiduMapRevenuebasePrice: 'Ingresos de Baidu Maps (precio base)',
    baiduMapNight: 'Noches de Baidu Maps',
    jingdongDirectRevenuebasePrice: 'Ingresos directos JD (precio base)',
    jingdongDirectConnectionBetweenNight: 'Noches directas JD',
    lightResidentialAndCommercialTravelRevenuebasePrice:
      'Ingresos de viajes corporativos Light Stay (precio base)',
    lightStayBusinessNights: 'Noches corporativas Light Stay',
    lightHomeDistributionRevenuebasePrice: 'Ingresos de distribución Light Stay (precio base)',
    lightNightInTheDistributionRoom: 'Noches de distribución Light Stay',
    storeAdr: 'ADR de la tienda',
    usGroupEbRevenue: 'Ingresos EB Meituan',
    usGroupEbNight: 'Noches EB Meituan',
    meituanEbadr: 'ADR EB Meituan',
    ctripEbRevenue: 'Ingresos EB Ctrip',
    ctripEbNight: 'Noches EB Ctrip',
    ctripEbadr: 'ADR EB Ctrip',
    flyingPigEbRevenue: 'Ingresos EB Fliggy',
    flyingPigEbNight: 'Noches EB Fliggy',
    ebadrTheFlyingPig: 'ADR EB Fliggy',
    douyinGroupPurchaseEbRevenue: 'Ingresos EB compras grupales Douyin',
    douyinGroupPurchaseEbNight: 'Noches EB compras grupales Douyin',
    douyinGroupPurchaseEbadr: 'ADR EB compras grupales Douyin',
    directAdrbasePrice: 'ADR directo (precio base)',
    miniProgramAdrbasePrice: 'ADR mini programa (precio base)',
    newMeituanDirectAdrbasePrice: 'ADR directo Nuevo Meituan (precio base)',
    directRouteAdrbasePrice: 'ADR directo Ctrip (precio base)',
    sameRouteDirectAdrbasePrice: 'ADR directo Tongcheng (precio base)',
    whereToDirectAdrbasePrice: 'ADR directo Qunar (precio base)',
    tiktokDirectAdrbasePrice: 'ADR directo TikTok (precio base)',
    flyingPigDirectAdrbasePrice: 'ADR directo Fliggy (precio base)',
    // Part 18, lines 3401 to 3600
    baiduMapAdrbasePrice: 'ADR de Baidu Maps (precio base)',
    jingdongDirectLinkAdrbasePrice: 'ADR de conexión directa JD (precio base)',
    lightResidentialAndBusinessAdrbasePrice: 'ADR de Light Stay negocios y viajes (precio base)',
    lightLiveDistributionAdrbasePrice: 'ADR de distribución Light Stay (precio base)',
  },
  incomeExpense: {
    consumptionAccountStatisticsReport: 'Informe estadístico de cuentas de consumo',
    accountId: 'ID de cuenta',
    roomNumbername: 'Habitación/Nombre',
  },
  incomeGuestSourceDetail: {
    selfUseRoom: 'Habitación de uso interno',
    roomNightDataIsBasedOnTheQueriedBusinessDayStatistics:
      'Los datos de noches se basan en las estadísticas del día hábil consultado',
    calculationMode: 'Modo de cálculo',
    guestCheckInDetailsReport: 'Informe detallado de check-in por fuente de huéspedes',
    freeRoom: 'Habitación gratuita',
    teamRoom: 'Habitación de grupo',
    singleRoom: 'Habitación de larga estancia',
    roomRate2: 'Importe de la tarifa de habitación',
  },
  incomeHandleover: {
    shiftSummaryStatisticsReport: 'Informe estadístico de resumen de turno',
    income: 'Ingresos',
    disburse: 'Gastos',
    totalAmount: 'Importe total',
    shiftSummaryReport: 'Informe de resumen de turno',
  },
  incomeManageSingle: {
    category: 'Categoría',
    today: 'Hoy',
    accumulatedThisMonth: 'Acumulado del mes',
    lastMonthCumulative: 'Acumulado del mismo periodo del mes pasado',
    monthlyGrowthRate: 'Tasa de crecimiento mensual',
    currentYearAccumulation: 'Acumulado del año',
    accumulatedInTheSamePeriodOfLastYear: 'Acumulado del mismo periodo del año pasado',
    annualGrowthRate: 'Tasa de crecimiento anual',
    operatingStatementsingleDay: 'Informe operativo (día único)',
    operatingStatementOneDayxlsx: 'Informe operativo día único.xlsx',
    orderSourceBedNightsIncludeFreeRoomsAndSelfUsedRoomNights:
      'Noches por origen del pedido: incluye habitaciones gratuitas y de uso propio',
    rentalRateexcludingSelfUsedRoomsAndFreeRoomsRentedBedNightsexcludingSelfUsedRoomsAndFreeRoomsTotalNumberOfRooms:
      'Tasa de ocupación (excluye uso propio y gratuitas) = noches alquiladas (excluye uso propio y gratuitas) / total de habitaciones',
    totalRoomFeeIncomeincludingCommissionExcludingFreeRoomsAndSelfUsedRooms:
      'Ingresos totales por habitaciones (incluye comisión): excluye habitaciones gratuitas y de uso propio',
    youHaveNotOpenedThecustomerCheckInDetailsReportViewingPermission:
      'No tiene habilitado el permiso para ver el informe de detalles de check-in por fuente',
    averageRoomRate:
      'Tarifa media (excluye uso propio y gratuitas) = ingresos totales por habitaciones / noches alquiladas (excluye uso propio y gratuitas)',
    revparFormula: 'RevPAR = ingresos totales por habitaciones / total de habitaciones',
    totalRevenueFormula:
      'Ingresos totales = ingresos por habitaciones + otros ingresos (incluye comisión, excluye recargas de membresía)',
  },
  incomeManageTotal: {
    generalLedger: 'Libro mayor',
    totalAverageRoomRateyuan: 'Tarifa media total',
    rentalTotalRoomNightroom: 'Total de noches alquiladas',
    fullDayRoomNightroom: 'Noches de habitación de día completo',
    longBagRoomNightroom: 'Noches de larga estancia',
    hourRoomNightroom: 'Noches por horas',
    teamRoomNightroom: 'Noches de grupo',
    freeRoomNightroom: 'Noches gratuitas',
    privateRoomNightroom: 'Noches de uso propio',
    totalRoomRateyuan: 'Tarifa total de habitaciones',
    smallCommoditiesyuan: 'Productos pequeños',
    mealFeeyuan: 'Gastos de comidas',
    serviceChargeyuan: 'Cargo por servicio',
    membershipFeermb: 'Cuota de membresía',
    otherExpensesyuan: 'Otros gastos',
    totalRevenueyuan: 'Ingresos totales',
    roomNightsroom: 'Número de noches',
    averageRoomRateyuan: 'Tarifa media',
    totalRoomRateyuan2: 'Total de tarifas de habitación',
    operatingStatementcumulative: 'Informe operativo (acumulado)',
    theQueryTimeRangeCannotBeLongerThanOneYear:
      'El rango de tiempo de consulta no puede ser mayor a un año',
    totalOccupancyRate: 'Tasa total de ocupación (%)',
    fullDayOccupancyRate: 'Tasa de ocupación de día completo (%)',
    hourlyOccupancyRate: 'Tasa de ocupación por horas (%)',
    lettingRate: 'Tasa de ocupación (%)',
    internightRatio: 'Proporción de noches (%)',
    totalRevpar: 'REVPAR total',
    cumulativeOperatingStatementxls: 'Informe operativo acumulado.xls',
    rentalRateexcludingSelfUsedRoomsAndFreeRoomsRentedBedNightsexcludingSelfUsedRoomsAndFreeRoomsTotalNumberOfRooms:
      'Tasa de ocupación (excluye uso propio y gratuitas) = noches alquiladas (excluye uso propio y gratuitas) / total de habitaciones',
    totalRoomFeeIncomeincludingCommissionExcludingFreeRoomsAndSelfUsedRooms:
      'Ingresos totales por habitaciones (incluye comisión): excluye habitaciones gratuitas y de uso propio',
    averageRoomRate:
      'Tarifa media (excluye uso propio y gratuitas) = ingresos totales por habitaciones / noches alquiladas (excluye uso propio y gratuitas)',
    totalRevenueFormula:
      'Ingresos totales = ingresos por habitaciones + otros ingresos (incluye comisión, excluye recargas de membresía)',
  },
  incomeOperatingIncome: {
    yesterdaysBalance: 'Saldo de ayer',
    todaysBalance: 'Saldo de hoy',
    statisticalStatementOfBusinessIncome: 'Informe estadístico de ingresos operativos',
    totalconsumptionTotalPaymentTotal: 'Total = consumo total - pagos totales',
    yesterdaysBalancetheHotelsCumulativeConsumptionTotalFromThePreviousBusinessDayMinusPaymentTotal:
      'Saldo de ayer = consumo acumulado hasta el día hábil anterior - pagos totales',
    todaysBalancetotalyesterdaysBalance: 'Saldo de hoy = total + saldo de ayer',
  },
  incomeBusinessIncomeDetail: {
    reportTitle: 'Informe detallado de ingresos operativos',
    consumeTotal: 'Total de consumo',
    settleTotal: 'Total de cobros',
    roomFee: 'Tarifa de habitación',
    mealFee: 'Gastos de comidas',
    goodsFee: 'Artículos',
    serviceFee: 'Tarifa de servicio',
    memberFee: 'Cuota de membresía',
    otherConsume: 'Otros consumos',
    dailyBalance: 'Saldo del día',
    orderNo: 'Nº de pedido',
    roomOrderNo: 'N.º de Pedido de Habitación',
    roomNo: 'N.º de habitación',
    guestName: 'Nombre del huésped',
    noData: 'Sin datos',
  },
  incomeOverduty: {
    category: 'Categoría',
    firstLevelSubject: 'Cuenta de primer nivel',
    description: 'Descripción',
    shiftStatisticsReport: 'Informe estadístico de turno',
  },
  incomePayExpense: {
    cashPaymentStatement3: 'Informe detallado de consumo con pago inmediato',
    abstract: 'Resumen',
  },
  incomePayment: {
    paymentAccountStatisticsReport: 'Informe estadístico de cuentas de pago',
    submitted: 'Enviado',
    earlyMorningWatch: 'Turno de madrugada',
    roomNumberName: 'Habitación-Nombre',
    dateRangeCannotExceedThreeMonths: 'El rango de fechas de consulta no puede superar los 3 meses',
  },
  incomeRoomTypeReport: {
    totalRoomRate: 'Tarifa total de habitaciones',
    numberOfOutages: 'Cantidad fuera de servicio',
    numberOfNightsForRent: 'Número de noches alquiladas',
    roomTypeReport: 'Informe por tipo de habitación',
    theEndTimeOfTheBusinessDayCannotExceedTheCurrentTime:
      'La hora de finalización del día hábil no puede exceder la hora actual',
    theSelectionPeriodCannotBeLongerThan31Days:
      'El periodo seleccionado no puede ser mayor a 31 días',
  },
  incomeSellercount: {
    roomNightDataIsBasedOnTheQueriedBusinessDayStatistics:
      'Los datos de noches se basan en las estadísticas del día hábil consultado',
    calculationMode: 'Modo de cálculo',
    salesPerformanceStatement: 'Informe de desempeño de ventas',
    roomFee3: 'Tarifa de habitación',
  },
  incomeSmallwaredetail: {
    detailedSalesReportOfSmallGoods: 'Informe detallado de ventas de productos pequeños',
  },
  incomeSmallwaresummary: {
    summaryReportOfSmallCommoditySales: 'Informe resumen de ventas de productos pequeños',
    averageUnitPrice: 'Precio unitario promedio',
  },
  kanbanIndex: {
    yesterday: 'Ayer',
    last7Days: 'Últimos 7 días',
    lastWeek: 'Semana pasada',
    last30Days: 'Últimos 30 días',
    lastMonth: 'Mes pasado',
    managementProfile: 'Resumen de gestión',
    flowConversion: 'Conversión de tráfico',
    serviceIndicator: 'Indicadores de servicio',
    competitiveCircleAnalysis: 'Análisis del entorno competitivo',
    writeAReport: 'Redactar informe',
    theTimeDimensionIsConsistentWithTheScreeningDateAndTheBookingAmountIsCalculatedAccordingToTheActualAmountPaidByTheGuest:
      'La dimensión temporal coincide con la fecha filtrada y el importe de reservas se calcula según el pago real del huésped',
    operationPersonnelManagementOverviewSuggestions2:
      'Sugerencias del personal operativo sobre el resumen de gestión',
    theTimeDimensionIsConsistentWithTheScreeningDateAndContainsTheDataSummaryOfAllPlatformsOfMeituanCtripAndFeizhu:
      'La dimensión temporal coincide con la fecha filtrada e incluye el resumen de datos de Meituan, Ctrip y Fliggy',
    operationPersonnelFlowConversionSuggestions2:
      'Sugerencias del personal operativo sobre conversión de tráfico',
    theTimeDimensionIsTheEndDateAndTheDayBeforeTheStartDateOfTheCurrentSelectedDateIncludingTheDataSummaryOfAllPlatformsOfMeituanCtripAndFeizhu:
      'La dimensión temporal va desde el día previo a la fecha inicial hasta la fecha final seleccionada, e incluye datos de Meituan, Ctrip y Fliggy',
    operationPersonnelServiceIndicatorsSuggestions2:
      'Sugerencias del personal operativo sobre indicadores de servicio',
    theTimeDimensionIsConsistentWithTheScreeningDateAndContainsTheDataSummaryOfAllPlatformsOfMeituanAndCtrip:
      'La dimensión temporal coincide con la fecha filtrada e incluye datos de Meituan y Ctrip',
    operationalPersonnelCompetitionCircleAnalysisAndSuggestions2:
      'Sugerencias del personal operativo sobre análisis del entorno competitivo',
    amountOfExposure: 'Exposición',
    pageView: 'Vistas',
    orderQuantity: 'Cantidad de pedidos',
    myExposureCount: 'Mi número de exposiciones',
    numberOfPeopleExposedInThePreviousIssue: 'Exposición del periodo anterior',
    myExposureConversionRate2: 'Mi tasa de conversión de exposición',
    previousExposureConversionRate2: 'Tasa de conversión de exposición del periodo anterior',
    myNumberOfViewers: 'Mis visitantes',
    numberOfVisitorsInTheLastIssue: 'Visitantes del periodo anterior',
    myConversionRate2: 'Mi tasa de conversión',
    conversionRateOfLastPeriodTransaction2: 'Tasa de conversión del periodo anterior',
    paymentOrderNumber: 'Pedidos pagados',
    myPaymentOrderNumber: 'Mis pedidos pagados',
    previousPaymentOrderNumber: 'Pedidos pagados del periodo anterior',
  },
  kanbanReportManage: {
    reportTitle: 'Título del informe',
    reportWriter: 'Autor del informe',
    reportDate: 'Fecha del informe',
    reportNumber: 'Número de informe',
    draft: 'Borrador',
    haveReleased: 'Publicado',
    reportTime: 'Hora del informe',
    exportDaily: 'Exportar informe diario',
  },
  kanbanSeeKanban: {
    dataBoard: 'Tablero de datos',
    managementProfile: 'Resumen de gestión',
    operationPersonnelManagementOverviewSuggestions2:
      'Sugerencias del personal operativo sobre el resumen de gestión',
    flowConversion: 'Conversión de tráfico',
    operationPersonnelFlowConversionSuggestions2:
      'Sugerencias del personal operativo sobre conversión de tráfico',
    serviceIndicator: 'Indicadores de servicio',
    operationPersonnelServiceIndicatorsSuggestions2:
      'Sugerencias del personal operativo sobre indicadores de servicio',
    competitiveCircleAnalysis: 'Análisis del entorno competitivo',
    operationalPersonnelCompetitionCircleAnalysisAndSuggestions2:
      'Sugerencias del personal operativo sobre análisis del entorno competitivo',
    theProportionOfSalesAmount: 'Proporción del importe de ventas',
    salesRoomNightProportion: 'Proporción de noches vendidas',
    noProposal: 'Sin sugerencias',
  },
  componentsDataReport: {
    compose: 'Redactar',
    dataReport: 'Informe de datos',
    reportType: 'Tipo de informe',
    pleaseSelectAReportType: 'Seleccione un tipo de informe',
    dailyOperationReport: 'Informe operativo diario',
    weeklyOperationsReport: 'Informe operativo semanal',
    // Part 19, lines 3601 to 3800
    monthlyOperatingReport: 'Informe operativo mensual',
    runCustomReports: 'Informes operativos personalizados',
    reportTitle: 'Título del informe',
    analysisDate: 'Fecha de análisis',
    businessDataAnalysisDimension: 'Dimensión de análisis de datos operativos',
    businessAnalysisAndSuggestion: 'Análisis y sugerencias operativas',
    trafficAnalysisSuggestion: 'Sugerencias de análisis de tráfico',
    serviceIndicatorSuggestion: 'Sugerencias de indicadores de servicio',
    competitiveCircleAnalysisSuggestion: 'Sugerencias de análisis del entorno competitivo',
    previewReport: 'Vista previa del informe',
    saveReport: 'Guardar informe',
    saveReleaseReport: 'Guardar y publicar informe',
    pleaseEnterTheTitleOfTheReport: 'Introduzca el título del informe',
    pleaseEnterBusinessAnalysisSuggestions: 'Introduzca sugerencias de análisis operativo',
    pleaseEnterTrafficAnalysisSuggestions: 'Introduzca sugerencias de análisis de tráfico',
    pleaseEnterTheServiceIndicatorSuggestion: 'Introduzca sugerencias de indicadores de servicio',
    pleaseEnterTheCompetitionCircleAnalysisSuggestion:
      'Introduzca sugerencias de análisis del entorno competitivo',
  },
  componentsFlowLine: {
    myExposureConversionRate2: 'Mi tasa de conversión de exposición',
    previousExposureConversionRate2: 'Tasa de conversión de exposición del periodo anterior',
    myConversionRate2: 'Mi tasa de conversión de transacciones',
    conversionRateOfLastPeriodTransaction2:
      'Tasa de conversión de transacciones del periodo anterior',
    exposureToViewConversionRate: 'Tasa de conversión de exposición a visualización',
    browseToTheConversionRateOfTheTransaction: 'Tasa de conversión de visualización a transacción',
  },
  componentsRatioPieChart: {
    directConnection3: 'Conexión directa',
  },
  competeCChannelData: {
    lostOrders: 'Cantidad de pedidos perdidos',
    single: 'Pedido',
    numberOfLostNights: 'Cantidad de noches perdidas',
    lossAmount: 'Importe perdido',
    distanceFromMe: 'Distancia desde mí',
    mark: 'Puntuación',
    startingPrice: 'Precio inicial',
    theProportionOfLostOrders: 'Proporción de pedidos perdidos',
    drainType: 'Tipo de habitación perdida',
    orderConversionRate: 'Tasa de conversión de pedidos',
    viewTheProportionOfUsers: 'Proporción de usuarios que visualizan',
    finalPurchaseRatio: 'Proporción de compra final',
  },
  flowFChart: {
    browseToTheConversionRateOfTheTransaction: 'Tasa de conversión de visualización a transacción',
    exposureToViewConversionRate: 'Tasa de conversión de exposición a visualización',
  },
  flowFTable: {
    myHotel: 'Mi hotel',
    monthOnMonth: 'Comparación intermensual',
    onlinePaymentSingular: 'Cantidad de pagos en línea',
    single: 'Pedido',
  },
  flowFlowTable: {
    payForOrderQuantity: 'Cantidad de pedidos pagados',
    exposureConversionRate: 'Tasa de conversión de exposición',
    transactionConversionRate: 'Tasa de conversión de transacciones',
  },
  reportManageLog: {
    dataReportOperationLogs: 'Registros de operaciones de informes de datos',
    logNumber: 'Número de registro',
    operationName: 'Nombre de la operación',
  },
  serveindexServeAnnularChart: {
    scoreDistributionGraph: 'Gráfico de distribución de puntuaciones',
    article: 'Ítems',
    numberOfCommentsWithChart: 'Cantidad de reseñas con imágenes',
    newBadReviewsThisPeriod: 'Reseñas negativas nuevas en este periodo: {num}',
    unrepliedBadReviews: 'Reseñas negativas sin respuesta: {num}',
  },
  serveindexServeRadarChart: {
    radarMap: 'Gráfico radar',
  },
  serveindexServelist: {
    basicScore: 'Puntuación básica',
    awardPoints: 'Puntos de recompensa',
    penaltyPoint: 'Puntos de penalización',
  },
  situationSChannelTable: {
    salesNight: 'Noches vendidas',
    averageSalesRate: 'Tarifa media de ventas',
    consumptionNight: 'Noches consumidas',
    averageHousePriceOfConsumption: 'Tarifa media de consumo',
    cancelNight: 'Noches canceladas',
    cancellationRate: 'Tasa de cancelación',
    noSingleRoomNights: 'Noches rechazadas',
    rejectRate: 'Tasa de rechazo',
    onlinePermeability: 'Penetración en línea',
    channelOnlineStatus: 'Estado en línea del canal',
    lightHoldTheDirectConnection: 'Light Stay conexión directa',
  },
  situationSGrid: {
    onAYearOnYearBasis: 'Interanual',
    chainRatio: 'Intermensual',
    cancellationRate: 'Tasa de cancelación',
    rejectRate: 'Tasa de rechazo',
    theBookingAmountIncludesCancelledAndRejectedOrders:
      'El importe de reservas incluye pedidos cancelados y rechazados',
    reservationAmountCancelAndRejectOrders:
      'Importe de reservas excluyendo pedidos cancelados y rechazados',
    accessSource: 'Fuente de acceso',
    onlineChannelConsumptionBedNightstotalAvailableInventory:
      'Noches consumidas en canales en línea / inventario total disponible',
    advanceBookingBedNightstotalSalesBedNights:
      'Noches de reserva anticipada / total de noches vendidas',
    cancelBedNightssalesBedNights: 'Noches canceladas / noches vendidas',
    rejectBedNightssalesBedNights: 'Noches rechazadas / noches vendidas',
  },
  situationSalePieChart: {
    salesRoomNightProportion: 'Proporción de noches vendidas',
    theProportionOfSalesAmount: 'Proporción del importe de ventas',
  },
  orderDiscontinuedrooms: {
    operationalDowntime: 'Tiempo de inactividad operativa',
    disableStartEndTime: 'Periodo de inicio y fin de desactivación',
    releaseTime2: 'Hora de liberación',
    inactiveRoomReport: 'Informe de habitaciones desactivadas',
    deactivationOperator: 'Operador de desactivación',
    releaseOperator: 'Operador de liberación',
    normalExchange: 'Cambio normal de habitación',
    freeUpgrade: 'Mejora gratuita',
    chargeEscalation: 'Mejora con cargo',
  },
  orderGuest: {
    reportType2: 'Tipo de informe',
    sameDayCheckIn: 'Check-in del mismo día',
    sameDayCheckOut: 'Check-out del mismo día',
    dailyArrivalsAndDepartures: 'Llegadas y salidas del día',
    contractCompany: 'Empresa de convenio',
    firstDayRate: 'Tarifa del primer día',
    nation2: 'País',
    roomListRemarks: 'Observaciones de la lista de habitaciones',
    guestStatement: 'Informe de estancia de huéspedes',
  },
  orderRoomChange: {
    unterracedHouse: 'Habitación no asignada',
    typeOfExchange: 'Tipo de cambio de habitación',
    normalExchange: 'Cambio normal de habitación',
    freeUpgrade: 'Mejora gratuita',
    chargeEscalation: 'Mejora con cargo',
    originalRoomNumber: 'Número de habitación original',
    existingRoomNumber: 'Número de habitación actual',
    currentHouseType: 'Tipo de habitación actual',
    roomChangeTime: 'Hora del cambio de habitación',
    changeRoomsAfterCheckIn: 'Cambio de habitación después del check-in',
    originalRoomRate: 'Tarifa original de la habitación',
    spotRate: 'Tarifa actual',
  },
  checkInIndex: {
    viewListingDetails: 'Ver detalles de la habitación',
    message: 'Información',
    individualStepIntoSuccess: 'Entrada de huésped individual exitosa',
    automaticallyRedirectsToListingDetails:
      'Redirección automática a los detalles de la habitación',
    successfulCodeScanning: 'Escaneo exitoso',
    thereIsNoCorrespondingProductForTheCurrentRoomType:
      'No hay productos correspondientes para el tipo de habitación actual',
    memberBalanceIs: 'El saldo del miembro es',
    pleaseSelectAnotherRecipient: ', seleccione otro método de cobro',
  },
  checkInNewindex: {
    committedParameter: 'Parámetros enviados',
    individualStepIntoSuccess: 'Entrada de huésped individual exitosa',
  },
  checkInRoomerItem: {
    moreInformation: 'Más información',
    number: 'Número',
  },
  componentsBookertypesearch: {
    pleaseEnterTheMemberInformationYouWantToQuery:
      'Introduzca la información del miembro que desea consultar',
    enterTheInformationAboutTheProtocolUnitToBeQueried:
      'Introduzca la información de la unidad de convenio que desea consultar',
  },
  componentsDepositsection: {
    selectPaymentMethod: 'Seleccionar método de pago',
  },
  componentsOpenpagetemplate: {
    conditionOfTheHouse2: 'Estado de la habitación',
  },
  componentsProductsection: {
    noProductAvailableOnBookingDateForThisRoomType:
      'No se encontraron productos para este tipo de habitación en la fecha de reserva',
  },
  componentsRoomerItem: {
    moreInformation: 'Más información',
    genderBirthday: 'Género - Fecha de nacimiento',
    nationalityNationality: 'Nacionalidad - Etnia',
    pleaseEnterTheFullAddress2: 'Introduzca la dirección completa',
    validityPeriod: 'Periodo de validez',
  },
  utilsLehuimixin: {
    viewListingDetails: 'Ver detalles de la habitación',
    automaticallyRedirectsToListingDetails:
      'Redirección automática a los detalles de la habitación',
    successfulCodeScanning: 'Escaneo exitoso',
    callbackRoute: 'Ruta de retorno',
    checkInSuccessful: 'Check-in exitoso',
    listingDetails: 'Detalles de la habitación',
    orderDetails: 'Detalles del pedido',
  },
  utilsUtils: {
    noProductAvailableOnBookingDateForThisRoomType:
      'No se encontraron productos para este tipo de habitación en la fecha de reserva',
    thisRoomTypeIsSoldOutWithinTheBookingDate:
      'Este tipo de habitación está agotado en la fecha de reserva',
    noPriceIsSetForThisRoomTypeDuringTheBookingDate:
      'No se ha establecido precio para este tipo de habitación en la fecha de reserva',
    memberBalanceIsInsufficientPleaseChooseAnotherPaymentMethod:
      'El saldo del miembro es insuficiente, elija otro método de pago',
  },
  componentsAuthcode: {
    laterOn: 'Más tarde',
    verificationCodeSentSuccessfullyPleaseNoteThatCheck:
      'El código de verificación se envió correctamente, por favor revíselo',
    // Part 20, lines 3801 to 4000
  },
  componentsBookingcommonmixin: {
    reset: 'Restablecer',
  },
  componentsBookingmixin: {
    nineHours: 'Nueve horas',
    tenHours: 'Diez horas',
    elevenHours: 'Once horas',
    twelveHours: 'Doce horas',
    hourStore: 'Por horas - tienda',
    noRoomTypesAvailable: 'No hay tipos de habitación disponibles para reservar',
    houseList: 'Lista de asignación de habitaciones',
    totalPrice: 'Precio total',
  },
  componentsLimitinput: {
    insufficientStock: 'Stock insuficiente',
  },
  componentsMembersearch: {
    memberInformationDoesNotExistOrHasBeenDisabled:
      'La información del miembro no existe o ha sido deshabilitada',
    pleaseEnterTheMemberInformationYouWantToQuery3:
      'Introduzca la información del miembro que desea consultar',
    memberBalanceIsInsufficientPleaseChooseAnotherPaymentMethod:
      'El saldo del miembro es insuficiente, elija otro método de pago',
    theMembersMobilePhoneNumberIsIncorrectAndTheStoredValuePaymentCannotBeUsed:
      'El número de móvil del miembro es incorrecto y no se puede usar el pago con saldo',
    memberNamephoneNumbermembershipNumber: 'Nombre del miembro / Teléfono / Número de membresía',
  },
  componentsPaytip: {
    memberPaymentFailure: 'Fallo en el pago del miembro',
    pleaseReEnterTheAccount: 'Por favor, vuelva a registrar el pago',
  },
  futureIndex: {
    roomTypeSummary: 'Resumen de tipos de habitación',
    roomDetail: 'Detalle de habitaciones',
  },
  futureSummary: {
    soldNumberavailableNumberoverSoldNumberdisabledNumber:
      'Vendidas / Disponibles (sobreventa) / Deshabilitadas',
    totalNumberOfRoomsPhysicalTotalNumberOfRooms:
      'Total de habitaciones: número físico total del hotel',
    availableNumberTotalNumberOfRoomsSoldNumberDisabledNumberFullDayRoomOverSoldNumber:
      'Disponibles: total - vendidas - deshabilitadas + sobreventa de habitaciones de día completo',
    disabledNumberNumberOfDisabledRoomsInTheHotel:
      'Deshabilitadas: número de habitaciones deshabilitadas del hotel',
    soldNumberRoomsBookedOnTheDayRoomsCurrentlyOccupiedOnTheDayWithoutTodaysDepartureAndClockRoom:
      'Vendidas: habitaciones reservadas del día + ocupadas del día (excluye salidas de hoy y por horas)',
  },
  groupbookingIndex: {
    pleaseEnterTeamName: 'Introduzca el nombre del grupo',
    memberBalanceNotEnough:
      'El saldo del miembro es {balance} yuanes, seleccione otro método de cobro',
    bookingRoomCannotBeZero: 'El número de habitaciones reservadas no puede ser 0',
    roomTypeStockNotEnough: 'Stock insuficiente para el tipo de habitación',
    pleaseEnterContractNo: 'Introduzca el número de contrato',
    remarkPlaceholder: 'Máximo 150 caracteres',
    discountPricePlaceholder: 'Introduzca el precio con descuento',
    leftRoomsTip: 'Quedan {count} habitaciones sin asignar',
    searchMemberPlaceholder: 'Nombre / Teléfono / Nº de miembro',
    groupBooking: 'Reserva de grupo',
    contractNumber: 'Número de contrato',
    teamBookingSuccessful: 'Reserva de grupo exitosa',
  },
  longbookingIndex: {
    singleRoom: 'Habitación de larga estancia',
  },
  longbookingProductionlist: {
    houseList: 'Lista de asignación de habitaciones',
    inAddition: 'Además',
  },
  onlinedataIndex: {
    chainRatio: 'Intermensual',
    onAYearOnYearBasis: 'Interanual',
    theDirectConnectionChannelHasNotBeenOpenedInOrderToPreventTheLossOfOrdersPleaseContactTheOperationManagerAsSoonAsPossibleToOpenTheDirectConnectionChannel:
      'El canal de conexión directa no está habilitado; para evitar pérdidas, contacte al gerente de operaciones',
    relevance: 'Relación',
    onlineRevenue: 'Ingresos en línea',
    onlineNight: 'Noches en línea',
    channelProportion: 'Proporción por canal',
    channelOnlineStatus: 'Estado en línea del canal',
    directConnection3: 'Conexión directa',
    temporarilyWithoutAuthority: 'Sin permisos temporalmente',
    totalOnlineRevenue: 'Ingresos totales en línea',
    onlineTotalNight: 'Total de noches en línea',
    online: 'En línea',
    thisEbAccountIsNotBoundPleaseBindEbAccountInEbAccountManagement:
      'La cuenta EB no está vinculada; vincúlela en la gestión de cuentas EB',
  },
  realTimeIndex: {
    allBuildings: 'Todos los edificios',
    allFloors: 'Todos los pisos',
    depositShort: 'Dep.',
    roomRateShort: 'Tar.',
    totalShort: 'Tot.',
    preAuthShort: 'Pre',
    balanceShort: 'Sal.',
    powerOff: 'Cortado',
    powerOn: 'Activo',
    new2: 'Nuevo',
    al: 'Vinc.',
    openChannelsForDirectConnection: 'Habilitar conexión directa de canales',
    createRoomType: 'Crear tipo de habitación',
    createARoom: 'Crear habitación',
    renewalOrder2: 'Pedido de extensión',
    roomChangeConfirmationForm3: 'Formulario de confirmación de cambio de habitación',
    checkInSlip4: 'Formulario de registro de entrada',
    whenExtendingYourStayTheRoomPriceDisplayedIsForTheFirstDayOfTheExtendedStayWhenCheckingOutEarlyOrChangingTheExpectedDepartureTimeThePriceDisplayedIsForTheLastNight2:
      'Al extender la estancia se muestra el precio del primer día; al adelantar salida/cambiar fecha, se muestra el de la última noche',
    friendlyReminderPleaseMakeSureToDoubleCheckAllTheDetailsAndThenSignForConfirmationAfterChangingRoomsRememberToTakeYourPersonalBelongingsFromTheOriginalRoom3:
      'Recordatorio: verifique los datos y firme; al cambiar de habitación lleve sus pertenencias',
    continuationRoomsShowTheFirstDayPrice2:
      'Las habitaciones en extensión muestran el precio del primer día',
    friendlyReminderPleaseDoubleCheckAllTheDetailsAndSignForConfirmationDontForgetToTakeYourPersonalBelongings3:
      'Recordatorio: verifique y firme; no olvide sus pertenencias',
    liveLightlyInTheDirectCamp: 'Light Stay directo',
    whereToConnectDirectly: 'Qunar directo',
    baiduMap: 'Baidu Maps',
    jingdong: 'JD',
    flyingPigCreditLiveOrdersDoNotSupportJointHousing2:
      'Los pedidos de crédito de Fliggy no admiten habitaciones vinculadas',
    flyingPigCreditOrdersCanNotBeSustained2:
      'Los pedidos de crédito de Fliggy no admiten extensión',
    itHasPassedTheCheckOutDateAndCannotBeExtended2:
      'Se superó la fecha de salida; no se puede extender',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomUpgradeIsNotSupported2:
      'Se superó la hora de salida; no se admite mejora',
    theCurrentTimeHasPassed600CheckInDateTheRoomUpgradeIsNotSupported2:
      'Se superó las 6:00 del día de salida; no se admite mejora',
    theCurrentTimeHasPassedTheCheckOutTimeTheRoomCannotBeChanged2:
      'Se superó la hora de salida; no se puede cambiar de habitación',
    successfulRoomExchange2: 'Cambio de habitación exitoso',
    successfulDisposal: 'Marcado como sucio exitoso',
    cleanAndSuccessful: 'Marcado como limpio exitoso',
    deactivateSuccessfully: 'Desactivación levantada con éxito',
    temporaryPassword: 'Contraseña temporal',
    thisPasswordIsValidFor30MinutesAndExpiresImmediatelyAfterUse:
      'Válida por 30 minutos; expira tras su uso',
    quickSearch: 'Búsqueda rápida por habitación o nombre',
    batchModify: 'Modificación masiva de estado',
    ignore: 'Ignorar',
    goAndOperate: 'Ir a operar',
    bookingInfo: 'Información de reserva pendiente de llegada',
    orderNo: 'Nº de pedido',
    channelName: 'Nombre del canal',
    bookerName: 'Nombre del reservante',
    arrivalTime: 'Hora de llegada',
    roomRate: 'Tarifa de habitación',
  },
  realTimeServicemsg: {
    dateOfService: 'Fecha del servicio',
    applicationTime2: 'Hora de solicitud',
    serviceType: 'Tipo de servicio',
    serviceTime: 'Hora del servicio',
    serviceSuccess: 'Servicio exitoso',
    serviceFailure: 'Servicio fallido',
    serviceCompletion: 'Servicio completado',
    theRoomRequestHasBeenServiced: 'La solicitud de la habitación fue atendida',
  },
  componentsCommon: {
    roomBalance: 'Saldo de la habitación',
    depositWithPreAuth: 'Depósito (incluye preautorización)',
    madeCardCount: 'Tarjetas creadas',
    stayOver: 'Extender estancia',
    checkOut4: 'Check-out',
    temporaryPassword: 'Contraseña temporal',
    sendPassword: 'Enviar contraseña',
    muck: 'Marcar sucio',
    setAside: 'Marcar limpio',
    deactivate: 'Levantar desactivación',
    faceEast: 'Orientación este',
    faceWest: 'Orientación oeste',
    faceSouth: 'Orientación sur',
    faceNorth: 'Orientación norte',
    decorativeFalseWindow: 'Ventana falsa decorativa',
    stayAwayFromElevators: 'Lejos de ascensores',
    nearTheStairs: 'Cerca de escaleras',
    closeToTheRoad: 'Cerca de la carretera',
    windowWall: 'Pared exterior',
    bedTypeDescription: 'Descripción del tipo de cama',
    guestControl: 'Control de huéspedes',
    latestCheckIn: 'Última estancia',
    noHistoricalCheckInInfo: 'No hay información de estancias anteriores para esta habitación',
    temporaryMakeCard: 'Emitir tarjeta temporal',
  },
  componentsEmpty: {
    searchNull: 'Búsqueda sin resultados',
  },
  componentsGrouphandle: {
    batchModify: 'Modificación masiva de estado',
    pleaseSelectAnActiveArea: 'Seleccione un área activa',
    selectStartDate: 'Seleccione fecha de inicio',
    selectEndDate: 'Seleccione fecha de fin',
    emptyCleanToEmptyDirty: 'Vacía limpia → vacía sucia',
    emptyDirtyToEmptyClean: 'Vacía sucia → vacía limpia',
    stayCleanAndTurnDirty: 'Ocupada limpia → ocupada sucia',
    stayDirtyAndTurnClean: 'Ocupada sucia → ocupada limpia',
    batchOutage: 'Desactivación masiva',
    batchDeactivation: 'Levantamiento masivo',
    pleaseEnterTheStartTime: 'Introduzca la hora de inicio',
    pleaseEnterTheEndTime: 'Introduzca la hora de fin',
    pleaseSelectTheRoomForBatchOperation: 'Seleccione las habitaciones para la operación masiva',
    batchOperationSuccessful: 'Operación masiva exitosa',
    whetherToConfirmTheDeactivationBatchDeactivationIncludesrowRooms:
      '¿Confirmar desactivación? Incluye habitaciones ya asignadas',
  },
  componentsHourcheckinconfirm: {
    checkInTimeConfirmation: 'Confirmación de hora de check-in',
    continuousHousing: 'Continuar asignación',
    theArrivalTimeHasBeenExceededPleaseConfirmTheGuestCheckInTime:
      'Se superó la hora estimada; confirme la hora de entrada',
    itHasBeenOccupiedPleaseManuallyArrangeTheRoomAfterFurtherProcessing:
      'Ya está ocupada; tras continuar, asigne manualmente',
  },
  componentsOperationlog: {
    operationRecord: 'Registro de operaciones',
  },
  componentsStopservice: {
    successfulDeactivation: 'Desactivación exitosa',
    selectStartDate: 'Seleccione fecha de inicio',
    selectEndDate: 'Seleccione fecha de fin',
    noteAtLeast3Words: 'La nota debe tener al menos 3 palabras',
    startMustAfterNow: 'La fecha de inicio debe ser mayor o igual a la fecha actual',
    endMustAfterStart: 'La fecha de finalización debe ser posterior a la fecha de inicio',
    // Part 21, lines 4001 to 4200
  },
  serviceHandle: {
    accept: 'Aceptar',
    turnDown2: 'Rechazar',
    serviceProcessing: 'Procesamiento del servicio',
    whetherToProcess: '¿Procesar o no?',
    reasonForRefusal: 'Motivo del rechazo',
    pleaseEnterTheReasonForTheRejection: 'Introduzca el motivo del rechazo',
    accepted: 'Aceptado',
    denialOfService: 'Servicio rechazado',
  },
  sankebookingArrangeroom: {
    noRoomAvailablePleaseConfirmAndTryAgain:
      'No hay habitaciones disponibles para asignar, confirme e inténtelo de nuevo',
    upgradeNumberOfRooms: 'Número de habitaciones a mejorar',
    pleaseEnterRoomChangeRemarks: 'Introduzca observaciones del cambio de habitación',
    conditionOfTheHouse2: 'Estado de la habitación',
    pleaseSelectTheRoomYouWantToUpgrade: 'Seleccione la habitación que desea mejorar',
    thereAreCurrentlyNoRoomTypesAvailableForUpgrade:
      'Actualmente no hay tipos de habitación disponibles para mejorar',
    theNumberOfRowRoomsCannotBeGreaterThanTheNumberOfReservedRooms:
      'El número de habitaciones asignadas no puede ser mayor que el número reservado',
    thisRoomTypeIsNotOnline: 'Este tipo de habitación no está en línea',
    hourProductPleaseSelectAnotherRoomType:
      'Producto por horas, seleccione otro tipo de habitación',
    thisRoomType: 'Este tipo de habitación',
    productsAreSoldOutPleaseChooseAnotherRoomType:
      'El producto por horas está agotado, seleccione otro tipo de habitación',
    noPriceIsSetForTheHourProductPleaseSelectAnotherRoomType:
      'El producto por horas no tiene precio configurado, seleccione otro tipo de habitación',
    yourUpgradedRoomTypeIsAllThatIsLeft: 'Del tipo de habitación mejorado solo quedan',
    pleaseChangeToAnotherRoomTypeOrReduceTheNumberOfRoomUpgrades:
      'habitaciones, cambie a otro tipo o reduzca el número de mejoras',
  },
  sankebookingIndex: {
    channelOrderRoomType: 'Tipo de habitación del pedido del canal',
    operationPrompt: 'Aviso de operación',
    furtherBooking: 'Continuar reserva',
    thisOrderHasAlreadyBeenBookedPleaseDoNotRepeat:
      'Este pedido ya ha sido reservado, no lo repita',
    floorPriceModel: 'Modelo de precio base',
    sellingPriceModel: 'Modelo de precio de venta',
    theNumberOfReservedRoomsCannotBe: 'El número de habitaciones reservadas no puede ser',
    reservationNumber: 'Número de reservas',
    inAddition: 'Además',
    useEbInformation: 'Usar información EB',
    useEbOrderInformation: 'Usar información del pedido EB',
    theNumberOfBookingRoomsIsInconsistentWithTheNumberOfChannelOrdersWhetherToContinueBooking:
      'El número de habitaciones reservadas no coincide con el del pedido del canal, ¿desea continuar?',
    thisOrderCannotBeBooked: 'Este pedido no se puede reservar',
  },
  activityData: {
    dailySpecial: 'Oferta diaria',
    keepPricesLow: 'Mantener precios bajos',
    motivateUsersToBuyMore: 'Incentivar a los usuarios a comprar más',
    earlyRush: 'Captar clientes anticipadamente',
  },
  componentsActivitydetail: {
    discount: 'Descuento',
    promotionInfo:
      'Tras enviar con éxito el registro, la actividad entra en vigor de inmediato. Durante la actividad el hotel puede modificarla o salir, pero los pedidos ya completados se rigen por las reglas existentes. El precio original del tipo de habitación participante no debe ser superior al de otros canales, de lo contrario podría no mostrarse.',
    offerDetails:
      'Si el precio previo a la promoción no es superior al de otros canales, se obtendrán más oportunidades de exposición. Se recomienda que el tipo de habitación más barato participe para obtener mayor tráfico.',
    backToActivityList: 'Volver a la lista de actividades',
    quantitySold: 'Cantidad vendida',
    sellLowEachNight: 'Venta baja por noche',
    pleaseSelectAnEventProduct: 'Seleccione un producto para la actividad',
    noRoomTypeInformationAvailable: 'No hay información de tipos de habitación',
    productsHaveBeenSelectedForTheEvent: 'Productos seleccionados para la actividad',
    selectOffer: 'Seleccionar oferta',
    iHaveReadAndAgree: 'He leído y acepto',
    activityRelatedClause: 'Cláusulas relacionadas con la actividad',
    selectedOffer: 'Oferta seleccionada',
    signUpNow: 'Inscribirse ahora',
    activeTime: 'Periodo de la actividad',
    activityProfile: 'Descripción de la actividad',
    activityRequirement: 'Requisitos de la actividad',
    preferentialDetails: 'Detalles del beneficio',
    specialSpecification: 'Especificación especial',
    entryAndExitRules: 'Reglas de entrada y salida',
    costAttribution: 'Atribución de costes',
    midAutumnFestival: 'Festival del Medio Otoño',
    specialProduct: 'Producto especial',
    areYouSureYouWantToCommitYourChanges: '¿Confirma que desea enviar los cambios?',
    pleaseSelectTheRoomTypeToParticipateInTheEvent:
      'Seleccione el tipo de habitación para participar',
    pleaseSelectDiscount: 'Seleccione el descuento',
    pleaseReadAndAgreeToTheTermsOfTheEvent: 'Lea y acepte las cláusulas de la actividad',
    successfulRegistration: 'Registro exitoso',
  },
  componentsSelfactivitylist: {
    expired: 'Expirado',
    copyPromotion: 'Copiar promoción',
    promotionType: 'Tipo de promoción',
    marginOfPreference: 'Margen de descuento',
    eventDate: 'Fecha de la actividad',
    beOffline: 'Fuera de línea',
    merchantsPushThemselvesOffline: 'Promoción propia fuera de línea',
    offlineSuccess: 'Salida de línea exitosa',
    areYouSureYouWantToDeleteTheActivity: '¿Confirma que desea eliminar la actividad?',
  },
  componentsActivitycontent: {
    activityRequirement: 'Requisitos de la actividad',
    quantitySold: 'Cantidad vendida',
    signUpNow: 'Inscribirse ahora',
    cancelRegistration: 'Cancelar inscripción',
    reEnroll: 'Inscribirse de nuevo',
    areYouSureYouWantToCancelYourRegistration: '¿Confirma que desea cancelar la inscripción?',
  },
  componentsSelfactivitylog: {
    inquire: 'Consultar',
    back: 'Volver',
  },
  componentsDialog: {
    rule: 'Regla',
    new: 'Nuevo',
    content: 'Contenido',
    activityRelatedClause: 'Cláusulas relacionadas con la actividad',
  },
  componentsSelfactivitydetail: {
    discountInfo:
      'Al activar la extensión automática, la promoción se extenderá automáticamente 30 días antes de la fecha de finalización creando una nueva promoción. Si faltan menos de 30 días, se ampliará hasta 30 días.',
    chooseToParticipateInPromotionalProducts: 'Seleccionar productos para la promoción',
    noRoomTypeInformationAvailable: 'No hay información de tipos de habitación',
    selectedProductsForPromotion: 'Productos seleccionados para la promoción',
    selectTheChannelWhereThePromotionIsEffective:
      'Seleccione el canal donde la promoción es efectiva',
    allChannels: 'Todos los canales',
    designatedChannel: 'Canal designado',
    noEffectiveChannelInformationIsAvailable: 'No hay información de canales efectivos',
    youHaveSelectedTheChannelWhereThePromotionTakesEffect:
      'Ha seleccionado el canal donde la promoción es efectiva',
    activeConfiguration: 'Configuración de la actividad',
    setForAtLeast2Days: 'Configurar al menos 2 días',
    setThisParameterForAtLeast1Day: 'Configurar al menos 1 día',
    discount: 'Descuento',
    theDiscountValueIsSetToAtLeast95Off: 'El valor del descuento debe ser como mínimo 95%',
    theMinimumAmountOfImmediateReductionIsSetAt5: 'El importe mínimo de reducción inmediata es 5',
    immediateReductionPromotionIsNotEffectiveForCtrip:
      'La promoción de reducción inmediata no es válida para Ctrip',
    thePromotionIsValidOnlyOnCtrip: 'Esta promoción solo es válida en Ctrip',
    thePromotionIsOnlyEffectiveOnCtripAndTongcheng:
      'Esta promoción solo es válida en Ctrip y Tongcheng',
    link: 'Estancia consecutiva',
    advanceBooking: 'Reserva anticipada',
    preferentialMode: 'Modo de descuento',
    firstStayDiscount: 'Descuento por primera estancia',
    automaticExtension: 'Extensión automática',
    saleTime: 'Tiempo de liquidación',
    theFollowingDay: 'Día siguiente',
    theIntervalShallNotBeLessThan30Days: 'El intervalo no debe ser inferior a 30 días',
    areYouSureYouWantToCommitYourChanges: '¿Confirma que desea enviar los cambios?',
    pleaseSelectTheRoomTypeToParticipateInTheEvent:
      'Seleccione el tipo de habitación para participar',
    pleaseSelectAnEventCheckInDate: 'Seleccione la fecha de check-in de la actividad',
    pleaseFillInTheDiscountAmount: 'Introduzca el importe del descuento',
    atLeast95OffUpTo30Off: 'El descuento debe ser como mínimo 95% y como máximo 30%',
    theDiscountAmountIsAtLeast5AndUpTo500:
      'El importe del descuento debe ser como mínimo 5 y como máximo 500',
    pleaseFillInTheNumberOfConsecutiveDays: 'Introduzca el número de días consecutivos',
    theNumberOfConsecutiveDaysMustBeGreaterThanOrEqualTo1DayAndLessThanOrEqualTo10Days:
      'Los días consecutivos deben ser entre 1 y 10',
    pleaseFillInTheAdvanceBookingDays: 'Introduzca los días de reserva anticipada',
    pleaseFillInTheSaleTime: 'Introduzca el tiempo de liquidación',
    congratulationsOnYourPromotionCreation: 'Felicidades, la promoción se ha creado con éxito',
    congratulationsOnYourSuccessfulCopyPromotion:
      'Felicidades, la promoción se ha copiado con éxito',
    back: 'Volver',
  },
  componentsSelfactivitytemp: {
    createNow: 'Crear ahora',
  },
  productOversaleSetting: {
    timePeriod: 'Periodo de tiempo',
    numberSold: 'Cantidad vendida',
    oversold: 'Sobreventa permitida',
    oversoldQuantity: 'Cantidad de sobreventa',
    oversoldCannotBeGreaterThanTheRemainingPhysicalRoomCapacityOfTheHotelOnThatDay:
      'La sobreventa no puede superar la capacidad física restante del hotel ese día',
    oversoldStockIsActivatedWhenTheActualPhysicalStockOfTheRoomTypeIsSoldOutForTheDay:
      'El stock de sobreventa se activa cuando el stock físico del tipo de habitación se agota ese día',
    pleaseOpenTheAutomaticOverbookingSettingInMoreSystemSettingsBasicSettingsDirectConnectionOrderToAvoidAutomaticRejectionOfOverbookingOrderTimeout:
      'Active la aceptación automática de sobreventa en Más > Configuración del sistema > Configuración básica > Pedidos de conexión directa para evitar rechazos automáticos',
    timeSelectionIsOutOfRange: 'La selección de tiempo está fuera de rango',
    configurationSuccessful: 'Configuración exitosa',
    theSetOverbookingQuantityMustBeGreaterThanOrEqualTo:
      'La cantidad de sobreventa configurada debe ser mayor o igual que',
  },
  productDelayprice: {
    holidayFactorRange:
      'Rango del coeficiente de festivos: decimales entre 1 y 5, con un máximo de una cifra decimal.',
    holidayPricingRule:
      'Tras establecer el coeficiente de festivos, el precio en festivos oficiales de China continental será un múltiplo del precio en días laborables. Por ejemplo, con coeficiente 2 y precio base 100, el precio en festivos será 2*100=200.',
    holidayFactor:
      'Tras establecer el coeficiente de festivos, el precio en festivos oficiales será un múltiplo del precio en días laborables',
    priceCopy: 'Copiar precios de 2 meses',
    open: 'Activado',
    deferredProduct: 'Producto con extensión de precio',
    allDayRoomProducts: 'Productos de habitación de día completo',
    deferralOnlyAppliesToProductsWithFullDayOccupancyType:
      'La extensión solo se aplica a productos de habitación de día completo',
    priceExtensionTime: 'Duración de la extensión de precio',
    holidayCoefficient: 'Coeficiente de festivos',
    statutoryHolidayPricesAreWeekdays: 'El precio en festivos oficiales es',
    times: 'veces',
    automaticDeferralDescription: 'Descripción de la extensión automática',
    theSystemCopiesThePriceOfTheMostRecentWeekToAFutureDateWithoutAPriceAndDatesThatAlreadyHaveAPriceWillNotBeOverwrittenByTheSystem:
      'El sistema copia los precios de la semana más reciente a fechas futuras sin precio; las fechas con precio no se sobrescriben',
    thePriceSourceOfTheAutomaticPriceExtensionIsThePriceOfTheWeekBeforeTheAutomaticPriceExtensionDateInCaseOfHolidaysItIsSkippedAndThePriceOfThePreviousWeekIsTaken:
      'La fuente del precio para la extensión automática es la semana anterior; si hay festivos se omite y se toma la semana previa',
    turnOffAutomaticDeferral: 'Desactivar extensión automática',
  },
  productManageSetting: {
    advanceSale: 'Preventa',
    needChannelConnection:
      'Este producto requiere habilitar la conexión directa del canal para crearse. ¿Confirma habilitarla?',
    confirmChangeProductType:
      'Cambiar el tipo de producto borrará los canales publicados y todas las reglas. ¿Confirma la operación?',
    limitSale: 'Venta limitada (habitaciones)',
    checkInDay: 'Día de check-in',
    beforeCheckIn: 'Antes del check-in',
    // Part 22, lines 4201 to 4400
    atLatest: 'Como máximo',
    theHourlyIncreaseCannotBeGreaterThanThePrice:
      'El recargo por hora no puede ser mayor que el precio',
    physicalRoomType: 'Tipo de habitación física',
    earliestCheckInTime: 'Hora más temprana de check-in',
    latestCheckOutTime: 'Hora más tardía de check-out',
    howLongNoAdditionalRoomChargeminutes: 'Tiempo de extensión sin recargo de habitación (minutos)',
    howLongIsTheFullDayRoomChargehours: 'Tras cuántas horas se cobra tarifa de día completo',
    cancelRule: 'Regla de cancelación',
    paymentPolicy: 'Política de pago',
    validForOnlineSalesOnly: 'Válido solo para ventas en línea',
    releaseChannel: 'Canal de publicación',
    productRegulation: 'Reglas del producto',
    effectiveChannel: 'Canal efectivo',
    priceyuan: 'Precio',
    inputPrice: 'Introducir precio',
    extraChargePerHourrmb: 'Recargo por cada hora adicional',
    forSaleOnly: 'Venta limitada (habitaciones)',
    inputSpace: 'Introducir cantidad de habitaciones',
    enjoyHotelStayLight: 'Qingzhu Enjoy Hotel',
    pleaseEnterTheNumberOfRooms: 'Introduzca el número de habitaciones',
    additionalRule: 'Añadir regla',
    found: 'Crear',
    containing: 'Incluye',
    pleaseEnterTheNumberOfRestrictedRooms:
      'Introduzca el número de habitaciones con venta limitada',
    nonDeletable: 'No eliminable',
    early: 'Temprano',
    withoutBreakfast: 'Sin desayuno',
    liveLightAndEnjoy: 'Qingzhu Premium',
    confirmToDeleteThisRule: 'Confirmar eliminación de esta regla',
    areYouSureToKeepItForSale: '¿Confirma guardar para la venta?',
    areYouSureToCreateASale: '¿Confirma crear la venta?',
    areYouSureYouWantToLeave: '¿Confirma que desea salir?',
  },
  productPriceCalendar: {
    is: '¿',
    confirmDeleteWarning:
      'Confirme si el producto tiene habitaciones aún no desocupadas para evitar afectar las estancias continuadas. Si confirma la eliminación, haga clic en “Confirmar eliminación”.',
    totalAvailableRooms: 'Total de habitaciones disponibles 10 (incluye 3 de sobreventa)',
    limitZeroFull:
      'Cuando el límite de venta es 0, el estado es completo; al cerrar habitaciones no se venderán en línea.',
    openRoomAvailable:
      'Al abrir habitaciones, las disponibles se venderán en línea; al cerrarlas no se venderán en línea',
    allProducts3: 'Todos los productos',
    onlineProduct2: 'Productos en línea',
    offLineProduct2: 'Productos fuera de línea',
    theReckoner: 'Calculadora',
    preSaleFullDayRoom: 'Preventa de habitación de día completo',
    presaleHourRoom: 'Preventa de habitación por horas',
    viewIsNotSupported: 'Vista no compatible por ahora',
    channelPricesCannotBeSet: 'No se pueden establecer precios por canal',
    smallProgramChannelPriceCanBeAdjustedToUpdate:
      'Se puede ajustar el precio del canal del mini programa para actualizar',
    switchRoom: 'Abrir/Cerrar habitaciones',
    limitedSalesNumber: 'Límite de venta',
    unlimitedSale: 'Venta ilimitada',
    packUpAllProducts: 'Plegar todos los productos',
    expandAllProducts: 'Desplegar todos los productos',
    modifyProductPrice: 'Modificar precio del producto',
    extraChargeForMoreThan1Hour: 'Recargo por más de 1 hora',
    enjoyHotelStayLight: 'Qingzhu Enjoy Hotel',
    pleaseEnterLimitedNumber: 'Introduzca el límite de venta',
    maintenancePrice: 'Mantenimiento de precios',
    priceNotMaintained: 'Precio no mantenido',
    amendTheSalesRestrictionRules: 'Modificar reglas de restricción de venta',
    confirmOrNot: 'Confirmar o no',
    areYouSureYouWantToContinue: '¿Confirma que desea continuar con la modificación?',
    theCurrentRateExceedsTheThresholdSetByTheHotel5:
      'El precio actual supera el umbral configurado por el hotel',
    definiteModification: 'Confirmar modificación',
  },
  productPriceCalendarNew: {
    open: 'Abrir habitaciones',
    iss: '¿',
    remainingContractReservedRooms: 'Habitaciones reservadas por contrato restantes',
    roomsCannotBeLower: ' habitaciones; la cantidad reservada no puede ser inferior a este valor',
    confirmDeleteWarning:
      'Confirme si el producto tiene habitaciones aún no desocupadas para evitar afectar las estancias continuadas. Si confirma la eliminación, haga clic en “Confirmar eliminación”.',
    Thenumberofremainingcontractreservedroomsforthisproduct:
      'La cantidad de habitaciones reservadas por contrato restantes de este producto no es 0; se ha enviado la solicitud de cierre, espere la revisión.',
    cannotCloseRoom:
      'La cantidad de habitaciones reservadas por contrato restantes no es 0; no se puede cerrar. Contacte al gerente del canal.',
    confirmModification: 'Confirmar modificación',
    EBDeepOperationFailed: 'Falló la operación profunda EB',
    syncCurrentPageEBData: 'Sincronizar datos EB de la página actual',
    previousTwoWeeks: 'Dos semanas anteriores',
    nextTwoWeeks: 'Dos semanas siguientes',
    batchChangeInventory: 'Modificar inventario por lotes',
    theReckoner: 'Calculadora',
    preSaleFullDayRoom: 'Preventa de habitación de día completo',
    presaleHourRoom: 'Preventa de habitación por horas',
    underRevision: 'En modificación',
    viewIsNotSupported: 'Vista no compatible por ahora',
    dataSynchronizationIsUnderwayPleaseQueryTheDataAgainAfter1Minute:
      'Sincronizando datos, vuelva a consultar después de 1 minuto',
    lightLiveDistributionChannelPriceCannotBeSet:
      'No se puede establecer el precio del canal de distribución Qingzhu',
    smallProgramChannelPriceCanBeAdjustedToUpdate:
      'Se puede ajustar el precio del canal del mini programa para actualizar',
    switchRoomSetup: 'Configuración de apertura/cierre',
    notModify: 'No modificar',
    roomSetting: 'Configuración de habitaciones',
    unlimitedSale: 'Venta ilimitada',
    reserveRoomSetup: 'Configuración de habitaciones reservadas',
    pleaseSelectRoomType: 'Seleccione el tipo de habitación',
    pleaseSelectCheckInType: 'Seleccione el tipo de check-in',
    notShowPreSaleProduct: 'No mostrar productos en preventa',
    showPreSaleProduct: 'Mostrar productos en preventa',
    notShowEbProduct: 'No mostrar productos EB',
    showEbProduct: 'Mostrar productos EB',
    allCheckInTypes: 'Todos los tipos de check-in',
    holiday: 'Festivo',
    packItAllUp: 'Plegar todo',
    expandAll: 'Desplegar todo',
    extraChargeForMoreThan1Hour: 'Recargo por más de 1 hora',
    theNumberOfReservedRoomsCanBeIncreasedAtMostNotMoreThanTheCurrentInventoryAtLeastNotLessThanTheNumberOfRemainingContractedReservedRooms:
      'La cantidad de habitaciones reservadas puede aumentar, como máximo no puede superar el inventario actual y como mínimo no puede ser inferior a las reservadas por contrato restantes',
    offLineProduct2: 'Productos fuera de línea',
    onlineProduct2: 'Productos en línea',
    allProducts3: 'Todos los productos',
    showFloor: 'Mostrar precio base',
    theReservePriceIsNotDisplayed: 'No mostrar precio base',
    directChannel4: 'Canal directo',
    goWhereTheDirectConnection: 'Conexión directa Qunar',
    unboundChannel: 'Canal no vinculado',
    synchronizationFailure: 'Fallo de sincronización',
    theStartDateOfTheLastTwoWeeksCannotBeLessThanTheCurrentDate:
      'La fecha de inicio de las dos semanas anteriores no puede ser menor que la fecha actual',
    pleaseSelectTheCurrentStartEndDate: 'Seleccione la fecha de inicio y fin actuales',
    pleaseEnterTheNumberOfReservedRooms: 'Introduzca la cantidad de habitaciones reservadas',
    pleaseEnterLimitedNumber: 'Introduzca el límite de venta',
    maintenancePrice: 'Mantenimiento de precios',
    priceNotMaintained: 'Precio no mantenido',
    modifyProductPrice: 'Modificar precio del producto',
    modifyProductInventory: 'Modificar inventario del producto',
    confirmOrNot: 'Confirmar o no',
    theCurrentRateExceedsTheThresholdSetByTheHotel5:
      'El precio actual supera el umbral configurado por el hotel',
    areYouSureYouWantToContinue: '¿Confirma que desea continuar con la modificación?',
    definiteModification: 'Confirmar modificación',
    ebChannel: 'Canal EB',
    ebMeituan: 'EB Meituan',
    ebCtrip: 'EB Ctrip',
    ebFeizhu: 'EB Feizhu',
  },
  productPriceAudit: {
    allRejectedSuccessfully: 'Todos rechazados con éxito',
    pass: 'Aprobar',
    turnDown: 'Rechazar',
    revisedPrice: 'Precio modificado',
    rangeOfVariation: 'Rango de variación',
    priceChanger: 'Modificador del precio',
    auditor: 'Auditor',
    auditTime: 'Hora de auditoría',
    toBeReviewed: 'Pendiente de revisión',
    passTheExamination: 'Aprobado',
    expired: 'Expirado',
    successfulAudit: 'Auditoría exitosa',
  },
  pcncomponentDataexplain: {
    totalAvailableRooms: 'Total de habitaciones disponibles 10 (incluye 3 de sobreventa)',
    ebPriceSoldRemaining: 'Precio (venta EB) / habitaciones vendidas / habitaciones restantes',
    ebPriceSoldCloseStatus: 'Precio (venta EB) / habitaciones vendidas / estado de cierre',
    ebBasePriceReservedUnlimited:
      'Precio base EB / habitaciones reservadas restantes (incluye contrato y temporales) / venta ilimitada',
    hourRoomProductsShowHourRoomIdentification:
      'Los productos por horas muestran la identificación de habitación por horas',
    whenTheProductPriceIsChangedOrTheHousingStatusIsNotImmediatelyEffectiveInTheAuditTheIdentificationInTheAuditIsDisplayedAndTheIdentificationInTheAuditIsHiddenAfterTheAuditPassesTheModificationAndBecomesEffective:
      'Tras cambiar el precio o el estado de habitaciones, si no entra en vigor de inmediato y está en auditoría, se muestra la identificación de auditoría; al aprobarse y hacerse efectivo, se oculta',
    underRevision: 'En modificación',
    thePriceOrInventoryHasDataThatIsBeingModifiedTheIdentifierIsDisplayedWhenTheModificationResultIsNotObtainedTheIdentifierIsHiddenOnlyAfterSuccessOrFailure:
      'Cuando el precio o inventario se está modificando y no hay resultado, se muestra un indicador; solo se oculta tras éxito o fallo',
    ifTheProductFailsToChangeThePriceOrChangeTheRoomStatusTheFailureIdentifierWillBeDisplayedAndTheIdentifierWillBeHiddenOnlyAfterTheNextOperationSucceedsInChangingThePriceOrChangingTheRoomStatus:
      'Si falla el cambio de precio o estado, se muestra un indicador de fallo; solo se oculta cuando la siguiente operación tiene éxito',
    theProductFailsToBeObtainedContactTheOperationManagerToCheckWhetherTheProductHasBeenChanged:
      'No se pudo obtener el producto; contacte al gerente de operaciones para confirmar si hubo cambios',
    statusDeclaration: 'Descripción del estado',
    whenTheLimitedNumberOfSalesIs0TheRoomIsFullAndItCannotBeSoldAfterClosingTheRoomOnlyTheRelevantRoomWillStopSellingInTheUnlimitedNumberState:
      'Cuando el límite de venta es 0, está completo y no se vende; en estado ilimitado, solo al cerrar habitaciones se detiene la venta',
    ctripEbPrepaidProductsShowThePrepaidLogo:
      'Los productos EB prepagados de Ctrip muestran el logo de prepago',
    ctripEbCashProductsShowTheCashLogo:
      'Los productos EB de pago en efectivo de Ctrip muestran el logo de efectivo',
  },
  pcncomponentBatchUpdateStock: {
    cannotCloseRoomTip:
      'Cuando las habitaciones reservadas restantes del producto EB no son 0, no se puede cerrar',
    roomSettingTip:
      'El ajuste de habitaciones modifica el límite de venta para todos los productos del tipo; el inventario de productos directos y EB toma el mínimo entre límite y stock físico',
    infiniteQuantityTip:
      'Cantidad ilimitada corresponde a: EB Meituan ilimitado, Feizhu sin límite, Ctrip freesale; en canal directo, venta ilimitada',
    notModify: 'No modificar',
    roomSetting: 'Configuración de habitaciones',
    restrictedSalesIncrease: 'Aumentar límite de venta',
    restrictedSalesReduction: 'Reducir límite de venta',
    directlyConnectedProductsOnlySupportToModifyTheSwitchingRoomStatusDoNotSupportToModifyTheInventory:
      'Los productos de conexión directa solo permiten modificar el estado de apertura/cierre, no el inventario',
    batchChangeInventory: 'Modificar inventario por lotes',
    productSelection: 'Selección de productos',
    whetherToDisplayPreSaleProducts: 'Mostrar o no productos en preventa',
    channelSelection: 'Selección de canales',
    paymentType: 'Tipo de pago',
    selectionWeek2: 'Seleccionar semana',
    switchRoomSetup: 'Configuración de apertura/cierre',
    open: 'Abrir habitaciones',
    someProductsFailedToModifyTheFollowingAreFailedProductsPleaseGetTheLatestPriceInventoryAndModifyAgain2:
      'Algunos productos no se pudieron modificar; a continuación se listan los fallidos. Obtenga el precio e inventario más recientes e intente de nuevo',
    pleaseSelectADateRange2: 'Seleccione un rango de fechas',
    pleaseSelectAWeek2: 'Seleccione una semana',
    pleaseEnterTheNumberOfRestrictedRooms:
      'Introduzca el número de habitaciones con venta limitada',
    pleaseEnterTheNumberOfRestrictedAdditionalRooms:
      'Introduzca el número de habitaciones a añadir al límite',
    pleaseEnterTheNumberOfRestrictedReducedRooms:
      'Introduzca el número de habitaciones a reducir del límite',
  },
  pcncomponentPriceunified: {
    weekend: 'Fin de semana',
    officialWebsiteDirect: 'Sitio web oficial directo',
    dateCannotRepeat: 'La fecha no puede repetirse',
    // Part 23, lines 4401 to 4600
    displayNextPage: 'Mostrar página siguiente',
    priceCannotBeLessThan20: 'El precio de venta no puede ser menor o igual a 20',
    lowSellingPriceTip:
      'El precio de venta de los siguientes productos es demasiado bajo, confirme si desea continuar con la modificación',
    priceExceedsThresholdTip:
      'Esta modificación de precio supera el rango preestablecido, contacte al gerente de la tienda para la revisión',
    selectProduct: 'Seleccionar producto',
    weekdays: 'Días laborables',
    noDifference: 'Sin distinción',
    distinguish: 'Distinguir',
    bulkAdjustment: 'Ajuste por lotes',
    increase: 'Aumentar',
    reduce: 'Reducir',
    weekdayWeekend: 'Laborables / Fin de semana',
    someProductsFailedToModifyTheFollowingAreFailedProductsPleaseGetTheLatestPriceInventoryAndModifyAgain2:
      'Algunos productos no se pudieron modificar, a continuación se muestran los productos fallidos. Obtenga el precio e inventario más recientes y modifique nuevamente',
    weekendPrice: 'Diferenciar precio de fin de semana',
    repricingDate: 'Fecha de cambio de precio',
    effectiveWeek: 'Semana efectiva',
    maxFiveDates: 'Máximo 5 fechas',
    priceChangeModeTip:
      'El modo de cambio de precio puede ser modificar precio de venta + comisión o precio base. En el modo precio de venta + comisión, solo los productos de Ctrip admiten modificar la comisión y solo puede aumentarse; el modo de precio base solo puede modificarse en productos de Ctrip',
    sellPriceCommission: 'Precio de venta + comisión',
    ebChannel: 'Canal EB',
    ebMeituan: 'EB Meituan',
    ebCtrip: 'EB Ctrip',
    ebFeizhu: 'EB Feizhu',
    splitPricing: 'Cambio de precio separado',
    uniformPriceChange: 'Cambio de precio unificado',
    productSelection: 'Selección de productos',
    paymentType: 'Tipo de pago',
    selectionWeek2: 'Seleccionar semana',
    thePreviousStepReselectTheProduct: 'Paso anterior: volver a seleccionar producto',
    methodOfRepricing: 'Método de cambio de precio',
    separatePriceChangesCanSetThePriceOfEachProductAndUnifiedPriceChangesCanBeAddedAndReducedInBatches:
      'El cambio de precio separado permite configurar el precio de cada producto; el cambio unificado permite aumentar o reducir precios por lotes',
    priceModel: 'Modelo de precio',
    priceBeforeModification: 'Precio antes de la modificación',
    extraChargeAfterOneHour: 'Recargo después de una hora',
    commission: 'Comisión',
    directChannel4: 'Canal directo',
    goWhereTheDirectConnection: 'Conexión directa Qunar',
    value: 'Valor',
  },
  pcncomponentTable: {
    passTheVerification: 'Verificación aprobada',
    verificationFail: 'Verificación fallida',
  },
  pcncomponentLog: {
    revisedPrice3: 'Precio modificado',
    pleaseEnterTheRevisedPrice: 'Introduzca el precio modificado',
    pleaseSelectAStandardProduct: 'Seleccione un producto estándar',
    straight: 'Directo',
  },
  giftPro: {
    bindUnbind: 'Vincular / Desvincular',
    giftValueInfo: 'El valor del paquete solo se muestra como referencia y no genera costos reales',
    thePackageCanOnlyBeConfiguredWithAllDayRoomProducts:
      'El paquete solo puede configurarse con productos de habitación de día completo',
    eachProductCanBeConfiguredWithOnlyOnePackage:
      'Cada producto solo puede configurarse con un paquete',
    theGiftPackageIsOnlyValidForMeituanDirectConnectionProducts:
      'El paquete solo es válido para productos de conexión directa de Meituan',
    packageDescription: 'Descripción del paquete',
    allProducts2: 'Todos los productos',
    modifiedGiftPack: 'Modificar paquete',
    packageName: 'Nombre del paquete',
    giftPackageGiving: 'Método de entrega del paquete',
    packageType: 'Tipo de paquete',
    packageStatus: 'Estado del paquete',
    activeProduct: 'Producto activo',
    createPackage: 'Crear paquete',
    packageValue: 'Valor del paquete',
    packageEffectiveDate: 'Fecha de vigencia del paquete',
    upperLimit1500: 'Límite máximo 1500',
    upperLimit: 'Límite máximo',
    packageDetails: 'Detalles del paquete',
    maximum80Characters: 'Máximo 80 caracteres',
    wayOfGiving: 'Forma de entrega',
    thePackageValueCannotBeEmpty: 'El valor del paquete no puede estar vacío',
    oneDeliveryPerRoom: 'Una entrega por habitación',
    complimentaryOnceADayPerRoom: 'Una cortesía diaria por habitación',
    pleaseEnterThePackageName: 'Introduzca el nombre del paquete',
    pleaseSelectTheGiftMethod: 'Seleccione el método de entrega',
    pleaseSelectAPackageType: 'Seleccione el tipo de paquete',
    pleaseSelectPackageDetails: 'Seleccione los detalles del paquete',
    pleaseSelectAnEffectiveProduct: 'Seleccione el producto efectivo',
    pleaseSelectAnEffectiveDate: 'Seleccione la fecha de vigencia',
    whetherToDropTheGiftPackage: '¿Desea dar de baja el paquete?',
    giftBagOffLine: 'Paquete fuera de línea',
    offlineSuccess: 'Baja exitosa',
    offlineFailure: 'Error al dar de baja',
    methodOfCancellation: 'Método de cancelación',
    createdSuccessfully: 'Creado con éxito',
    creationFailure: 'Error al crear',
  },
  giftLog: {
    packageOperationLog: 'Registro de operaciones del paquete',
  },
  pullnewMember: {
    memberInformationEntry: 'Ingreso de información de miembros',
    areRequiredFieldsOtherFieldsAreNotRequired: 'Son campos obligatorios, los demás no lo son',
    idNumber: 'Número de documento',
    inputResult: 'Resultado del ingreso',
    recordSuccessfully: 'Registro exitoso',
    entryFailure: 'Error en el registro',
    memberSale: 'Venta especial para miembros',
    enter: 'Ingresar',
    passport: 'Pasaporte',
    pleaseEnterTheIdNumber: 'Introduzca el número de documento',
    theNameFormatIsIncorrect: 'El formato del nombre es incorrecto',
    theMobilePhoneNumberCannotBeEmpty: 'El número de teléfono móvil no puede estar vacío',
    theMobilePhoneNumberFormatIsIncorrect: 'El formato del número de teléfono móvil es incorrecto',
    theFormatOfTheIdCardNumberIsIncorrect: 'El formato del número de identificación es incorrecto',
    memberInformationEnteredSuccessfully: 'La información del miembro se ingresó correctamente',
  },
  pullnewNewlist: {
    promoter: 'Promotor',
    pullTime: 'Hora de captación',
    pleaseEnterYourPromoterName: 'Introduzca el nombre del promotor',
    memberNickname: 'Apodo del miembro',
    pulsingType: 'Tipo de captación',
  },
  pullnewQrcode: {
    aboutHalfA4: 'Aproximadamente media hoja A4',
    sizeLarge: 'Grande',
    sizeSmall: 'Pequeño',
    sizeMedium: 'Mediano',
    lShapedStand: 'Soporte en forma de L',
    paperSize: 'Tamaño de papel',
    downloadPicture: 'Descargar imagen',
    memberPullNewCodeGenerationPleaseWait:
      'Generando código de captación de miembros, espere por favor',
    memberPoster: 'Póster de miembros',
    frontDeskStaff: 'Personal de recepción',
    foreground: 'Recepción',
    commonArea: 'Área común',
    corridor: 'Pasillo',
    elevator: 'Ascensor',
    displayStand: 'Expositor',
  },
  tiktokpresalecouponDetail: {
    name: 'Nombre',
    totalGoodsPrice: 'Precio total del producto (precio tachado)',
    uploadImageTips:
      'Suba de 1 a 5 imágenes, tamaño máximo 5M; resolución recomendada 375*280px; proporción 4:3',
    unavailableCheckInDates: 'Fechas no disponibles para入住:',
    otherInStoreOffers: 'Puede disfrutar de otras ofertas en tienda (consulte con el comerciante)',
    createACoupon: 'Crear cupón de preventa',
    support: 'Compatible',
    nonsupport: 'No compatible',
    putUp: 'Alojamiento',
    bindAvailableProducts: 'Vincular productos disponibles',
    bindAtLeastOneProduct: 'Vincular al menos un producto',
    meal: 'Comida',
    addMeal: 'Añadir comida',
    courteousReception: 'Cortesía',
    addItem: 'Añadir ítem',
    unlimitedInventory: 'Inventario ilimitado',
    stockLimit: 'Límite de inventario',
    whenAutomaticExtensionIsEnabledTheProductWillBeAutomaticallyExtendedFor30DaysAfterTheExpirationDate:
      'Al habilitar la extensión automática, el producto se extenderá automáticamente por 30 días tras la fecha de vencimiento',
    namedDate: 'Fecha específica',
    specifiedDays: 'Días especificados',
    fromTheDateOfPurchase: 'Desde la fecha de compra',
    availableWithinDays: 'Días disponibles',
    unavailableWeek: 'Semana no disponible',
    unavailableHolidays: 'Festivos no disponibles',
    unavailableDate: 'Fecha no disponible',
    subjectToAMarkup: 'Requiere recargo',
    noMarkup: 'Sin recargo',
    allStores: 'Todas las tiendas',
    addMarkupRules: 'Añadir reglas de recargo',
    limitOnePurchasePerOrder: 'Límite de una compra por pedido',
    purchaseLimitPerPerson: 'Límite de compra por persona',
    maximumPurchasePerPerson: 'Máximo de compra por persona',
    zhang: 'Unidad',
    noAdvanceReservationRequired: 'No se requiere reserva anticipada',
    advanceReservationRequired: 'Se requiere reserva anticipada',
    aheadOfSchedule: 'Con antelación',
    dailyReservation: 'Reserva por días',
    beforeCheckIn: 'Antes del check-in',
    cannotBeCombinedWithOtherInStoreOffers: 'No combinable con otras ofertas en tienda',
    theMealTypeCannotBeEmpty: 'El tipo de comida no puede estar vacío',
    theNameOfTheOfferCannotBeEmpty: 'El nombre de la cortesía no puede estar vacío',
    ticketName: 'Nombre del cupón de preventa',
    pleaseEnterTicketNamemaximum24Words:
      'Introduzca el nombre del cupón de preventa (máximo 60 caracteres)',
    fractionalAppointment: 'Reserva fraccionada',
    commodityContent: 'Contenido del producto',
    lunch: 'Almuerzo',
    automaticExtension: 'Extensión automática',
    availabilityDate: 'Fecha disponible para入住',
    markUpPolicy: 'Política de recargo',
    additionalChargesApply: 'Aplican cargos adicionales',
    purchaseRestrictionRule: 'Regla de restricción de compra',
    reservationRule: 'Regla de reserva',
    upload110PicturesImageSize5mOrLessRecommendedResolution375280pxImageRatio:
      'Suba de 1 a 10 imágenes, tamaño máximo 5M; resolución recomendada 375*280px; proporción',
    preSaleTicketHeadChart: 'Imagen principal del cupón de preventa',
    longMapOfAdvanceTickets: 'Imagen larga del cupón de preventa',
    reservationValidity: 'Validez de la reserva',
    markupStore: 'Tienda con recargo',
    markupSession: 'Periodo con recargo',
    unit: 'Unidad',
    pleaseEnterTheUnit: 'Introduzca la unidad',
    priceyuan: 'Precio',
    cancellationRules: 'Reglas de cancelación de reserva',
    // Part 24, lines 4601 to 4800
    rulesOfUse: 'Reglas de uso',
    otherDescriptiveInformation: 'Otra información descriptiva',
    pleaseEnterAdditionalExplanatoryInformation: 'Ingrese otra información explicativa',
    found: 'Crear',
    picturePreview: 'Vista previa de imágenes',
    theNameOfTheVoucherCannotBeEmpty: 'El nombre del cupón de preventa no puede estar vacío',
    theNameOfTheVoucherCannotExceed24Characters:
      'El nombre del cupón de preventa no puede exceder 60 caracteres',
    pleaseSelectASaleDate: 'Seleccione la fecha de venta',
    pleaseSelectTheReservationValidityPeriod: 'Seleccione el período de validez de la reserva',
    pleaseSelectTheHeaderDiagram: 'Seleccione la imagen principal',
    pleaseSelectALongMap: 'Seleccione la imagen larga',
    thePurchaseLimitPerPersonCanOnlyBeANumber:
      'El límite de compra por persona solo puede ser un número',
    pleaseFillInTheLengthOfStay: 'Ingrese la duración de la estancia',
    mealPriceMustBeGreaterThan: 'El precio de la comida debe ser mayor que',
    theCourtesyPriceMustBeGreaterThan: 'El precio de la cortesía debe ser mayor que',
    theTotalPriceOfTheGoodsCannotBeEmpty: 'El precio total del producto no puede estar vacío',
    theTotalPriceOfTheGoodsMustBeGreaterThan: 'El precio total del producto debe ser mayor que',
    pleaseFillInTheActualPricePaidByTheGuest: 'Ingrese el precio real pagado por el huésped',
    theActualPricePaidMustBeGreaterThan: 'El precio real pagado debe ser mayor que',
    theActualPricePaidByTheGuestCannotBeGreaterThanTheTotalPriceOfTheProduct:
      'El precio real pagado por el huésped no puede ser mayor que el precio total del producto',
    youCanOnlyUploadPictureFiles: 'Solo se pueden subir archivos de imagen',
    pleaseUploadAtLeast1HeaderImage: 'Suba al menos una imagen principal',
    pleaseUploadAtLeast1LongPicture: 'Suba al menos una imagen larga',
    pleaseEnterTheMaximumPurchasePerPerson: 'Ingrese el máximo de compra por persona',
    pleaseFillInTheDailyLimit: 'Ingrese el límite diario',
    confirmTheDateToDeleteThis: 'Confirmar la eliminación de esta fecha',
    confirmToDeleteThisProduct: 'Confirmar la eliminación de este producto',
    confirmToDeleteThisMeal: 'Confirmar la eliminación de esta comida',
    removeMarkupRules: 'Eliminar reglas de recargo',
    confirmToRemoveThisMarkupPolicy: 'Confirmar la eliminación de esta política de recargo',
    newMarkupRules: 'Agregar nueva regla de recargo',
    confirmToDeleteThisOffer: 'Confirmar la eliminación de esta cortesía',
    addProjectData: 'Agregar datos del proyecto',
    popUpsAreClosed: 'Las ventanas emergentes se han cerrado',
    beSureToRemoveThisRestriction: 'Confirmar la eliminación de esta restricción',
    imageUploadFailed: 'Error al subir la imagen',
  },
  tiktokpresalecouponList: {
    deleteConfirm:
      'Después de eliminar, el producto no se podrá recuperar. ¿Confirmar eliminación?',
    shelveConfirm: 'Después de retirar, el producto no se podrá vender. ¿Confirmar retiro?',
    unrestrictedInventory: 'Inventario sin límite',
    theRemovalHasBeenCancelled: 'El retiro ha sido cancelado',
    productId: 'ID del producto',
    product: 'Producto',
    createACoupon: 'Crear cupón de preventa',
    listing: 'Publicar',
    delist: 'Retirar',
    auditFailure: 'Fallo en la auditoría',
    soldInventory: 'Inventario vendido',
    modifiedPricePool: 'Modificar banco de precios',
    copy: 'Copiar',
    exportListOfPreSaleTickets: 'Exportar lista de cupones de preventa',
    itemDeletion: 'Eliminación del producto',
    goodsOffTheProductionLine: 'Producto fuera de línea',
    removedSuccessfully: 'Retirado con éxito',
  },
  assemblyAddpriceruledialog: {
    allStores: 'Todas las tiendas',
    byDate: 'Por fecha',
    byHoliday: 'Por festivo',
    addMarkupRules: 'Agregar reglas de recargo',
    markupStore: 'Tienda con recargo',
    markUpPeriod: 'Período de recargo',
    pleaseEnterTheAmountOfTheIncrease: 'Ingrese el monto del recargo',
    theIncreaseMustBeGreaterThan: 'El recargo debe ser mayor que',
    pleaseSelectTheIncreasePeriod: 'Seleccione el período de recargo',
    pleaseSelectAFestival: 'Seleccione un festivo',
    pleaseSelectTheWeekOfIncrease: 'Seleccione la semana del recargo',
  },
  assemblyAddmeals: {
    addMeal: 'Agregar comida',
    typeOfMeal: 'Tipo de comida',
    pleaseSelectTheTypeOfMeal: 'Seleccione el tipo de comida',
    lunch: 'Almuerzo',
    dinner: 'Cena',
    copies: 'Cantidad',
    pleaseEnterTheNumberOfCopies: 'Ingrese la cantidad',
    theNumberOfCopiesMustBeGreaterThan: 'La cantidad debe ser mayor que',
  },
  settingHardware: {
    hardwareManagementToBeDeveloped: 'Gestión de hardware, en desarrollo',
  },
  settingMessage: {
    messageManagementToBeDeveloped: 'Gestión de mensajes, en desarrollo',
  },
  baseinfotabBase: {
    orientation: 'Ubicación',
    china: 'China',
    province: 'Provincia',
    hotelRating: 'Categoría del hotel',
    detailedAddress: 'Dirección detallada',
    city: 'Ciudad',
    hotelPrice: 'Precio del hotel',
    hotelReceptionCellPhone: 'Teléfono móvil de recepción',
    hotelFrontDesk: 'Teléfono fijo de recepción',
    areaCode: 'Código de área',
    landlineNumber: 'Número fijo',
    extensionNumber: 'Extensión',
    serviceStatus: 'Estado del servicio',
    ctripHotelStars: 'Clasificación de estrellas Ctrip',
    noStarLevel: 'Sin estrellas',
    whetherToSellItOnTheInternet: '¿Vender en internet?',
    currency: 'Moneda',
    longitude: 'Longitud',
    latitude: 'Latitud',
    baiduLatitudeAndLongitude: 'Latitud y longitud (Baidu)',
    pleaseEnterTheCorrectPhoneNumberWithAMaximumOf11Digits:
      'Ingrese un número de teléfono correcto con un máximo de 11 dígitos',
    theLengthIs78Characters: 'La longitud es de 7-8 caracteres',
    theLengthIs34Characters: 'La longitud es de 3-4 caracteres',
    pleaseEnterAnInteger: 'Ingrese un número entero',
    pleaseEnterTheHotelName: 'Ingrese el nombre del hotel',
    lengthOf250ChineseCharacters: 'Longitud de 2 a 50 caracteres chinos',
    theValueContains34Digits: 'El valor contiene de 3 a 4 dígitos',
    theValueContains78Characters: 'El valor contiene de 7 a 8 dígitos',
    pleaseEnterTheValue: 'Ingrese el valor',
    pleaseSelectAProvince: 'Seleccione una provincia',
    pleaseSelectCity: 'Seleccione una ciudad',
    pleaseSelectACounty: 'Seleccione un distrito/condado',
    pleaseEnterTheFullAddress2: 'Ingrese la dirección completa',
    theDetailedAddressDoesNotExceed50ChineseCharacters:
      'La dirección detallada no debe exceder 50 caracteres chinos',
    pleaseSelectHotelClass: 'Seleccione la categoría del hotel',
    pleaseSelectACtripHotelStar: 'Seleccione la estrella Ctrip',
    selectWhetherTheExternalNetworkIsVisible: 'Seleccione si es visible en la red externa',
    pleaseSelectHotelServiceStatus: 'Seleccione el estado del servicio del hotel',
    economical: 'Económico',
    quasi1Star: 'Cuasi 1 estrella',
    true1Star: '1 estrella',
    quasi2Star: 'Cuasi 2 estrellas',
    true2Star: '2 estrellas',
    quasi3Star: 'Cuasi 3 estrellas',
    true3Star: '3 estrellas',
    quasi4Star: 'Cuasi 4 estrellas',
    true4Star: '4 estrellas',
    quasi5Star: 'Cuasi 5 estrellas',
    true5Star: '5 estrellas',
    inOperation: 'En operación',
    suspendBusiness: 'Operación suspendida',
    tencentMapLatitudeAndLongitudeCanNotBeEmpty:
      'La latitud y longitud de Tencent Map no pueden estar vacías',
    theNameAndAddressOfTheHotelAreUnderReview:
      'El nombre y la dirección del hotel están en revisión',
    districtcounty: 'Distrito/Condado',
    tencentamapLatitudeAndLongitude: 'Latitud y longitud Tencent/Amap',
    pleaseEnterTheCorrectPhoneNumberAndTheMaximumIs11Digits:
      'Ingrese un número de teléfono correcto con un máximo de 11 dígitos',
  },
  baseinfotabFull: {
    hotelTimezone: 'Zona horaria del hotel',
    fixedRoomNumber: '¿Número de habitaciones fijo?',
    businessCircle: 'Zona comercial',
    hotelBuildingHeight: 'Altura del edificio del hotel',
    subordinateBusinessCircle: 'Subzona comercial',
    totalNumberOfRooms: 'Total de habitaciones',
    hotelOpeningHours: 'Fecha de apertura del hotel',
    pleaseSelectADate5: 'Seleccione año y mes',
    affiliatedGroup: 'Grupo afiliado',
    hotelRenovationTime: 'Fecha de renovación del hotel',
    affiliatedBrand: 'Marca afiliada',
    hotelTypeupToThree: 'Tipo de hotel (máximo 3)',
    hotelThemeupToThreeCanBeSelected: 'Tema del hotel (máximo 3)',
    settlementMethod: 'Método de liquidación',
    hotelProfile: 'Perfil del hotel',
    hotelTransportationLocation: 'Ubicación y transporte',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan3Digits:
      'Ingrese un número mayor o igual a 0 y no mayor a 3 dígitos',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan2Digits:
      'Ingrese un número mayor o igual a 0 y no mayor a 2 dígitos',
    pleaseEnterADescriptionOfTheHotelWithAMaximumLengthOf800Characters:
      'Ingrese la descripción del hotel con un máximo de 800 caracteres',
    pleaseEnterTheHotelTransportationLocation: 'Ingrese la ubicación de transporte del hotel',
    pleaseEnterTheHotelTransportationLocationInAMaximumOf800Characters:
      'Ingrese la ubicación de transporte del hotel con un máximo de 800 caracteres',
    pleaseEnterTheTotalNumberOfRooms: 'Ingrese el total de habitaciones',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan3Digits2:
      'Ingrese un número mayor o igual a 0 y no mayor a 3 dígitos',
    pleaseSelectYourBrand: 'Seleccione la marca afiliada',
    pleaseEnterTheHotelBuildingHeight: 'Ingrese la altura del edificio del hotel',
    pleaseEnterANumberGreaterThanOrEqualTo0AndNoMoreThan2Digits2:
      'Ingrese un número mayor o igual a 0 y no mayor a 2 dígitos',
    pleaseEnterHotelRenovationTime: 'Ingrese la fecha de renovación del hotel',
    pleaseEnterHotelOpeningHours: 'Ingrese la fecha de apertura del hotel',
    pleaseEnterTheCheckoutSupportCardType: 'Ingrese los tipos de tarjeta admitidos para el pago',
    pleaseSelectHotelType: 'Seleccione el tipo de hotel',
    pleaseSelectAHotelTheme: 'Seleccione un tema del hotel',
    bizumi: 'Meizhu',
    theBusinessCircleIsUnderReview: 'La zona comercial está en revisión',
    includesButNotLimitedToHotelAddressHotelFacilitiesHotelServicesProvidedHotelFeaturesAndAdvantages:
      'Incluye, entre otros: dirección del hotel, instalaciones, servicios ofrecidos, características y ventajas',
    includesButNotLimitedToTrafficFacilitiesNearTheHotelSuchAsDistanceFromTheBusStation100MetersDistanceFromTheHighSpeedTrainStation25Km:
      'Incluye, entre otros: instalaciones de transporte cercanas, por ejemplo: 100 m a la parada de autobús, 2.5 km a la estación de tren de alta velocidad',
  },
  baseinfotabInfo: {
    commission2: 'Impuestos y tasas',
    bookingInstructions: 'Instrucciones de reserva',
    variousFaults: 'Diversas fallas',
    earliestCheckInTime: 'Hora más temprana de check-in',
    latestDepartureTime: 'Hora más tardía de salida',
    hourRoomEarliestCheckInTime: 'Hora más temprana de check-in (habitación por horas)',
    hourRoomLatestCheckOutTime: 'Hora más tardía de check-out (habitación por horas)',
    aMaximumOf30Characters: 'Máximo 30 caracteres',
    taxTitle: 'Nombre del impuesto',
    chargingStandard: 'Estándar de cobro',
    reservationNotes: 'Notas de reserva',
    chineseDescription: 'Descripción en chino',
    pleaseEnterYourEarliestCheckInTime: 'Ingrese la hora más temprana de check-in',
    // Part 25, lines 4801 to 5000
    pleaseEnterTheLatestDepartureTime: 'Ingrese la hora más tardía de salida',
    pleaseEnterTheEarliestCheckInTimeForTheHourRoom:
      'Ingrese la hora más temprana de check-in para habitaciones por horas',
    pleaseEnterTheLatestCheckOutTimeForTheHourRoom:
      'Ingrese la hora más tardía de check-out para habitaciones por horas',
    pleaseSelectTheBookingInstructions: 'Seleccione las instrucciones de reserva',
    noMoreThan10ChineseCharactersInLength: 'La longitud no debe exceder 10 caracteres chinos',
    theLengthCannotExceed20Characters: 'La longitud no debe exceder 20 caracteres',
    noMoreThan20ChineseCharactersInLength: 'La longitud no debe exceder 20 caracteres chinos',
    noMoreThan30ChineseCharactersInLength: 'La longitud no debe exceder 30 caracteres chinos',
    theLengthCannotExceed60Characters: 'La longitud no debe exceder 60 caracteres',
    cutOffTheWaterSupply: 'Corte de agua',
    powerFailure: 'Corte de energía',
    elevatorFailure: 'Falla del ascensor',
    cantUseBankCard: 'No se puede usar tarjeta bancaria',
    networkFault: 'Falla de red',
    pleaseEnterTheStartTimeAndEndTime: 'Ingrese la hora de inicio y la hora de finalización',
    theStartTimeMustBeYoungerThanTheEndTime:
      'La hora de inicio debe ser menor que la hora de finalización',
  },
  baseinfotabServer: {
    squareMeter: 'Metros cuadrados',
    parkingLot: 'Estacionamiento',
    elevator2: 'Ascensor',
    pleaseEnterArea: 'Ingrese el área',
    internetAccessInPublicAreas: 'Acceso a internet en áreas públicas',
    hotelFacilities: 'Instalaciones del hotel',
    otherFacilities: 'Otras instalaciones',
    hotelService: 'Servicios del hotel',
    otherServices: 'Otros servicios',
    fallow: 'Ocio',
    otherLeisure: 'Otro ocio',
    pleaseEnterAMaximumOf10DigitsInEnglish:
      'Ingrese caracteres alfanuméricos (inglés/chino) con una longitud máxima de 10',
    pleaseSelectParking: 'Seleccione el estacionamiento',
    pleaseSelectTheHall: 'Seleccione el vestíbulo',
    pleaseEnterTheHallArea: 'Ingrese el área del vestíbulo',
    pleaseSelectElevator: 'Seleccione el ascensor',
    pleaseSelectPublicAreasToAccessTheInternet:
      'Seleccione las áreas públicas con acceso a internet',
    pleaseSelectHotelFacilities: 'Seleccione las instalaciones del hotel',
    pleaseSelectHotelServices: 'Seleccione los servicios del hotel',
    pleaseSelectLeisure: 'Seleccione ocio',
    oneToFiveStars: 'Cuasi 1-5 estrellas',
    true15Stars: '1-5 estrellas',
    walkUp: 'Sin ascensor',
    thereIsAnElevator: 'Con ascensor',
    lobbyless: 'Sin vestíbulo',
    haveALobby: 'Con vestíbulo',
    noInternetAccess: 'Sin acceso a internet',
    freeParking: 'Estacionamiento gratuito',
    noParking: 'Sin estacionamiento',
    parkingLotAvailable: 'Con estacionamiento',
    paidParking: 'Estacionamiento de pago',
    charge: 'Con cargo',
  },
  borrowBorrowrecord: {
    loanDate2: 'Fecha de préstamo',
    newBorrowing: 'Nuevo préstamo',
    return: 'Devolver',
    cannotBeGreaterThanTheAvailableAmount: 'No puede ser mayor que la cantidad disponible',
    enterItemNameAndRoomNumber: 'Ingrese el nombre del artículo y el número de habitación',
    unitPriceOfGoods2: 'Precio unitario del artículo',
    quantityBorrowed: 'Cantidad prestada',
    borrowARoom: 'Habitación prestataria',
    dateOfReturn: 'Fecha de devolución',
    returnQuantity: 'Cantidad devuelta',
    borrowedState: 'Estado del préstamo',
    amountOfCompensation: 'Monto de compensación',
    serviceSuccess: 'Servicio exitoso',
    serviceFailure: 'Fallo del servicio',
    reasonForRefusal: 'Motivo del rechazo',
    enterAMaximumOf30Characters: 'Ingrese un máximo de 30 caracteres',
    returnOrNot: '¿Devolver o no?',
    hasItBeenReturned: '¿Ha sido devuelto?',
    onlyNumbersGreaterThan0CanBeEntered: 'Solo se pueden ingresar números mayores que 0',
    theAmountReturnedCannotBeGreaterThanOrEqualToTheAmountBorrowed:
      'La cantidad devuelta no puede ser mayor o igual que la cantidad prestada',
    upTo20Characters: 'Hasta 20 caracteres',
    pleaseEnterTheReturnQuantity: 'Ingrese la cantidad a devolver',
    onLoan: 'En préstamo',
    theRoomRequestHasBeenServiced: 'La solicitud de habitación ha sido atendida',
    serviceCompletion: 'Servicio completado',
    returned: 'Devuelto',
    noReturn: 'No devuelto',
    enterAMaximumOf9Characters: 'Ingrese un máximo de 9 caracteres',
    chooseToBorrowRoom: 'Seleccione la habitación para el préstamo',
  },
  borrowBorrowset: {
    newItem: 'Nuevo artículo',
    usable: 'Disponible',
    notAvailable: 'No disponible',
    alreadyRemoved: 'Eliminado',
    enterItemName: 'Ingrese el nombre del artículo',
    unitPriceOfGoods2: 'Precio unitario del artículo',
    inventory: 'Inventario',
    amountBorrowed: 'Cantidad prestada',
    loanableQuantity: 'Cantidad disponible para préstamo',
    theNameCannotExceed9CharactersPleaseEnterANewName:
      'El nombre no puede exceder 9 caracteres, ingrese uno nuevo',
    priceCannotBeLessThan0PleaseReEnter: 'El precio no puede ser menor que 0, vuelva a ingresar',
    priceCannotBeGreaterThan9999PleaseReEnter:
      'El precio no puede ser mayor que 9999, vuelva a ingresar',
    theInventoryCannotBeLessThan0PleaseReEnter:
      'El inventario no puede ser menor que 0, vuelva a ingresar',
    inventoryCannotBeLessThanTheBorrowedAmountPleaseReEnter:
      'El inventario no puede ser menor que la cantidad prestada, vuelva a ingresar',
    areYouSureYouWantToDeleteThisItem: '¿Está seguro de que desea eliminar este artículo?',
    areYouSureYouWantToDisableThisItem: '¿Está seguro de que desea deshabilitar este artículo?',
    thisItemHasNotBeenReturnedConfirmToDelete:
      'Este artículo aún no ha sido devuelto. ¿Confirmar eliminación?',
  },
  businessCardIndex: {
    pleaseUploadPictures: 'Suba imágenes',
    pleaseEnterRoomType: 'Ingrese el tipo de habitación',
    uploadBackground: 'Subir fondo',
    saveOperation: 'Guardar',
    uploadProfilePicture: 'Subir avatar',
    pleaseEnterAValidNumber: 'Ingrese un número válido',
    businessCardType: 'Tipo de tarjeta',
    currentPriceOfRoomType: 'Precio actual del tipo de habitación',
    roomTypeOriginalPrice: 'Precio original del tipo de habitación',
    backgroundImage: 'Imagen de fondo',
    avatar: 'Avatar',
    hotelRecommendation: 'Recomendación del hotel',
    roomTypeRecommendation: 'Recomendación del tipo de habitación',
    theNameCannotBeBlank2: 'El nombre no puede estar vacío',
    thePhoneNumberCannotBeEmpty: 'El número de teléfono no puede estar vacío',
    pleaseEnterAValidPhoneNumber: 'Ingrese un número de teléfono válido',
    roomTypeNameCannotBeEmpty: 'El nombre del tipo de habitación no puede estar vacío',
    theCurrentPriceOfTheRoomTypeCannotBeEmpty:
      'El precio actual del tipo de habitación no puede estar vacío',
    roomTypeOriginalPriceCannotBeEmpty:
      'El precio original del tipo de habitación no puede estar vacío',
    pleaseUploadTheBackgroundImage: 'Suba la imagen de fondo',
    pleaseUploadPhoto: 'Suba el avatar',
    areYouSureYouWantToLeaveTheCurrentPage: '¿Está seguro de que desea salir de la página actual?',
    pleaseSelectImageUpload: 'Seleccione la carga de imagen',
    theCurrentPriceOfTheRoomTypeShallNotBeLessThan:
      'El precio actual del tipo de habitación no debe ser menor que',
    roomTypeOriginalPriceMustNotBeLessThan:
      'El precio original del tipo de habitación no debe ser menor que',
  },
  businessCardUploadavatar: {
    selectPicture: 'Seleccionar imagen',
    uploadProfilePicture: 'Subir avatar',
    pleaseSelectImageUpload: 'Seleccione la carga de imagen',
    onlyJpgAndPngImagesAreSupportedAndTheSizeOfTheImageDoesNotExceed5m:
      'Solo se admiten imágenes JPG y PNG, y el tamaño de la imagen no excede',
  },
  ctnhotelHotelserver: {
    applicationTime2: 'Hora de solicitud',
    toDealWith: 'Ir a gestionar',
    pleaseRenewYourStayOnTheDayOfDeparture: 'Por favor, renueve la estancia el día de salida',
    applicant: 'Solicitante',
    originalExpectedArrivalDate: 'Fecha original prevista de llegada',
    originalDepartureDate: 'Fecha original prevista de salida',
    applicationType: 'Tipo de solicitud',
    renewTheNewOrderNumber: 'Nuevo número de pedido de renovación',
    renewalDate: 'Fecha de renovación',
  },
  ebaccountLogin: {
    accountLogin: 'Inicio de sesión de cuenta',
    gotTheMessage: 'Mensaje recibido',
  },
  ebaccountSetting: {
    accountBinding: 'Vinculación de cuenta',
    goToMaintain: 'Ir a mantenimiento',
    priceModel: 'Modelo de precios',
    automaticOrder: 'Transferencia automática de pedidos',
    comingSoon: 'Próximamente',
    hourlyRoomOrder: 'Recepción de pedidos de habitaciones por horas',
    orderCancellation: 'Cancelación de pedidos',
    bound: 'Vinculado',
    roomTypeSetting: 'Configuración del tipo de habitación',
    goToSettings: 'Ir a configuración',
    lastStep: 'Paso anterior',
    correlationState: 'Estado de correlación',
    bindAccount: 'Vincular cuenta',
    synchronizationTime: 'Hora de sincronización',
    onSale: 'En venta',
    associated: 'Asociado',
    uncorrelated: 'No asociado',
    bind: 'Vincular',
    noDataIsQueried: 'No se encontraron datos',
    whetherToUnbindTheAccount: '¿Desea desvincular la cuenta?',
    pleaseEnterTheCommissionRate: 'Ingrese la tasa de comisión',
    channelSetting: 'Configuración del canal',
    floorPriceModel: 'Modelo de precio base',
    sellingPriceModel: 'Modelo de precio de venta',
    viewSettings: 'Ver configuración',
    orderSetup: 'Configuración de pedidos',
    pleaseSelectAPriceModel: 'Seleccione un modelo de precios',
    pleaseSelectHourRoomPickUp: 'Seleccione la recepción de habitaciones por horas',
    dataSynchronization: 'Sincronización de datos',
    ctripRoomType: 'Tipo de habitación Ctrip',
    usGroupRoomType: 'Tipo de habitación Meituan',
    lightWinTreasureRoomTypeName: 'Nombre del tipo de habitación Light Win Treasure',
    commissionRate: 'Tasa de comisión',
    pleaseEnterTheSmsVerificationCode: 'Ingrese el código de verificación SMS',
    pleaseEnterTheContentInThePicture: 'Ingrese el contenido de la imagen',
    groggery: 'Hotel',
    ctripProductName: 'Nombre del producto Ctrip',
    meituanProductName: 'Nombre del producto Meituan',
    ctripProducts: 'Productos Ctrip',
    meituanProducts: 'Productos Meituan',
    lightWinTreasureProductName: 'Nombre del producto Light Win Treasure',
    commissionRateIsGreaterThanOrEqualTo0AndLessThan100:
      'La tasa de comisión es mayor o igual a 0 y menor que 100',
    commissionRatesAreNumericalAndReservedForTwoDecimalPlaces:
      'La tasa de comisión es numérica y se conserva con dos decimales',
    pleaseSelectTheHourlyOrderSetting:
      'Seleccione la configuración de transferencia de pedidos por horas',
    automaticCancellation: 'Cancelación automática',
    manualCancellation: 'Cancelación manual',
    automaticConfirmation: 'Confirmación automática',
    manualValidation: 'Confirmación manual',
    // Part 26, lines 5001 to 5200
    meituancom: 'Meituan',
    ctrip: 'Ctrip Travel',
    pleaseEnterTheImageVerificationCode: 'Ingrese el código de verificación de la imagen',
    pleaseSelectHotel: 'Seleccione el hotel',
    theDataSynchronizationIsSuccessfulQueryTheDataAgain10MinutesLater:
      'La sincronización de datos fue exitosa, vuelva a consultar los datos en 10 minutos',
    unbind: 'Ir a vincular',
    whetherToUnbindTheProduct: '¿Desea desvincular la relación de este producto?',
    pleaseSelectTheProductName: 'Seleccione el nombre del producto Light Win Treasure',
    unbindSuccessfully: 'Desvinculación exitosa',
    whetherToUnbindTheBindingRelationshipOfTheHouseType:
      '¿Desea desvincular la relación de este tipo de habitación?',
    pleaseSelectLightWinTreasureRoomTypeName:
      'Seleccione el nombre del tipo de habitación Light Win Treasure',
    feizhu: 'Fliggy',
    notYetUnlocked: 'No habilitado',
    pleaseBindTheAccountFirst: 'Primero realice la vinculación de la cuenta',
    areYouSureYouWantToUnbindTheAccount: '¿Está seguro de que desea desvincular la cuenta?',
    notYetBound: 'No vinculada',
    pleaseConfirmTheHotelYouWantToBindTo: 'Confirme el hotel que desea vincular',
    ctripEbAccount: 'Cuenta EB de Ctrip',
    meituanEbAccount: 'Cuenta EB de Meituan',
    pleaseContactYourHotelOperationsManagerToSetUpACtripHotelid:
      'Póngase en contacto con su gerente de operaciones del hotel para configurar el HotelID de Ctrip',
    useEbOrderInformation: 'Usar información de pedidos EB',
    pleaseSelectEbOrderCancellation: 'Seleccione la cancelación de pedidos EB',
    meituanEbRoomType: 'Tipo de habitación EB de Meituan',
    lightWinTreasureRoomTypeId: 'ID del tipo de habitación Light Win Treasure',
    lightWinTreasureProductId: 'ID del producto Light Win Treasure',
    pleaseSelectTheEbOrderCancellationSettings:
      'Seleccione la configuración de cancelación de pedidos EB',
    whenYouAutomaticallyMoveTheOrderIfYouDoNotSetTheRoomTypeYouWillMoveTheOrderManually:
      'Al mover pedidos automáticamente, si no configura el tipo de habitación, el pedido se moverá manualmente',
    whenYouManuallyMoveTheOrderYouWillBeGivenPriorityToMatchTheRoomTypeSetSavingTheTimeOfMovingTheOrder:
      'Al mover pedidos manualmente, se priorizará el tipo de habitación configurado para ahorrar tiempo',
    thisEbOrderSetupCompletedPleaseProceedAsSoonAsPossible:
      'La configuración de pedidos EB está completa, continúe lo antes posible',
    reminderIfYouNeedToSetOrAddARoomTypePleaseContactYourOperationalManager:
      'Recordatorio: si necesita configurar o agregar tipos de habitación, contacte a su gerente de operaciones',
    orderSetupCompletedPleaseProceedAsSoonAsPossible:
      'La configuración del pedido está completa, continúe lo antes posible',
    yourctripTravelEbkAccountisNotBoundAndYouWillNotBeAbleTo:
      'Su cuenta EBK de “Ctrip Travel” no está vinculada y no podrá realizar',
    associationToAvoidAffectingEbMovingOrdersPleaseBindAsSoonAsPossible:
      'la asociación. Para evitar afectar el traslado de pedidos EB, vincule la cuenta lo antes posible',
    yourctripTravelEbkAccounthasExpiredAndYouWillNotBeAbleTo:
      'Su cuenta EBK de “Ctrip Travel” ha caducado y no podrá realizar',
    associationToAvoidAffectingEbMovingOrdersPleaseunbindAndReBindAfterThe:
      'la asociación. Para evitar afectar el traslado de pedidos EB, desvincule y vuelva a vincular la cuenta',
    yourmeituanEbkAccountisNotBoundAndYouWillNotBeAbleTo:
      'Su cuenta EBK de “Meituan” no está vinculada y no podrá realizar',
    automaticallyCreditedToArAccount: 'Acreditado automáticamente a la cuenta AR',
    noticeOfMovingOrderEb: 'EB aceptará automáticamente el pedido tras el traslado',
    checkInSuccessNoticeEb: 'Notificación de check-in',
    meituanMovingOrderDeductsPublicGoods:
      'El traslado de pedidos de Meituan deduce el fondo público',
    meituanMovingOrderServiceRate: 'Tarifa de servicio operativo de Meituan %',
    yourctripTravelEbkAccounthasExpired:
      'Su cuenta EB de Ctrip Travel ha caducado. Haga clic en “Ir a mantenimiento” para volver a configurarla',
    yourmeituanEbkAccounthasExpired:
      'Su cuenta EB de Meituan ha caducado. Haga clic en “Ir a mantenimiento” para volver a configurarla',
  },
  ebmanagementIndex: {
    accountBinding: 'Vinculación de cuenta',
    commissionRate: 'Tasa de comisión',
    theAccountIsBoundSuccessfullyAndTheInDepthOperationIsStartedSimultaneously:
      'La cuenta se vinculó correctamente y se inició simultáneamente la operación avanzada',
    whetherToUnbindTheAccount: '¿Desea desvincular la cuenta?',
    pleaseEnterTheCommissionRate: 'Ingrese la tasa de comisión',
    theTimeDimensionIsConsistentWithTheScreeningDateAndTheBookingAmountIsCalculatedAccordingToTheActualAmountPaidByTheGuest:
      'La dimensión temporal es coherente con la fecha seleccionada y el monto de reserva se calcula según el pago real del huésped',
    pleaseEnterTheSmsVerificationCode: 'Ingrese el código de verificación SMS',
    pleaseEnterTheContentInThePicture: 'Ingrese el contenido de la imagen',
    groggery: 'Hotel',
    commissionRateIsGreaterThanOrEqualTo0AndLessThan100:
      'La tasa de comisión es mayor o igual a 0 y menor que 100',
    commissionRatesAreNumericalAndReservedForTwoDecimalPlaces:
      'La tasa de comisión es numérica y se conserva con dos decimales',
    pleaseSelectHotel: 'Seleccione el hotel',
    pleaseEnterTheImageVerificationCode: 'Ingrese el código de verificación de la imagen',
    accountUntying: 'Desvincular cuenta',
    unbindSuccessfully: 'Desvinculación exitosa',
    pleaseConfirmTheHotelYouWantToBindTo: 'Confirme el hotel que desea vincular',
    noEbAccountHasBeenBound: 'No hay ninguna cuenta EB vinculada',
    ebAccountLogin: 'Inicio de sesión de cuenta EB',
  },
  hardwareBluetoothlock: {
    smartDoorLock: 'Cerradura inteligente',
    configurationFailure: 'Error de configuración',
    thisFunctionSpecificallyRefersToTheConnectionOfSmartDoorLocksSuchAsPasswordAndBluetoothWhichCanBeOpenedByUsingPasswordAndBluetoothThroughSmallProgramsAndAppsToImproveTheCustomersCheckInExperience:
      'Esta función se refiere específicamente a la integración de cerraduras inteligentes (contraseña, Bluetooth, etc.), que permiten abrir puertas mediante mini programas y apps para mejorar la experiencia de check-in',
  },
  hardwareChoseroom: {
    selectARoom2: 'Seleccionar habitación',
  },
  hardwareCreatepassworddialog: {
    createPassword: 'Crear contraseña',
    selectType: 'Seleccionar tipo',
    pleaseEnterAgain: 'Ingrese nuevamente',
    validUntil: 'Válido hasta',
    pleaseEnterA6DigitPassword: 'Ingrese una contraseña numérica de 6 dígitos',
    passwordIsDifferentPleaseReEnter: 'Las contraseñas no coinciden, vuelva a ingresar',
    oneTimePassword: 'Contraseña de un solo uso',
    timePeriodCipher: 'Contraseña por período',
    offlinePassword: 'Contraseña sin conexión',
    longAgingOfflinePassword: 'Contraseña sin conexión de larga duración',
  },
  hardwareEditpassworddialog: {
    oneTimePassword: 'Contraseña de un solo uso',
    timePeriodCipher: 'Contraseña por período',
    offlinePasswordForALongTime: 'Contraseña sin conexión de larga duración',
    offlinePassword: 'Contraseña sin conexión',
    recover2: 'Restaurar',
    currentPassword: 'Contraseña actual',
    pleaseEnterAgain: 'Ingrese nuevamente',
    validUntil: 'Válido hasta',
    pleaseEnterA6DigitPassword: 'Ingrese una contraseña numérica de 6 dígitos',
    passwordIsDifferentPleaseReEnter: 'Las contraseñas no coinciden, vuelva a ingresar',
    longAgingOfflinePassword: 'Contraseña sin conexión de larga duración',
  },
  hardwareHousepricecard: {
    memberRightsShowStoreActivitiesShow:
      'Mostrar beneficios de miembros y actividades de la tienda',
    openThePriceBoard: 'Abrir tablero de precios',
    downloadRateBoard: 'Descargar tablero de precios',
    failedToConfigureElectronicPriceBoard:
      'No se pudo configurar el tablero electrónico de precios',
  },
  hardwareIdcard: {
    whenTheIdCardTypeIsIdCardTheIdCardInformationCanBeReadByTheIdCardReaderAndAutomaticallyFilledIntoTheTextBox:
      'Cuando el tipo de documento es DNI, la información puede leerse mediante el lector y completarse automáticamente',
    idCardReader: 'Lector de DNI',
    failedToConfigureTheIdCardReader: 'No se pudo configurar el lector de DNI',
  },
  hardwareLock: {
    doorLockType: 'Tipo de cerradura',
    selectiveLock: 'Seleccionar cerradura',
    areYouSureYouWantToDeleteTheDoorLockConfigurationForThisRoom:
      '¿Confirma eliminar la configuración de la cerradura para esta habitación?',
    pleaseEnterRoomNumberAndEquipmentModel:
      'Ingrese el número de habitación y el modelo del equipo',
    doorLockCardPrintingRecord: 'Registro de impresión de tarjetas de cerradura',
    roomDoorLockConfiguration2: 'Configuración de cerradura de habitación',
    passwordSetting2: 'Configuración de contraseña',
    deviceType: 'Tipo de dispositivo',
    equipmentBrand: 'Marca del equipo',
    equipmentType: 'Modelo del equipo',
    versionNumber: 'Número de versión',
    roomLockNumber: 'Número de cerradura',
    doorLock: 'Cerradura',
    doorLockPower: 'Batería de la cerradura',
    editDoorLockConfiguration: 'Editar configuración de la cerradura',
    selectDevice: 'Seleccionar dispositivo',
    setTheDoorLock: 'Configurar cerradura',
    setTheRoomLockNumber: 'Configurar número de cerradura de habitación',
    pleaseEnterDoorLock: 'Ingrese la cerradura',
    settingNmsParameters: 'Configurar parámetros de gestión de red',
    pleaseEnterNetworkManagementParameters: 'Ingrese los parámetros de gestión de red',
    traditionalDoorLock: 'Cerradura tradicional',
    smartDoorLock: 'Cerradura inteligente',
    pleaseEnterTheLockId: 'Ingrese el ID de la cerradura',
    pleaseEnterLockmac: 'Ingrese el lockMac',
    batchDelete: 'Eliminar en lote',
    confirmBatchDeleteText:
      '¿Confirma eliminar en lote las configuraciones seleccionadas de cerraduras?',
    pleaseSelectRecordsToDelete: 'Seleccione los registros a eliminar',
    batchDeleteSuccess: 'Eliminación en lote exitosa',
    batchDeleteFail: 'Fallo en la eliminación en lote',
  },
  hardwareLockpassword: {
    createPassword: 'Crear contraseña',
    comeIntoForce: 'Entrar en vigor',
    activationCode: 'Código de activación',
    applicableRoom: 'Habitación aplicable',
    expirationDate3: 'Fecha de expiración',
    theDoorLockThatSupportsThePasswordIsNotEnabled:
      'No se ha habilitado una cerradura compatible con contraseñas',
    passwordSetting: 'Configuración de contraseña',
    invalidate: 'Invalidar',
    restore: 'Restaurar',
    confirmInvalidatePassword: '¿Confirma invalidar la contraseña actual?',
  },
  hardwareLockroom: {
    importTemplateFileName: 'Plantilla de importación de cerraduras.xlsx',
    downloadSuccess: 'Descarga exitosa de la plantilla de importación de cerraduras',
    downloadFail: 'Fallo en la descarga de la plantilla de importación de cerraduras',
    importDialogTitle: 'Importación masiva de cerraduras',
    roomDoorLockConfiguration: 'Configuración de cerraduras por habitación',
    customRule: 'Regla personalizada',
    rule: 'Regla',
    deviceType: 'Tipo de dispositivo',
    selectDevice: 'Seleccionar dispositivo',
    empty: 'Vacío',
    selectLock: 'Seleccionar cerradura',
    deviceBrand: 'Marca del dispositivo',
    deviceModel: 'Modelo del dispositivo',
    version: 'Versión',
    configurationInfo: 'Información de configuración',
    selectRoom: 'Seleccionar habitación',
    lockDeviceId: 'ID del dispositivo de la cerradura',
    remainingPower: 'Batería restante',
    remoteOpenDoorType: 'Tipo de apertura remota',
    gatewayOpen: 'Apertura por gateway',
    bluetoothOpen: 'Apertura por Bluetooth',
    rule1: 'Número de cerradura = número de habitación',
    rule2Prefix: 'Número de cerradura =',
    rule3Prefix: 'Número de cerradura =',
    trimRoomNumber: 'Eliminar el primer dígito del número de habitación',
    import: 'Importar',
    clickUpload: 'Haga clic para subir',
    imported: 'Importado',
    rulePrefix: 'Regla:',
    generateLockId: 'Generar número de cerradura',
    lockIdLabel: 'ID de cerradura',
    roomLockNumberLabel: 'Número de cerradura de habitación',
    enterRoomLockNumber: 'Ingrese el número de cerradura de habitación',
    enterLockId: 'Ingrese el ID de la cerradura',
    gatewayParams: 'Parámetros del gateway',
    enterGatewayParams: 'Ingrese los parámetros del gateway',
    // Part 27, lines 5201 to 5400
    enterLockMac: 'Ingrese lockMac',
    getFreeGoLock: 'Obtener cerradura FreeGo',
  },
  hardwareNfclock: {
    thisFunctionRefersToTheDockingOfCarmenLockWhichCanImproveTheEfficiencyOfCheckInByMakingTheGuestsRoomCardThroughLightWinTreasure:
      'Esta función se refiere específicamente a la integración de la cerradura Carmen; permite crear la tarjeta de habitación del huésped mediante Light Win Treasure y mejorar la eficiencia del check-in',
    traditionalDoorLock: 'Cerradura tradicional',
    doorLockInformationConfiguration2: 'Configuración de información de la cerradura',
    functionCardManagement2: 'Gestión de tarjetas funcionales',
    failedToConfigureATraditionalDoorLock: 'No se pudo configurar la cerradura tradicional',
  },
  hardwarePricecard: {
    full: 'Completo',
    serviceHotline: 'Línea de atención',
    downloadRateBoard: 'Descargar tablero de tarifas',
  },
  hardwareSelfdevicedialog: {
    selfServiceMachinePaymentConfiguration: 'Configuración de pagos de la máquina de autoservicio',
    depositAllocationCollection: 'Configuración de cobro de depósito',
    orderRetentionTimeConfiguration: 'Configuración del tiempo de retención del pedido',
    whetherTheUnpaidOrderIsCancelledImmediately:
      '¿Los pedidos no pagados se cancelan inmediatamente?',
    minutes: 'Minutos',
    checkOutArrangement: 'Configuración de salida',
    checkOutAccountingConfiguration: 'Configuración contable de salida',
    temporaryCheckOut: 'Salida con cuenta temporal',
    checkOut2: 'Check-out',
    autoAddRoomFeeConfig: 'Configuración de agregar cargo de habitación automático',
    whetherToEnableAutoAddRoomFee: '¿Habilitar agregar cargo de habitación automático?',
    occupancyConfiguration: 'Configuración de入住',
    whetherToSupportHourRoomWithoutReservation: '¿Admite habitación por horas sin reserva?',
    supportForTimePeriodsWithoutReservation:
      'Franjas horarias admitidas sin reserva para habitaciones por horas',
    theSelfServiceMachineIsSuccessfullyConfigured:
      'La máquina de autoservicio se configuró correctamente',
    selfServiceMachineConfiguration2: 'Configuración de la máquina de autoservicio',
    pleaseFillInTheDepositConfiguration: 'Complete la configuración del depósito',
    pleaseSelectTheTimePeriodWhenTheHourRoomIsNotBooked:
      'Seleccione el período sin reserva para habitaciones por horas',
  },
  hardwareSelfservice: {
    selfServiceMachine: 'Máquina de autoservicio',
    selfServiceMachineConfiguration2: 'Configuración de la máquina de autoservicio',
    failedToConfigureTheSelfServiceMachine: 'No se pudo configurar la máquina de autoservicio',
    thereIsNoSelfServiceMachineInTheHotel: 'El hotel no tiene máquina de autoservicio configurada',
    thisSwitchIsToOpenTheSelfServiceMachineAndPmsSystemInterfaceSwitchIfTheHotelNeedsToConnectToTheSelfServiceCheckInMachineYouNeedToTurnOnTheSwitch:
      'Este interruptor habilita la interfaz entre la máquina de autoservicio y el sistema PMS; si el hotel necesita conectarse a la máquina de auto check-in, debe activarlo',
  },

  "hardwareSetWitness": {
    "title": "Dispositivo de reconocimiento facial",
    "desc": "Reconocimiento facial, check-in autoservicio",
    "setting": "Configurar",
    "configSuccess": "Configuración de reconocimiento facial activada con éxito",
    "configClose": "Configuración de reconocimiento facial desactivada con éxito",
    "configFailed": "Error en la configuración"
  },
  "hardwareWitness": {
    "deviceSnSetting": "Configuración de código de dispositivo",
    "deviceSn": "SN del dispositivo",
    "addSn": "Añadir SN",
    "enterSn": "Por favor, ingrese el SN",
    "addSnBtn": "+ Añadir SN",
    "saveSuccess": "Guardado con éxito",
    "deleteSuccess": "Eliminado con éxito",
    "snRepeatError": "El SN no puede estar duplicado",
    "deleteConfirmMsg": "¿Está seguro de que desea eliminar el SN de este dispositivo?",
    "deleteConfirmTitle": "Aviso"
  },

  hardwareSethouserpricecard: {
    transversePlate: 'Horizontal',
    verticalVersion: 'Vertical',
    addPictureUpload: 'Agregar carga de imágenes',
    show: 'Mostrar',
    doNotShow: 'No mostrar',
    format: 'Formato',
    storePicture: 'Imagen de la tienda',
    pleaseEnterADescription: 'Ingrese una descripción',
    hourRoomRates: 'Tarifas de habitaciones por horas',
    pleaseSelectTheNumberOfHours: 'Seleccione el número de horas',
    whetherToDisplayMemberPrices: '¿Mostrar precios para miembros?',
    roomReservationPhone: 'Teléfono de reservas',
    pleaseEnterTheReservationNumber: 'Ingrese el teléfono de reservas',
    bookingGuide: 'Texto guía de reserva',
    pleaseEnterThePreOrderGuideCopy: 'Ingrese el texto guía de reserva',
    hotelAnnouncement: 'Anuncio del hotel',
    pleaseEnterTheHotelBulletin: 'Ingrese el anuncio del hotel',
    uploadedPictures: 'Imágenes cargadas',
    storePicturesMustBeUploaded: 'Es obligatorio cargar imágenes de la tienda',
    onlyJpgjepgpngFormatIsSupported: '¡Solo se admiten formatos jpg, jpeg y png!',
  },
  functionalcardAuthorizationcard: {
    authorizationCardBeforeReportingTheLoss: 'Tarjeta de autorización antes del reporte de pérdida',
    authorizationCard: 'Tarjeta de autorización',
    generallyOnlyOneAuthorizationCardNeedsToBeBrushedOnTheLockAndTheLockWillMakedidiTwiceToIndicateAuthorizationSuccess:
      "Normalmente, solo es necesario pasar la tarjeta de autorización por la cerradura; la cerradura emitirá dos sonidos 'bip bip' indicando autorización exitosa",
    whenTheRoomNumberOrTimeInformationOnTheLockIsLostTheRoomNumberSettingCardOrTheClockSettingCardCanBeUsedToSetTheLockOrTheAuthorizationCardCanBeBrushedThreeTimesAndTheRoomGuestCardCanBeUsedToOpenTheLock:
      'Si se pierde el número de habitación o la información de hora de la cerradura, puede usar la tarjeta de configuración de número de habitación o la tarjeta de ajuste de reloj; o pasar la tarjeta de autorización tres veces y luego usar la tarjeta del huésped para abrir',
  },
  functionalcardExtendssetting: {
    after: 'Después',
    inMinutes: 'En minutos',
    findRoomNumber: 'Buscar número de habitación',
    timeDeviation: 'Desviación de tiempo',
    roomNumberRequired: 'El número de habitación es obligatorio',
    whenTheRoomNumberOrTimeInformationOnTheLockIsLostTheRoomNumberSettingCardOrTheClockSettingCardCanBeUsedToSetTheLockOrTheAuthorizationCardCanBeBrushedThreeTimesAndTheRoomGuestCardCanBeUsedToOpenTheLock:
      'Si se pierde el número de habitación o la información de hora de la cerradura, puede usar la tarjeta de configuración de número de habitación o la tarjeta de ajuste de reloj; o pasar la tarjeta de autorización tres veces y luego usar la tarjeta del huésped para abrir',
    generallyOnlyOneAuthorizationCardNeedsToBeBrushedOnTheLockAndTheLockWillMakedidiTwiceToIndicateAuthorizationSuccess:
      "Normalmente, solo es necesario pasar la tarjeta de autorización por la cerradura; la cerradura emitirá dos sonidos 'bip bip' indicando autorización exitosa",
  },
  functionalcardIndex: {
    selectiveClassification: 'Seleccionar clasificación',
    functionCardManagement2: 'Gestión de tarjetas funcionales',
    authorizationCard: 'Tarjeta de autorización',
    extendedSettingsClass: 'Clase de configuración extendida',
    openCategory: 'Categoría de apertura',
    specificFunctionClass: 'Clase de funciones específicas',
    businessCardFailure: 'Error al crear la tarjeta',
  },
  functionalcardOpendoor: {
    beforeTheLossWasReported: 'Antes del reporte de pérdida',
    publicDoorsCanBeOpened: 'Puede abrir puertas públicas',
    canOpenTheLock: 'Puede abrir el seguro',
    availablePeriod: 'Período disponible',
    startTimeRequired: 'La hora de inicio es obligatoria',
    theEndTimeIsRequired: 'La hora de fin es obligatoria',
    floorFill: 'El piso es obligatorio',
    theFloorMustConsistOf4PureDigits: 'El piso debe consistir en 4 dígitos numéricos',
    layerControlCardUsedToOpenAllLocksInASpecificLayerOfABuilding:
      'Tarjeta de control de piso: se utiliza para abrir todas las cerraduras de un piso específico en un edificio',
    totalCardCanOpenAllLocksInThisSystem:
      'Tarjeta maestra: puede abrir todas las cerraduras del sistema',
  },
  functionalcardParticularfeature: {
    checkOutCardBeforeTheLossWasReported: 'Tarjeta de salida antes del reporte de pérdida',
    theMissingCardNumber: 'Número de tarjeta perdida',
    pleaseEnterTheCardNumberToFind: 'Ingrese el número de tarjeta para buscar',
    theLostCardNumberIsRequired: 'El número de tarjeta perdida es obligatorio',
    lostCardIfACardIsLostItCanBeReportedEnterTheNumberOfTheLostCardMakeALostCardAndBrushItOnceOnTheDoorThatCanOpenTheLostCard:
      'Tarjeta de pérdida: si una tarjeta se pierde, puede reportarla ingresando el número de la tarjeta perdida, crear una tarjeta de pérdida y pasarla una vez por la cerradura que dicha tarjeta podía abrir',
    checkOutCardUsedByTheWaiterGenerallyTheWaiterHasTwoCardsOneIsTheLayerControlCardUsedToOpenTheDoorAndTheOtherIsTheCheckOutCardWhenTheGuestNotifiesTheCheckOutTheWaiterChecksTheRoomAndTheCheckOutCardIsBrushedOnceOnTheDoorThatCanOpenTheCheckOutCardThePreviousGuestCardCannotBeOpenedAndDoesNotAffectTheNewGuestCard:
      'Tarjeta de salida: utilizada por el personal; normalmente el personal tiene dos tarjetas, una de control de piso para abrir puertas y otra de salida. Tras la notificación de salida, el personal revisa la habitación y pasa la tarjeta de salida una vez por la cerradura; la tarjeta del huésped anterior deja de funcionar sin afectar a la nueva',
  },
  sdkinitIndex: {
    theLockInformationIsInitializedSuccessfullyProcedure:
      'La información de la cerradura se inicializó correctamente',
    afterEnteringTheCardManagement: 'Después de entrar a la gestión de tarjetas',
    performTheInitialConfigurationOfDoorLockInformationFirst:
      'Realice primero la configuración inicial de la información de la cerradura',
    hardwareDeviceType: 'Tipo de dispositivo de hardware',
    hardwareBrand: 'Marca de hardware',
    configurationInformation: 'Información de configuración',
    thisParameterIsMandatory: 'La información de configuración es obligatoria',
    initialConfiguration: 'Configuración inicial',
    doorLockInformationConfiguration2: 'Configuración de información de la cerradura',
    theDoorLockInformationIsConfiguredSuccessfully:
      'La información de la cerradura se configuró correctamente',
    configurationFailure: 'Error de configuración',
  },
  hotelBaseInfo: {
    basicInformation3: 'Información básica',
    detailedInformation: 'Información detallada',
    hotelFacilitiesAndServices: 'Instalaciones y servicios del hotel',
    hotelPoliciesAndNotices: 'Políticas y avisos del hotel',
  },
  hotelFloor: {
    floorInformationToBeDeveloped: 'Información de pisos, en desarrollo',
  },
  hotelPicture: {
    acquiesce: 'Predeterminado',
    theLatestTime: 'Más reciente',
    theFarthestTime: 'Más antiguo',
    batchDeletion: 'Eliminación por lotes',
    undelete: 'Cancelar eliminación',
    cover: 'Portada',
    firstMap: 'Imagen principal',
    setAsHotelCover: 'Establecer como portada del hotel',
    noPictureInformationIsAvailable: 'No hay información de imágenes',
    submit2: 'Enviar',
    photoEditor: 'Editor de imágenes',
    setAsTheFirstPictureOfTheRoomType: 'Establecer como primera imagen del tipo de habitación',
    recentRevision: 'Modificado recientemente',
    appearance: 'Exterior',
    guestRoom: 'Habitación',
    publicFacilities: 'Instalaciones públicas',
    catering: 'Restauración',
    surroundingEnvironment: 'Entorno',
    theCoverImageAndFirstImageCannotBeDeletedDirectly:
      'La imagen de portada y la imagen principal no se pueden eliminar directamente',
    areYouSureToDeleteThePicture: '¿Confirma eliminar la imagen?',
    operate: 'Operación',
    pleaseSelectAtLeastOnePicture: 'Seleccione al menos una imagen',
    pleaseSelectCategory: 'Seleccione una categoría',
    pleaseUploadThePictureSuccessfullyBeforeSubmitting:
      'Cargue la imagen correctamente antes de enviar',
    imagesCannotBeUploadedInBatchEditingMode:
      'No se pueden cargar imágenes en modo de edición por lotes',
    pleaseUploadThePictureSuccessfullyBeforeSubmitting: 'Cargue la imagen correctamente antes de enviar',
    imagesCannotBeUploadedInBatchEditingMode: 'No se pueden cargar imágenes en modo de edición por lotes',
    logoOnlyOne: 'Solo se puede subir una imagen de Logo',
    logoSizeLimit: 'El tamaño de la imagen del Logo no puede superar los 500KB',
    logoRatioError: 'El Logo debe ser una imagen cuadrada con proporción 1:1. Tamaño actual: {width}×{height}',
  },
  assemblyModifyinventoryprice: {
    unlimitedInventory: 'Inventario ilimitado',
    stockLimit: 'Límite de inventario',
    modifiedPricePool: 'Pool de precios modificado',
    soldInventory: 'Inventario vendido',
  },
  hotelPreview: {
    viewPicture: 'Ver imagen',
  },
  hotelRoomType: {
    batchImportRoomType: 'Importación masiva de tipos de habitación',
    importTemplateFileName: 'Plantilla de importación de tipos de habitación.xlsx',
    downloadSuccess: 'Descarga exitosa de la plantilla de importación de tipos de habitación',
    downloadFail: 'Fallo en la descarga de la plantilla de importación de tipos de habitación',
    newHousingType: 'Crear tipo de habitación',
    partialWindow: 'Ventana parcial',
    skylight: 'Tragaluz',
    closedWindow: 'Ventana cerrada',
    bayWindow: 'Ventanal',
    hotelCode: 'Código del hotel',
    roomTypeCode: 'Código del tipo de habitación',
    externalRoomTypeCode2: 'Código externo del tipo de habitación',
    whetherToSellOnline: '¿Vender en línea?',
    bedType2: 'Tipo de cama',
  },
  hotelRoom: {
    newRoom: 'Crear habitación',
    pleaseArrangeTheRoomInformationAccordingToTheRequirementsInTheTemplate:
      'Organice la información de la habitación según los requisitos de la plantilla',
    downloadTemplate: 'Descargar plantilla',
    downloadFailureData: 'Descargar datos fallidos',
    batchImport: 'Importación masiva',
    floor2: 'Piso',
    building: 'Edificio',
    housingType: 'Tipo de habitación',
    faceEast: 'Orientación este',
    // Part 28, lines 5401 to 5600
    faceWest: 'Orientación oeste',
    faceSouth: 'Orientación sur',
    faceNorth: 'Orientación norte',
    stayAwayFromElevators: 'Lejos del ascensor',
    nearTheStairs: 'Cerca de las escaleras',
    closeToTheRoad: 'Cerca de la carretera',
    windowWall: 'Pared exterior visible desde la ventana',
    decorativeFalseWindow: 'Ventana falsa decorativa',
    theRoomNumberCannotBeEmpty: 'El número de habitación no puede estar vacío',
    theFloorOnWhichTheRoomIsLocatedCannotBeEmpty:
      'El piso donde se encuentra la habitación no puede estar vacío',
    theRoomTypeCannotBeEmpty:
      'El tipo de habitación al que pertenece la habitación no puede estar vacío',
    editSuccessfully: 'Editado correctamente',
    newSuccess: 'Añadido correctamente',
    theHouseTypeAndNameCannotBeEmptyTheFloorWhereTheHouseResidesCannotBeEmpty:
      'El tipo de habitación y el nombre no pueden estar vacíos; el piso donde se ubica no puede estar vacío',
    currentLimitSelect1FilePleaseRemoveAndAdd:
      'Actualmente solo se permite seleccionar 1 archivo; elimínelo y vuelva a añadirlo',
    definitiveRemoval: 'Confirmar eliminación',
    abnormalDataInformationTemplate: 'Plantilla de información de datos anómalos',
    xlsFormatOnly: 'Solo se admite el formato XLS',
    dataCannotBeRecoveredAfterDeletingTheRoomAreYouSureToDeleteIt:
      'Después de eliminar la habitación, los datos no se pueden recuperar. ¿Confirma eliminarla?',
  },
  hotelTypedetail: {
    newHousingType: 'Crear tipo de habitación',
    editRoomType: 'Editar tipo de habitación',
    viewRoomType: 'Ver tipo de habitación',
    basicInformation3: 'Información básica',
    squareMeter: 'Metros cuadrados',
    bedSize: 'Tamaño de la cama',
    extraBedCondition: 'Condición de cama supletoria',
    internetAccess: 'Acceso a internet',
    roomTypeFacilities: 'Instalaciones del tipo de habitación',
    roomTypeStatus: 'Estado del tipo de habitación',
    saveAndSubmit: 'Guardar y enviar',
    roomTypeNameAMaximumOf50Characters:
      'El nombre del tipo de habitación admite como máximo 50 caracteres',
    floorArea: 'Área construida',
    roomTypeEnglishName: 'Nombre en inglés del tipo de habitación',
    floorType: 'Tipo de piso',
    floor2: 'Piso',
    pleaseEnter1511: 'Ingrese -1,5,11',
    chineseRemarks: 'Observaciones en chino',
    capacity: 'Capacidad (personas)',
    englishRemarks: 'Observaciones en inglés',
    externalRoomTypeCode2: 'Código externo del tipo de habitación',
    extraBed: 'Cama supletoria',
    internetAccess2: '¿Puede acceder a internet?',
    roomInternetInformation: 'Información de internet en la habitación',
    broadbandTariff: 'Tarifa de banda ancha',
    disposableToiletries: 'Artículos de aseo desechables',
    bathroomType: 'Tipo de baño',
    numberOfToilets: 'Cantidad de baños',
    computer: 'Computadora',
    showerRoom: 'Ducha',
    smokeFreeInformation: 'Información de no fumar',
    bathroom: 'Baño',
    pleaseEnterAnIntegerWithNoMoreThanTwoDigits: 'Ingrese un entero de no más de 2 dígitos',
    pleaseEnterAnIntegerGreaterThan0: 'Ingrese un entero mayor que 0',
    dataDuplicationPleaseConfirm: 'Datos duplicados, confirme',
    pleaseEnterAValueOfAThreeDigitIntegerUpTo500:
      'Ingrese un entero de hasta 3 dígitos y no mayor a 500',
    enterAMaximumOfTwoDecimalsAndAMaximumOf6Characters:
      'Se permiten hasta 2 decimales y no más de 6 caracteres',
    pleaseEnterBuildingArea: 'Ingrese el área construida',
    pleaseEnterTheCapacity: 'Ingrese la capacidad',
    pleaseEnterAnIntegerOfUpToTwoDigits: 'Ingrese un entero de hasta 2 dígitos',
    roomTypeNameCannotBeEmpty: 'El nombre del tipo de habitación no puede estar vacío',
    roomTypeNameCannotExceed50Characters:
      'La longitud del nombre del tipo de habitación no debe exceder 50 caracteres',
    theLengthCannotExceed30Characters: 'La longitud no puede exceder 30 caracteres',
    theTotalNumberOfRoomsCannotBeEmpty: 'El total de habitaciones no puede estar vacío',
    theLengthCannotExceed60Characters: 'La longitud no puede exceder 60 caracteres',
    pleaseSelectBedSize: 'Seleccione el tamaño de la cama',
    pleaseSelectWindowType: 'Seleccione el tipo de ventana',
    pleaseSelectRoomTypeStatus: 'Seleccione el estado del tipo de habitación',
    pleaseSelectExtraBedCondition: 'Seleccione la condición de cama supletoria',
    pleaseSelectWhetherYouCanAccessTheInternet: 'Seleccione si se puede acceder a internet',
    pleaseSelectAPhone: 'Seleccione teléfono',
    pleaseSelectDisposableToiletries: 'Seleccione artículos de aseo desechables',
    pleaseSelectABathroomType: 'Seleccione el tipo de baño',
    pleaseSelectTheNumberOfBathrooms: 'Seleccione la cantidad de baños',
    pleaseSelectComputer: 'Seleccione computadora',
    pleaseSelectABathRoom: 'Seleccione ducha',
    pleaseSelectSmokeFreeInformation: 'Seleccione la información de no fumar',
    pleaseSelectOther: 'Seleccione otros',
    pleaseSelectBathroom: 'Seleccione baño',
    commonFloor: 'Piso estándar',
    executiveFloor: 'Piso ejecutivo',
    businessFloor: 'Piso de negocios',
    noExtraBed: 'No se permite cama supletoria',
    freeExtraBed: 'Cama supletoria gratis',
    payExtraBed: 'Cama supletoria con costo',
    haveInternetAccess: 'Internet disponible',
    someInternetAccess: 'Internet disponible parcialmente',
    noInternetAccess: 'Sin internet',
    freeWireless: 'Wi-Fi gratis',
    tollWireless: 'Wi-Fi de pago',
    freeWire: 'Cableado gratis',
    tollWire: 'Cableado de pago',
    nationalTollCall: 'Llamadas de larga distancia nacional',
    internationalCall: 'Llamadas internacionales',
    freeDomesticLongDistanceCalls: 'Llamadas nacionales de larga distancia gratis',
    disposableToiletriesAreNotProvided: 'No se proporcionan artículos de aseo desechables',
    disposableToiletriesAreProvidedForFree: 'Artículos de aseo desechables gratis',
    disposableToiletriesAreProvidedForAFee: 'Artículos de aseo desechables de pago',
    indoor: 'Interior',
    commonality: 'Público/compartido',
    aroom: 'Una habitación',
    twoRooms: 'Dos habitaciones',
    moreThanTwoRooms: 'Más de dos habitaciones',
    allRoomsChargeComputers: 'Computadora con cargo en todas las habitaciones',
    freeComputersInAllRooms: 'Computadora gratis en todas las habitaciones',
    freeComputersInSomeRooms: 'Computadora gratis en algunas habitaciones',
    nonSmokingRoomsAreNotAvailable: 'No se puede ofrecer habitación de no fumadores',
    nonSmokingRoomsAvailable: 'Se puede ofrecer habitación de no fumadores',
    noSmoking: 'No se permite fumar',
    partialWindow: 'Ventana parcial',
    skylight: 'Tragaluz',
    closedWindow: 'Ventana cerrada',
    bayWindow: 'Ventanal',
    roomTypeNameAndBedSizeAreUnderReview:
      'El nombre del tipo de habitación y el tamaño de la cama están en revisión',
    roomTypeAddedSuccessfully: 'Tipo de habitación añadido correctamente',
    containsAMaximumOf7CharactersOnlyDigitsCanBeEntered:
      'Longitud máxima de 7 caracteres; solo se permiten dígitos y . -',
    pleaseEnterAnIntegerAndEnsureItsLegalitySuchAs3SquareMeters5SquareMeters:
      'Ingrese un entero y asegúrese de que sea válido: por ejemplo, 3㎡-5㎡',
    personbed: 'Personas/habitación',
  },
  managementAccountList: {
    searchAccountAndEmployeeName: 'Buscar cuenta o nombre del empleado',
    staffPosition: 'Puesto del empleado',
    createAnAccount: 'Crear cuenta',
    employeeName: 'Nombre del empleado',
    employeeRole: 'Rol del empleado',
    confirmTo: 'Confirmar',
    user: 'Usuario',
    areYouSureYouWantToDeleteThisUser: '¿Confirma eliminar este usuario?',
    isThisMaterial: '¿Este material?',
  },
  managementRoleList: {
    enterARoleName: 'Ingrese el nombre del rol',
    newRole: 'Añadir rol',
    roleName: 'Nombre del rol',
    roleDescription: 'Descripción del rol',
    editorRole: 'Editar rol',
    modifyPermission: 'Modificar permisos',
    deletingARole: 'Eliminar rol',
    areYouSureYouWantToDeleteThisRole: '¿Confirma eliminar este rol?',
  },
  componentsCreateaneditingrole: {
    roleName: 'Nombre del rol',
    roleDescription: 'Descripción del rol',
    standardPostBased: 'Basado en puesto estándar',
    limitsOfAuthority: 'Permisos',
    pleaseEnterARoleName: 'Ingrese el nombre del rol',
    modifyRole: 'Modificar rol',
    newRole: 'Añadir rol',
    succeededInModifyingTheRole: 'Rol modificado correctamente',
    creatingTheRoleSucceeded: 'Rol creado correctamente',
  },
  componentsPopupeditingpermission: {
    editPermission: 'Editar permisos',
  },
  componentsUpdatematerial: {
    staffPosition: 'Puesto del empleado',
    employeeRole: 'Rol del empleado',
    thePhoneNumberCannotBeEmpty: 'El número de teléfono no puede estar vacío',
    pleaseEnterYourConfirmationPassword: 'Ingrese la contraseña de confirmación',
    pleaseEnterEmployeeName: 'Ingrese el nombre del empleado',
    pleaseSelectEmployeeStatus: 'Seleccione el estado del empleado',
    pleaseSelectAnEmployeePosition: 'Seleccione el puesto del empleado',
    modifyAccount: 'Modificar cuenta',
    viewInformation: 'Ver información',
    addAnAccount: 'Añadir cuenta',
    theTwoPasswordEntriesAreDifferent: 'Las dos contraseñas no coinciden',
    modifyingTheMaterialInformationMayAffectTheInformationAboutStoredGoodsExerciseCautionWhenPerformingThisOperation:
      'Modificar la información del material puede afectar la información de los productos almacenados; proceda con cautela',
    materialUnit: 'Unidad del material',
    pleaseSelectTheMaterialType: 'Seleccione el tipo de material',
    pleaseFillInTheMaterialName: 'Complete el nombre del material',
    pleaseSelectMaterialUnit: 'Seleccione la unidad del material',
    modifyMaterial: 'Modificar material',
    newMaterial2: 'Añadir material',
    materialModificationSucceeded: 'Material modificado correctamente',
    newMaterialSuccessfully: 'Material creado correctamente',
  },
  smallwareMaterial: {
    confirmEnable: '¿Desea activar este artículo?',
    confirmDisable: '¿Desea desactivar este artículo?',
    enableSuccess: 'Artículo activado correctamente',
    disableSuccess: 'Artículo desactivado correctamente',
    newMaterial: 'Crear material',
    thereIsInventoryUnderTheCurrentMaterialDoNotSupportToDeleteTheMaterialPleaseDeleteAfterTheWarehouse:
      'Hay inventario bajo el material actual; no se permite eliminarlo. Elimínelo después de sacar el inventario del almacén',
    areYouSureYouWantToDeleteThisMaterial: '¿Confirma eliminar este material?',
    confirmTo: 'Confirmar',
    isThisMaterial: '¿Este material?',
  },
  smallwareRealtimestock: {
    saleStatus: 'Estado de venta',
    exportedInventory: 'Exportar inventario',
    resumptionOfSale: 'Reanudar venta',
    banOnSale: 'Prohibir venta',
    averagePurchasePriceyuan: 'Precio promedio de compra (yuan)',
    sellingPriceyuan: 'Precio unitario de venta (yuan)',
    unmarketable: 'No vendible',
    vendibility: 'Vendible',
    exportFileName: 'Lista de inventario en tiempo real',
    areYouSureYouWantToStopSellingThisMaterial: '¿Confirma dejar de vender este material?',
    // Part 29, lines 5601 to 5800
    successfulClosure: 'Suspensión de venta exitosa',
    successfulResumptionOfSale: 'Reanudación de venta exitosa',
  },
  smallwareStockshift: {
    undoSuccessfully: 'Cancelación exitosa',
    outboundTime: 'Hora de salida de almacén',
    newDelivery2: 'Nueva salida',
    outboundMode: 'Modo de salida',
    theNumberOfTheWarehouseReceipt: 'Código del comprobante de salida',
    deliveryFromStorage: 'Salida de almacén',
    cancel: 'Cancelar',
    exportFileList: 'Lista de exportación de archivos de salida',
    doYouConfirmTheCancellation: '¿Confirma la cancelación?',
  },
  smallwareStockunshift: {
    warehousingTime: 'Hora de entrada a almacén',
    newStorage: 'Nueva entrada',
    theCodeOfTheEntrySlip: 'Código del comprobante de entrada',
    purchasePriceyuan: 'Precio unitario de compra',
    importFileExportList: 'Lista de exportación de archivos de entrada',
  },
  componentsAddnewstock: {
    adjustableQuantity: 'Cantidad ajustable',
    purchasePrice: 'Precio unitario de compra',
    whetherToSell: '¿Vender?',
    unitSellingPrice: 'Precio unitario de venta',
    pleaseFillInTheUnitPrice: 'Complete el precio unitario de venta',
    pleaseFillInTheQuantityOfStorage: 'Complete la cantidad de entrada',
    pleaseSelectTheMaterialType: 'Seleccione el tipo de material',
    pleaseSelectAMaterialName: 'Seleccione el nombre del material',
    modifiedEntry: 'Modificar entrada',
    newStorage: 'Nueva entrada',
    createdSuccessfully2: 'Creado correctamente',
    theStorageQuantityCannotBe: 'La cantidad de entrada no puede ser',
    theModifiedQuantityCannotBeSmallerThanTheConsumedQuantity:
      'La cantidad modificada no puede ser menor que la cantidad ya consumida',
  },
  componentsAddoutstock: {
    selected: 'Seleccionado',
    newDelivery2: 'Nueva salida',
    pleaseSelectOutgoingMaterials: 'Seleccione los materiales a retirar',
    pleaseSelectTheMaterialToBeShippedOut: 'Seleccione el material a retirar',
    successfulDelivery: 'Salida exitosa',
  },
  componentsSellricedialog: {
    unitSellingPrice: 'Precio unitario de venta',
    pleaseFillInThePrice: 'Complete el precio',
  },
  systemsetBase: {
    requireIdNumberEnabled:
      'La función de requerir número de documento se ha activado correctamente',
    requireIdNumberDisabled:
      'La función de requerir número de documento se ha desactivado correctamente',
    requireIdNumberForCheckin: '¿Requerir número de documento al realizar el check-in?',
    enableAutomaticDepositRefund: 'Activar reembolso automático de depósito',
    refundImmediatelyAfterCheckOut:
      'Reembolsar inmediatamente después de que el huésped realice el check-out',
    refundAfter: 'Reembolsar después de',
    hoursAutoRefund: 'horas para reembolso automático',
    pleaseEnterDelayRefundHours: 'Ingrese las horas de retraso para el reembolso del depósito',
    delayRefundHoursRangeError:
      'El tiempo de retraso del reembolso no puede ser menor a 1 hora ni mayor a 48 horas',
    depositConfigSuccess: 'Configuración de depósito de check-in exitosa',
    tempMakeCardEnabled: 'Activar emisión de tarjeta temporal',
    tempMakeCardEnabledSuccess: 'Emisión de tarjeta temporal activada',
    tempMakeCardDisabledSuccess: 'Emisión de tarjeta temporal desactivada',
    hideCheckInRegisterRoomPrice: 'Ocultar tarifa de habitación en el registro de entrada',
    hideCheckInRegisterRoomPriceEnabledSuccess: 'Tarifa de habitación oculta en el registro de entrada',
    hideCheckInRegisterRoomPriceDisabledSuccess: 'Tarifa de habitación visible en el registro de entrada',
    weeHours: 'Madrugada',
    shiftPattern: 'Modo de turnos',
    messageVoiceReminder: 'Recordatorio por voz de mensajes',
    directConnectionSingleSettings: 'Configuración de recepción de pedidos por conexión directa',
    automaticHouseSetting: 'Configuración de asignación automática de habitaciones',
    sameDayAdvanceOrders: 'Pedidos con llegada prevista el mismo día',
    allOrders: 'Todos los pedidos',
    unreservedRoomOrderAutomaticRoomSchedulingPeriod:
      'Periodo de asignación automática para pedidos sin habitación asignada',
    inThisTimePeriodTheUnreservedRoomOrderWillBeAutomaticallyExecuted:
      'Durante este periodo, los pedidos sin habitación asignada se asignarán automáticamente',
    inventorySyncSetup: 'Configuración de sincronización de inventario',
    orderSynchronizationSettings: 'Configuración de sincronización de pedidos',
    nightAuditSetup: 'Configuración de auditoría nocturna',
    nightTrialMethod: 'Método de auditoría nocturna',
    manualOperation: 'Manual',
    auto: 'Automático',
    storeOrdersHaveNotArrived: 'Pedidos de la tienda con llegada prevista no realizada',
    preArrivalDepartureHandle: 'Pre-arrival & Pre-departure Order Handling',
    preArrivalDepartureHandleTip: 'Configure automatic handling for pre-arrival and pre-departure orders. The system will automatically execute the corresponding operations during night audit',
    preArrivalHandle: 'Pre-arrival Order Handling',
    preDepartureHandle: 'Pre-departure Order Handling',
    noHandle: 'No handling',
    autoCheckIn: 'Auto check-in',
    autoNoshow: 'Auto no-show',
    autoCheckOut: 'Auto check-out',
    autoExtendStay: 'Auto extend stay',
    shiftSetting: 'Configuración de turnos',
    noOverlapIsAllowedAndTheTotalTimeIntervalMustCover24HoursOfTheDay:
      'No se permite solapamiento de turnos y el intervalo total debe cubrir las 24 horas',
    morningShiftSetting: 'Configuración del turno de madrugada',
    shiftReportimprestMode: 'Informe de cambio de turno (modo fondo de caja)',
    hourRoomCheckOutMessage: 'Mensaje de check-out de habitación por horas',
    fullDayCheckOutMessage: 'Mensaje de check-out de habitación de día completo',
    onlineChannelNewOrderAlerts: 'Alertas de nuevos pedidos de canales en línea',
    onlineChannelOrderCancellationAlerts: 'Alertas de cancelación de pedidos de canales en línea',
    hourCheckOutReminder: 'Recordatorio de check-out de habitación por horas',
    fullDayCheckOutReminder: 'Recordatorio de check-out de habitación de día completo',
    automaticOrderSettingWhenOversold:
      'Configuración de recepción automática en caso de sobreventa',
    hourRoomAutomaticOrderSetting:
      'Configuración de recepción automática para habitaciones por horas',
    automaticRowHouseConfiguration: 'Estado de asignación automática de habitaciones',
    automaticHouseRules: 'Reglas de asignación automática',
    supportBillingTypes: 'Tipos de facturación compatibles',
    '30MinutesBeforeCheckOut': '30 minutos antes del check-out',
    '15MinutesBeforeCheckOut': '15 minutos antes del check-out',
    atCheckOut: 'En el check-out',
    pleaseEnterTheTime: 'Ingrese la hora',
    automaticCancellation: 'Cancelación automática',
    manualCancellation3: 'Cancelación manual',
    automaticOverbookingSetReminders:
      'Recordatorio de configuración de recepción automática por sobreventa',
    hourRoomAutomaticOrderSettingReminder:
      'Recordatorio de configuración de recepción automática de habitaciones por horas',
    autoEnterArAccountText: 'Registrar automáticamente los pedidos de conexión directa en AR',
    pleaseSelectABusinessDay: 'Seleccione el día operativo',
    operationSuccessfulPleaseManuallyTriggerTheNightAudit:
      'Operación exitosa, ejecute manualmente la auditoría nocturna',
    theStartTimeAndEndTimeOfTheMorningShiftCannotBeTheSame:
      'La hora de inicio y fin del turno de madrugada no pueden ser iguales',
    earlyMorningWatch: 'Turno de madrugada',
    theAutomaticRowHouseIsSetSuccessfully: 'Configuración de asignación automática exitosa',
    theEbRoomStatusIsAutomaticallyClosedWhenTheRoomIsFull:
      'El estado EB de la habitación se cierra automáticamente cuando está llena',
    supportSwitchOrderSynchronization: 'Soporta sincronización de pedidos switch',
    inventoryAutomaticSynchronizationSystemInventory:
      'Sincronización automática del inventario del sistema',
    whenTheStoreOrderIsSetToautoCancelTheSystemWillAutomaticallyCancelTheStoreOrderForUnpaidOrdersAtNightAuditPleaseHandleTheCheckInInAdvanceToAvoidCancellation:
      'La prórroga de estancia de pedidos de salida prevista tiene prioridad sobre el check-in de pedidos de llegada prevista. Si no hay habitaciones disponibles al procesar automáticamente el check-in, el sistema marcará NoShow automáticamente; si no hay habitaciones disponibles al procesar automáticamente la prórroga, el sistema realizará el check-out automáticamente',
    whenTheStoreOrderIsSetTomanualCancelPleaseHandleTheCheckInOrCancelTheStorePreArrivalOrderInAdvanceToAvoidTheNightAuditNotPassing:
      'La prórroga de estancia de pedidos de salida prevista tiene prioridad sobre el check-in de pedidos de llegada prevista. Si no hay habitaciones disponibles al procesar automáticamente el check-in, el sistema marcará NoShow automáticamente; si no hay habitaciones disponibles al procesar automáticamente la prórroga, el sistema realizará el check-out automáticamente',
    whenTheRoomIsFullTheEbRoomStatusSwitchIsAutomaticallyTurnedOff:
      'Cuando la habitación está llena, el interruptor de estado EB se apaga automáticamente',
    inventoryAutomaticSynchronizationSystemInventorySwitchSettingsSaved:
      'Configuración del interruptor de sincronización automática de inventario guardada',
    atLeastOneMessageReminderSettingMustBeSelected:
      'Debe seleccionarse al menos un recordatorio de mensaje',
    closeturnOnToAutomaticallySortRoomsAtNight:
      'Cerrar (al activarlo, los nuevos pedidos se asignan automáticamente todo el día)',
    crossBusinessDayShiftsYouCanSetTheNightShiftSeparatelyForAccountingPurposesTheNightShiftDoesNotParticipateInNormalShiftTimeCalculations:
      'Turnos que cruzan el día operativo; se puede configurar el turno de madrugada por separado para facilitar el cálculo contable. El turno de madrugada no participa en el cálculo normal de turnos',
    dailyPredeparture: 'Salidas previstas del día',
    theHotelSupportsSynchronousSwitchOrderChannelSettingsSaving:
      'El hotel admite guardar la configuración sincronizada de canales de pedidos switch',
    theNightAuditTimeMustBeBetween2100And0800TheNextDay:
      'La hora de la auditoría nocturna debe estar entre las 21:00 y las 08:00 del día siguiente',
    theScheduleNeedsToCover24HoursADayPleaseReset:
      'El horario debe cubrir las 24 horas del día, vuelva a configurarlo',
    showMemberRechargeAmount:
      '¿Mostrar el importe de recarga de miembros en el informe de cambio de turno?',
    splitDeposit: '¿Dividir el depósito en el informe de cambio de turno?',
    splitArAccount: '¿Dividir la cuenta AR en el informe de cambio de turno?',
    allowTimeConflict: 'Permitir conflicto de horarios en la asignación de habitaciones',
    selfCheckInDepositSetting: 'Configuración de depósito para auto check-in',
    depositConfig: 'Configuración de cobro de depósito',
    defaultDepositAmount: 'Importe de depósito predeterminado',
    defaultDepositError: 'Valor predeterminado de depósito incorrecto, vuelva a ingresar',
    roomDepositError:
      'Configuración incorrecta para el tipo de habitación “{roomName}”, vuelva a configurar',
    additionalRoomFeeSetting: 'Configuración de cargos adicionales por habitación',
    fulldayAddFeeRule: 'Regla de cargo adicional para habitación de día completo',
    fulldayAddFeeType: 'Tipo de cargo adicional para habitación de día completo',
    memberRechargeSetting: 'Configuración de cobro de recarga de miembros',
    noVerificationPayment: 'Pago sin verificación',
    enforceAdditionalRoomCharge: 'Forzar cargo adicional posterior',
    manualAdditionalRoomFee: 'Cargo adicional manual por habitación',
    halfDayAdditionalRoomFee: 'Cargo adicional de media jornada',
    fullDayAdditionalRoomFee: 'Cargo adicional de jornada completa',
    morningOrderCheckInAddFee: 'Cobrar tarifa adicional por check-in temprano',
    morningOrderAddFeeEnabled: 'La tarifa adicional por check-in temprano está habilitada',
    morningOrderAddFeeDisabled: 'La tarifa adicional por check-in temprano está deshabilitada',
    popUpMethodSetting: 'Configuración del método de interacción',
    newTab: 'Abrir nueva pestaña',
    originalTabRedirection: 'Redirección de pestaña original',
    popupNotification: 'Ventana emergente',
    sidebar: 'Panel lateral derecho',
    breakfastReportCtrl: 'Reglas de estadísticas del informe de desayuno',
    repotShowByUserNums: 'Estadísticas por número real de huéspedes',
    repotShowByProductNums: 'Estadísticas por cantidad de desayunos incluidos en la habitación',
    breakfastReportCtrlSuccessByUserNums: 'La regla de estadísticas del informe de desayuno se ha configurado en "Estadísticas por número real de huéspedes"',
    breakfastReportCtrlSuccessByProductNums: 'La regla de estadísticas del informe de desayuno se ha configurado en "Estadísticas por cantidad de desayunos incluidos en la habitación"'
  },
  systemsetConditionConfig: {
    unspaced: 'Sin separación por filas',
    arrangeByFloorBranch: 'Ordenar por filas según piso',
    lineUpByRoomType: 'Ordenar por filas según tipo de habitación',
    theSizeOfTheCell: 'Tamaño de celda de estado',
    small: 'Pequeño',
    inThe: 'Mediano',
    big: 'Grande',
    wide: 'Ancho',
    high: 'Alto',
    custom: 'Personalizado',
    roomTypeFont: 'Fuente del tipo de habitación',
    size: 'Tamaño',
    colour: 'Color',
    roomNumberFont: 'Fuente del número de habitación',
    whetherFullGuestNamesAreDisplayed: '¿Mostrar el nombre completo del huésped?',
    alreadyRowHouseStatusDisplayContent: 'Contenido mostrado para habitaciones ya asignadas',
    alreadyRowHouseStatusDetailsDisplayContent: 'Detalles mostrados para habitaciones ya asignadas',
    noRowRoomStatusDetailsDisplayContent: 'Detalles mostrados para habitaciones no asignadas',
    arrearsIncludeToday: '¿La deuda pendiente incluirá el cargo de habitación que está pendiente de generarse hoy',
    bedType2: 'Tipo de cama',
    restoreDefault: 'Restaurar valores predeterminados',
    roomDiagramArrangement: 'Método de disposición del diagrama de habitaciones',
    theAppletTakesEffectAtTheSameTime: 'El mini programa entra en vigor al mismo tiempo',
    cellColor: 'Color de la celda de estado',
    unarrangedRoomStatusContent: 'Contenido mostrado para habitaciones no asignadas',
    powerSwitch: 'Interruptor de energía',
    roomBalance: 'Saldo de la habitación',
    depositAmount: 'Importe del depósito',
    popUpMethodSetting: 'Configuración del método de interacción',
    newTab: 'Nueva pestaña',
    popupNotification: 'Ventana emergente',
    sidebar: 'Panel lateral derecho'
  },
  systemsetConfiguration: {
    changePriceRangeSettings: 'Configuración del rango de cambio de precios',
    revaluationRange: 'Rango de cambio de precios',
    theSystemWillJudgeWhetherTheAveragePriceOfEachRoomTypeInThePast30DaysExceedsTheChangePriceRangeIfSoTheChangePriceWillBeEnteredIntoTheChangePriceAuditAndThePriceWillBeEffectiveAfterTheAuditTheChangePriceWillBeAutomaticallyRejectedAfter1HourIfItIsNotProcessed:
      'El sistema evaluará si el precio promedio de cada tipo de habitación en los últimos 30 días excede el rango permitido. Si lo excede, el cambio de precio entrará en auditoría y solo será efectivo tras aprobarse. Si no se procesa en 1 hora, el cambio se rechazará automáticamente',
  },
  systemsetLog: {
    operationRecord: 'Registro de operaciones',
  },
  systemsetPrint: {
    documentType: 'Tipo de documento',
    paperSize: 'Tamaño de papel',
    typeSize: 'Tamaño de fuente',
    printingMode: 'Modo de impresión',
    noticeToGuests: 'Aviso para huéspedes',
  },
  systemsetTarget: {
    monthlyGoalSetting: 'Configuración de objetivos mensuales',
    goal: 'Objetivo',
    goalAchievementRate: 'Tasa de logro del objetivo',
    intertargetNight: 'Objetivo de noches',
    targetOccupancyRate: 'Tasa de ocupación objetivo',
    recommendedTargetValue: 'Valor objetivo recomendado',
    actualAchievement: 'Logro real',
    reachedLastMonth: 'Logrado el mes pasado',
    theSamePeriodLastYear: 'Mismo período del año pasado',
    commitFailure: 'Error al enviar',
    // Part 30, lines 5801 to 6000
  },
  systemsetWarning: {
    earningsWarning: 'Alerta de logro de ingresos',
    dailyWarning: 'Alerta diaria',
  },
  systemsetWifi: {
    commonality: 'Público',
    batchModification: 'Modificación por lotes',
    pleaseCompleteTheWiFiAccountPassword: 'Complete la cuenta y contraseña de Wi-Fi',
    pleaseEnterAValidWifiName: 'Ingrese un nombre de WiFi válido',
    noPasswordOrMobilePhoneAuthenticationOfTheWifiDoNotNeedToFillIn:
      'WiFi sin contraseña o con verificación por móvil no requiere completar',
    pleaseFillInTheWiFiAccount: 'Complete la cuenta de Wi-Fi',
    roomWifiSettings: 'Configuración de WiFi de la habitación',
    wifiName: 'Nombre del WiFi',
    wifiPassword: 'Contraseña del WiFi',
  },
  assemblyBindavailableproducts: {
    bindAvailableProducts: 'Vincular productos disponibles',
    bindAtLeastOneProduct: 'Vincule al menos un producto',
  },
  componentsWarning: {
    byTheMonth: 'Mensual',
    achievedOnDays: 'Días alcanzados',
    below: 'Por debajo',
    viewRemainingConditions: 'Ver condiciones restantes',
    newEarlyWarningItems: 'Agregar ítems de alerta',
    achieved: 'Alcanzado',
    additionalCondition: 'Agregar condición',
    internightMoonTargetReachWarning: 'Alerta de logro del objetivo mensual de noches',
    earlyWarningOfMonthlyTargetOfRentalRate: 'Alerta de logro del objetivo mensual de ocupación',
    surplusRoom: 'Habitaciones restantes',
    pointScoring: 'Puntuación de reseñas',
    gmvMonthlyTargetWarning: 'Alerta de tasa de logro del objetivo mensual de GMV',
    revparMonthlyTargetWarning: 'Alerta de tasa de logro del objetivo mensual de RevPAR',
  },
  componentsWarningday: {
    overallHotel: 'Hotel en general',
    everyday: 'Diario',
    theDayBefore: 'Día anterior',
    viewRemainingConditions: 'Ver condiciones restantes',
    newEarlyWarningItems: 'Agregar ítems de alerta',
    additionalCondition: 'Agregar condición',
    lessThan: 'Menor que',
    greaterThan: 'Mayor que',
    pointScoring: 'Puntuación de reseñas',
    surplusRoom: 'Habitaciones restantes',
  },
  payLehuipaySetting: {
    youHaveNotOpenedOnlinePayment: 'Aún no ha habilitado el pago en línea',
    contactOperationOrTechnicalSupportToEnableTheService:
      'Contacte a operaciones o soporte técnico para habilitar el servicio',
    lehuiPay: 'Lehui Pay',
    download: 'Descargar',
    inquire: 'Consultar',
    withdraw: 'Retirar',
    withdrawalRecord: 'Registro de retiros',
    billDownload: 'Descarga de estados de cuenta',
    accountBalanceInquiry: 'Consulta de saldo de cuenta',
    theWithdrawalAmountIsRequired: 'El monto a retirar es obligatorio',
    theAmountRangeIs: 'El rango del monto es',
    doYouWantToChangeThePaymentMethod: '¿Confirma que desea cambiar el método de pago?',
    modifyingThePaymentModeSucceeded: 'Cambio del método de pago exitoso',
    pleaseFillInTheWithdrawalAmount: 'Complete el monto a retirar',
    ifTheWithdrawalFailsTheWithdrawalAmountCannotBeLessThan10Yuan:
      'Retiro fallido, el monto no puede ser menor a 10',
  },
  foodLogin: {
    cashierSystem: 'Sistema de Caja de Restaurantes',
    shopSystem: 'Sistema de Tiendas de Restaurantes',
    pleaseEnterYourAccount: 'Por favor ingrese su cuenta',
    noFoodSystemPermission: 'No tiene permiso para acceder a {system}',
    systemConfigurationError: 'Error de configuración del sistema, comuníquese con el soporte técnico',
    loginFailed: 'Error al iniciar sesión, inténtelo de nuevo más tarde',
  },
  loginIndex: {
    hotelManagementSystem: 'Sistema de gestión hotelera',
    qrCodeExpired: 'Código QR expirado',
    pleaseClickRefresh: 'Haga clic en actualizar',
    openWechatScanTheQrCode: 'Abra WeChat y escanee el código QR',
    customerServiceNumber: 'Teléfono de atención al cliente',
    theAccountOrPasswordYouEnteredIsIncorrect: 'La cuenta o contraseña ingresada es incorrecta',
    forgotPassword: 'Olvidé mi contraseña',
    verificationCodeSentToYourMobilePhoneValidFor5Minutes:
      'El código de verificación se envió a su móvil y es válido por 5 minutos',
    enter820CharactersIncludingLettersNumbersAndSymbolsOfTwoOrMoreTypes:
      'Ingrese de 8 a 20 caracteres combinando letras, números y símbolos (al menos dos tipos)',
    submit2: 'Enviar',
    loginPasswordUpdateSuccessful: 'Actualización de la contraseña de inicio de sesión exitosa',
    reLogin: 'Volver a iniciar sesión',
    bind: 'Vincular',
    findPassword: 'Recuperar contraseña',
    pleaseEnterTheVerificationCode: 'Ingrese el código de verificación',
    mobilePhoneSmsVerificationCode: 'Código SMS del teléfono móvil',
    pleaseEnterTheMobilePhoneVerificationCode: 'Ingrese el código de verificación del móvil',
    pleaseVerifyTheNewPassword: 'Verifique la nueva contraseña',
    bindWechat: 'Vincular WeChat',
    pleaseEnterTheLoginPassword: 'Ingrese la contraseña de inicio de sesión',
    theTwoPasswordsEnteredAreInconsistent: 'Las dos contraseñas ingresadas no coinciden',
    pleaseEnterTheVerificationCode3: 'Ingrese el código de verificación gráfico',
    loggingIn: 'Iniciando sesión',
    acquire: 'Obtener',
    resendVerificationCode: 'Reenviar código de verificación',
    loginNow: 'Iniciar sesión ahora',
    currentPhoneNumber: 'Número de teléfono actual',
    changeSuccessful: 'Cambio exitoso',
    afterReGetting: 'para volver a obtener',
    pleaseEnterCorrectAccount: 'Ingrese una cuenta correcta',
  },
  accountIndex: {
    scope: 'Ámbito de aplicación',
    confirmDelete: '¿Confirmar eliminación de este conjunto contable?',
    onlyDeleteDisabled: 'Solo se pueden eliminar conjuntos contables deshabilitados',
    cancelDelete: 'Eliminación cancelada',
  },
  accountsetMember: {
    accountSubject: 'Cuenta contable',
    addCash: 'Agregar cuenta de pago inmediato',
    roomAccount: 'Cuenta a la habitación',
    pleaseEnterTheExternalOrderNumber: 'Ingrese el número de pedido externo',
    consumptionStatement: 'Factura de consumo',
    submitted: 'Enviado',
    pleaseFillInTheAmountSpent: 'Complete el monto consumido',
    theAmountSpentMustBeGreaterThan: 'El monto consumido debe ser mayor que',
    blanked: 'Compensado',
    pleaseFillInTheRoomAccount: 'Indique si se carga a la habitación',
    pleaseSelectAnAccount: 'Seleccione una cuenta',
    pleaseSelectASmallItem: 'Seleccione un artículo',
    newSuccess: 'Agregado correctamente',
    goAndCheck: 'Ir a verificar',
  },
  pcncomponentRoomtypesortingcomponent: {
    roomTypeRanking: 'Orden de tipos de habitación',
  },
  activitySelfHelp: {
    selfHelpPromotionDescription: 'Descripción de promociones de autoservicio',
    promotionalOffersAreAllBorneByTheMerchantDifferentChannelsOfSettlementMethodsAreDifferent:
      'Las promociones son asumidas por el comerciante; los métodos de liquidación varían según el canal',
    inCaseOfFalsePromotionTheConsequencesShallBeBorneByTheMerchant:
      'En caso de promoción falsa, las consecuencias serán asumidas por el comerciante',
    onceCreatedThePromotionWillTakeEffectAcrossAllChannels:
      'Una vez creada, la promoción será efectiva en todos los canales',
    promotionType: 'Tipo de promoción',
    promotionalProduct: 'Producto promocional',
    effectiveChannel: 'Canal efectivo',
    promotionStatus: 'Estado de la promoción',
    noRegistrationIsAvailable: 'No hay actividades disponibles para inscripción',
    dailySpecial: 'Especial diario',
    tonightSpecial: 'Especial de esta noche',
    firstStayDiscount: 'Descuento por primera estancia',
    travelSpecial: 'Oferta de viaje',
    festivalCoverage: 'Cobertura de festividades',
    studentOnly: 'Exclusivo para estudiantes',
    batchOffLine: 'Desconectar por lotes',
    thereAreNoRegisteredActivities: 'No hay actividades registradas',
    thereAreNoCanceledEvents: 'No hay actividades canceladas',
    pleaseSelectThePostPromotionOperationBatchOfflineFeature:
      'Seleccione la función de desconexión por lotes posterior a la promoción',
    massMerchantsSelfPromotionOffline: 'Desconexión masiva de autopromociones de comerciantes',
    allChannels: 'Todos los canales',
  },
  componentsPrintsettingdialog: {
    previewEditing: 'Vista previa y edición',
    printTheFullIdNumber: 'Imprimir número de documento completo',
    printGuestAddress: 'Imprimir dirección del huésped',
    printPaymentInformation: 'Imprimir información de pago',
    modifySettings: 'Modificar configuración',
    documentType: 'Tipo de documento',
    paperSize: 'Tamaño de papel',
    typeSize: 'Tamaño de fuente',
    printingMode: 'Modo de impresión',
    noticeToGuests: 'Aviso a los huéspedes',
    thisContentWillBeDisplayedOnTheDocumentWhenPrintingPleaseBeSureToPrintATestAfterFillingInTheDocumentToAvoidTheDisplayEffectAffectedByTheNumberOfLinesOrExcessiveWords:
      'Este contenido se mostrará en el documento al imprimir. Después de completarlo, realice una impresión de prueba para evitar que el efecto se vea afectado por demasiadas líneas o texto',
    defaultPrint: 'Impresión predeterminada',
    manualSelection: 'Selección manual',
    standard: 'Estándar',
    larger: 'Más grande',
    pleaseSelectPaperSize: 'Seleccione el tamaño de papel',
    pleaseSelectAPrintingMethod: 'Seleccione el método de impresión',
    pleaseSelectTheSize: 'Seleccione el tamaño de fuente',
  },
  assemblyAddprojectdialog: {
    addItem: 'Agregar proyecto',
    projectName: 'Nombre del proyecto',
    pleaseEnterAProjectName: 'Ingrese el nombre del proyecto',
    copies: 'Cantidad',
    pleaseEnterTheNumberOfCopies: 'Ingrese la cantidad',
    pleaseEnterTheNameOfTheOffer: 'Ingrese el nombre del beneficio',
    theNumberOfCopiesMustBeGreaterThan: 'La cantidad debe ser mayor que',
  },
  viewsHomePageIndex: {
    commonFunctions: 'Funciones comunes',
    roomStatusOverview: 'Resumen del estado de habitaciones',
    todayData: 'Datos de hoy',
    thisMonthData: 'Datos de este mes',
    dataAsOf: 'Datos hasta:',
    todoList: 'Tareas pendientes',
    allRead: 'Marcar todo como leído',
    noTodos: 'Ya ha completado todas las tareas pendientes',
    efficientDay: '¡Ha sido un día muy eficiente!',
    logUpdates: 'Actualizaciones del registro',
    selectedFunctionsTitle: 'Funciones seleccionadas',
    selectedFunctionsTip: 'Arrastre para ajustar el orden; seleccione al menos una función',
    maxSix: 'Máximo 6 funciones',
    allReadSuccess: 'Marcado todo como leído correctamente',
  },
  viewsReportFinanceOnlinePaymentReconciliation: {
    tradeDate: 'Fecha de transacción',
    billType: 'Tipo de factura',
    platform: 'Plataforma de pago',
    qzTradeNo: 'Número de transacción',
    qzTradeNoPlaceholder: 'Ingrese el número de transacción',
    // Part 31, lines 6001 to 6200
    amountTotal: 'Total de importe',
    feeTotal: 'Total de comisiones',
    reportName: 'Informe de conciliación en línea',
    pleaseSelectAtLeastOneDateType: 'Seleccione al menos un tipo de fecha de consulta',
    income: 'Cobros',
    alipay: 'Alipay',
    wechat: 'WeChat',
    merchantCode: 'Código de comerciante',
    merchantName: 'Nombre del comerciante',
    qzTradeNoColumn: 'Número de transacción',
    externalOrderNo: 'Número de pedido externo',
    orderAmount: 'Importe del pedido',
    merchantRate: 'Tasa del comerciante',
    commission: 'Comisión',
    billTypeColumn: 'Tipo de factura',
    finishTime: 'Hora de finalización',
    oriQzTradeNo: 'Número de pedido de cobro original',
    platformColumn: 'Plataforma de pago',
  },
  appShop: {
    label1: '🔥「Ahorre 25% en comisiones de cobro」',
    label2: '💰「¡Imprescindible para comerciantes! Guía para ahorrar miles al mes en comisiones」',
    label3: '⚠「¿Aún preocupado por las altas comisiones de retiro？」',
    label4: '⏳「Los primeros 100 en activar reciben caja de escaneo」',
    label5: '❓「¿Por qué las grandes marcas usan este cobro？」',
    label6: '🛡「Certificación de seguridad bancaria｜Elección de miles de comercios」',
    label7: '📞「Solicite ahora｜Comisiones reducidas 25%」',
    label8: '💼「Dueños de hoteles lo confirman: ganan más cada mes」',
  },
  settleDialog: {
    entryRoom: 'Habitación de cargo',
    selectEntryRoom: 'Seleccione una habitación de cargo',
    confirmTotalRoomRate: 'Confirmar tarifa total de la habitación',
    preAuthorizationSettlement: 'Liquidación de preautorización',
    completeCheckout: 'Completar salida',
    additionalChargeAmount: 'Importe adicional',
    hourlyRoomTip: 'Habitación por horas: confirme la tarifa real a cobrar',
    fullDayRoomTip: 'Habitación de día completo: ingrese la tarifa adicional a cobrar',
    noAdditionalCharge: 'Sin cargos adicionales',
    generateRoomFee: 'Generar tarifa de habitación',
    hangAccount: 'Cargar a cuenta',
    hangToMaster: 'Cargar a la orden principal',
    hangAccountReason: 'Motivo de carga a cuenta',
    hangAccountTip: 'La operación de carga se guardará en la cuenta de la orden principal.',
    inputAdditionalAmount: 'Ingrese el importe adicional',
    detail: 'Detalle',
    selectAtLeastOneRoom: 'Seleccione al menos una orden de habitación',
    transferBeforeHangAccount:
      'Transfiera las habitaciones en estado “pendiente de入住” antes de cargar a cuenta',
    pleaseAddRoomFee: 'Agregue primero la tarifa de la habitación',
    noRoomOrderFound:
      'No se encontró la orden a liquidar, actualice la página e intente nuevamente',
  },
  notUploadList: {
    searchPlaceholder: 'Ingrese nombre o número de habitación',
    uploadStatus: 'Estado de carga',
    notUploaded: 'No cargado',
    uploaded: 'Cargado',
    loggedOut: 'Sesión cerrada',
    downloadAllGuestInfo: 'Descargar toda la información de huéspedes',
    idAddress: 'Dirección del documento',
    uploadStatusColumn: '¿Cargado a seguridad pública?',
    downloadInfo: 'Descargar información',
    finishUpload: 'Finalizar carga',
  },
  notification: {
    markAllRead: 'Marcar todo como leído',
    expand: 'Expandir ({count})',
    collapse: 'Contraer ({count})',
    ignore: 'Ignorar',
  },
  adjustFinance: {
    title: 'Ajustar finanzas',
    adjustAccount: 'Ajuste contable',
    balanceZeroWarning: 'Asegúrese de que el saldo sea 0 antes de enviar',
    addOneRecordWarning: 'Agregue al menos un registro de ingreso',
  },
  roomStatusStatistics: {
    details: 'Información detallada',
  },
  hotelStateDialog: {
    title: 'Estadísticas de estado de habitaciones',
    checkIn: 'En estancia',
    prepareCheckIn: 'Prellegada',
    sold: 'Vendido',
    available: 'Disponible',
    fetchError: 'Error al obtener datos de tipos de habitación',
  },
  futureRoomIndex: {
    quickSearch: 'Búsqueda rápida',
    reEnable: 'Reactivar',
    confirmChangeRoomTitle: '¿Desea cambiar la habitación original por la nueva?',
    originalRoom: 'Habitación original',
    newRoom: 'Nueva habitación',
    dragTargetInvalid: 'Error al arrastrar: no se encontró la celda de destino',
    selectSameRoomTypeSameStayDate: 'Seleccione una habitación del mismo tipo con las mismas fechas de llegada y salida',
    differentRoomTypeSwapNotSupported: 'No se admite el intercambio con una reserva existente entre tipos de habitación distintos',
    AVL: 'Saldo',
  },
  financePaymentIndex: {
    addPaymentSubject: 'Agregar concepto de pago',
    paymentSubjectName: 'Nombre del concepto de pago',
    symbol: 'Símbolo',
    confirmDelete: '¿Confirma eliminar este concepto?',
  },
  financeAccountDialog: {
    pleaseEnterSubject: 'Ingrese el concepto de {type}',
    pleaseSelectCategoryType: 'Seleccione el tipo de categoría de {type}',
    addTitle: 'Agregar concepto de {type}',
    editTitle: 'Editar concepto de {type}',
    subjectName: 'Concepto de {type}',
    subjectCategory: 'Categoría del concepto de {type}',
    isEnabled: '¿Habilitado?',
  },
  financeConsumerAccount: {
    subjectCategory: 'Categoría de consumo',
    addSubject: 'Agregar concepto de consumo',
    subjectName: 'Nombre del concepto de consumo',
    symbol: 'Símbolo',
    confirmDelete: '¿Confirma eliminar este concepto?',
  },
  financeSubjectSorting: {
    consumeSortTitle: 'Ordenar conceptos de consumo',
    paySortTitle: 'Ordenar conceptos de pago',
    consumeSubjectName: 'Nombre del concepto de consumo',
    paySubjectName: 'Nombre del concepto de pago',
    sortSuccess: 'Ordenación exitosa',
  },
  aiPms: {
    common: {
      aiDriven: 'Impulsado por IA',
      justNow: 'Ahora mismo',
      minutesAgo: 'Hace {count} minutos',
      hoursAgo: 'Hace {count} horas',
    },
    aiConfig: { pageTitle: 'AI Configuration', save: 'Save', hotelSection: 'Hotel Configuration', roomTypeSection: 'Room Type Configuration', priceGuard: 'Price Guardrail', enabled: 'Enabled', disabled: 'Disabled', hotelFloorPrice: 'Hotel Floor Price', hotelCeilingPrice: 'Hotel Ceiling Price', floorPrice: 'Floor Price (CNY)', ceilingPrice: 'Ceiling Price (CNY)', floorPricePlaceholder: 'Enter floor price', ceilingPricePlaceholder: 'Enter ceiling price', yuan: 'CNY', roomTypeName: 'Room Type Name', roomTypeCode: 'Room Type Code', amountNonNegative: ' amount must be greater than or equal to 0', floorGreaterThanCeiling: ' floor price cannot exceed ceiling price', hotelLabel: 'Hotel', roomTypeLabel: 'Room type “{name}”', noChanges: 'No configuration changes detected', saveSuccess: 'Saved successfully', pricingSelloutTimeTitle: 'Target Sellout Time Policy', pricingSelloutTimeTip: 'Used for same-day price increases, slow-selling price reductions, and peer-traffic urgency.', custom: 'Custom Policy', legalHoliday: 'Legal Holiday', weekend: 'Friday and Saturday', defaultDate: 'Other Dates (including Sunday)', selectTime: 'Select time', pricingSelloutTimeInvalid: 'The sellout time policy returned by the server is invalid. Explicitly handle it before saving.', pricingSelloutTimeRequired: 'All target sellout times must use HH:mm and be within 14:00–23:59 or 00:00–06:00.' },
    roomPricingReport: { reportTitle: 'Room Type Pricing Report', reportTip: 'AI recommendations, operating basis, and pricing factors', hotelInfo: 'Hotel Information', sellDate: 'Sale Date', metricDate: 'Metric Business Date', hotelOcc: 'Current Hotel OCC', hotelRevpar: 'Current Hotel RevPAR', currentPrice: 'Current Price', aiRecommendedPrice: 'AI Recommended Price', aiCurrentDelta: 'AI vs. Current Price', sameDayOcc: 'Same-day OCC', sameDayRevpar: 'Same-day RevPAR', confidence: 'AI Confidence', inventorySnapshot: 'Vendido / Disponible (Sobreventa) / Deshabilitado', operatingBasis: 'Room Type Operating Basis', aiDecision: 'AI Decision', tradeoff: 'Multi-factor Trade-off: ', aiFactors: 'AI Pricing Factors', historicalPrice: 'Historical Price', operation: 'Operating Data', market: 'Market Position', timeEvent: 'Time and Events', guardrailRisk: 'Guardrails and Risks', status: 'Status: ', priceImpact: 'Price Impact: ', conclusion: 'Conclusion: ', reason: 'Reason: ', evidence: 'Evidence: ', riskReminder: 'Risk Reminders', noRisk: 'No additional risk reminders', severity: 'Severity: ', suggestion: 'Suggested Action: ', used: 'Used', notUsed: 'Not Used', notAvailable: 'No Data Available', up: 'Supports Increase', hold: 'Hold', down: 'Supports Decrease', limit: 'Guardrail Limit', none: 'No Direct Impact', yes: 'Yes', no: 'No', yuan: 'CNY', priceAdjustment: 'Ajustar precios de productos', priceAdjustmentDialogTitle: 'Precios inteligentes: ajustar precios de productos', noAdjustableProducts: 'No hay productos ajustables para este tipo de habitación', roomTypeName: 'Tipo de habitación: ', roomTypeCode: 'Código del tipo de habitación: ', roomTypeCurrentPrice: 'Precio actual del tipo de habitación', algorithmRecommendedPrice: 'Precio recomendado por el algoritmo', aiAdjustmentDelta: 'Variación de precio de IA', currencySymbol: '¥', snapshotPriceNote: 'Las recomendaciones de IA se basan en la instantánea de esta notificación de precios inteligentes.', product: 'Producto: ', channel: 'Canal', channelId: 'ID de canal: {id}', channelCurrentPrice: 'Precio de venta actual del canal', aiAdjustedPrice: 'Precio de venta ajustado por IA', operationLabel: 'Acción', oneClickAdjustment: 'Ajustar precio', confirmGroupAdjustment: '¿Ajustar los precios de los {count} canales de este producto?', confirmChannelAdjustment: '¿Ajustar el precio de este producto de canal?', confirmAdjustmentTitle: 'Confirmar ajuste de precio', confirm: 'Confirmar', cancel: 'Cancelar', adjustmentSuccess: 'Precio ajustado correctamente', bookingHourPreference: 'Preferencias de reserva por franja horaria (últimos 7 días)', bookingHourNoData: 'No hay datos de reserva por franja horaria', bookingHourDateRange: '{start} a {end}', bookingHourTooltip: '{hour}:00<br/>Porcentaje de reservas: {value}%' },
    roomPricingFeedback: { button: 'Aceptar', dialogTitle: 'Enviar comentarios', accept: 'Aceptar', reject: 'No aceptar', rejectReasonPlaceholder: 'Introduzca el motivo de no aceptar', actionRequired: 'Seleccione el resultado de los comentarios', rejectReasonRequired: 'Introduzca el motivo de no aceptar', rejectReasonTooLong: 'El motivo de no aceptar no puede superar los 100 caracteres', acceptSuccess: 'Recomendación aceptada', rejectSuccess: 'Comentarios de no aceptación enviados' },
    roomPricing: {
      empty: 'No hay resultados de precios para mostrar',
      roomTypeFallback: 'Tipo de habitación {index}',
      decisionTitle: 'Explicación de la decisión',
      riskLabel: 'Advertencia de riesgo:',
      modeLabel: 'Modo:',
      floorPriceLabel: 'Límite de precio:',
      confidenceLabel: 'Nivel de confianza:',
      directionFlat: 'Sugerencia de mantener precio',
      directionUp: 'Sugerencia de aumentar precio',
      directionDown: 'Sugerencia de bajar precio',
      priorityLow: 'Prioridad baja',
      priorityMedium: 'Prioridad media',
      priorityHigh: 'Prioridad alta',
    },
    roomPricingCard: { pricingTime: 'Hora de precios: ', expand: 'Expandir', collapse: 'Contraer' },
    noticeCenter: {
      unreadCount: '{count} sin leer',
      readAll: 'Marcar todo como leído',
      defaultTitle: 'Notificación de IA',
      browserNotificationTitle: 'Aviso de IA',
      browserNotificationBody: 'Ha recibido una nueva notificación de IA.',
      browserPermissionGuide: 'Actívelas para recibir nuevas notificaciones de IA en segundo plano en el navegador.',
      enableBrowserNotification: 'Activar notificaciones',
      skipBrowserNotification: 'Ahora no',
      statusRead: 'Leído',
      statusUnread: 'Sin leer',
      emptySummary: 'No hay resumen de la notificación',
      like: 'Me gusta',
      dislike: 'No me gusta',
      viewDetail: 'Ver detalle',
      markRead: 'Marcar como leído',
      emptyList: 'No hay notificaciones',
      dislikeDialogTitle: 'Enviar motivo de rechazo',
      dislikePlaceholder: 'Por favor, deje su sugerencia',
      categoryAll: 'Todo',
      readAllSuccess: 'Todas las notificaciones fueron marcadas como leídas',
      markReadSuccess: 'Marcado como leído correctamente',
      likeSuccess: 'Gracias por tus comentarios',
      dislikeReasonRequired: 'Por favor, complete el motivo del rechazo',
      dislikeSuccess: 'Enviado correctamente',
      uncategorized: 'Sin categoría',
    },
    noticeDetail: {
      back: 'Volver a notificaciones de IA',
      sendTime: 'Hora de generación: ',
      businessType: 'Categoría principal: ',
      businessSubType: 'Categoría secundaria: ',
      sideLabel: 'Detalle de la notificación',
      contentTitle: 'Contenido de la notificación',
      contentTip: 'Mostrar el contenido original de la notificación en formato markdown',
      badReviewTitle: 'Detalle de reseñas negativas',
      badReviewTip: 'Mostrar el texto de la reseña y la respuesta sugerida por la IA',
      badReviewContent: 'Texto de la reseña',
      badReviewReply: 'Respuesta sugerida',
      structuredTitle: 'Resultado estructurado',
      structuredTip: 'Mostrar datos estructurados y análisis por secciones del informe de IA',
      structuredEmptyTip: 'No se encontraron datos estructurados para mostrar en este contenido',
      missingNoticeNo: 'Falta noticeNo',
    },
    smartPricing: {
      pageTitle: 'Precios inteligentes',
      empty: 'No hay notificaciones recientes de precios inteligentes',
      peerHotelMonitor: {
        title: 'Monitor de precios de atracción de competidores',
        refresh: 'Actualizar',
        meituan: 'Meituan',
        empty: 'No hay datos de precios de atracción de competidores',
        unnamedHotel: 'Hotel competidor sin nombre',
        crawlSubmitted: 'Actualice la página más tarde para ver los datos.',
      },
    },
    futurePricing: { realtimeTab: 'Informes de precios en tiempo real', futureTab: 'Informes de precios futuros', reportTitle: 'Informe de precios futuros por tipo de habitación', reportTip: 'Muestra recomendaciones y análisis de precios congelados para los próximos 14 días', empty: 'No hay informe de precios futuros disponible', hotelOverview: 'Resumen de precios futuros', priceSource: 'Fuente del precio', pricingBusinessDate: 'Fecha comercial de precios', forecastDateRange: 'Rango de fechas de previsión', to: 'a', confidence: 'Confianza de 14 días', dailyEmpty: 'No hay resultado diario de precios', analysis: 'Análisis', aiDecision: 'Decisión de IA', decisionSummary: 'Resumen de decisión', pricingFactors: 'Factores de precio', noFactor: 'No hay detalles de factores', status: 'Estado', priceImpact: 'Impacto en el precio', reason: 'Motivo', conclusion: 'Conclusión', tradeoff: 'Equilibrio', riskReminder: 'Recordatorios de riesgo', noRisk: 'No hay recordatorios de riesgo', severity: 'Gravedad', suggestion: 'Sugerencia', sellDate: 'Fecha de venta', algorithmReferencePrice: 'Precio de referencia del algoritmo', aiRecommendedPrice: 'Precio recomendado por IA', historicalExpectedOcc: 'OCC histórico esperado', historicalExpectedRevpar: 'RevPAR histórico esperado', holidayEvent: 'Festivo / Evento', systemRisk: 'Riesgo del sistema', yes: 'Sí', no: 'No', legalHoliday: 'Festivo legal', weekendPeak: 'Pico de fin de semana', normalDate: 'Fecha normal', reportGeneratedAt: 'Hora de generación del informe', listEmpty: 'No hay informe de precios futuros completado', selectDate: 'Seleccionar fecha', dailyAverageOrders: 'Pedidos diarios medios de los últimos 7 días', viewAllReports: 'Ver todos los informes', backToAllReports: 'Volver a la lista de informes', realtimeListEmpty: 'No hay informe de precios por tipo de habitación completado' },
    futurePricingCalendar: { calendarTitle: 'Calendario de precios futuros por tipo de habitación', roomType: 'Tipo de habitación', expectedOcc: 'OCC previsto', expectedRevpar: 'RevPAR previsto', pricingBasis: 'Base de precios', dataIntegrityRisk: 'Recordatorio de integridad de datos / riesgo', highRisk: 'Riesgo alto', calendarEmpty: 'No hay datos de calendario de precios futuros', priceUp: 'Subir', priceDown: 'Bajar', priceHold: 'Mantener', overallPricingBasis: 'Base general de precios', roomOverallRisk: 'Aviso general de riesgo del tipo de habitación', dailyRiskReminder: 'Aviso diario de riesgo' },
    storeManagerReport: {
      pageTitle: 'Informe del gerente de tienda',
      pageDesc: 'Ver los resultados más recientes de informes diarios, semanales y mensuales.',
      dailyButton: 'Diario',
      weeklyButton: 'Semanal',
      monthlyButton: 'Mensual',
      datePlaceholder: 'Seleccione una fecha',
      empty: 'No hay informe reciente del gerente de tienda para el período seleccionado',
      contentTitle: 'Contenido del informe',
      contentTip: 'Mostrar el contenido original del informe más reciente',
      analysisTitle: 'Análisis estructurado',
      analysisTip: 'Mostrar el informe por secciones estructuradas',
      monthLabel: '{year}-{month}',
      weekLabel: '{start} a {end}',
      dailyTitle: 'Informe diario de tienda',
      weeklyTitle: 'Informe semanal de tienda',
      monthlyTitle: 'Informe mensual de tienda',
      periodLabel: 'Período: {range}',
    },
    storeDiagnosis: {
      pageTitle: 'Diagnóstico de tienda',
      pageDesc: 'Un informe de diagnóstico de tienda al día, generado automáticamente a partir de los datos estáticos y las reseñas de los últimos 31 días. Solo se puede generar 1 vez al día. La página muestra el resultado más reciente.',
      refresh: 'Actualizar',
      generate: 'Generar diagnóstico',
      hotelInfoIncomplete: 'La información del hotel está incompleta. Confirme que ha iniciado sesión y ha seleccionado un hotel.',
      emptyTitle: 'Aún no hay informe de diagnóstico',
      emptyDesc: 'Cuando el perfil del hotel, los tipos de habitación, las imágenes y los demás datos estén completos, el diagnóstico de IA se inicia automáticamente. Después de generarlo no se puede repetir.',
      emptyMeta: 'Código de hotel {hotelCode}  Lote {batchNo}',
      taskInfo: 'Tarea',
      batch: 'Lote',
      todayTask: 'Tarea de hoy',
      preparingData: 'Preparando datos',
      generating: 'Generando diagnóstico',
      failedNoRetry: 'Falló. No se puede generar de nuevo',
      generated: 'Generado',
      notGenerated: 'No generado. Puede generarlo manualmente',
      noReport: 'Sin informe',
      latestDone: 'El último informe está completado',
      latestFailed: 'El último informe falló',
      done: 'Completado',
      failed: 'Error al generar',
      statusWait: '1 / Pendiente de verificación',
      statusDiagnosing: '2 / Diagnosticando',
      statusDone: '3 / Completado',
      statusFailed: '4 / Fallido',
      metaStatus: 'Estado',
      failSummary: 'Resumen del fallo',
      currentStage: 'Etapa actual',
      crawlRetry: 'Reintentos de integración',
      diagnoseDone: 'Diagnóstico completado',
      diagnosingStage: 'Generando diagnóstico',
      generateFailedShort: 'Error al generar',
      failTitle: 'Diagnóstico no completado',
      failMessageToday: 'Falló la integración de datos o la generación de IA. No se puede generar de nuevo hoy.',
      failMessageLatest: 'El último diagnóstico falló. El informe de hoy aún no se ha generado y puede crearse manualmente.',
      failHintToday: 'No se puede generar de nuevo hoy. Reintente mañana o contacte a operaciones.',
      failHintLatest: 'Lo anterior es el último fallo. El informe de hoy aún no se ha generado. Haga clic en Generar diagnóstico.',
      stepCrawl: '1. Iniciar integración de datos',
      stepSuccess: '2. Integración de datos correcta',
      stepSync: '3. Sincronizar datos',
      stepAdp: '4. Iniciar diagnóstico',
      progressDiagnosing: 'La integración y la sincronización ya terminaron. Se está generando el informe.',
      progressWait: 'Obteniendo perfiles de Meituan/Ctrip, tipos de habitación e imágenes. El diagnóstico comienza automáticamente cuando los datos estén listos.',
      reportPending: 'El informe aún no está listo. El diagnóstico comienza automáticamente cuando los datos estén listos. Puede salir y volver más tarde.',
      reportGenerating: 'Generando el informe de diagnóstico. Espere…',
      reportBody: 'Informe de diagnóstico',
      reportEmpty: 'El contenido del informe está vacío',
      generateSuccess: 'Tarea de diagnóstico creada. Preparando datos',
      retryCount: '{count} / {max}',
    },
    structured: {
      channelAnalysis: 'Análisis de canales',
      roomTypeAnalysis: 'Análisis de tipos de habitación',
      commentAnalysis: 'Análisis de comentarios',
      marketAnalysis: 'Calor del mercado / zona comercial',
      momLabel: 'Mes a mes: ',
      yoyLabel: 'Interanual: ',
      dayMomLabel: 'Comparación interperiodo: ',
      dayYoyLabel: 'Semana a semana: ',
      weekMomLabel: 'Comparación interperiodo: ',
      weekYoyLabel: 'Mes a mes: ',
      monthMomLabel: 'Comparación interperiodo: ',
      monthYoyLabel: 'Interanual: ',
      channel: 'Canal',
      revenue: 'Ingresos',
      roomNight: 'Noches de habitación',
      channelShare: 'Participación del canal',
      roomTypeName: 'Tipo de habitación',
      totalRooms: 'Habitaciones totales',
      soldRoomNights: 'Noches vendidas',
      totalRoomRevenue: 'Ingresos totales por habitación',
      occupancyRate: 'Ocupación',
      averageRoomRate: 'ADR',
      disabledRooms: 'Habitaciones deshabilitadas',
      commentType: 'Tipo de comentario',
      count: 'Cantidad',
      share: 'Participación',
      goodMediumBad: 'Bueno / Medio / Malo',
      goodRate: 'Tasa de comentarios positivos',
      eventName: 'Nombre del evento',
      eventFallback: 'Evento',
      summaryAnalysis: 'Análisis general',
      goodComment: 'Comentario positivo',
      mediumComment: 'Comentario neutro',
      badComment: 'Comentario negativo',
      channelRevenueChart: 'Ingresos por canal',
      roomTypeRevenueChart: 'Ingresos por tipo de habitación',
    },
    revenueManager: {
      pageTitle: 'Gestor de ingresos',
      adviceTitle: 'Sugerencias operativas de IA',
      pendingCount: '{count} pendientes',
      trafficTitle: 'Monitoreo de tráfico',
      trafficSubtitle: 'Pronóstico de IA · actualización en tiempo real',
      selectDate: 'Seleccionar fecha',
      todayShortcut: 'Hoy',
      allDay: 'Todo el día',
      timeLabel: 'Hora',
      storeTrafficLabel: 'Tráfico del hotel',
      orderLabel: 'Pedidos',
      orderCount: '{count} pedidos',
      summaryNote: 'Canal {channel} · actualizado a las {time}',
      forecastLabel: 'Pronóstico de todo el día (modelo de IA)',
      meituanForecast: 'Pronóstico de tráfico de Meituan',
      ctripForecast: 'Pronóstico de tráfico de Ctrip',
      allDayVisit: 'Visitas de todo el día',
      occLabel: 'Ocupación',
      roomNightLabel: 'Noches de habitación',
      revenueLabel: 'Ingresos',
      analysisTag: 'Análisis de IA',
      defaultStrategyTag: 'Estrategia de precios',
      collapse: 'Contraer',
      expandMore: 'Ver más',
      badReviewLoading: 'Cargando respuesta de reseña negativa...',
      badReviewReply: 'Respuesta',
      badReviewEmpty: 'No hay contenido de respuesta para reseñas negativas',
      realtimeTitle: 'Resumen en tiempo real',
      revenueForecastTitle: 'Pronóstico de ingresos ({range})',
      occForecastTitle: 'Pronóstico de ocupación ({range})',
      aiForecastBadge: 'AI Forecast',
      todayForecast: 'Pronóstico de hoy {value}',
      peakLabel: 'Pico',
      channelMeituan: 'Meituan',
      channelCtrip: 'Ctrip',
      hours1: 'Última 1 h',
      hours3: 'Últimas 3 h',
      hours5: 'Últimas 5 h',
      hours12: 'Últimas 12 h',
      yesterdayValue: 'Ayer {value}',
      futureSevenDays: 'Próximos 7 días',
      dailyAdviceTitle: 'Sugerencia diaria de IA {date}',
      allDayAdviceTitle: 'Sugerencia de IA para todo el día',
      hoursAdviceTitle: 'Sugerencia de IA de las últimas {hours} h',
      adrForecastLabel: 'Pronóstico ADR ',
      defaultAdviceDetail: 'Se recomienda ajustar el precio de la habitación y la estrategia de distribución según la demanda actual.',
      displayDate: '{year}-{month}-{day}',
      roomNightValue: '{count} habitaciones',
      revenueInsightCollapse: 'Contraer la explicación de ingresos con IA',
      revenueInsightExpand: 'Expandir la explicación de ingresos con IA',
      forecastForDate: 'Pronóstico para {date}: {value}',
      revenueInsightTitle: 'Explicación de ingresos con IA',
      revenueInsightJudgment: 'Evaluación de ingresos',
      revenueInsightKeySteps: 'Factores clave',
      revenueInsightRisks: 'Alertas de riesgo',
      revenueInsightRecommendations: 'Recomendaciones operativas',
      metricTips: {
        traffic: {
          meituan: { title: 'Tráfico de Meituan', p1: 'El tráfico de Meituan muestra las visitas al hotel desde el canal Meituan en el periodo seleccionado.', p2: 'El sistema considera el rendimiento histórico, las tendencias recientes, las visitas ya registradas hoy, los festivos y otros factores.', p3: 'Sirve para evaluar tendencias por franja y cambios inusuales; no es el total final del día.' },
          ctrip: { title: 'Tráfico de Ctrip', p1: 'El tráfico de Ctrip muestra las visitas al hotel desde el canal Ctrip en el periodo seleccionado.', p2: 'El sistema toma como referencia fechas históricas comparables, el rendimiento reciente del canal, cambios en tiempo real y festivos.', p3: 'Revíselo junto con los cambios de pedidos para valorar la conversión del tráfico en reservas.' },
          order: { title: 'Pedidos', p1: 'Los pedidos muestran cambios de reservas generados para el canal, la fecha y el intervalo actuales.', p2: 'Esta métrica refleja la conversión de reservas en tiempo real según los filtros activos.', p3: 'Si las variaciones de corto plazo son altas, revise también el pronóstico diario y el rendimiento histórico.' },
        },
        hotelForecast: {
          meituan: { title: 'Pronóstico de tráfico de Meituan', p1: 'Es el volumen total estimado de visitas del canal Meituan para hoy.', p2: 'Se basa en el tráfico histórico, cambios recientes del canal, el desempeño de hoy, festivos y ritmo operativo.', p3: 'Sirve para anticipar la demanda y apoyar la planificación de precios, inventario de habitaciones y operaciones.' },
          ctrip: { title: 'Pronóstico de tráfico de Ctrip', p1: 'Es el volumen total estimado de visitas del canal Ctrip para hoy.', p2: 'Considera fechas históricas comparables, tendencias recientes, rendimiento en tiempo real de hoy y festivos.', p3: 'Sirve para valorar la demanda potencial y compararla con el pronóstico de Meituan.' },
          occ: { title: 'Ocupación', p1: 'La ocupación es la proporción prevista de habitaciones vendidas hoy.', p2: 'Considera la ocupación histórica, el ritmo reciente de reservas, el tráfico y los pedidos de hoy, y los festivos.', p3: 'Sirve para valorar la presión de estancia, el riesgo de habitaciones sin vender y la dirección de precios o promociones.' },
          roomNights: { title: 'Noches de habitación', p1: 'Las noches de habitación son la cantidad prevista de noches que pueden venderse hoy.', p2: 'Se basa en ventas históricas, ritmo reciente de reservas, tráfico y pedidos de hoy, y festivos.', p3: 'Revíselo con la ocupación para valorar la velocidad de consumo del inventario de habitaciones.' },
          adr: { title: 'ADR', p1: 'El ADR es la tarifa media diaria prevista para las habitaciones vendidas hoy.', p2: 'Se basa en precios históricos, transacciones recientes, demanda de hoy y festivos.', p3: 'Revíselo con la ocupación y los ingresos para evitar perseguir solo la ocupación.' },
          revenue: { title: 'Ingresos', p1: 'Los ingresos son la venta estimada de habitaciones para hoy.', p2: 'Combina noches de habitación y ADR previstos, rendimiento histórico, demanda reciente y festivos.', p3: 'Sirve para valorar si los resultados operativos van según lo previsto e identificar oportunidades de mejora.' },
        },
        futureRevenue: { title: 'Pronóstico de ingresos', p1: 'El pronóstico de ingresos muestra los ingresos diarios estimados de habitaciones para los próximos 7 días.', p2: 'Considera el rendimiento histórico, reservas recientes, tráfico y pedidos, el desempeño de hoy y festivos.', p3: 'Sirve para identificar fechas de alta y baja demanda y planificar precios, habitaciones y operaciones.' },
        occRevenue: { title: 'Pronóstico de ocupación', p1: 'El pronóstico de ocupación muestra la proporción estimada de habitaciones vendidas cada día de los próximos 7 días.', p2: 'Considera la ocupación histórica, reservas recientes, tráfico del canal, pedidos, cambios de hoy y festivos.', p3: 'Sirve para identificar con antelación el riesgo de lleno o de ocupación insuficiente y planificar precios y promociones.' },
      },
    },
  },
  route: {
    ai: 'AI',
    aiRevenueManager: 'Gestor de ingresos',
    aiSmartPricing: 'Precios inteligentes',
    aiNoticeCenter: 'Centro de notificaciones',
    aiStoreManagerReport: 'Informe del gerente de tienda',
    aiStoreDiagnosis: 'Diagnóstico de tienda',
    aiNoticeDetail: 'Detalle de la notificación',
    aiConfig: 'AI Configuration',
    businessLog: 'Registro de cambios del día operativo',
    nightAuditLog: 'Registro de auditoría nocturna',
    channelConfig: 'Configuración de canal',
    turnoverSubmit: 'Ingresos procedentes de las operaciones comerciales',
  },
  systemsetNotice: {
    systemMessageReminder: 'Recordatorio de mensajes del sistema',
    messageReminderSettingsAtLeastOneItem:
      'Configuración de recordatorios (seleccione al menos uno)',
    hourlyRoomCheckoutMessage: 'Mensaje de salida de habitación por horas',
    fullDayCheckoutMessage: 'Mensaje de salida de habitación de día completo',
    messageVoiceReminder: 'Recordatorio por voz',
    onlineChannelNewOrderReminder: 'Aviso de nuevos pedidos en canales en línea',
    onlineChannelOrderCancellationReminder: 'Aviso de cancelación de pedidos en línea',
    hourlyRoomCheckoutReminder: 'Recordatorio de salida de habitación por horas',
    fullDayCheckoutReminder: 'Recordatorio de salida de habitación de día completo',
    operationFailed: 'Operación fallida',
    thirtyMinutesBeforeCheckout: '30 minutos antes de la salida',
    fifteenMinutesBeforeCheckout: '15 minutos antes de la salida',
    atCheckoutTime: 'En el momento de la salida',
    checkoutTimeUpdated: 'Hora de recordatorio de salida actualizada',
    voiceSettingUpdated: 'Estado del recordatorio por voz actualizado',
  },
  binding: {
    publicAccountMessageReminder: 'Recordatorio de mensajes de la cuenta pública',
    scanToBindUser: 'Escanear para vincular usuario',
    cancelEdit: 'Cancelar edición',
    allMembers: 'Todos los miembros',
    scanToBindTitle: 'Escanear para vincular cuenta pública',
    scanWithWechat: 'Use WeChat para escanear y vincular',
    qrCodeGenerateFail: 'Error al generar el código QR, intente más tarde',
    unbindSuccess: 'Desvinculación exitosa',
    unbindFail: 'Error al desvincular, intente nuevamente',
    confirmCloseQrDialog: '¿Confirma cerrar el cuadro del código QR?',
    orderCreate: 'Nuevo pedido',
    orderCancel: 'Cancelación de pedido',
    orderConfirm: 'Pedido pendiente de confirmación',
    orderCheckOutTip: 'Antes de la salida',
    orderCheckOut: 'Salida',
    orderCreateEbk: 'Nuevo pedido EBK',
    orderCancelEbk: 'Cancelación de pedido EBK',
    roomCleanDone: 'Limpieza de habitación completada',
    ebAccountOffline: 'Cuenta EB fuera de línea',
    computerHardwareOffline: 'Hardware del equipo fuera de línea',
    ebWarnNotice: 'Alerta de sobreventa',
  },
  writeDoorCardIndex: {
    preIssuedDoorCard: 'Tarjeta de puerta preemitida',
    effectiveTime: 'Hora de vigencia',
    expiryTime: 'Hora de expiración',
    viewPassword: 'Ver contraseña',
    passwordStatusNotSent: 'No enviada',
    passwordStatusSending: 'Enviando',
    passwordStatusSent: 'Enviada con éxito',
    passwordStatusFailed: 'Error al enviar',
    generatePasswordOnly: 'Solo generar contraseña',
    generateAndSendPassword: 'Generar y enviar contraseña',
    getLockInfoFailed: 'Error al obtener información de la cerradura',
    makeCardFailedPrefix: 'Error al emitir tarjeta:',
    deactivateFailedPrefix: 'Error al desactivar tarjeta:',
    pleaseEnterValidPhoneNumber: 'Ingrese un número de teléfono válido',
    passwordSendSuccess: 'Contraseña enviada con éxito',
    roomPasswordGeneratedAndSent:
      'La contraseña de la habitación se ha generado y enviado al huésped; recuérdele revisar el SMS',
    roomPasswordGenerated: 'Contraseña de la habitación generada',
    invalidTimeString: 'Cadena de tiempo no válida',
    temporaryMakeCard: 'Emitir tarjeta temporal',
    validDoorCard: 'Tarjetas válidas actuales',
    makeCardLogTitle: 'Registro de Emisión de Tarjeta',
    makeType: 'Tipo de Tarjeta',
    operationResult: 'Resultado de la Operación',
    createTime: 'Hora de creación',
  },
  operating: {
    total: 'Total',
    index: 'Índice',
    businessDay: 'Día operativo',
    totalAccount: 'Cuenta total',
    totalOcc: 'Ocupación total (%)',
    fullDayOcc: 'Ocupación de día completo (%)',
    hourDayOcc: 'Ocupación por horas (%)',
    avgPrice: 'Tarifa promedio',
    revPar: 'REVPAR total',
    totalRoomNight: 'Total de noches ocupadas',
    fullDayRoomNight: 'Noches de día completo',
    busLongRoomNight: 'Noches de estancia larga',
    hourRoomNight: 'Noches por horas',
    teamRoomNight: 'Noches de grupo',
    freeRoomNight: 'Noches gratuitas',

    // Part 32, lines 6201 to 6236
    privateRoomNight: 'Noches de habitación de uso propio',
    houseRent: 'Total de ingresos por habitaciones',
    smallGoods: 'Pequeños artículos',
    meals: 'Gastos de comida',
    serviceFee: 'Tarifa de servicio',
    memberFee: 'Cuota de membresía',
    otherFee: 'Otros cargos',
    generalIncome: 'Ingresos operativos totales',
    roomNight: 'Número de noches',
    avgRoomPrice: 'Tarifa promedio por habitación',
    totalHouseRent: 'Total de tarifas de habitación',
    rentalRate: 'Tasa de ocupación (%)',
    roomNightProportion: 'Proporción de noches (%)',
    calcFormula: 'Fórmula de cálculo',
    known: 'Entendido',
  },
  incomeIncomesum: {
    pleaseCheckTheStartAndEndTimesOfTheSearch: 'Verifique las horas de inicio y fin de la búsqueda',
    roomRateIncome: 'Ingresos por habitaciones',
    smallwareIncome: 'Ingresos por pequeños artículos',
    mealFeeIncome: 'Ingresos por comidas',
    reportTitle: 'Informe resumen de ingresos',
    cooperationModel: 'Modelo de cooperación',
    status: 'Nuevo contrato / Cambio de contrato',
    roomsCount: 'Número de habitaciones físicas',
    startBusiness: 'Fecha de apertura',
  },
  commonImportDialog: {
    tip: 'Organice la información según los requisitos de la plantilla',
    downloadTemplate: 'Descargar plantilla',
    removeFileConfirm: 'Confirmar eliminación',
    limitOneFile: 'Actualmente solo se permite seleccionar 1 archivo, elimínelo y vuelva a agregar',
    uploadError: 'Error de carga, intente nuevamente',
    reupload: 'Volver a cargar',
  },
  roomOccupiedDetail: {
    title: 'Detalle de Ocupación de Habitaciones',
    unassigned: 'Sin Asignar',
    roomOrderNo: 'N.º de Pedido de Habitación',
    roomCount: 'Número de Habitaciones',
    roomType: 'Tipo Hab.',
    roomNo: 'N.º Hab.',
    contact: 'Contacto',
    arrival: 'Llegada',
    departure: 'Salida',
    orderAndPayStatus: 'Estado del Pedido (Pago)',
    unpaidOrderNotAllowed: 'Los pedidos no pagados no se pueden operar',
    invalidRoomOrderOperation:
      'Los pedidos no pagados, pendientes de entrada o sin asignación no se pueden operar',
  },
  hardware: {
    smartRoomControl: 'Control Inteligente de Habitaciones',
    smartRoomControlDesc:
      'Permite controlar de forma remota los dispositivos inteligentes de la habitación',
    smartRoomControlSetting: 'Configuración de Control Inteligente',
    appKey: 'App Key',
    appKeyPlaceholder: 'Introduzca App Key',
    appSecret: 'App Secret',
    appSecretPlaceholder: 'Introduzca App Secret',
    thirdHotel: 'Hotel de Terceros',
    thirdHotelPlaceholder: 'Introduzca el hotel de terceros',
    thirdGroup: 'Grupo de Terceros',
    thirdGroupPlaceholder: 'Introduzca el grupo de terceros',
    enable: 'Activar',
    disable: 'Desactivar',
    deviceType: 'Tipo de Dispositivo',
    fullDayAutoOff: 'Apagar Automáticamente al Llegar al Tiempo de Precio Total',
    hourAutoOff: 'Apagar Automáticamente al Llegar al Tiempo de Precio por Hora',
  },
  lockpwd: {
    makeCardLogTitle: 'Registro de Emisión de Tarjetas',
    operationType: 'Tipo de Operación',
    operationTime: 'Hora de Operación',
    makeCard: 'Emitir Tarjeta',
    cancelCard: 'Cancelar Tarjeta',
    roomTypeCode: 'Código de Tipo de Habitación',
    roomTypeName: 'Nombre del Tipo de Habitación',
    roomNumber: 'Número de Habitación',
    lockBrandName: 'Marca de Cerradura',
    lockId: 'ID de Cerradura',
    orderRoomNo: 'Número de Pedido',
    operator: 'Operador',
    makeType: 'Tipo de Tarjeta',
    validPeriod: 'Periodo de Validez',
    operationResult: 'Resultado de la Operación',
    errorMessage: 'Mensaje de Error',
  },
  roomType: {
    createBundleRoomType: 'Crear Tipo de Habitación en Paquete',
    roomTypeName: 'Nombre del Tipo de Habitación',
    relatedRoomTypes: 'Tipos de Habitación Relacionados',
    relateRoom: 'Vincular Habitaciones',
    selectedRooms: 'Habitaciones Seleccionadas',
  },
  channelConfig: {
    noChannelConfigData: 'Sin datos de configuración de canal',
    directConnected: 'Conexión directa activa',
    notDirectConnected: 'Sin conexión directa',
    roomTypeMatch: 'Asociación de tipos de habitación',
    bindNewAccount: 'Vincular nueva cuenta',
    openDirectConnection: 'Activar conexión directa',
    meituanHomestayStore: 'Tienda Meituan Homestay',
    deleteAccount: 'Eliminar cuenta',
    noBoundAccount: 'Sin cuenta vinculada',
    breakDirectConnection: 'Desconectar',
    directConnectionStatus: 'Estado de conexión',
    channelDiscount: 'Descuento del canal',
    channelCommission: 'Comisión del canal',
    qzCommission: 'Comisión Qingzhu',
    meituanRoomTypeId: 'ID de habitación Meituan',
    goodsTypeNormal: 'Producto estándar',
    goodsTypeFree: 'Producto de habitación gratuita',
    goodsTypeOnlineHour: 'Habitación por horas online',
    goodsTypePresaleFullDay: 'Preventa habitación día completo',
    goodsTypePresaleHour: 'Preventa habitación por horas',
    fetchChannelConfigFail: 'Error al obtener la configuración del canal',
    goodsTypePrefix: 'Tipo de producto {type}',
    openDirectSuccess: 'Conexión directa activada con éxito',
    openDirectFail: 'Error al activar la conexión directa',
    channelNotSupportRoomMatch: 'Este canal no admite la asociación de habitaciones',
    fetchRoomMatchFail: 'Error al obtener los datos de asociación',
    pleaseSelectRoomType: 'Seleccione un tipo de habitación Qingyingbao',
    pleaseSelectProduct: 'Seleccione un producto Qingyingbao',
    bindFail: 'Error al vincular',
    confirmUnbindRoomType: '¿Desea desvincular este tipo de habitación?',
    unbindFail: 'Error al desvincular',
    channelNotSupportAccountBind: 'Este canal no admite la vinculación de cuentas',
    bindAccountSuccess: 'Cuenta vinculada con éxito',
    bindAccountFail: 'Error al vincular la cuenta',
    fetchAccountDetailFail: 'Error al obtener los detalles de la cuenta',
    confirmDeleteAccount: '¿Desea eliminar esta cuenta?',
    confirmBreakDirect: '¿Desea desconectar la conexión directa?',
    breakDirectSuccess: 'Desconectado con éxito',
    breakDirectFail: 'Error al desconectar',
    turnoverSubmit: 'Entrega de Ingresos',
  },
  turnoverSubmit: {
    summaryLoadFailed: 'No se pudieron cargar los datos de entrega de caja. Las operaciones de esta página están deshabilitadas.',
    reload: 'Recargar',
    initBeforeUse: 'Inicialice los saldos actuales de caja antes del primer uso.',
    initCashier: 'Inicializar Caja',
    submitManage: 'Gestión de Entrega',
    summaryTipPrefix: 'Nota: Los datos de consumo y liquidación contados aquí son de',
    to: 'a',
    summaryTipSuffix: '',
    consumeSubject: 'Cuentas de Consumo',
    paymentSubject: 'Cuentas de Pago',
    serialNumber: 'N.º',
    subtotal: 'Subtotal',
    subject: 'Cuenta',
    amount: 'Importe',
    dataSummary: 'Resumen de Datos',
    lastBalanceSummary: 'Saldo anterior de caja: {total} = Efectivo({cash}) + Tarjeta bancaria({bankCard}) + Otros({other})',
    currentAmountSummary: 'Importe actual de caja: {total} = Efectivo({cash}) + Tarjeta bancaria({bankCard}) + Otros({other})',
    currentCash: 'Efectivo actual en caja:',
    currentBankCard: 'Tarjeta bancaria actual en caja:',
    currentOther: 'Otros importes actuales en caja:',
    submitCash: 'Entregar Efectivo',
    submitBankCard: 'Entregar Tarjeta Bancaria',
    submitOther: 'Entregar Otros',
    cashBalance: 'Saldo de Efectivo:',
    bankCardBalance: 'Saldo de Tarjeta Bancaria:',
    otherBalance: 'Saldo de Otros:',
    remark: 'Observación:',
    submit: 'Entregar',
    submitHistory: 'Historial de Entregas',
    submitTime: 'Hora de Entrega',
    startDate: 'Fecha de Inicio',
    endDate: 'Fecha de Fin',
    operator: 'Operador',
    pleaseEnter: 'Introduzca',
    search: 'Buscar',
    export: 'Exportar',
    lastCashierBalance: 'Saldo de Caja Anterior',
    cash: 'Efectivo',
    bankCard: 'Tarjeta Bancaria',
    other: 'Otros',
    currentCashierAmount: 'Importe de Caja del Periodo Actual',
    currentSubmitAmount: 'Importe Entregado del Periodo Actual',
    currentCashierBalance: 'Saldo de Caja del Periodo Actual',
    initTipLine1: 'Introduzca el importe real actual de caja.',
    initTipLine2: 'Tras la inicialización, se generará un registro con la observación [Datos de Inicialización].',
    currentCashierCash: 'Efectivo Actual de Caja',
    currentCashierBankCard: 'Tarjeta Bancaria Actual de Caja',
    currentCashierOther: 'Otros Importes Actuales de Caja',
    skipInit: 'No Inicializar Ahora',
    confirmInit: 'Confirmar Inicialización',
    pleaseEnterAmount: 'Introduzca el importe',
    invalidAmountFormat: 'Formato de importe no válido. Se permiten hasta 2 decimales.',
    notGreaterThanCurrentCash: 'No puede exceder [Efectivo Actual de Caja]',
    notGreaterThanCurrentBankCard: 'No puede exceder [Tarjeta Bancaria Actual de Caja]',
    notGreaterThanCurrentOther: 'No puede exceder [Otros Importes Actuales de Caja]',
    hotelHistoricalTotal: 'Total Histórico del Hotel',
    currentTime: 'Hora Actual',
    initBalanceCannotBeNegative: 'El saldo inicial no puede ser inferior a 0',
    cashierInitSuccess: 'Caja inicializada correctamente',
    exportFailed: 'Error al exportar',
    checkSubmitAmount: 'Compruebe si el importe entregado es correcto',
    confirmSubmitMessage: '¿Confirma la entrega de este registro de ingresos?',
    tip: 'Aviso',
    submitSuccess: 'Entrega realizada correctamente',
    submitFailed: 'Error en la entrega',
    total: 'Total',
    pushPriceLibrary: 'Enviar precio e inventario',
    pushPriceLibrarySuccess: 'Precio e inventario enviados correctamente',
    pushPriceLibraryFail: 'Error al enviar precio e inventario',
  },
  channelConfig: {
    noChannelConfigData: 'Sin datos de configuración de canal',
    directConnected: 'Conexión directa activa',
    notDirectConnected: 'Sin conexión directa',
    roomTypeMatch: 'Asociación de tipos de habitación',
    bindNewAccount: 'Vincular nueva cuenta',
    openDirectConnection: 'Activar conexión directa',
    meituanHomestayStore: 'Tienda Meituan Homestay',
    tujiaHomestayAccount: 'Cuenta Tujia Homestay',
    deleteAccount: 'Eliminar cuenta',
    noBoundAccount: 'Sin cuenta vinculada',
    breakDirectConnection: 'Desconectar',
    directConnectionStatus: 'Estado de conexión',
    channelDiscount: 'Descuento del canal',
    channelCommission: 'Comisión del canal',
    qzCommission: 'Comisión Qingzhu',
    meituanRoomType: 'Tipo de habitación Meituan',
    meituanRoomTypeId: 'ID de habitación Meituan',
    tujiaHouse: 'Casa Tujia',
    tujiaHouseId: 'ID de casa Tujia',
    meituanHomestay: 'Meituan Homestay',
    tujiaHomestay: 'Tujia Homestay',
    homestay: 'Homestay',
    goodsTypeNormal: 'Producto estándar',
    goodsTypeFree: 'Producto de habitación gratuita',
    goodsTypeOnlineHour: 'Habitación por horas online',
    goodsTypePresaleFullDay: 'Preventa habitación día completo',
    goodsTypePresaleHour: 'Preventa habitación por horas',
    fetchChannelConfigFail: 'Error al obtener la configuración del canal',
    goodsTypePrefix: 'Tipo de producto {type}',
    openDirectSuccess: 'Conexión directa activada con éxito',
    openDirectFail: 'Error al activar la conexión directa',
    channelNotSupportRoomMatch: 'Este canal no admite la asociación de habitaciones',
    fetchRoomMatchFail: 'Error al obtener los datos de asociación',
    pleaseSelectRoomType: 'Seleccione un tipo de habitación Qingyingbao',
    pleaseSelectProduct: 'Seleccione un producto Qingyingbao',
    bindFail: 'Error al vincular',
    confirmUnbindRoomType: '¿Desea desvincular este tipo de habitación?',
    unbindFail: 'Error al desvincular',
    channelNotSupportAccountBind: 'Este canal no admite la vinculación de cuentas',
    bindAccountSuccess: 'Cuenta vinculada con éxito',
    bindAccountFail: 'Error al vincular la cuenta',
    fetchAccountDetailFail: 'Error al obtener los detalles de la cuenta',
    confirmDeleteAccount: '¿Desea eliminar esta cuenta?',
    confirmBreakDirect: '¿Desea desconectar la conexión directa?',
    breakDirectSuccess: 'Desconectado con éxito',
    breakDirectFail: 'Error al desconectar',
    pushPriceLibrary: 'Enviar precio e inventario de 90 días',
    pushPriceLibrarySuccess: 'Precio e inventario enviados correctamente',
    pushPriceLibraryFail: 'Error al enviar precio e inventario',
    pushPriceLibrarySwitch: 'Interruptor de envío',
    pushSwitchOnSuccess: 'Interruptor de envío activado',
    pushSwitchOffSuccess: 'Interruptor de envío desactivado',
    pushSwitchChangeFail: 'Error al cambiar el interruptor de envío',
  },
  aiPmsRoomPricingSync: {
    hotelChannelSource: 'Fuente del precio', bookingHourOrderCountTitle: 'Pedidos de reserva por hora', bookingHourOrderCountNoData: 'No hay datos de pedidos de reserva por hora disponibles', bookingHourOrderCountDateRange: 'Últimos 7 días {start} a {end} | Hoy {date}', bookingHourOrderCountDateOnly: 'Hoy {date}', bookingHourOrderCountSevenDay: 'Pedidos de los últimos 7 días', bookingHourOrderCountToday: 'Pedidos de hoy', bookingHourOrderUnit: 'pedidos', bookingHourOrderAxis: 'Pedidos', viewTodayReports: 'Ver informes de hoy', backToTodayReports: 'Volver a los informes de hoy', backToLatestReport: 'Volver al informe más reciente', historyEmpty: 'Este informe de precios inteligentes no está disponible', todayReportTitle: 'Informes de {date}', pricingTime: 'Hora de fijación de precios', reportTitle: 'Título del informe', pricingChannel: 'Canal de fijación de precios', viewDetail: 'Detalles', todayReportEmpty: 'No hay informes de precios de tipo de habitación completados hoy',
  },
  commonBook: {
    commonBooking: 'Reserva unificada', fitBooking: 'Reserva individual', longStayBooking: 'Reserva de larga estancia', teamBooking: 'Reserva de grupo', walkIn: 'Entrada sin reserva', ebkManualMove: 'Traslado manual EBK',
    sourceType: 'Tipo de origen', externalChannel: 'Canal externo', channelOrderNo: 'N.º de pedido del canal', arrivalTime: 'Hora de llegada', departureTime: 'Hora de salida', retentionTime: 'Hora límite', stayDuration: 'Duración de estancia', days: 'Días', contact: 'Contacto', contactPhone: 'Teléfono de contacto', teamType: 'Tipo de grupo', teamName: 'Nombre del grupo', contractNo: 'N.º de contrato',
    paymentInfo: 'Información de pago', paymentMethod: 'Método de pago', amount: 'Importe', storedValueMember: 'Miembro con saldo', paymentCode: 'Código de verificación', remark: 'Observaciones', totalRooms: 'Habitaciones', stayDays: 'Días de estancia', taxAmount: 'Impuesto', roomPrice: 'Tarifa de habitación', totalPrice: 'Precio total', submitBooking: 'Confirmar reserva',
    addRoom: 'Añadir habitación', addRoomType: 'Añadir tipo de habitación', roomType: 'Tipo de habitación', roomStatus: 'Estado de habitación', room: 'Habitación', loading: 'Cargando', noAvailableRoomType: 'No hay tipos de habitación disponibles', noAvailableRoom: 'No hay habitaciones disponibles. Ajuste el tipo o el estado.', noValidRoomType: 'No hay tipos de habitación válidos', selectedRoomCount: '{count} habitación(es) seleccionada(s); seleccione al menos 1', emptyClean: 'Vacía limpia', emptyDirty: 'Vacía sucia', selectRoomType: 'Seleccione un tipo de habitación',
    availableRooms: 'Disponibles', breakfast: 'Desayuno', roomCount: 'Habitaciones', bookedRoomCount: 'Habitaciones reservadas', walkInRoomCount: 'Habitaciones para check-in', arrangeRoom: 'Asignar habitación', dailyPrice: 'Precio diario', unassignedRooms: '{count} habitación(es) sin asignar', assignedRoom: 'Asignada {room}', selectedRoom: 'Seleccionada {room}', delete: 'Eliminar', to: 'a', addGuest: 'Añadir huésped', channelRoomType: 'Tipo de habitación del canal', currencyUnit: 'CNY', tax: 'Impuesto',
    pleaseSelect: 'Seleccione', pleaseEnter: 'Introduzca', enterChannelName: 'Introduzca el nombre del canal', cancel: 'Cancelar', confirm: 'Confirmar', close: 'Cerrar', roomDetail: 'Detalle de cuenta de habitación',
    selectSourceType: 'Seleccione el tipo de origen', selectMemberInfo: 'Seleccione la información del miembro', selectCompany: 'Seleccione una cuenta corporativa', selectStayType: 'Seleccione el tipo de estancia', selectArrivalTime: 'Seleccione la hora de llegada', selectDepartureTime: 'Seleccione la hora de salida', enterContact: 'Introduzca un contacto', selectTeamType: 'Seleccione el tipo de grupo', enterTeamName: 'Introduzca el nombre del grupo',
    basePriceMode: 'Modo de precio base', sellingPriceMode: 'Modo de precio de venta', useEbkOrderInfo: 'Usar información del pedido EB', initializationFailed: 'No se pudo inicializar la reserva unificada. Cierre e inténtelo de nuevo.', dictionaryLoadFailed: 'No se pudieron cargar los datos de reserva', companyNotFound: 'No se encontró una cuenta corporativa coincidente',
    minimumStayDays: 'La estancia mínima es de {count} día(s)', maximumStayDays: 'La estancia máxima es de {count} día(s)', retentionBeforeArrival: 'La hora límite no puede ser anterior a la llegada', retentionTooLate: 'La hora límite supera la permitida', retentionOutOfRange: 'La hora límite está fuera del intervalo permitido',
    invalidBreakfast: 'El número de desayunos de {roomType} debe ser un entero entre 0 y 999 y no puede estar vacío', invalidRoomCount: 'El número de habitaciones de {roomType} debe ser un entero no negativo y no puede estar vacío', enterExternalChannel: 'Introduzca el nombre del canal externo', invalidHourDuration: 'La duración debe ser un entero entre 1 y 12 horas', invalidStayDays: 'Los días de estancia deben ser un entero entre {min} y {max}', incompleteStay: '{roomType} tiene un período de estancia incompleto', arrivalBeforeBusinessDate: 'La llegada de {roomType} no puede ser anterior a la fecha operativa actual', roomTypeStayRange: 'La estancia de {roomType} debe ser de 1 a {max} días', roomTypeDuplicateStay: 'No se pueden añadir períodos duplicados para {roomType}',
    selectAtLeastOneRoomType: 'Seleccione al menos un tipo de habitación reservable', selectMember: 'Seleccione un miembro', missingProductOrPrice: 'Falta el producto o los precios diarios de un tipo seleccionado', roomCountExceedsAvailability: 'Las habitaciones reservadas superan la disponibilidad', walkInRequiresRoom: 'La entrada sin reserva requiere habitaciones asignadas', guestRequiredPerRoom: 'Introduzca un huésped para cada habitación', completeGuestName: 'Complete todos los nombres de huéspedes', selectPaymentForDeposit: 'Seleccione un método de pago al cobrar un depósito', selectMemberForStoredValue: 'Seleccione un miembro para pagar con saldo', insufficientMemberBalance: 'El saldo del miembro es {balance} CNY. Seleccione otro método.', enterStoredValueCode: 'Introduzca el código de verificación para pagar con saldo',
    bookingFailed: 'La reserva ha fallado. Ajuste los datos e inténtelo de nuevo.', bookingSuccess: 'Reserva realizada', overOccupancyConfirmation: 'El número de huéspedes supera la ocupación máxima de la habitación. ¿Desea continuar con el check-in?', overOccupancyPromptTitle: 'Aviso', walkInMissingMasterRoom: 'La entrada se realizó, pero no se devolvió la cuenta principal', checkInSuccess: 'Entrada realizada', createdWithoutOrderNo: 'Creado correctamente, pero no se devolvió el número de pedido. Registre el cobro en Finanzas.', walkInWithoutMasterRoomForPayment: 'Entrada realizada, pero no se devolvió la cuenta principal. Registre el cobro en Finanzas.', onlinePaymentFailed: 'Falló la solicitud de pago en línea', paymentStatusFailed: 'No se pudo consultar el estado del pago',
    sameStayExists: 'Ya existe el mismo período para este tipo de habitación', departureAfterArrival: 'La salida debe ser posterior a la llegada', duplicateStayNotAllowed: 'No se permiten períodos duplicados para el mismo tipo', selectUnaddedRoom: 'Seleccione una habitación que no se haya añadido', keepOneWalkInRoom: 'Mantenga al menos una habitación para la entrada', ebkRoomCountMismatch: 'El número de habitaciones reservadas no coincide con el pedido del canal. ¿Desea continuar?', continueBooking: 'Continuar reserva', modify: 'Modificar',
  },
  aiPmsRoomPricingSync: {
    hotelChannelSource: 'Fuente del precio', bookingHourOrderCountTitle: 'Pedidos de reserva por hora', bookingHourOrderCountNoData: 'No hay datos de pedidos de reserva por hora disponibles', bookingHourOrderCountDateRange: 'Últimos 7 días {start} a {end} | Hoy {date}', bookingHourOrderCountDateOnly: 'Hoy {date}', bookingHourOrderCountSevenDay: 'Pedidos de los últimos 7 días', bookingHourOrderCountToday: 'Pedidos de hoy', bookingHourOrderUnit: 'pedidos', bookingHourOrderAxis: 'Pedidos', viewTodayReports: 'Ver informes de hoy', backToTodayReports: 'Volver a los informes de hoy', backToLatestReport: 'Volver al informe más reciente', historyEmpty: 'Este informe de precios inteligentes no está disponible', todayReportTitle: 'Informes de {date}', pricingTime: 'Hora de fijación de precios', reportTitle: 'Título del informe', pricingChannel: 'Canal de fijación de precios', viewDetail: 'Detalles', todayReportEmpty: 'No hay informes de precios de tipo de habitación completados hoy',
  },

  inventoryPhase1: {
    itemType: 'Tipo de artículo',
    itemSpec: 'Especificación del artículo',
    itemTypeName: '物品类型名称',
    itemSpecName: '物品规格名称',
    itemName: 'Nombre del artículo',
    itemCode: 'Código del artículo',
    enterItemName: 'Introduzca el nombre del artículo',
    itemUnit: 'Unidad',
    itemSort: 'Ordenar artículos',
    enterItemTypeName: '输入物品类型名称',
    enterItemSpecName: '输入物品规格名称',
    newType: '新建类型',
    newSpec: '新建规格',
    newItem: 'Nuevo artículo',
    modifyItem: 'Editar artículo',
    warningQty: '预警数量',
    warningQtyLabel: 'Cantidad de alerta de existencias',
    salePoint: 'Puntos de venta',
    scene: 'Usos',
    guestRoom: 'Habitación',
    fnb: 'Alimentos y bebidas',
    meeting: 'Reuniones',
    sceneSale: 'Disponible para venta',
    sceneClean: 'Disponible para limpieza de habitaciones',
    sceneBorrow: 'Disponible para préstamo',
    selectType: 'Seleccione el tipo de artículo',
    selectSpec: 'Seleccione la especificación del artículo',
    fillItemName: 'Introduzca el nombre del artículo',
    selectSalePoint: 'Seleccione al menos un punto de venta',
    warningCloseHint: 'Introduzca 0 para desactivar las alertas',
    inboundType: 'Método de entrada',
    outboundType: 'Método de salida',
    manualInbound: 'Entrada manual',
    sale: 'Venta de artículos',
    roomClean: 'Suministros de limpieza de habitaciones',
    roomBorrow: 'Préstamo en habitación',
    manualOutbound: 'Salida manual',
    newOutbound: 'Nueva salida',
    selectOutboundType: 'Seleccione el tipo de salida',
    createTime: '创建时间',
    catalogSource: '来源',
    groupCatalog: '集团底账',
    hotelCatalog: '本店',
    groupCatalogCannotEdit: '集团底账不能修改',
    groupCatalogCannotDelete: '集团底账不能删除',
    confirmDeleteType: '确认要删除该物品类型吗？',
    confirmDeleteSpec: '确认要删除该物品规格吗？',
    modifySuccess: '修改成功',
    createSuccess: '新建成功',
    filterSale: 'Disponible para venta',
    filterRoomClean: 'Disponible para limpieza de habitaciones',
    filterRoomBorrow: 'Disponible para préstamo',
    availableSalePoint: 'Puntos de venta disponibles',
    borrowReturn: 'Devolución de artículos prestados',
    saleVoid: 'Anulación de venta',
    sortOrder: 'Orden',
    fillWarningQty: 'Introduzca la cantidad de alerta de existencias',
    warningQtyInvalid: 'La cantidad de alerta debe ser un número entero no negativo',
  },
  aiPmsCtripPeerSync: {
    ctrip: 'Ctrip',
    account: 'Cuenta',
    mobilePlaceholder: 'Introduzca el móvil',
    code: 'Código SMS',
    codePlaceholder: 'Introduzca el código SMS',
    login: 'Iniciar sesión',
    resend: 'Reenviar',
    send: 'Enviar código',
    collectFailed: 'No se pudieron recopilar los precios de competidores de Ctrip. Actualice más tarde.',
    dataFailed: 'Error al cargar datos',
    relogin: 'Volver a iniciar sesión',
    unbind: 'Desvincular',
    updatedAt: 'Actualizado: {time}',
    hotelName: 'Hotel',
    price: 'Precio',
    empty: 'No hay precios de captación de competidores de {channel}',
    accountRequired: 'Introduzca su cuenta de Ctrip',
    codeRequired: 'Introduzca el código de verificación SMS',
    loggingIn: 'Iniciando sesión; después se recopilarán los precios de competidores de Ctrip',
    smsSent: 'Código SMS enviado. Introduzca el código',
    smsFailed: 'Error al enviar el código SMS. Reenvíelo',
    verifyFailed: 'Verificación SMS fallida. Introduzca de nuevo el código para iniciar sesión',
    loginFailed: 'Error al iniciar sesión en Ctrip. Envíe un nuevo código',
    deviceVerify: 'Complete la verificación del dispositivo de su cuenta de Ctrip y envíe un nuevo código',
    loginRequired: 'Envíe un código SMS para volver a iniciar sesión en Ctrip',
    expired: 'La cuenta de Ctrip ha caducado. Inicie sesión',
    sending: 'Enviando código SMS…',
    collecting: 'Sesión iniciada. Recopilando precios de competidores de Ctrip…',
    today: 'Hoy {time}',
    daysAgo: 'Hace {days} días',
    crawlSubmitted: 'Tarea de recopilación de hoteles favoritos de Ctrip enviada',
    smsSubmitted: 'Solicitud de código SMS enviada',
    unbindConfirm: '¿Desvincular la cuenta actual de Ctrip? Se conservarán los precios históricos.',
    unbindTitle: 'Desvincular cuenta de Ctrip',
    unbound: 'Cuenta de Ctrip desvinculada',
  },
};
